import ApiErrorCodes from 'src/consts/apiErrorCodes.consts';
import { DISPUTE_REASONS } from 'src/consts/dispute.consts';

export default {
  translation: {
    // Constants
    ACCOUNT: 'Account',
    ORIGINAL_PAID: 'Original Paid',
    MERCHANT_WALLETS: 'Merchant Wallets',
    ADD_VIRTUAL_ACCOUNT: 'Add Virtual Account',
    CLIENT_PORTAL: 'Client Portal',
    INSTRUCTIONS: 'Instructions',
    HERE: 'here',
    VIEW_HERE: 'View Here',
    SUBMIT: 'Submit',
    PREVIOUS: 'Previous',
    NO_DATA_TO_DISPLAY: 'No data to display',
    VIEW_DETAILS: 'View Details',
    CREATED_AT: 'Created At',
    UPDATED_AT: 'Updated At',
    COMPLETED_AT: 'Completed At',
    PAID_AT: 'Paid At',
    EXPIRED_AT: 'Expired At',
    REFUNDED_AT: 'Refunded At',
    COUNTRY: 'Country',
    COUNTRY_CODE: 'Country Code',
    ALL: 'All',
    VIEW_BY: 'View By',
    BANK: 'Bank',
    CONTACT: 'Contact',
    TIMEFRAME: 'Timeframe',
    AND: 'and',
    OR: 'or',
    IF: 'if',
    ADD_FILTER: 'Add Filter',
    FILTERS_SELECTED: '{{value}} filters applied',
    ADD_CONDITION: 'Add Condition',
    EDIT: 'Edit',
    DELETE: 'Delete',
    ENABLE: 'Enable',
    DISABLE: 'Disable',
    CREATE: 'Create',
    QTY: 'QTY',
    ID: 'Id',
    PREVIEW: 'Preview',
    SANDBOX: 'Sandbox',
    SEE_ALL: 'see all',
    SEE_LESS: 'see less',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    YEAR: 'Year',
    SEE_MORE_DETAILS: 'See more details',
    MORE_DETAILS: 'More Details',
    LAST_TRANSACTION_DATE: 'Last Transaction Date',
    ADDITIONAL_FIELDS: 'Additional Fields',
    HOVER_STATEMENT_DESCRIPTOR_ICON_INFO:
      "If supported by the receiving bank, the descriptor will be displayed in Beneficiary's bank statement",
    STATEMENT_DESCRIPTOR_DESCRIPTION: 'Max 35 characters, no special characters.',
    CONFIRMATION: 'Confirmation',
    SOURCE_OF_FUNDS: 'Source of Funds',
    WALLET: 'Wallet',
    WALLET_HEADER: 'Wallet....{{id}}',
    WALLET_TO_FUND: 'Wallet to Fund',
    CLIENT_WALLET: 'Client Wallet',
    CLIENT_BALANCE: 'Client Balance',
    END_USER_WALLET: 'End User Wallet',
    PAYOUT_AMOUNT: 'Payout Amount',
    PAYOUT_WITH_FX: 'Payout with FX',
    INDIVIDUAL: 'Individual',
    INDIVIDUAL_BENEFICIARY: 'Individual Beneficiary',
    COMPANY_BENEFICIARY: 'Company Beneficiary',
    COMPANY: 'Company',
    LAST_NAME: 'Last Name',
    ID_TYPE: 'ID Type',
    ID_NUMBER: 'ID Number',
    REFERENCE_ID: 'Reference ID',
    COMPANY_REGISTRATION_NUMBER: 'Company Registration Number',
    NEW_SENDER: 'New Sender',
    EXISTING_SENDER: 'Existing Sender',
    NEW_BENEFICIARY: 'New Beneficiary',
    EXISTING_BENEFICIARY: 'Existing Beneficiary',
    OPTIONAL_FIELDS: 'Optional Fields',
    OPTIONAL: 'Optional',
    SEARCH_BY: 'Search By',
    IDENTIFICATION_ID: 'Identification ID',
    INTERNATIONAL_PASSPORT: 'International Passport',
    RESIDENCE_PERMIT: 'Residence Permit',
    SOCIAL_SECURITY: 'Social Security',
    WORK_PERMIT: 'Work Permit',
    NO_RESULT_FOUND: 'No result found',
    ARE_YOU_SURE_YOU_WANT_TO_LEAVE: 'Are you sure you want to leave? Your progress won’t be saved',
    INFORMATION: 'Information',
    ERROR_SENDER_CURRENCY_MISMATCH:
      'The Sender selected does not support the Sender Currency selected in the previous step. Either select a different sender, create a new one, or go back and change the currency of the source wallet.',
    BACK_TO_PAYOUTS: 'Back to Overview',
    ADD: 'Add',
    ADD_MORE: 'Add Fields',
    ADD_FIELD: 'Add Field',
    REFUNDED_BADGE_TEXT: 'Refunded',
    VERIFY_CODE: 'Verify Code',
    RULE_COPIED_FROM_LIBRARY: 'Rule Copied From Library',
    RULES_LIBRARY: 'Rule Library',
    RULES_LIBRARY_SUBTITLE:
      ' Predefined and editable rules that can be added to your active rule list',
    RULE_COPIED_MESSAGE:
      'Rule <b>{{name}}</b> was added to your rules list.  It is currently disabled.  To edit or activate the rule, go to the rule display page',
    GO_TO_RULES: 'Go to Rules Page',
    THREE_DS: '3DS',
    APPEARS_IN_LIST: 'Appears in list',
    NOT_APPEARS_IN_LIST: 'Does not appear in list',
    TRANSFER: 'Transfer',
    TO: 'To',
    FROM: 'From',
    SELECT_WALLET: 'Select Wallet',
    USER_WALLET: ' User Wallet',
    CLIENT_WALLET_TOOLTIP: 'Merchant wallets store your account funds.',
    USER_WALLET_TOOLTIP:
      'User wallets are personal or company wallets to store your customers funds.',
    AUDIT_LOG: 'Audit Log',
    CHOOSE_INTEGRATION: 'Choose the right integration for your business',
    VIEW_API_GUIDE: 'View our API Reference Guide',
    ACCESS_SANDBOX_CREDENTIALS: 'Access your Sandbox Credentials',
    ACCESS_PRODUCTION_CREDENTIALS: 'Access your Production Credentials',
    START_TESTING_SANDBOX: 'Start testing in our Sandbox',
    BROWSE_OUR_DOCS: 'Browse our docs for use cases, code samples, tools and pre-integrations',
    CHOOSE_INTEGRATION_TEXT: 'Accept payments immediately with one of our integration solutions',
    WELCOME_HEADER_MESSAGE: 'Welcome, {{userName}}, follow these steps to get started',
    REQUEST_PAYMENT: 'Request Payment',
    CREATE_PAYMENT_LINK: 'Create Payment Link',
    COLLECT_PAYMENT: 'Collect Payment',
    VIRTUAL_TERMINAL: 'Virtual Terminal',
    VIEW_PAYMENTS: 'View Payments',
    CREATE_MASS_PAYOUT: 'Create Mass Payout',
    CREATE_WALLET: 'Create Wallet',
    CREATE_PERSONAL_WALLET: 'Create Personal Wallet',
    CREATE_BUSINESS_WALLET: 'Create Business Wallet',
    BUSINESS_WALLET: 'Business Wallet',
    PERSONAL_WALLET: 'Personal Wallet',
    SELECT_WALLET_TYPE: 'Select Wallet Type',
    ADD_CONTACT_ADDRESS: 'Add Contact Address',
    CONTACT_ADDRESS_OPTIONAL: 'Contact Address (Optional)',
    DELETE_CONTACT_TITLE_MODAL: 'Delete Contact',
    DELETE_CONTACT_MESSAGE_MODAL: 'Are you sure you want to delete',
    DELETE_CONTACT_THIS_CONTACT_MESSAGE_MODAL: 'Are you sure you want to delete this contact ?',
    BUSINESS_DETAILS_OPTIONAL: 'Business Details (Optional)',
    PAYOUT_NOT_SUPPORTED_HEADER: 'Payout request not supported',
    PAYOUT_NOT_SUPPORTED_MESSAGE:
      'The sender and beneficiary combination you selected is not currently supported by your accounts Payout Method Types. This could be due to numerous reasons including the Country, Currency and Entity type of the sender or beneficiary. To resolve this issue either change the sender or beneficiary details or <0>contact support</0> to open additional payout methods.',
    PAYOUT_REQUIRED_FIELDS_MISSING_IN_SENDER_AND_OR_BENEFICIARY_HEADER: 'Cannot Complete Payout',
    PAYOUT_REQUIRED_FIELDS_MISSING_IN_SENDER_AND_BENEFICIARY_MESSAGE:
      'The existing Sender and Beneficiary selected cannot be used with this Payout Method. To proceed either choose a different payout method or create a new Sender and Beneficiary.',
    PAYOUT_REQUIRED_FIELDS_MISSING_IN_SENDER_MESSAGE:
      'The existing Sender selected cannot be used with this Payout Method. To proceed either choose a different payout method or create a new Sender.',
    PAYOUT_REQUIRED_FIELDS_MISSING_IN_BENEFICIARY_MESSAGE:
      'The existing Beneficiary selected cannot be used with this Payout Method. To proceed either choose a different payout method or create a new Beneficiary.',
    RESTRICTED_INFORMATION_HEADER: 'Restricted information',
    RESTRICTED_INFORMATION_MESSAGE_1:
      'Only your account owner can view your production credentials.',
    RESTRICTED_INFORMATION_MESSAGE_2: 'To view your sandbox credentials',
    CLICK_HERE: 'Click Here',
    START_INTEGRATING: 'Start Integrating',
    REQUIRED: 'Required',
    NO_SPECIAL_CHARS: 'No special characters',
    SETTINGS: 'Settings',
    SEND: 'Send',
    ACCOUNT_SETTINGS: 'Account Settings',
    BUSINESS_SETTINGS: 'Business Settings',
    BRANDING: 'Branding',
    PAYMENT_METHODS_SETTINGS_MESSAGE:
      'View the status of the payment methods that are enabled on your account (Collect)',
    PAYOUT_METHODS_SETTINGS_MESSAGE:
      'View the status of the payout methods that are enabled on your account (Disburse)',
    FX_RATES_SETTINGS_MESSAGE: 'View the daily base rates used for currency exchanges',
    BRANDING_SETTINGS_MESSAGE:
      'Customize the look and functionality of your Rapyd hosted checkout pages',
    ISSUING_REQUESTS_SETTINGS_MESSAGE: 'Make a request to receive cards issued by Rapyd',
    FUNDING_REQUESTS_SETTINGS_MESSAGE: 'Add funds to your Rapyd account via Bank Transfer',
    RAPYD_BANK_ACCOUNTS_SETTINGS_MESSAGE: 'Rapyd Bank accounts that can receive funds',
    SETTLEMENTS_SETTINGS_MESSAGE: 'View completed and pending settlements to your account',
    SETTLEMENTS_USERS_MESSAGE: 'Invite users and manage their permissions',
    SETTLEMENTS_AUDIT_MESSAGE: 'View all actions performed by users in the Client Portal',
    KORTA_ACCOUNTING_SETUP_MESSAGE:
      'Configure settlement reports to be compatible with your accounting software',
    NUMBER_OF_HITS: '{{number}} hits in the last 60 days',
    HOSTED_CHECKOUT: 'Hosted Checkout',
    CARD_TOKENIZATION: 'Save Card Details Page',
    HOSTED_BENEFICIARY: 'Beneficiary Account Details Page',
    NOT_AVAILABLE_FOR_PAGE: 'Not available on this page',
    THANK_YOU_FOR_ORDER: 'Thank you for your order!',
    PAYMENT_WAS_COMPLETE_MESSAGE:
      'Your payment was complete successfully and your order is on its way',
    IBAN_CODE: 'IBAN CODE',
    FINISH: 'Finish',
    PAGE: 'Page',
    PICK_COLOR: 'Pick a Color',
    MORE_METHODS: 'More methods',
    CUSTUMER_SUPPORT_HCP_BRANDING_PAGE_TITLE: 'Customer Support (Optional)',
    CUSTUMER_SUPPORT_HCP_BRANDING_PAGE_SUBTITLE: 'Add details for reaching your customer support.',
    UPLOAD_MASS_PAYOUT: 'Upload Mass Payout',
    DOWNLOAD_SAMPLE_FILE: 'Download Sample File',
    DOWNLOAD_ACCOUNT_OWNERSHIP_PROOF: 'Download Proof Of Account Ownership',
    NO_CSV_SELECTED: 'No CSV files selected for upload',
    DOWNLOAD_COMPLETE: 'Download Complete',
    UPLOAD_COMPLETE: 'Upload Complete',
    MASS_PAYOUT_SAMPLE_DOWNLOAD_MESSAGE:
      'To create a mass payout fill the CSV file and upload it via the “Create Mass Payout” button. You can do it now or anytime via the button on top of the page.',
    MASS_INVOICE_SAMPLE_DOWNLOAD_MESSAGE:
      'To create a mass payments fill the CSV file and upload it via the “Create Mass Payments button. You can do it now or anytime via the button on top of the page.',
    MASS_INVOICE_UPLOAD_MESSAGE:
      'Create multiple payments or hosted payment pages by uploading a CSV file with the required fields for the selected payment method type. You can download a sample CSV with the relevant required fields by clicking on the “Download Sample File” button on the top of this page.',
    SELECT_PAYMENT_TYPE_MESSAGE:
      'Please select if you want to create a payment or create a hosted payment page (Checkout).',
    SELECT_PAYMENT_TYPE:
      'In order to create a subscription, first you need to add a payment method.',
    MASS_INVOICE_UPLOAD_COMPLETE_MESSAGE:
      'We are preparing your files.<br />You will receive an email containing<br />a link to the file in the next 15 minutes',
    CREATE_CUSTOMER: 'Create Customer',
    AMOUNT_AND_CURRENCY: 'Amount and currency',
    CUSTOMER_CREATED: 'Customer Created',
    ADD_NEW_CUSTOMER: 'Add New Customer',
    ADD_ADDRESS: 'Add Address',
    ADD_CUSTOMER_ADDRESS_HEADER: 'Add Customer Address',
    WALLETS_AND_BALANCES: 'Wallets and Balances',
    FUND_ACCOUNT: 'Fund Account',
    SHOW_ALL_TRANSACTIONS: 'Show All Transactions',
    ACTIONS: 'Actions',
    VIEW_WALLET_PAGE: 'View Wallet Page',
    CREATE_SUPPORT_TICKET: 'Create Support Ticket',
    CREATE_FEATURE_REQUEST_HEADER: 'Request a New Rapyd Feature',
    CREATE_FEATURE_REQUEST_MESSAGE:
      'Help shape the future of the Rapyd products by submitting your ideas for new features.  Your feedback is the most important driver of our production roadmap and we want to hear what you would like to see us build next.',
    DELETE_CONTACT_TITLE: 'Delete Contact',
    DELETE_CONTACT_MESSAGE:
      'Are you sure you want to delete contact {{fullName}} from {{ewalletId}}? This action cannot be reversed.',
    DELETE_CONTACT_DELETE: 'Delete',
    DELETE_CONTACT_FAILURE_TITLE: 'Error Deleting Contact',
    DELETE_CONTACT_FAILURE_MESSAGE: 'There was an error deleting this contact.',
    DELETE_CONTACT_SUCCESS_TITLE: 'Contact Deleted',
    DELETE_CONTACT_SUCCESS_MESSAGE: 'Contact {{contact}} was deleted.',
    FIND_A: 'Find a',
    CREATE_NEW: 'Create New',
    REMOVE_AND_SELECT_ANOTHER: 'Remove and Select Another',
    SELECTED: 'Selected',
    BY: 'By',
    BALANCE_AMOUNT: 'Balance: {{balance}}',

    UPDATE_CONTACT_EDIT: 'Edit',
    UPDATE_CONTACT_HEADER: 'Edit Contact',
    UPDATE_CONTACT_DETAILS: 'Edit contact details',

    UPDATE_CONTACT_SUCCESS_TITLE: 'Action Successful',
    UPDATE_CONTACT_SUCCESS_MESSAGE: '<b>{{firstName}}</b> <b>{{lastName}}</b> was updated',
    UPDATE_CONTACT_FAILURE_TITLE: 'Action Unsuccessful',
    UPDATE_CONTACT_FAILURE_MESSAGE:
      'There was an error performing this action.  Please try again at a later time, if the problem persists, contact support.',

    EDIT_CONTACT_ADDRESS: 'Edit Contact Address',

    ADD_CONTACT_THREE_DOTS: 'Add contact',
    ADD_CONTACT_HEADER: 'Add Contact',
    ADD_CONTACT_DETAILS: 'Only personal contacts can be added to business wallets',
    TRANSACTION_PERMISSION: 'Allowed to perform financial transactions on the company account',
    ROLE: 'Role',
    CREATE_CONTACT: 'Create Contact',
    GO_TO_DESKTOP: 'Go to desktop version',

    ADD_CONTACT_SUCCESS_TITLE: 'Action Successful',
    ADD_CONTACT_SUCCESS_MESSAGE:
      '<b>{{firstName}}</b> <b>{{lastName}}</b> was added to <0>{{ewalletId}}</0>',
    ADD_CONTACT_FAILURE_TITLE: 'Action Unsuccessful',
    ADD_CONTACT_FAILURE_MESSAGE:
      'There was an error performing this action.  Please try again at a later time, if the problem persists, contact support.',
    ADD_CONTACT_UNDER_REVIEW_FAILURE_TITLE: 'Contact Under Review',
    ADD_CONTACT_UNDER_REVIEW_FAILURE_MESSAGE:
      'The contact was added but requires additional review before they can be activated',

    DELETE_CUSTOMER: 'Delete Customer',
    DELETE_CUSTOMER_MESSAGE:
      'Are you sure you want to delete this Customer? This action cannot be reversed. If this customer is deleted they cannot be charged in the future',
    DELETE_CUSTOMER_FAILURE_MESSAGE:
      'There was an error deleting {{id}}, {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    DELETE_CUSTOMER_SUCCESS_MESSAGE:
      'The customer {{id}}, {{name}} was successfully deleted. This customer can no longer be charged',
    CUSTOMER_NAME: 'Customer Name',
    CUSTOMER_PHONE: 'Customer Phone',
    CUSTOMER_EMAIL: 'Customer Email',
    VAT_ID: 'Vat ID',
    INVOICE_PREFIX: 'Invoice Prefix',
    DONE: 'Done',
    CUSTOMER_ADDED_SUCCESSFULLY: 'New Customer',
    CUSTOMER_ADDED_MESSAGE:
      'The customer {{name}} was successfully created.  You can now add a payment method to the customer or request the customer submit their card details using our Card Tokenization hosted page',
    REQUEST_CARD_DETAILS: 'Request Card Details',
    CONTACT_NAME_INVALID:
      'Cardholder name can only contain Roman alphabets , without special characters and under 50 characters. Please contact customer support for assistance.',
    COUPON: 'Coupon',
    CREATE_CUSTOMER_COUPON: 'Create Coupon',
    CUSTOMER_DELETE_DISCOUNT: 'Delete Discount from Customer',
    CUSTOMER_DELETE_DISCOUNT_MESSAGE:
      'Are you sure you want to delete this discount?  this action cannot be reversed',
    ADD_NEW_ADDRESS: 'Add New Address',
    EDIT_ADDRESS: 'Edit {{address_name}} Address',
    CUSTOMER_CREATE_PAYMENT_URL: 'Create Payment URL',
    CREATE_PAYMENT: 'Create Payment',
    BENEFICIARY_ADDED_SUCCESSFULLY: 'Action Successful',
    BENEFICIARY_ADDED_MESSAGE: 'A beneficiary has been successfully created. \n {{id}}',
    DELETE_BENEFICIARY: 'Delete Beneficiary',
    DELETE_BENEFICIARY_MESSAGE: `Are you sure you want to delete <b>{{beneficiary_id}}</b> ?\n This action cannot be reversed`,
    BENEFICIARY_DELETED_SUCCESSFULLY: '{{beneficiary_id}} has been deleted',
    DELETE_SENDER: 'Delete Sender',
    CREATE_PAYOUT: 'Create Payout',
    DELETE_SENDER_MESSAGE: `Are you sure you want to delete <b>{{sender_id}}</b> ?\n This action cannot be reversed`,
    SENDER_DELETED_SUCCESSFULLY: '{{sender_id}} has been deleted',
    BATCH_DETAILS: 'Batch Details',
    DOWNLOAD_REPORT: 'Download Report',
    FAILED_TRANSACTION_REPORT: 'Failed Transaction Report',
    EXISTING_CUSTOMER: 'Existing Customer',
    NEW_CUSTOMER: 'New Customer',
    CUSTOMER: 'Customer',
    PAID_TO: 'Paid To',
    PAYMENT_EXPIRATION_CHECKOUT: 'Days to Complete Payment',
    PAYMENT_EXPIRATION_CHECKOUT_TOOLTIP:
      'After providing payment information the payer must complete the payment within this amount of days',
    PAYMENT_EXPIRATION_VALIDATION: 'Amount must be Bigger than 0',
    HCP_IFRAME_ERROR_MSG: 'One or more of the card details you provided is incorrect',
    STEPS_WIZARD_CHECKOUT_DESCRIPTION: 'A hosted payment page',
    STEPS_WIZARD_API_DESCRIPTION: 'Integrate with your existing infrastructure',
    STEPS_WIZARD_CLIENT_PORTAL_DESCRIPTION: 'Create payments through this app',
    BANK_PAYOUT: 'Bank Payouts',
    BANK_PAYMENT: 'Bank Payments',
    VIEW_INSTRUCTIONS: 'View Instructions',
    PAYMENT_INSTRUCTIONS: 'Payment Instructions',
    PAYMENT_INSTRUCTIONS_MESSAGE: 'Follow the steps below in order to complete the payment:',
    MASS_BENEFICIARY_STEP_1:
      'Upload the csv with the list of beneficiaries whose account details you would like to tokenize. You can download a sample file',
    MASS_BENEFICIARY_STEP_2:
      'Select the expiration date for the link the beneficiaries will receive for submitting their bank information.',
    INSTRUCTIONS_MODAL: 'Instructions',
    MASS_BENEFICIARY_INSTRUCTIONS_MESSAGE:
      'Beneficiary Tokenization allows you to create a hosted page in which beneficiaries can safely add their bank account details, which can then be used for completing payouts.',
    MASS_BENEFICIARY_INSTRUCTIONS_STEP_1:
      'To generate multiple Bank Account submission pages upload a csv file with the email and entity type (Individual or Company) or each beneficiary using the Sample file template.',
    MASS_BENEFICIARY_INSTRUCTIONS_STEP_2:
      'Fill out the file and upload it by selecting the "Upload Beneficiary File" button at the top of this page.',
    MASS_BENEFICIARY_INSTRUCTIONS_STEP_3:
      'Define an expiration date for the generated links and submit the file.',
    MASS_BENEFICIARY_INSTRUCTIONS_WARNING:
      'Beneficiaries will receive an email from Rapyd with a link to a hosted page.  After submitting their bank details a Beneficiary ID will be assigned to each beneficiary.  These beneficiary IDs can be viewed by clicking on the Batch ID on this page. Note: The fields "beneficiary_country", "payout_currency", "sender_country" and "sender_currency" are not mandatory.',
    CHECK_FX_RATES: 'Check FX Rates',
    GET_STARTED: 'Get started with Rapyd',
    NO_CODE_PLUGINS: 'No-Code Plugins',
    NO_CODE_PLUGINS_DESCRIPTION:
      'Accept cards and local payments in 100+ countries. Access plugins for the world’s leading ecommerce platforms.',
    VISIT_PLUGINS: 'Visit plugins',
    VIEW_DOCUMENTATION: 'View Documentation',
    VIEW_DOCUMENTATION_DESCRIPTION:
      'Make your first API call and start integrating  Collect, Disburse, Wallet and Issuing APIs.',
    VISIT_DOCS: 'Visit docs',
    RAPYD_CHECKOUT: 'Rapyd Checkout',
    RAPYD_CHECKOUT_DESCRIPTION:
      'Integrate Checkout, a white-labeled and PCI-ready solution to easily accept cards and local payments.',
    VIEW_DEMO: 'View demo',
    GET_STARTED_SETTLEMENTS_INSTRUCTIONS_COMMENT: 'In order to receive settlements you must first:',
    PROVIDE_YOUR_BANK_DETAILS: 'Provide your bank details',
    VIEW_API_KEYS: 'View API Keys',
    CREATE_YOUR_FIRST_PAYMENT: 'Create your first payment',
    PAYMENT_METHODS: 'Payment Methods',
    VIEW_AVAILABLE_PAYMENT_METHODS: 'View available payment methods',
    EXPLORE: 'Explore',
    PROFILE_COMPLETION: 'Profile Completion',
    COMPLETE_KYB: 'Complete KYB',
    CREATE_PAYMENT_PAGE: 'Create a Payment Page',
    CERTIFY_YOUR_ACCOUNT: 'Certify Your Account',
    HIDE: 'Hide',
    PENDING_APPROVAL: 'Pending Approval',
    AVAILABLE_AFTER_KYB: 'Available only after KYB approval',
    AMOUNT_SELECTED: '({{amount}} selected)',
    ENTITY_DETAILS: 'Entity Details',
    EXP: 'Exp:',
    CARD_CODE: '****',
    ACCOUNT_DEACTIVATED: 'Account Deactivated',
    ACCOUNT_DEACTIVATED_MESSAGE:
      'Your account has been deactivated. For details please <0>contact support</0>. Please make sure that you have provided accurate bank details in order to receive any unsettled funds from your account.',
    ACCOUNT_DEACTIVATED_CTA: 'Go to Bank Account',
    MORE_ACTIONS: 'More Actions',
    FORM_INVALID_OR_MISSING_VALUE: 'Invalid or missing value in mandatory field',
    REQUEST_METHOD_TYPE_SUCCESS_HEADER: 'Access Requested',
    REQUEST_METHOD_TYPE_ACCESS_SUCCESS_MESSAGE:
      'Access to the Payment method Type <b>{{name}}</b> has been requested.  Your request will be reviewed and you will be notified if access has been granted.  Please note, in requesting access to this Payment method you are requesting access to all related Payment method types.  For more information, please contact support',
    DEACTIVATED_PMT_HEADER_MESSAGE: 'Payment Method deactivated',
    DEACTIVATED_PMT_MESSAGE:
      'Payment method <b>{{name}}</b> has been successfully deactivated. To reactivate it, click the toggle again.',
    ACTIVE_PMT_HEADER_MESSAGE: 'Payment Method activated',
    ACTIVE_PMT_MESSAGE: 'Payment method <b>{{name}}</b> has been successfully activated.',
    SHOW_DOCUMENT: 'Show Document',
    // Not found in codebase
    SIGN_IN_TO_PORTAL_AND_DOWNLOAD: 'Sign in to the portal and download your report',
    FILE_NOT_ACCEPTED: 'File not accepted, sorry!',
    MERCHANTS_PORTAL_UNAUTHORIZED_ACTION: 'Insufficient credentials',
    PRODUCTION_CREDENTIALS: 'Production Credentials',
    CREATION_DATE: 'Creation Date',
    RULE_NAME: 'Rule Name',
    DECISION: 'Decision',
    TAGS: 'Tags',
    VIEW_RULE: 'View Rule',
    EDIT_RULE: 'Edit Rule',
    VIEW_ENTIRE_RULE: 'View Entire Rule',
    COPY_TO_MY_RULES: 'Copy to My Rules',
    CARD_PAYMENTS: 'Card Payments',
    CARD_PAYMENT: 'Card Payment',
    PAY: 'Pay',
    BENEFICIARY_NAME: 'Beneficiary Name',
    BENEFICIARY_COUNTRY: 'Beneficiary Country',
    BENEFICIARY_CURRENCY: 'Beneficiary Currency',
    SENDER_NAME: 'Sender Name',
    SENDER_COUNTRY: 'Sender Country',
    SENDER_ENTITY_TYPE: 'Sender Entity Type',
    SENDER_CURRENCY: 'Sender Currency',
    UPLOAD_BENEFICIARY_FILE: 'Upload Beneficiary File',
    BENEFICIARY_TOKENIZATION_MODAL: 'Beneficiary Tokenization Modal',
    UPLOAD_FILE: 'Upload File',
    ACTION_CURRENTLY_DISABLED: 'Action Currently Disabled',
    YOU_MUST_COMPLETE_KYB_MESSAGE:
      'You must complete the KYB form and be approved before this action can be completed',
    PROFILE_COMPLETED_MESSAGE: '{{name}}, you are awesome! <br/> Your profile is completed',
    CUSTOMIZE_COLUMNS: 'Customize Columns',
    CUSTOMIZE_TABLE: 'Customize Table',
    CUSTOMIZE_COLUMNS_DESCRIPTION: 'Select your table columns and their order.',
    SELECT_TWO_COLUMNS: 'Select at least two columns',
    SELECT_TWO_COLUMNS_ERROR: '* Select at least two columns',
    NO_DATA_IS_AVAILABLE: 'No data is available',
    NO_DATA_IS_AVAILABLE_REQUIRES_KYB_PAYMENTS:
      'You will be able to see your payments here once they have been created. Activate your account to start transacting.',
    NO_DATA_IS_AVAILABLE_REQUIRES_KYB_REFUNDS:
      'You will be able to see your refunds here once they have been created. Activate your account to start transacting.',
    NO_DATA_IS_AVAILABLE_REQUIRES_KYB_CUSTOMERS:
      'You will be able to see your customers here once they have been created. Activate your account to start transacting.',
    NO_DATA_IS_AVAILABLE_REQUIRES_KYB_HOSTED_PAGES:
      'You will be able to see your hosted pages here once they have been created. Activate your account to start transacting.',
    NO_DATA_IS_AVAILABLE_REQUIRES_CREATE_PAYMENT:
      'You will be able to see your payments here once they have been created.',
    NO_DATA_IS_AVAILABLE_REQUIRES_CREATE_REFUND:
      'You will be able to see your refunds here once they have been created.',
    NO_DATA_IS_AVAILABLE_REQUIRES_CREATE_CUSTOMER:
      'You will be able to see your customers here once they have been created.',
    NO_DATA_IS_AVAILABLE_REQUIRES_CREATE_HOSTED_PAGE:
      'You will be able to see your hosted pages here once they have been created. ',
    COLUMNS: 'Columns',
    ROWS: 'Rows',
    CREATE_TICKET: 'Create Ticket',
    CREATE_FEATURE_REQUEST: 'Request a Feature',
    SUPPORT_CENTER: 'Support Center',
    STEP_NUMBER: 'Step {{number}}',
    PRODUCT: 'Product',
    PLAN: 'Plan',
    INTERVAL: 'Interval',
    SWITCH_ACCOUNT: 'Switch Account',
    SWITCH_ACCOUNT_SUPPORT_MESSAGE:
      'Mobile support is available exclusively for the Rapyd Portal. To access Saga View, please use a desktop.',
    RAPYD_PORTAL_ACCOUNTS: 'Rapyd portal accounts',

    APPROX: 'approx',
    // Sign in - wizard
    SIGN_IN_EMAIL_PASSWORD_INCORRECT: 'Email or password are incorrect',
    SIGN_IN_USER_PENDING:
      'User email has not been confirmed, if confirmation email was not received, <0>resend it</0> or <1>contact support</1>',
    SIGN_IN_INVALID_EMAIL: 'Invalid email address',
    SIGN_IN_INVALID_PASSWORD: 'Invalid password',
    SIGN_IN: 'Sign in',
    SIGN_IN_LABEL_EMAIL: 'Email',
    SIGN_IN_LABEL_PASSWORD: 'Password',
    SIGN_IN_LABEL_REMEMBER_ME: 'Stay signed in for a week',
    FORGOT_PASSWORD: 'Forgot Password',
    SIGN_IN_DONT_HAVE_ACCOUNT: `Don't have an account?`,
    SIGN_IN_USER_SUSPENDED: 'User is currently blocked, to unblock <0>contact support</0>',
    ACCOUNT_SUMMARY: 'Account Summary',
    TRANSACTIONS_TO_AND_FROM_RAPYD: 'Transactions to and from Rapyd',
    SEE_ALL_SETTLEMENTS: 'See All Settlements',
    SEE_ALL_FUNDING_REQUESTS: 'See All Funding Requests',

    // Add 2fa - wizard
    ADD_2FA_GENERAL_ERROR: 'Phone number not found, please try again',
    ADD_2FA_INVALID_NUMBER: 'Invalid number',
    ADD_2FA_TITLE: 'Two-Factor Authentication',
    ADD_2FA_CONTENT: 'Please enter your mobile phone number',
    ADD_2FA_CONTENT_BOTTOM: `By clicking the 'Send' button, you hereby approve receiving SMS messages from Rapyd.`,
    ADD_2FA_BTN: 'Send Verification Code',

    // Enter 2fa - wizard
    ENTER_2FA_INCORRECT_CODE: 'Code is incorrect',
    ENTER_2FA_CODE_EXPIRE: 'Code expired',
    ENTER_2FA_ALERT_3_TIMES: 'Something went wrong, please try again later',
    ENTER_2FA_TITLE: 'Please Enter Code',

    ENTER_2FA_TOTP_TITLE: 'Authenticator App',
    ENTER_2FA_TOTP_DESCRIPTION:
      'Generate OTP using an application. No network connectivity required.',
    enter2faTotpInstruction: {
      step1: 'Open your Authenticator App.',
      step2: 'Add an account within the app, and scan the barcode.',
      step3: "Enter OTP. After you've scanned the barcode, enter the OTP generated by the app.",
    },
    VERIFY_OTP: 'Verify OTP',
    FOR_MORE_DETAILED_INSTRUCTIONS: 'for more detailed instructions',
    INCORRECT_OTP_CODE: 'Incorrect code. If this error repeats, <0>contact support</0>',
    OR_USE_AUTHENTICATOR_APP: 'Or use authenticator app',
    RECEIVE_A_CALL: 'Receive a call',
    RECEIVE_ANOTHER_CALL: 'Receive another call',

    ENTER_2FA_CONTENT_OTP:
      'If an account with the email address exists, you’ll receive an SMS message containing a 6-digit code sent to your mobile phone. Type it in below to verify your number.',
    ENTER_2FA_CONTENT_WHATSAPP_OTP:
      'If an account with the email address exists, you’ll receive a WhatsApp message containing a 6-digit code sent to your mobile phone. Type it in below to verify your number.',
    ENTER_2FA_CONTENT_TOTP: 'Generate OTP using an application. No network connectivity required.',

    ENTER_2FA_CONTENT_1: `A message containing a 6-digit code was sent to your phone`,
    ENTER_2FA_CONTENT_1_LOGIN: `A message containing a 6-digit code was sent to your mobile phone. Type it in below to verify your number`,
    ENTER_2FA_CONTENT_2: `{{ phone_number }}. `,
    ENTER_2FA_CONTENT_3: 'Please type it in to verify your number.',
    ENTER_2FA_CONTENT_3_LOGIN: 'Please type it in to verify your number.',
    ENTER_2FA_CONTENT_3_ROTATE_API_KEYS: 'Please type it in for verification.',
    ENTER_2FA_CONTENT_ROTATE_API_KEYS_SUBTITLE: `{{first_section}} <b>{{phone_number}}</b>. <br /> {{second_section}}`,

    ENTER_2FA_BTN: 'Verify Number',
    ENTER_2FA_RESEND_BTN: 'Resend SMS',
    ENTER_2FA_RESEND_ANOTHER_BTN: 'Resend Another SMS',
    RESEND_CODE: 'Resend Code',
    EDIT_PHONE_NUMBER: 'Change Number',

    // New Entry - forgot
    FORGOT_NEW_ENTRY_TITLE: 'Reset Password',
    FORGOT_NEW_ENTRY_SUB_TITLE: 'Select the method for reseting your password:',
    FORGOT_NEW_ENTRY_RESET_PHONE: 'Phone',
    FORGOT_NEW_ENTRY_RESET_EMAIL: 'Email',
    RETURN_TO_SIGN_IN: 'Return to Sign In',
    FORGOT_NEW_ENTRY_BTN: 'Continue',
    FORGOT_NEW_ENTRY_BTN_BACK: 'Back',

    // Reset password - Email
    RESET_PASSWORD: 'Reset Password',
    RESET_EMAIL_TITLE: 'Reset account by email',
    RESET_EMAIL_CONTACT: 'Please enter the email address that you have signed up with',
    RESET_EMAIL_LABEL: 'Email',
    RESET_EMAIL_INVALID_EMAIL: 'Invalid email address',
    RESET_EMAIL_GENERAL_ERROR:
      "If an account with this email address exists, you'll receive an email with a reset link to restart the reset process. If you haven't received anything, please <1>contact support</1>",
    RESET_EMAIL_BTN: 'Reset password',
    RESET_MAX_LIMIT_ATTEMPTS: 'User is currently blocked, to unblock <1>contact support</1>',
    RESET_EMAIL_SENT_MESSAGE:
      'A reset link was sent to your email account, please go to your inbox and start the reset process.',

    VIRTUAL_ACCOUNT_SUCCESS_TITLE: 'Account successfully added',
    VIRTUAL_ACCOUNT_SUCCESS_CONTENT: 'The virtual account you created was successfully added',

    ACTION_NOT_COMPLETED_CONTENT:
      'There was an error completing this request. Please try again at a later time, if the problem persists, please Contact Us.',
    EDIT_THRESHOLD_SUCCESS_TITLE: 'Settings successfully changed',
    EDIT_THRESHOLD_SUCCESS_CONTENT: 'Threshold settings successfully changed',
    ACCOUNT_CHANGES_SUCCESS_TITLE: 'The changes have been saved',
    ACCOUNT_CHANGES_SUCCESS_CONTENT: 'The changes you made were saved successfully',
    ADD_CONTACT_SUCCESS_CONTENT: 'Contact was added to <br/> {{ewalletToken}}',
    // Reset password - Phone
    RESET_PHONE_GENERAL_ERROR: 'Phone number not found, please try again',
    RESET_PHONE_TITLE: 'Reset account using mobile number',
    RESET_PHONE_CONTENT:
      'Please type in the phone number that you have originally signed up with to Rapyd',
    RESET_PHONE_CONTENT_BOTTOM:
      'By clicking ‘Send confirmation code’ text you hereby approve receiving SMS messages from Rapyd.',
    RESET_PHONE_BTN: 'Send confirmation code',
    RESET_PHONE_WITH_EMAIL_BTN: 'Reset with email',
    RESET_PHONE_EMAIL_HEADER: 'Number associated to more than 1 account',
    RESET_PHONE_EMAIL_CONTENT:
      'the phone number provided is associated to more than 1 rapyd account.  Please provide the relevant email address below to receive a confirmation code to the number {{phoneNumber}}',

    // Phone number input
    PHONE_INPUT_MOBILE_NUMBER_LABEL: 'Mobile Number',
    PHONE_INPUT_ERROR_REQUIRED: 'Required',
    PHONE_INPUT_ERROR_INVALID: 'Invalid phone number',

    // percentage validation
    PERCENTAGE_INTEGER_BETWEEN_1_TO_100: 'Percentage must be between 1 and 100 percent',

    // Email sent
    EMAIL_SENT_TITLE: 'Please check your inbox',
    EMAIL_SENT_CONTENT:
      "If an account with this email address exists, you'll receive an email with a reset link to restart the reset process. If you haven't received anything, please <0>contact support.</0>",
    EMAIL_SENT_BUTTON: 'Back to sign in',

    // Change password with token
    CHANGE_PASSWORD_ERROR_IN_SETTING_NEW_PASSWORD: 'Something went wrong, please try again later',
    CHANGE_PASSWORD_INVALID_PASSWORD: 'Invalid password',
    CHANGE_PASSWORD_INCORRECT_PASSWORDS: 'Passwords do not match',
    CHANGE_PASSWORD_SETUP_PASSWORD_BTN: 'Setup new password',
    CHANGE_PASSWORD_NEW_PASSWORD: 'New password',
    CHANGE_PASSWORD_RETYPE_NEW_PASSWORD: 'Retype new password',

    // Invite user
    INVITE_USER: 'Invite User',
    INVITE_USER_SETTINGS: 'Invite Settings',
    INVITE_USER_SETUP_NEW_PASSWORD: 'Setup new passwords',
    INVITE_USER_NEW_PASSWORD: 'New password',
    INVITE_USER_RETYPE_NEW_PASSWORD: 'Retype new password',
    INVITE_USER_SETUP_BTN: 'Setup new password',
    INVITE_USER_INVALID_PASSWORD: 'Invalid passwords',
    INVITE_USER_INVALID_PASSWORD_SHORT:
      'Minimum 10 characters, must contain 2 of the following:\n • Upper case letters • Lower case letters • Numbers',
    INVITE_USER_INCORRECT_PASSWORDS: 'Passwords do not match',

    // Invite User allowed domains
    USER_DOMAINS_DOMAIN_NOT_ALLOWED:
      'Email domain not supported by administrator. You can view the list ',
    USER_DOMAINS_DOMAIN_NOT_ALLOWED_HERE: 'here',
    USER_DOMAINS_REMOVE_DOMAIN_FROM_LIST: 'Remove domain from list',
    USER_DOMAINS_ADD_DOMAINS_FAILURE_HEADER: 'Action Unsuccessful',
    USER_DOMAINS_ADD_DOMAINS_FAILURE_MESSAGE:
      'There was an error performing this action. Please try again at a later time, if the problem persists, <0>contact support</0>.',
    USER_DOMAINS_ADD_DOMAIN_SUCCESS_HEADER: 'Approved List Updated',
    USER_DOMAINS_ADD_DOMAIN_SUCCESS_MESSAGE:
      'The Approved domain list has been updated with the following domain: {{domains}}. You will only be able to add users with emails from approved domains.',
    USER_DOMAINS_ADD_DOMAINS_SUCCESS_MESSAGE:
      'The Approved domain list has been updated with the following domains: {{domains}}. You will only be able to add users with emails from approved domains.',
    sendAnotherInvitationModel: {
      header: 'Invitation email resent',
      message: 'The email invite to {{first_name}} {{last_name}} was resent',
    },
    // New password
    NEW_PASSWORD_GENERIC_ERROR: 'Error setting up new password, please <0>contact support</0>',
    NEW_PASSWORD_GENERIC_ERROR_FROM_MAIL:
      'Error setting up new password, please <0>contact support</0>',
    NEW_PASSWORD_INVALID_PASSWORD: 'Invalid password',
    NEW_PASSWORD_INVALID_PASSWORD_SHORT:
      'Minimum 10 characters, must contain 2 of the following:\n • Upper case letters • Lower case letters • Numbers',
    NEW_PASSWORD_INCORRECT_PASSWORDS: 'Passwords do not match',
    NEW_PASSWORD_TITLE: 'Please Setup new password',
    NEW_PASSWORD_LABEL_NEW: 'New password',
    NEW_PASSWORD_LABEL_RETYPE: 'Retype new password',
    CHANGE_PASSWORD: 'Change password',
    SETUP_NEW_PASSWORD_TOOLTIP:
      'Minimum 10 characters, must contain 2 of the following:\n • Upper case letters\n • Lower case letters\n • Numbers',
    MERCHANTS_PORTAL_SMS_NOT_VERIFIED: 'SMS code was not verified',
    MERCHANTS_PORTAL_ERROR_PREVIOUS_PASSWORD:
      'You cant use your previous password, Please enter a new password',
    INVALID_PASSWORD: 'Invalid Password',

    // Edit save ewallet reference ID
    EWALLET_REFERENCE_ID_LONG: 'ID must be up to 200 standard characters',
    EWALLET_REFERENCE_ID_GENERAL_ERROR: 'Error saving ID, try again later',
    EWALLET_REFERNECE_ID_SAVE_BUTTON: 'Save',
    EWALLET_REFERNECE_ID_CANCEL_BUTTON: 'Cancel',
    EWALLET_REFERNECE_ID_EDIT_BUTTON: 'Edit',
    EWALLET_REFERENCE_ID_PLACEHOLDER: 'Reference ID',

    // client wallet ribbon
    CLIENT_WALLET_RIBBON_LABEL_BUSINESS_NAME: 'Legal Business Name:',
    CLIENT_WALLET_RIBBON_LABEL_VAT_NUMBER: 'VAT/IVA Number:',
    CLIENT_WALLET_RIBBON_LABEL_TYPE: 'Type:',
    CLIENT_WALLET_RIBBON_LABEL_CATEGORY: 'Category:',

    // Account Details
    ACCOUNT_DETAILS_SUBTITLE: 'View your account profile credentials',

    ACCOUNT_DETAILS_ACCOUNT_NAME: 'Account Name',
    ACCOUNT_DETAILS_EMPTY_STATE_CARD: 'No cards have been issued for this wallet',
    ACCOUNT_DETAILS_EMPTY_STATE_CARD_BUTTON_TEXT: '+ Request Cards',
    ACCOUNT_DETAILS_CARD_CARD_NUMBER: 'Card Number',
    ACCOUNT_DETAILS_CARD_PROGRAM: 'Program',
    ACCOUNT_DETAILS_CARD_CONTACT_NAME: 'Contact Name',
    ACCOUNT_DETAILS_CARD_EXPIRATION_DATE: 'Exp. Date',
    ACCOUNT_DETAILS_CARD_ACTIVE: 'Active',
    ACCOUNT_DETAILS_CARD_RESET_PIN: 'Reset PIN',
    ACCOUNT_DETAILS_CARD_VIEW_PROGRAM: 'View Program',

    ACCOUNT_DETAILS_EMPTY_STATE_VIRTUAL_ACCOUNTS:
      'No Virtual accounts are associated to this wallet',
    ACCOUNT_DETAILS_EMPTY_STATE_VIRTUAL_ACCOUNTS_BUTTON_TEXT: 'Create a virtual account',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_IBAN_OR_ACCOUNT_NUMBER: 'IBAN/Account #',

    ACCOUNT_DETAILS_WALLET_CONTACTS_CONTACT_NAME: 'Contact Name',
    ACCOUNT_DETAILS_WALLET_CONTACTS_EMAIL: 'Email',
    ACCOUNT_DETAILS_WALLET_CONTACTS_PHONE: 'Phone',
    ACCOUNT_DETAILS_EMPTY_STATE_WALLET_CONTACT: 'No contacts associated to this wallet',
    ACCOUNT_DETAILS_EMPTY_STATE_WALLET_CONTACT_BUTTON_TEXT: '+ Add contact',

    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_ACCOUNT_NAME: 'Account Name',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_BENEFICIARY_NAME: 'Beneficiary Name',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_COUNTRY: 'Country',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_SORT_CODE: 'Sort Code',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_BIC_SWIFT: 'BIC',
    ACCOUNT_DETAILS_VIRTUAL_ACCOUNT_CURRENCY: 'Currency',

    ACCOUNT_DETAILS_EMPTY_STATE_BANK_ACCOUNTS:
      'No Accounts associated to your account \n Min. settlement amount is {{amount}}',
    ACCOUNT_DETAILS_EMPTY_STATE_BANK_ACCOUNTS_BUTTON_TEXT: '+ Add Bank Account',

    ACCOUNT_DETAILS_EMPTY_STATE_WALLET_THRESHOLDS:
      'No minimum balance thresholds have been defined for this wallet',
    ACCOUNT_DETAILS_EMPTY_STATE_WALLET_THRESHOLDS_BUTTON_TEXT: '+ Add Threshold',
    ACCOUNT_DETAILS_WALLET_THRESHOLDS_CURRENCY: 'Currency',
    ACCOUNT_DETAILS_WALLET_THRESHOLDS_THRESHOLD: 'Threshold',

    ACCOUNT_DETAILS_WALLET_EDIT_WALLET_NAME: 'Edit Wallet Name',

    // Wallet Account Details
    TAB_DETAILS: 'Details',
    TAB_TRANSACTIONS: 'Transactions',
    WALLET_ACCOUNT_DETAILS_NO_BANK_ACCOUNTS_ADDED: 'No bank accounts added',
    WALLET_ACCOUNT_DETAILS_NO_CONTACTS_ADDED: 'No Contacts added',
    WALLET_ACCOUNT_DETAILS_NO_IMAGES_UPLOADED: 'No images uploaded',

    TAB_CORPORATE_CARDS: 'Corporate Cards',
    card_already_exist: {
      header: 'Looks like you already have an active corporate card',
      message:
        'Corporate cards are limited to 1 card per account. Removing this limitation is on our roadmap.',
    },
    kyb_approval_required: {
      header: 'This feature is unavailable ',
      message:
        'Once your business information has been reviewed, this feature will become available.',
    },
    kyb_submission_required: {
      header: 'Looks like your account hasn’t been activated',
      message: 'Please complete activating your account to explore Rapyd tools.',
    },
    no_view_cards_permission: {
      header: 'This feature is unavailable ',
      message:
        'You may not have the appropriate permissions to access this feature. Please contact support for more details. ',
    },
    balances_required: {
      header: 'Looks like your account has no balance',
      message:
        'Corporate cards are only available when your account has balance of the supported currencies ({{supported_currencies}}). Go ahead and create a collection first!',
    },
    CARD_CREATED: 'Card created!',
    CARD_CREATED_MESSAGE: 'Your card was created successfully.',
    CREATE_CORPORATE_CARD: 'Create a corporate card',
    CARD_PLACEHOLDER_DESCRIPTION: 'Manage expenses with a virtual corporate card!',
    ID_OR_PASSPORT_NUMBER: 'ID or Passport Number',
    CARD_CURRENCY: 'Currency',
    VIRTUAL: 'Virtual',
    PHYSICAL: 'Physical',
    NICKNAME: 'Nickname',
    CARD_NICKNAME: 'Card Nickname',
    SHARE_CARD_DETAILS: 'Share Card Details',

    // Invitation link expired
    INVITE_EXPIRED: 'Invitation link expired',
    INVITE_EXPIRED_TEXT:
      'Your invitation link has been expired. Please contact your system administrator and request him to resend you the invitation.',
    INVITE_EXPIRED_BTN: 'Back home',

    // Notifications

    NOTIFICATIONS_SETTINGS: 'Notifications Settings',
    NOTIFICATIONS_SETTINGS_USER: 'User',
    NOTIFICATIONS_SETTINGS_ACCOUNT: 'Account',
    NOTIFICATIONS_SETTINGS_EXTERNAL_SUBSCRIBERS: 'External Users',
    NOTIFICATIONS_SETTINGS_ACCOUNT_ADD_USER: 'Add User',
    ALL_NOTIFICATIONS: 'All Notifications',
    NOTIFICATIONS_RECENT: 'Recent',
    NOTIFICATIONS_CENTER: 'Notification Center',
    NOTIFICATIONS_MANAGE_YOUR_NOTIFICATIONS: 'Manage you notifications',
    NOTIFICATIONS_ACCOUNT_SETTINGS_REMOVE_USER_MESSAGE:
      'Are you sure you want to remove {{email}} from receiving this notification ?',
    NOTIFICATIONS_ACCOUNT_SETTINGS_REMOVE_USER_HEADER: 'Remove User',
    NOTIFICATIONS_ACCOUNT_SETTINGS_ADD_USER_MESSAGE:
      'Are you sure you want to add {{email}} to the list of users who receive this notification ?',
    NOTIFICATIONS_ACCOUNT_SETTINGS_ADD_USER_HEADER: 'Add User',
    NOTIFICATIONS_SETTINGS_EXTERNAL_SUBSCRIBERS_ADD_USER: '+ Add New User',
    NOTIFICATIONS_SETTINGS_EXTERNAL_SUBSCRIBERS_EDIT_USER: 'Add Category',
    NOTIFICATIONS_SETTINGS_EXTERNAL_SUBSCRIBERS_USERS: 'Users',

    // Navigation Links
    OVERVIEW: 'Overview',
    TAB_ONBOARDING: 'Activate Account',
    TAB_ONBOARDING_PENDING: 'KYB Submitted',
    TAB_MY_ACCOUNT: 'My Account',
    TAB_MY_ACCOUNT_MY_ACCOUNT_DETAILS: 'Account Details',
    TAB_MY_ACCOUNT_MY_WALLET_DETAILS: 'Wallet Details',
    TAB_PAYMENT_METHOD_TYPES: 'Payment Methods',
    TAB_PAYOUT_METHOD_TYPES: 'Payout Methods',
    TAB_ACCOUNT_BALANCE: 'Balance',
    TAB_USERS_ROLES: 'Users & Roles',
    TAB_USERS: 'Users',
    TAB_PAYMENTS: 'Payments',
    TAB_PROTECT: 'Protect',
    TAB_PAYMENT_LINKS: 'Payment Links',
    TAB_REUSABLE_PAYMENT_LINKS: 'Reusable Links',
    TAB_ONE_TIME_PAYMENT_LINKS: 'One Time Links',
    TAB_GROUP_PAYMENTS: 'Group Payments',
    TAB_WEBHOOKS: 'Webhooks',
    TAB_AUDITING: 'Audit Log',
    TAB_REFUNDS: 'Refunds',
    TAB_REPORTS: 'Reports',
    TAB_REPORTS_BILLING: 'Reports & Billing',
    TAB_MASS_INVOICES: 'Mass Payments',
    TAB_INVOICES: 'Invoices',
    TAB_REPORTS_SETTINGS: 'Reports Settings',
    TAB_EWALLETS: 'Wallets',
    TAB_EWALLETS_IDV_CHECKS: 'IDV Checks',
    TAB_EWALLETS_CONTACTS: 'Contacts',
    TAB_WALLETS_TRANSACTIONS: 'Transactions',
    TAB_WALLETS_ACCOUNT: 'Accounts',
    TAB_ISSUED_CARDS: 'Issuing',
    TAB_ISSUED_REQUESTS: 'Issuing Requests',
    TAB_CARDS: 'Cards',
    TAB_CARDS_PERSONALIZED: 'Personalized',
    TAB_CARDS_NOT_PERSONALIZED: 'Not Personalized',
    TAB_CARDS_TRANSACTIONS: 'Transactions',
    TAB_CARD_PROGRAMS: 'Programs',
    TAB_TRANSACTIONS_WALLETS: 'Wallets',
    TAB_CUSTOMERS: 'Customers',
    TAB_ESCROWS: 'Escrow',
    TAB_SETTLEMENTS: 'Settlements',
    TAB_CHECKOUT_PAGE: 'Checkout Page',
    TAB_FUNDING_REQUEST: 'Funding Requests',
    TAB_RAPYD_PROTECT: 'Protect',
    TAB_RULE_CREATOR: 'Rule Creator',
    TAB_GETTING_STARTED: 'Getting Started',
    TAB_CARDS_BLOCKED_TRANSACTIONS: 'Blocked',
    TAB_PAYMENT_LIST: 'Payments',
    TAB_CARD_TO_CARD: 'Card to Card',
    TAB_DISPUTES: 'Disputes',
    TAB_PAYOUT_LIST: 'Payouts',
    TAB_SETTINGS: 'Settings',
    TAB_FX_RATES: 'FX Rates',
    TAB_BRANDING: 'Branding',
    TAB_PROFILE: 'Account profile',
    TAB_BANK_ACCOUNTS: 'Bank Account',
    TAB_HOSTED_PAGES: 'Hosted Pages',
    TAB_CHECKOUT_PAGES: 'Checkout Pages',
    TAB_CARD_TOKENIZATION_LINKS: 'Card Tokenization Links',
    TAB_PRODUCTS: 'Products',
    TAB_SUBSCRIPTION_BETA: 'Subscriptions',
    TAB_SUBSCRIPTION: 'Subscription',
    TAB_SUBSCRIPTIONS: 'Subscriptions',
    TAB_COUPONS: 'Coupons',
    TAB_PRICING_PLANS: 'Pricing Plans',
    TAB_SUBSCRIPTION_INVOICES: 'Subscription Invoices',
    TAB_ROLES: 'Roles',

    // Subscription
    ACTIVE_SUBSCRIPTIONS: 'Active Subscriptions',
    NO_ACTIVE_SUBSCRIPTIONS: 'No subscriptions created yet.',
    SUBSCRIPTIONS_INVOICES: 'Subscriptions Invoices',
    CREATE_SUBSCRIPTION: 'Create Subscription',
    PLANS: 'Plans',
    BILLING_CYCLE_ANCHOR: 'Billing Cycle Anchor',
    DEFINE_TRIAL: 'Define Trial at the Subscription level',
    PLAN_TRIAL_PERIOD: 'Plan’s trial',
    TRIAL_PERIOD: 'Subscription trial',
    NO_PMT:
      'The customer does not have a card on file. This is required for creating a subscription',
    INVALID_PMT:
      'Customer doesn’t have a card that supports the {{currency}}. <0>Click Here</0> to add a card',
    ADD_PMT: 'Add Card',
    BILLING_CYCLE_ANCHOR_TOOLTIP: 'The start of the first full billing cycle',
    ADD_TAX: 'Add Tax',
    TAX: 'Tax',
    SUBSCRIPTION_WITH_CUSTOMER: 'Subscription With Customer',
    SUBSCRIPTION_WITHOUT_CUSTOMER: 'Subscription Without Customer',

    // Korta Tabs
    TAB_KORTA_TRANSACTIONS: 'Transactions',
    TAB_KORTA_AUTHORISATIONS: 'Authorisations',
    TAB_KORTA_ACCOUNTING_SETUP: 'Accounting Setup',
    TAB_KORTA_AGREEMENTS: 'Agreements',
    TAB_KORTA_ACQUIRING_CONTRACTS: 'Acquiring Contracts',
    TAB_KORTA_MERCHANT_AGREEMENTS: 'Merchant Agreements',
    TAB_KORTA_SETTLEMENT_ACCOUNTS: 'Settlement Accounts',
    TAB_KORTA_SETTLEMENTS: 'Settlements',
    TAB_KORTA_SETTLED_PAYMENTS: 'Settled payments',
    TAB_KORTA_UNSETTLED_PAYMENTS: 'Unsettled payments',
    TAB_KORTA_INCOMING_BATCH: 'Incoming Batches',
    TAB_KORTA_OUTGOING_BATCH: 'Outgoing Batches',
    TAB_KORTA_CLEARED_TRANSACTIONS: 'Cleared Transactions',
    TAB_KORTA_DISPUTES: 'Disputes',
    TAB_KORTA_CHARGEBACKS: 'Chargebacks',
    TAB_KORTA_FRAUDS: 'Frauds',
    TAB_KORTA_ICELANDIC_PAYMENTS: 'Icelandic payments',
    TAB_ACCOUNTING_FILES: 'Accounting files',

    FX_RATES: 'FX Rates',
    UP_TO_MAX_COLUMNS: 'Up to {{amount}} max columns',
    FX_RATES_SUBTITLE:
      'The rates below solely reflect the benchmark rates and do not include the additional fees applied by Rapyd. For more details please review your Merchant Agreement.',
    FUNDING_REQUESTS: 'Funding Requests',
    FUNDING_REQUEST_TAB_CREATE: 'Create Request',
    FUNDING_REQUEST_TAB_HISTORY: 'History',
    FUNDING_REQUEST_AMOUNT_BELOW_MINIMUM: 'Minimum funding amount is {{minAmount}} {{currency}}',
    TABLE_HEADER_FUNDING_REQUEST_REQUEST_DATE: 'Request Date',
    TABLE_HEADER_FUNDING_REQUEST_BANK_NAME: 'Bank Name',
    TABLE_HEADER_FUNDING_REQUEST_STATUS: 'Status',
    TABLE_HEADER_FUNDING_REQUEST_AMOUNT: 'Requested Amount',
    TABLE_HEADER_FUNDING_REQUEST_WALLET: 'Wallet',
    TABLE_HEADER_FUNDING_PAY_DATE: 'Pay Date',
    SUGGESTION_FUNDING_REQUEST_BANK_NAME: 'To which the funds were transfered',
    SUGGESTION_FUNDING_REQUEST_CURRENCY: 'Currency',
    TAB_RULES_DISPLAY: 'Rules',
    BENEFICIARY_TOKENIZATION: 'Beneficiary Tokenization',
    BENEFICIARY_TOKENIZATION_TAB_UPLOAD_FILE: 'Upload File',
    BENEFICIARY_TOKENIZATION_TAB_FILE_STATUS: 'File Status',
    RAPYD_BANK_ACCOUNTS: 'Rapyd Bank Accounts',
    READ_MORE: 'Read more',
    FREE_TEXT: 'Add your preferred name',
    PREFERRED_NAME: 'Preferred Name',
    // Account popup
    USER_DETAILS: 'User Details',
    SIGN_OUT: 'Sign out',

    // Help popup
    USER_GUIDE: 'User Guide',
    TERMS_AND_CONDITIONS: 'T&Cs',
    TERMS_AND_CONDITIONS_UPDATED: '(updated {{-termsAndConditionDate}})',
    VIEW_WELCOME_WIZARD: 'View Welcome Wizard',

    // Table
    DISPLAYING_PAGE: 'Displaying page',
    ROWS_PER_PAGE: 'Rows per page',
    PLACEHOLDER_SEARCH: 'Search...',

    // My Account
    TITLE_MY_ACCOUNT: 'Account Details',
    TITLE_BALANCE: 'Balance',
    HEADER_MY_ACCOUNT: 'Personal Details',
    LABEL_FULL_NAME: 'Full Name',
    LABEL_PHONE_NUMBER: 'Phone Number',
    LABEL_EMAIL: 'Email',
    LABEL_PASSWORD: 'Password',
    LABEL_BUSINESS_NAME: 'Legal Business Name',
    LABEL_VAT_NUMBER: 'VAT/IVA Number',
    MY_ACCOUNT_SAVE_BTN: 'Save',
    MY_ACCOUNT_CANCEL_BTN: 'Cancel',
    SECRET_KEY: 'Secret key',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
    COPY_LINK: 'Copy Link',
    COPY: 'Copy',
    COPY_ID: 'Copy ID',
    COPY_URL: 'Copy URL',
    DEACTIVATE_PAYMENT_URL: 'Deactivate Payment Link',
    ACCESS_KEY: 'Access key',
    HEADER_PRODUCTION_CREDENTIALS: 'Production Credentials',
    HEADER_SANDBOX_CREDENTIALS: 'Sandbox Credentials',
    ROTATE_API_KEYS: 'Rotate API Keys',
    ROTATE_API_KEYS_MODAL_HEADER: 'Warning!',
    ROTATE_API_KEYS_MODAL_HEADER_STEP1: 'Choose when to revoke the existing key',
    ROTATE_API_KEYS_MODAL_BODY_TEXT:
      'This action will immediatly stop and prevent any new payments! consider contacting Rapyd support before proceeding.',
    ROTATE_API_KEYS_MODAL_BODY_TEXT_SCHEDULED:
      'Make sure to update any script or program with the new API keys, and accept Webhooks with either the new or previous API keys until the previous API keys are revoked.',
    ROTATE_API_KEYS_CONFIRM_CHECKBOX_LABEL: 'I confirm rotating the API keys immediately',
    ROTATE_API_KEYS_CONFIRM_CHECKBOX_LABEL_SCHEDULED: 'I confirm rotating the API keys',
    ROTATE_API_KEYS_SUCCESS_MODAL_MESSAGE: 'API keys have been updated successfully',
    ROTATE_API_KEYS_BUTTON_TOOLTIP_DISABLE:
      'You tried more than five times. please try again in one hour',
    ROTATE_API_KEYS_BUTTON_TOOLTIP:
      'This will create new API keys and revoke the currently used keys within a period you will specify',
    ROTATE_API_KEYS_DROPDOWN_TITLE: 'Within',
    ROTATE_API_KEYS_DROPDOWN_NOW: 'Now',
    ROTATE_API_KEYS_DROPDOWN_1_HOUR: 'One hour',
    ROTATE_API_KEYS_DROPDOWN_24_HOUR: 'Twenty four hours',
    ROTATE_API_KEYS_DROPDOWN_3_DAYS: 'Three Days',
    ROTATE_API_KEYS_DROPDOWN_7_DAYS: 'Seven Days',
    ROTATE_API_KEYS_BANNER_TEXT: 'Previous keys will be revoked on: {{revoke_date}}',
    ROTATE_API_KEYS_BANNER_BUTTON_TEXT: 'Show Keys',
    ROTATE_API_KEYS_PREVIOUS_KEYS_MODAL_HEADER: 'Previous keys',
    ROTATE_API_KEYS_PREVIOUS_KEYS_MODAL_BUTTON: 'Got it',
    ROTATE_API_KEYS_PREVIOUS_KEYS_MODAL_KEY_HEADER_ACCESS: 'Access key',
    ROTATE_API_KEYS_PREVIOUS_KEYS_MODAL_KEY_HEADER_SECRET: 'Secret key',
    ROLLBACK_API_KEYS: 'Rollback API Keys',
    ROLLBACK_API_KEYS_MODAL_BODY_TEXT:
      'This action will delete the new API keys and keep the previous API keys active. Make sure all scripts and programs use the active API keys to avoid payments failure.',
    ROLLBACK_API_KEYS_CONFIRM_CHECKBOX_LABEL: 'I confirm rolling back the API keys immediately',
    ROLLBACK_API_KEYS_SUCCESS_MODAL_MESSAGE:
      'The API keys for your account have been successfully rolled back',
    BUSINESS_DETAILS: 'Business Details',
    HEADER_WEBHOOKS: 'Webhooks',
    URL: 'URL',
    SELECTED_EVENTS: 'Selected Events',
    SELECTED_EVENTS_TO_SEND: 'Selected webhooks to send',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    CREATE_WEBHOOK_BTN: 'Create Webhook',
    EDIT_WEBHOOKS: 'Edit Webhooks',
    NO_WEBHOOKS: 'Define your callback URL and the events that will trigger it.',
    BALANCE_GROUPBY_WALLET: 'Wallet',
    BALANCE_GROUPBY_CURRENCY: 'Currency',
    BALANCE_TOTAL_BALANCE: 'Total Balance',
    ACCOUNT_RESERVE_BALANCE: 'Account Reserve Balance',
    TITLE_AUDIT_LOG_PAGE: 'Audit Log',
    SUB_TITLE_AUDIT_LOG_PAGE: 'View all actions performed by users in the Client Portal',
    ACCOUNT_DETAILS_DESCRIPTION:
      'Manage your bank accounts, settlement preferences, virtual accounts, funds, and card issuing.  <0>Read more</0>.',
    ACCOUNT_DETAILS_BALANCE_DESCRIPTION:
      'Manage your balances, client wallet transactions, funding requests, and settlements. <0>Read more</0>.',
    ACCOUNT_SETTLEMENTS_DESCRIPTION:
      'Review your settlement history and future settlements. Settlements can take up to eight business days to be received once they are finalized. Please <0>contact support</0> if it has taken longer.',
    ACCOUNT_TRANSACTIONS_DESCRIPTION:
      'View all the funds collected into your client wallets and the fees sent to Rapyd.',
    LAST_PAYOUTS: 'Last {{amount}} Payouts',

    // My Account - Webhook menu
    SELECT_WEBHOOK_EVENTS: 'Select Webhook Events',

    // My Account - Edit password
    EDIT_PASSWORD_ENTER_VALID_PASSWORD: 'Please enter a valid password',
    EDIT_PASSWORD_INVALID_PASSWORD_SHORT:
      'Minimum 10 characters, must contain 2 of the following:\n • Upper case letters • Lower case letters • Numbers',
    MERCHANTS_PORTAL_ERROR_USER_PREVIOUS_PASSWORD: 'Please enter a new password',
    EDIT_PASSWORD_INCORRECT_PASSWORDS: 'Passwords do not match',
    EDIT_PASSWORD_MODAL_TITLE: 'Edit password',
    EDIT_PASSWORD_LABEL_CURRENT: 'Current password',
    EDIT_PASSWORD_LABEL_NEW: 'New password',
    EDIT_PASSWORD_LABEL_RETYPE: 'Retype password',
    EDIT_PASSWORD_SAVE_BTN: 'Save new password',

    // My Acount - Balance
    NO_TRANSACTIONS: 'No transactions were created',
    NO_TRANSACTIONS_YET: 'No Transactions Yet!',
    YOU_CAN_CREATE_PAYMENT: 'You can easily create your first Payment!',
    YOU_CAN_CREATE_PAYOUT: 'You can easily create your first Payout!',
    NO_SETTLEMENTS: 'No settlements were created',
    NO_FUNDING_REQUESTS: 'No funding requests were created',
    VIEW_ALL_TRANSACTIONS: 'View All Transactions',
    VIEW_ALL_SETTLEMENTS: 'View All Settlements',
    VIEW_ALL_TRANSACTIONS_FUNDING_REQUESTS: 'View All Funding Requests',
    DOWNLOAD_BALNCE_STATMENT: 'Download Balance Statement',
    SETTLEMENTS: 'Settlements',
    SETTLEMENTS_DISCLAIMER:
      'Once finalized, settlements can take up to 8 business days to be received. If it has taken longer, please contact support.',

    // My Account - Balance - Download Balance Modal
    DOWNLOAD_BALNCE_STATMENT_MODAL_TITLE: 'Download Balance Statement',
    DOWNLOAD_BALNCE_STATMENT_MODAL_SUB_TITLE:
      'Select the wallet and currencies that will appear on your balance statement.',

    // Users & Roles
    TITLE_USERS_ROLES: 'Users & Roles',
    INVITE: 'Invite',
    TABLE_HEADER_FULLNAME: 'Full Name',
    TABLE_HEADER_FIRST_NAME: 'First name',
    TABLE_HEADER_LAST_NAME: 'Last name',
    TABLE_HEADER_EMAIL: 'Email Address',
    TABLE_HEADER_ROLE: 'Role',
    TABLE_HEADER_UPDATED_AT: 'Updated At',
    TABLE_HEADER_LAST_LOGIN: 'Last Login',
    MENU_ITEM_RESENT_INVITATION: 'Resend Invitation',
    // Users & Roles - Invite modal
    INVITE_MODAL_HEADER: 'Invite User',
    INVITE_MODAL_SUB_HEADER: 'invite users to your account',
    INVITE_MODAL_FULLNAME: 'Full Name',
    INVITE_MODAL_EMAIL: 'Email Address',
    INVITE_MODAL_ROLE: 'Role',
    INVITE_MODAL_SELECT_ROLE: 'Please select...',
    INVITE_MODAL_ADMIN: 'Administrator',
    INVITE_MODAL_EDITOR: 'Editor',
    INVITE_MODAL_BASIC: 'Basic',
    INVITE_MODAL_CANT_PERFORM_UPDATES_SHORT_NAME: 'Please enter your first and last name',
    INVITE_MODAL_MERCHANT_PORTAL_USER_EXISTS: 'This user already exists',
    INVITE_MODAL_GENERIC_USER_ERROR_MESSAGE: 'Something went wrong',
    INVITE_MODAL_PLEASE_SELECT_ROLE_ERROR: 'Please select role',
    INVITE_MODAL_INVALID_EMAIL: 'Invalid email address',

    // Users & Roles - Allowed User Domains modal
    USER_DOMAINS_HEADER: 'Invite Settings',
    USER_DOMAINS_READ_ONLY_HEADER: 'Allowed Domains',
    USER_DOMAINS_BODY:
      'Define a list of approved domains to which client portal invites can be sent',
    USER_DOMAINS_APPROVED_DOMAINS: 'Approved Domains',
    USER_DOMAINS_ADD_APPROVED_DOMAINS: 'Add Approved Domains:',
    USER_DOMAINS_ADD: 'Add',
    USER_DOMAINS_EXAMPLE_DOMAIN: '@example.com',
    USER_DOMAINS_DONE: 'Done',
    USER_DOMAINS_CANCEL: 'Cancel',
    USER_DOMAINS_CLOSE: 'Close',
    USER_DOMAINS_OPEN_TO_ALL_DOMAINS: 'Open to all domains',
    DOMAIN_NOT_VALID: 'Please enter a valid domain',

    // Checkout Page
    TITLE_CHECKOUT_PAGE: 'Checkout Page',
    ONE_TIME: 'One time',
    ONE_TIME_LINK_DESCRIPTION:
      'Generate a custom payment page and send it to a recipient to let them make a payment',
    REUSABLE: 'Reusable',
    REUSABLE_LINK_DESCRIPTION:
      'Create a payment page, send it to various recipients, and allow them to make multiple payments on it.',
    FIXED_AMOUNT: 'Fixed amount',
    OPEN_AMOUNT: 'Open amount',
    PAYMENT_OPTIONS: 'Payment options',
    PAYMENT_OPTIONS_DESCRIPTION: 'Accepted payment methods',
    ADVANCE_OPTIONS: 'Advanced options',
    BUYERS_PAYS: 'Buyers pays',
    SHARE: 'Share',
    PAYMENT_METHOD: 'Payment Method',
    ADDITIONAL_DETAILS: 'Additional Details',
    ADDITIONAL_DETAILS_DESCRIPTION: 'Add additional details - optional',
    CHECKOUT_STEP1_SUBTITLE: 'Select the required Payment method',
    CHECKOUT_STEP2_SUBTITLE: 'Choose the required amount to charge',
    CHECKOUT_STEP3_SUBTITLE: 'Add additional details - optional',
    HEADLINE_CHECKOUT_PAGE: 'Branding',
    SUB_TITLE_CHECKOUT_PAGE:
      'Customize your Rapyd hosted Checkout Page, to give it the look and feel that fits your brand.',
    SUB_TITLE_CHECKOUT_PAGE_OPTIONAL_FIELDS: 'Add methods for reaching your customer support',
    ADD_LOGO_BUTTON_EMPTY_CHECKOUT_PAGE: 'Add logo',
    ADD_LOGO_BUTTON_CHECKOUT_PAGE: 'Logo',
    ADD_LOGO_TOOLTIP_CHECKOUT_PAGE:
      'Upload a file containing your company logo (optional). Valid file types: PNG, JPG, JPEG, GIF',
    CHECKOUT_FALLBACK_URL: 'Fallback URL',
    CHECKOUT_FALLBACK_URL_TOOLTIP:
      'The URL which the customer will be redirected to when the checkout process is completed or canceled in the event that  ‘complete_checkout_url’ or ‘cancel_checkout_url’ are not specified',
    CHECKOUT_ACCEPTED_PAYMENT_METHODS: 'Accepted Payment Methods',
    CHECKOUT_SAVE_BUTTON: 'Save',
    CHECKOUT_UNDO_BUTTON: 'Undo',
    CHECKOUT_PREVIEW_ORDER_DETAILS: 'Order Details',
    CHECKOUT_PREVIEW_CONTINUE_BUTTON: 'Place Your Order',
    CHECKOUT_PREVIEW_WEB_WEBSITE_SECURE: 'This website is secure. Your personal details are safe.',
    CHECKOUT_PREVIEW_WEB_POWERED_BY_TEXT: 'Powered by',
    CHECKOUT_PREVIEW_WEB_POWERED_BY_COMPANY: 'Rapyd',
    CHECKOUT_PREVIEW_MOBILE_PAYMENT_METHOD: 'Payment method',
    CHECKOUT_PREVIEW_DROPDOWN_TEXT: 'Select',
    CHECKOUT_PREVIEW_COMPANY_LOGO_PLACEHOLDER: 'Company logo',
    CHECKOUT_PREVIEW_WEB_BACK_TO_WEBSITE: 'Back to website',
    CHECKOUT_SUPPORT_EMAIL: 'Support Email',
    CHECKOUT_SUPPORT_WEBSITE: 'Support Website',
    CHECKOUT_PRIVACY_POLICY: 'Privacy Policy',
    CHECKOUT_SUPPORT_PHONE: 'Support Phone',
    CHECKOUT_TERMS_AND_CONDITION: 'Terms & Conditions',
    CHECKOUT_CTA_MAIN_TEXT: {
      MAIN: `Choose a CTA's main text`,
      SUPPORTED: `CTA Supported Text`,
      place_your_order: 'Place Your Order',
      pay_now: 'Pay Now',
      make_payment: 'Make Payment',
      buy: 'Buy',
      donate: 'Donate',
      save: 'Save',
      activate: 'Activate',
      subscribe: 'Subscribe',
      start_trial: 'Start Trial',
    },
    SEVEN_ELEVEN: '7Eleven',

    checkoutPreview: {
      sevenEleven: '7Eleven',
      instruction: {
        locate: 'Locate a Commerce-HQ point of sale',
        willAsk: 'The merchant will ask you to pay the amount',
        makePayment: 'Please make payment in cash at the counter',
        willProvide: 'The merchant will provide you with an approval once the payment is complete',
        pleaseMake: 'Please make payment in cash at the counter',
        packageOnWay: 'Your package is on its way',
      },
      subtotalAmount: 'USD 10',
      transactionFeeAmount: 'USD 2.50',
      exchangeFeeAmount: '0.2',
      orderTotalAmount: 'ILS 36.33',
      exchangeRateAmount: 'USD 1.0 = ILS 3.633553',
      asForDisclaimer: '(as of 14 May 2020)',
      agreeToTerms: `By placing your order, you agree to the <strong>terms and conditions</strong> and acknowledge the <strong>privacy policy</strong>`,
      choosePreferPayment: 'Choose your prefer payment method below',
    },
    CHECKOUT_PAGE_URL: 'Checkout Page URL',
    CHECKOUT_PAGE_ID: 'Checkout Page ID',
    ONE_TIME_PAYMENT_LINK_DETAILS: 'One-Time Payment Link Details',
    CHECKOUT_PAGE_STATIC_DESCRIPTION: 'A hosted payment page was created',
    CHECKOUT_PAYMENT_DETAILS: 'Checkout Payment Details',
    COMPLETE_CHECKOUT_URL: 'Complete Checkout URL',
    COMPLETE_PAYMENT_URL: 'Complete Payment URL',
    LANGUAGE: 'Language',
    ACCEPTED_CATEGORIES: 'Accepted Categories',
    PAYMENT_METHOD_CATEGORY: 'Payment Method Category',
    CANCEL_PAYMENT_BODY:
      'Do you want to cancel this payment? {{paymentId}} will no longer be active',

    // Users & Roles - User modal
    USER_MODAL_HEADER: 'Edit user',
    USER_MODAL_FULLNAME: 'Full name',
    USER_MODAL_EMAIL: 'Email address',
    USER_MODAL_ROLE: 'Select role',
    USER_MODAL_SELECT_ROLE: 'Please select...',
    USER_MODAL_ADMIN: 'Administrator',
    USER_MODAL_EDITOR: 'Editor',
    USER_MODAL_BASIC: 'Basic',
    USER_MODAL_REMOVE: 'Remove',
    USER_MODAL_SAVE: 'Save',
    USER_MODAL_GENERIC_USER_ERROR_MESSAGE: 'Something went wrong',

    // Group Payments
    TITLE_GROUP_PAYMENTS: 'Group Payments',
    TABLE_HEADER_GROUP_PAYMENT_ID: 'Group Payment ID',
    TABLE_HEADER_GROUP_PAYMENT_AMOUNT: 'Amount',
    TABLE_HEADER_GROUP_PAYMENT_DESCRIPTION: 'Description',
    TABLE_HEADER_GROUP_PAYMENT_EXPIRATION_DATE: 'Expiration Date',
    TABLE_HEADER_GROUP_PAYMENT_REFERENCE_ID: 'Merchant Reference ID',
    TABLE_HEADER_GROUP_PAYMENT_STATUS: 'Status',
    TABLE_HEADER_GROUP_PAYMENT_AMOUNT_TO_REPLACE: 'Amount to Replace',

    // Group Payments SideMenu
    GROUP_PAYMENT_SIDE_MENU_DETAILS_LABEL: 'Group Payment Details',
    GROUP_PAYMENT_SIDE_MENU_AMOUNT: 'Amount',
    GROUP_PAYMENT_SIDE_MENU_CURRENCY: 'Currency',
    GROUP_PAYMENT_SIDE_MENU_AMOUNT_TO_REPLACE: 'Amount to Replace',
    GROUP_PAYMENT_SIDE_MENU_DESCRIPTION: 'Description',
    GROUP_PAYMENT_SIDE_MENU_EXPIRATION: 'Expiration Date',
    GROUP_PAYMENT_SIDE_MENU_REFERENCE_ID: 'Merchant reference ID',
    GROUP_PAYMENT_SIDE_MENU_STATUS: 'Status',

    GROUP_PAYMENT_SIDE_MENU_LIST_PAYMENTS_LABEL: 'List of Payment IDs',
    GROUP_PAYMENT_SIDE_MENU_CANCEL_GROUP_PAYMENT_BTN: 'Cancel Payment',
    GROUP_PAYMENT_SIDE_MENU_REFUND_BTN: 'Refund',
    GROUP_PAYMENT_SIDE_MENU_TOOLTIP_TEXT:
      'Cannot cancel Group Payment because one or more of the individual payments are not cancellable',

    GROUP_PAYMENT_SIDE_MENU_CANNOT_REFUND_HEADER: 'Cannot Refund Group Payment',
    GROUP_PAYMENT_SIDE_MENU_CANNOT_REFUND_BODY: `One or more of the individual payments has already been refunded.<br /> Payments that were not refunded can be refunded individually.`,

    // Payments
    TITLE_PAYMENTS: 'Payments',
    TABLE_HEADER_PAYMENT_CATEGORY: 'Category',
    TABLE_HEADER_PAYMENT_METHOD: 'Payment Method',
    TABLE_HEADER_PAYMENT_AMOUNT: 'Paid Amount',
    TABLE_HEADER_PAYMENT_CURRENCY: 'Paid Currency',
    TABLE_HEADER_PAYMENT_REQUESTED_CURRENCY: 'Requested Currency',
    TABLE_HEADER_PAYMENT_PAID_AT: 'Paid At',
    TABLE_HEADER_PAYMENT_STATUS: 'Status',
    TABLE_HEADER_PAYMENT_REFERENCE_ID: 'Merchant Reference ID',
    TABLE_HEADER_PAYMENT_REFUNDED: 'Refunded',
    TABLE_HEADER_PAYMENT_PAYMENT_WITH_FX: 'Payment With FX',
    TABLE_HEADER_PAYMENT_REFUNDED_AMOUNT: 'Refunded Amount',
    TABLE_HEADER_PAYMENT_STATEMENT_DESCRIPTOR: 'Statement Descriptor',
    TABLE_HEADER_PAYMENT_ORIGINAL_AMOUNT: 'Requested Amount',
    TABLE_HEADER_PAYMENT_ID: 'Payment ID',
    TABLE_HEADER_PAYMENT_EXPIRATION: 'Expiration Date',
    TABLE_HEADER_PAYMENT_FEES: 'Fees',
    TABLE_HEADER_PAYMENT_METADATA: 'Metadata',
    TABLE_HEADER_PAYMENT_PAYCODE: 'Paycode',
    TABLE_HEADER_PAYMENT_TEXTUAL_CODES: 'Paycode',
    TABLE_PAYMENT_PLACEHOLDER: 'Search Payment ID',
    TABLE_PAYMENT_TOOLTIP: 'Searches Payment ID unless another field is selected',
    EXPORT: 'Export',
    EXPORT_EXCEL: 'Export Xslx',
    EXPORT_CSV: 'Export CSV',
    EXPORT_PDF: 'Export PDF',
    PRINT: 'Print',
    PAYMENT_COMPLETED_AUDIT_DESCRIPTION: 'The user manually completed a payment through the portal',
    TABLE_HEADER_PAYMENT_DESCRIPTION: 'Description',
    TABLE_HEADER_PAYMENT_CAPTURE: 'Captured',
    TABLE_HEADER_PAYMENT_LAST4: 'Last 4 Digits',
    TABLE_HEADER_PAYMENT_EWALLET: 'Wallet ID',
    TABLE_HEADER_PAYMENT_PAYMENT_INITIATION_TYPE: 'Initiation Type',
    CAPTURED_PAYMENT: 'Captured Payment',
    CUSTOMER_PAID: 'Customer Paid',
    SPLIT_PAYMENT: 'Split Payment',
    NO_DESTINATION_CURRENCIES: 'Source currency can not currently be exchanged',
    QUOTE_ERROR: 'Error retrieving exchange rate',
    CURRENCY_CONVERSION_SUCCESS_HEADER: 'Currency Conversion Complete',
    CURRENCY_CONVERSION_SUCCESS_BODY:
      'A conversion on {{sourceAmount}} {{sourceCurrency}} to {{destinationAmount}} {{destinationCurrency}} was successfully completed.',
    TRANSFER_WITH_FX_SUCCESS_HEADER: 'Transfer with FX',
    TRANSFER_WITH_FX_SUCCESS_BODY:
      'Transferred {{sourceAmount}} {{sourceCurrency}} to {{destinationAmount}} {{destinationCurrency}},\n Originating Wallet: {{source_ewallet}}\n Receiving Wallet: {{destination_ewallet}}',
    TRANSACTIONS_ARNS: `Transaction ARN's`,
    BALANCE: `Balance`,
    PLUGIN_DETAILS: `Plugin Details`,

    // Customers
    TITLE_CUSTOMERS: 'Customers',
    TABLE_HEADER_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_CUSTOMER_NAME: 'Name',
    TABLE_HEADER_CUSTOMER_PAYMENT_METHOD_TYPE_CATEGORY: 'Category',
    TABLE_HEADER_CUSTOMER_DEFAULT_PAYMENT_METHOD: 'Default Payment Method',
    TABLE_HEADER_CUSTOMER_DESCRIPTION: 'Description',
    TABLE_HEADER_CUSTOMER_DISCOUNT: 'Discount',
    TABLE_HEADER_CUSTOMER_COUPON: 'Coupon',
    TABLE_HEADER_CUSTOMER_EMAIL: 'Email',
    TABLE_HEADER_CUSTOMER_EWALLET: 'Ewallet',
    TABLE_HEADER_CUSTOMER_PHONE_NUMBER: 'Phone Number',
    NO_ACTIVE_COUPONS: 'No coupons created yet.',
    COPY_CUSTOMER_ID: 'Copy Customer ID',

    TABLE_HEADER_METHOD_TYPES_REQUEST_STATUS: 'Request Status',
    TABLE_METHOD_TYPES_REQUEST_STATUS_REJECTED: 'Rejected',
    TABLE_METHOD_TYPES_REQUEST_STATUS_PENDING: 'Pending',

    // Payment Methods
    TITLE_PAYMENT_METHOD_TYPES: 'Payment Methods',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_NAME: 'Name',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_TYPE: 'Payment Method Type',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_CATEGORY: 'Category',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_FLOW_TYPE: 'Flow Type',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_CURRENCIES: 'Currencies',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_STATUS: 'Status',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_CANCELABLE: 'Cancelable',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_EXPIRABLE: 'Expirable',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_ONLINE: 'Complete Online',
    TAB_PAYMENT_METHOD_ALL: 'All',
    TAB_PAYMENT_METHOD_ACTIVATED: 'Active',
    TAB_PAYMENT_METHOD_DEACTIVATED: 'Deactivated',
    TAB_PAYMENT_METHOD_NO_ACCESS: 'No Access',
    TAB_PAYMENT_METHOD_SUPPORTED: 'Supported',
    TAB_PAYMENT_METHOD_ADVANCED: 'Advanced',
    TAB_PAYMENT_METHOD_DIGITAL_PROVIDERS: 'Digital Wallets',
    TAB_PAYMENT_METHOD_NO_ACCESS_DESCRIPTION:
      'These payment methods require additional information or specific approval before becoming active.',
    TAB_PAYOUT_METHOD_NO_ACCESS_DESCRIPTION:
      'These payout methods require additional information or specific approval before becoming active.',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_REQUIRE_KYB: 'KYB',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_REQUESTED_ACCESS_STATUS: 'access status',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_ORG_IS_ACTIVE: 'is active',
    TABLE_HEADER_PAYMENT_METHOD_TYPE_REFUNDABLE: 'Refundable',
    WORLD_WIDE_CREDIT_CARD_PMT_SUPPORT: 'You can accept card payments worldwide.',
    // Payout Methods
    TITLE_PAYOUT_METHOD_TYPES: 'Payout Methods',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_NAME: 'Name',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_TYPE: 'Payout Method Type',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_CATEGORY: 'Category',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_COUNTRY: 'Beneficiary Country',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_CURRENCIES: 'Currencies',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_STATUS: 'Status',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_CANCELABLE: 'Cancellable',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_EXPIRABLE: 'Expirable',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_ONLINE: 'Complete Online',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_SENDER_TYPE: 'Sender Type',
    TABLE_HEADER_PAYOUT_METHOD_TYPE_BENEFICIARY_TYPE: 'Beneficiary Type',
    SUGGESTION_PAYOUT_METHODS_NAME: 'Name of the payout method',
    SUGGESTION_PAYOUT_METHOD_TYPE_TYPE: 'Code of the payout method',
    SUGGESTION_PAYMENT_METHOD_TYPE_TYPE: 'Code of the payment method',
    SUGGESTION_PAYOUT_METHOD_TYPE_ENTITY_TYPE: 'Company or Individual',

    // Export modal
    EXPORT_MODAL_TITLE: 'Export data',
    EXPORT_MODAL_DESCRIPTION: 'Export according to the requested data.',
    EXPORT_MODAL_VISIBLE_COLUMNS: 'Visible Columns',
    EXPORT_MODAL_ALL_COLUMNS: 'All Columns',
    EXPORT_MODAL_CREATION_DATE: 'Creation date',
    EXPORT_MODAL_CURRENT_FILTERS: 'Export according to the current filters:',
    EXPORT_MODAL_TO: 'To',
    EXPORT_MODAL_FROM: 'From',
    EXPORT_MODAL_SELECT: 'Select',
    EXPORT_MODAL_EXPORT_BTN: 'Export',
    EXPORT_MODAL_EXPORT_MORE_BTN: 'Export More',
    EXPORT_MODAL_EXPLAIN_MESSAGE: 'You will receive an email with a link to download the report',
    EXPORT_MODAL_ERROR_IN_DATE_RANGE: 'Invalid date range',
    EXPORT_MODAL_ERROR_IN_EXPORT_TITLE: `Error Creating Export`,
    EXPORT_MODAL_ERROR_IN_EXPORT: `There was an error generating your report,<br /> please try again at a later date`,
    EXPORT_MODAL_EMPTY_DATE_RANGE: 'Please select a valid date range',
    EXPORT_MODAL_NO_DATA: 'No data in range. Please change your filters or dates and try again',
    EXPORT_MODAL_DIRECT_DOWNLOAD_SUCCESS_HEADER: 'File Downloaded',
    EXPORT_MODAL_DIRECT_DOWNLOAD_SUCCESS: 'The requested file was successfully downloaded',
    EXPORT_MODAL_SUCCESS:
      'The requested file is being generated,<br /> you will receive an email when it is ready to be downloaded',
    EXPORT_MODAL_SUCCESS_HEADER: 'Export request received',
    PAYMENT_COMPLETED_SUCCESS_MODAL_HEADER: 'Payment Closed',
    PAYMENT_COMPLETED_SUCCESS_MODAL_MESSAGE: '{{id}} has been completed',
    PAYMENT_COMPLETED_ERROR_MODAL_HEADER: 'Error Completing Payment',
    PAYMENT_COMPLETED_ERROR_MODAL_BODY:
      'We were unable to complete the payment. Please try again. <br/>If you get this error again, please <0>contact support</0>',
    DELAY_MESSAGE: 'A delay of up to 2 minutes may occur until new data is displayed',

    // Feature Is Unavailable Message Modal
    FEATURE_IS_UNAVAILABLE_HEADER: 'This feature is unavailable',
    FEATURE_IS_UNAVAILABLE_CONTENT:
      'Once your business information has been reviewed, this feature will become available.',

    // Already Has A Virtual Account Message Modal
    ALREADY_HAS_A_VIRTUAL_ACCOUNT_HEADER: 'Looks like you already have a virtual account',
    ALREADY_HAS_A_VIRTUAL_ACCOUNT_CONTENT: 'Virtual accounts are limited to 1 account.',
    ALREADY_REACHED_MAX_VIRTUAL_ACCOUNTS_CONTENT:
      'Virtual accounts are limited to 1 account per currency.',

    // Prepare File Modal
    FILE_MODAL_TITLE: 'We are preparing your file',
    FILE_MODAL_MIGHT_TAKE_A_WHILE: 'This might take a while, an email will be sent',
    FILE_MODAL_FILE_READY_TO_DOWNLOAD: 'to you once the file is ready to download',
    FILE_MODAL_ALL_DATA: 'All data',
    FILE_MODAL_BY_DATES: 'By dates',
    FILE_MODAL_TO: 'To',
    FILE_MODAL_FROM: 'From',
    FILE_MODAL_BTN: 'Close',

    // Refunds
    TITLE_REFUNDS: 'Refunds',
    TABLE_HEADER_REFUNDS_PAYMENT_METHOD: 'Payment Method',
    TABLE_HEADER_REFUNDS_PAYMENT_CREATED_AT: 'Payment Created At',
    TABLE_HEADER_REFUNDS_AMOUNT: 'Refunded Amount',
    TABLE_HEADER_REFUNDS_AMOUNT_RECEIVED: 'Received Amount',
    TABLE_HEADER_REFUNDS_PAYMENT_ID: 'Payment ID',
    TABLE_HEADER_REFUNDS_CURRENCY: 'Received Currency',
    TABLE_HEADER_REFUNDS_STATUS: 'Status',
    TABLE_HEADER_REFUNDS_ID: 'Refund ID',
    TABLE_HEADER_REFUNDS_EXCHANGED_AMOUNT: 'Exchanged Amount',
    TABLE_HEADER_REFUNDS_REFUND_WITH_FX: 'Refund With FX',
    TABLE_HEADER_REFUNDS_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_COUPON_ID: 'Coupon ID',
    TABLE_HEADER_COUPON_CURRENCY: 'Currency',
    TABLE_HEADER_COUPON_STATUS: 'Status',
    REFUNDS_DETAILS_REFUND_ID: 'Refund ID',
    REFUNDS_DETAILS_REFUND_PAYMENT_ID: 'Payment ID',
    REFUNDS_DETAILS_REFUNDED_AMOUNT: 'Refunded Amount',
    REFUNDS_DETAILS_REFUND_CUREENCY: 'Refund Currency',
    REFUNDS_DETAILS_REFUNDED: 'Refunded',
    REFUNDS_DETAILS_REQUESTED: 'Requested',
    REFUNDS_DETAILS_ORIGINAL_PAYMENT_METHOD: 'Original payment method type',
    REFUNDS_DETAILS_DATE: 'Date created',
    REFUNDS_DETAILS_COMPLETE_REFUND: 'Complete Refund',
    REFUNDS_CHOOSE_COLUMNS_TOOLTIP: 'Choose Columns',
    REFUNDS_DETAILS_REFUND_FAILURE_REASON: 'Reason',
    REFUNDS_DETAILS_REFUND_RECEIPT_NUMBER: 'Receipt Number',
    REFUNDS_DETAILS_REFUND_IS_PROPORTIONAL: 'Proportional Refund',
    REFUNDS_DETAILS_UPDATED_DATE: 'Updated At',
    REFUNDS_DETAILS_PAID_AT: 'Paid At',
    REFUND_PAYMENT_DETAILS_TITLE: 'Original payment details',
    REFUND_DETAILS_METADATA: 'Metadata',
    PAYER_PAYMENT_DETAILS_TITLE: 'Payer details',
    PAYMENT_PAYER_ID: 'Customer ID',
    PAYMENT_PAYER_NAME: 'Name',
    PAYMENT_PAYER_EMAIL: 'email',
    PAYMENT_PAYER_PHONE: 'Phone number',
    VIEW_PAYMENT: 'View Payment',
    YOU_RECEIVED: 'You Received',
    REFUNDS_MERCHANT_DEBITED_CURRENCY: 'Exchange Currency',
    REFUND_REASON_NOT_AVAILABLE: 'Reason: N/A',
    REFUND_DETAILS: 'Refund Details',
    CUSTOMER_DETAILS: 'Customer Details',
    // Escrow Payments
    TITLE_ESCROWS: 'Escrows',
    TABLE_HEADER_ESCROW_ID: 'Escrow ID',
    TABLE_HEADER_ESCROW_RELEASE_DAYS: 'Days',
    TABLE_HEADER_ESCROW_LAST_PAYMENT_COMPLETION: 'Last Payment Completion',
    TABLE_HEADER_ESCROW_ON_HOLD_AMOUNT: 'Held Amount',
    TABLE_HEADER_ESCROW_TOTAL_RELEASED_AMOUNT: 'Released Amount',
    TABLE_HEADER_ESCROW_PAYMENT_ID: 'Payment ID',
    TABLE_HEADER_ESCROW_STATUS: 'Status',
    TABLE_HEADER_ESCROW_UPDATED_AT: 'Last Update',
    TABLE_HEADER_ESCROW_CURRENCY: 'Currency',

    // Subscriptions
    TABLE_HEADER_SUBSCRIPTIONS_SUBSCRIPTION_ID: 'Subscription ID',
    TABLE_HEADER_SUBSCRIPTIONS_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_SUBSCRIPTIONS_CREATED_AT: 'Created At',
    TABLE_HEADER_SUBSCRIPTIONS_CANCELED_AT: 'Canceled At',
    TABLE_HEADER_SUBSCRIPTIONS_CUSTOMER_NAME: 'Customer Name',
    TABLE_HEADER_SUBSCRIPTIONS_NEXT_BILLING_CYCLE: 'Next Billing Cycle',
    TABLE_HEADER_SUBSCRIPTIONS_BILLING_METHOD: 'Billing Method',
    TABLE_HEADER_SUBSCRIPTIONS_PLAN: 'Plan',
    TABLE_HEADER_SUBSCRIPTIONS_STATUS: 'Status',
    SUBSCRIPTION_SUGGESTION_CUSTOMER_NAME: 'Name of customer associated to the subscription',
    SUBSCRIPTION_SUGGESTION_CUSTOMER_ID:
      'Rapyd identifier of the customer associated to the subscription',
    SUBSCRIPTION_SUGGESTION_COUPON_ID: 'Coupon ID',
    SUBSCRIPTION_SUGGESTION_SUBSCRIPTION_ID: 'Rapyd identifier of the subscription',
    SUBSCRIPTION_SIDE_MENU_SUBSCRIPTION_DETAILS: 'Subscription Details',
    SUBSCRIPTION_SIDE_MENU_ID: 'Subscription ID',
    SUBSCRIPTION_SIDE_MENU_CREATED_AT: 'Created At',
    SUBSCRIPTION_SIDE_MENU_START: 'Start',
    SUBSCRIPTION_SIDE_MENU_BILLING_METHOD: 'Billing Method',
    SUBSCRIPTION_SIDE_MENU_STATUS: 'Status',
    SUBSCRIPTION_SIDE_MENU_NEXT_BILLING_CYCLE: 'Next Billing Cycle',
    SUBSCRIPTION_SIDE_MENU_CANCELED_AT: 'Canceled At',
    SUBSCRIPTION_SIDE_MENU_ENDED_AT: 'Ended At',
    SUBSCRIPTION_SIDE_MENU_CUSTOMER_DETAILS: 'Customer Details',
    SUBSCRIPTION_SIDE_MENU_CUSTOMER_NAME: 'Customer Name',
    SUBSCRIPTION_SIDE_MENU_CUSTOMER_ID: 'Customer ID',
    SUBSCRIPTION_SIDE_MENU_EMAIL: 'Email',
    SUBSCRIPTION_SIDE_MENU_PHONE_NUMBER: 'Phone Number',
    SUBSCRIPTION_SIDE_MENU_NO_ITEMS: 'No Subscription Items',
    SUBSCRIPTION_SIDE_MENU_SUBSCRIPTION_ITEMS: 'Subscription Items',
    SUBSCRIPTION_SIDE_MENU_SUBSCRIPTION_ITEM_QUANTITY: 'Quantity:',
    SUBSCRIPTION_SIDE_MENU_SUBSCRIPTION_LAST_PAYMENTS: 'Last 5 Payments Made',
    SUBSCRIPTION_SIDE_MENU_SUBSCRIPTION_NO_PAYMENTS: 'No payments have been made',
    SUBSCRIPTION_SIDE_MENU_SEE_PAYMENT_DETAILS: 'See Payment Details',
    SUBSCRIPTION_SIDE_MENU_EMPTY_STATE_HEADLINE: 'Canceled Subscription',
    SUBSCRIPTION_SIDE_MENU_EMPTY_STATE_TEXT: 'Data Not Available For Canceled Subscription',
    SUBSCRIPTION_SIDE_MENU_COUPON_ID: 'Coupon ID',
    SUBSCRIPTION_SIDE_MENU_COUPON_VALUE: 'Coupon Value',
    PAY_INVOICE: 'Pay Invoice',
    CANCEL_SUBSCRIPTION_MODAL_IMMEDIATELY_OPTION: 'Cancel Subscription Immediately',
    CANCEL_SUBSCRIPTION_MODAL_END_OF_PERIOD_OPTION:
      'Cancel Subscription At The End of Billing Period',

    // Subscriptions Invoice
    SEE_ALL_INVOICES: 'See all Invoices',
    NO_SUBSCRIPTIONS_INVOICES:
      'You will be able to see your subscription invoices here once they have been created.',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_STATUS: 'Status',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_INVOICE_ID: 'Invoice ID',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_SUBSCRIPTION_ID: 'Subscription ID',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_PAID_AT: 'Paid At',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_CUSTOMER_NAME: 'Customer Name',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_REFUNDED: 'Refunded',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_REFUNDED_AMOUNT: 'Refunded Amount',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_NEXT_PAYMENT_ATTEMPT: 'Next Payment Attempt',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_CREATED_AT: 'Created At',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_BILLING_METHOD: 'Billing',
    TABLE_HEADER_SUBSCRIPTIONS_INVOICES_DUE_DATE: 'Due Date',
    SUBSCRIPTION_INVOICE_SIDE_MENU_DESCRIPTION:
      'A subscription payment was made by customer {{customerId}}',
    SUBSCRIPTION_INVOICE_SIDE_MENU_SUBSCRIPTION_INVOICE_DETAILS: 'Subscription Invoice Details',
    SUBSCRIPTION_INVOICE_SIDE_MENU_ID: 'Invoice ID',
    SUBSCRIPTION_INVOICE_SIDE_MENU_CREATED_AT: 'Created At',
    SUBSCRIPTION_INVOICE_SIDE_MENU_PAID_AT: 'Paid At',
    SUBSCRIPTION_INVOICE_SIDE_MENU_INVOICE_AMOUNT: 'Subscription Invoice Amount',
    SUBSCRIPTION_INVOICE_SIDE_MENU_BILLING_METHOD: 'Billing method',
    SUBSCRIPTION_INVOICE_SIDE_MENU_SUBSCRIPTION_ID: 'Subscription ID',
    SUBSCRIPTION_INVOICE_SIDE_MENU_ATTEMPTED_PAYMENTS: 'Attempted payments',
    SUBSCRIPTION_INVOICE_SIDE_MENU_CUSTOMER_DETAILS: 'Customer Details',
    SUBSCRIPTION_INVOICE_SIDE_MENU_CUSTOMER_ID: 'Customer ID',
    SUBSCRIPTION_INVOICE_SIDE_MENU_REFUNDED: 'Refunded',
    SUBSCRIPTION_INVOICE_SIDE_MENU_REFUNDED_AMOUNT: 'Refunded Amount',
    SUBSCRIPTION_INVOICE_SIDE_MENU_PLAN: 'Plan',
    SUBSCRIPTION_INVOICE_SIDE_MENU_PAYMENT_METHODS: 'Payment Methods',
    SUBSCRIPTION_RETRY_PAYMENT: 'Retry Payment',
    SUBSCRIPTION_RETRY_PAYMENT_TOOLTIP: 'Using the Default Payment Method',
    SUBSCRIPTION_PAY_INVOICE_SUCCESS_HEADER: 'Subscription Invoice Paid',
    SUBSCRIPTION_PAY_INVOICE_SUCCESS_DEFAULT_PMT_BODY:
      'Payment of the subscription invoice {{invoiceToken}} was successful.',
    SUBSCRIPTION_PAY_INVOICE_SUCCESS_NON_DEFAULT_PMT_BODY:
      'Payment of the subscription invoice {{invoiceToken}} was successful. Please note that this payment method is currently not the default one for this subscription.',
    SUBSCRIPTION_PAY_INVOICE_FAILURE_HEADER: 'Payment Attempt Failed',
    SUBSCRIPTION_PAY_INVOICE_FAILURE_BODY:
      'The attempt to pay subscription invoice {{invoiceToken}} was unsuccessful. You can try again at a later time, or try using a different payment method.',
    SUBSCRIPTION_PAY_INVOICE_AUDIT: 'Subscription Invoice Payment Retried',
    SELECT_PAYMENT_METHOD: 'Make Default Subscription Payment Method',
    SUBSCRIPTION_UPDATE_FAILURE_TITLE: 'Subscription was not updated',
    SUBSCRIPTION_UPDATE_PAYMENT_METHOD_SUCCESS_MESSAGE: 'Subscription payment method was updated',
    SUBSCRIPTION_UPDATE_PAYMENT_METHOD_FAILURE_TITLE: 'Subscription payment method was not updated',
    SUBSCRIPTION_CREATE_PAYMENT_METHOD_FAILURE_MESSAGE:
      'We couldn’t add this card. Try again or use a different card.',
    SUBSCRIPTION_UPDATE_PAYMENT_METHOD_FAILURE_MESSAGE: `The card was added, but we couldn't set it as the default payment method. Try again or use a different card.`,
    UPDATE_CARD: 'Update Card',
    ATTACH_COUPON: 'Attach Coupon',
    FILTER_GROUP_CREATED_DESCRIPTION: 'A user created a filter group',
    FILTER_GROUP_DELETED_DESCRIPTION: 'A user deleted a filter group',
    FILTER_NAME: 'Filter name',
    FILTER_TYPE: 'Filter type',
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    SUBSCRIPTION_DELETED_DESCRIPTION: 'A user deleted a subscription',
    SUBSCRIPTION_ID: 'Subscription ID',
    CANCELATION_PERIOD: 'Cancelation period',
    END_OF_BILLING_CYCLE: 'End of billing cycle',
    IMMEDIATELY: 'Immediately',
    SUBSCRIPTION_REQUEST_PAGE_TITLE: 'Get Started With Rapyd Subscriptions',
    SUBSCRIPTION_REQUEST_PAGE_DESCRIPTION:
      'Introducing Rapyd Subscriptions. Billing and revenue management that helps you grow \n revenue, support new products, and accept recurring payments internationally.',
    SUBSCRIPTION_REQUEST_ACCESS_MODAL_TITLE: 'Request Access To Subscriptions',
    SUBSCRIPTION_REQUEST_ACCESS_MODAL_DESCRIPTION: `Rapyd's subscription service is currently in closed beta. if you would like to join, \n please tell us more about your needs and we'll contact you if the program is right \n for you.`,

    // Plans
    TABLE_HEADER_PLANS_ID: 'Plan ID',
    TABLE_HEADER_PLANS_CREATED_AT: 'Created At',
    TABLE_HEADER_PLANS_AMOUNT_AND_CURRENCY: 'Amount+Currency',
    TABLE_HEADER_PLANS_NICKNAME: 'Plan Name',
    TABLE_HEADER_PLANS_PRODUCT: 'Product',
    TABLE_HEADER_PLANS_BILLING_SCHEME: 'Billing Scheme',
    TABLE_HEADER_PLANS_USAGE_TYPE: 'Usage Type',
    TABLE_HEADER_PLANS_AMOUNT: 'Amount',
    TABLE_HEADER_PLANS_CURRENCY: 'Currency',
    TABLE_HEADER_PLANS_INTERVAL: 'Interval',
    TABLE_HEADER_PLANS_PRODUCT_ID: 'Product ID',
    TABLE_HEADER_PLANS_PRODUCT_NAME: 'Product Name',
    PLAN_SUGGESTION_PLAN_ID: 'Plan ID as defined by Rapyd',
    PLAN_SUGGESTION_PLAN_NICKNAME: 'Plan name as defined by the merchant',
    PLAN_SUGGESTION_PRODUCT_NAME: 'Name of product associated to the plan',
    PLAN_SUGGESTION_PRODUCT_ID: 'Rapyd Identifier of Product associated to the plan',
    PLAN_SIDE_MENU_PLAN_DETAILS: 'Plan Details',
    PLAN_SIDE_MENU_PLAN_ID: 'Plan ID',
    PLAN_SIDE_MENU_PLAN_NICKNAME: 'Plan Name',
    PLAN_SIDE_MENU_PLAN_USAGE_TYPE: 'Usage Type',
    PLAN_SIDE_MENU_PLAN_INTERVAL: 'Interval',
    PLAN_SIDE_MENU_PLAN_PRICE: 'Price',
    PLAN_SIDE_MENU_PLAN_TIERS_MODE: 'Tiers Mode',
    PLAN_SIDE_MENU_PLAN_TRIAL_PERIOD: 'Trial period',
    PLAN_SIDE_MENU_PRODUCT_DETAILS: 'Product Details',
    PLAN_SIDE_MENU_PRODUCT_ID: 'Product ID',
    PLAN_SIDE_MENU_PRODUCT_NAME: 'Product Name',
    PLAN_SIDE_MENU_TIERS: 'Tiers',
    tiers: {
      tier: 'Tier',
      firstUnit: 'First Unit',
      lastUnit: 'Last Unit',
      perUnit: 'Per Unit',
    },
    PLAN_SIDE_MENU_LOWERCASE_TIER: 'tier',
    PLAN_SIDE_MENU_PLAN_PRICE_MESSAGE_LICENSED: '{{amount}} {{currency}} per {{interval}}',
    PLAN_SIDE_MENU_PLAN_PRICE_MESSAGE_PER_UNIT: '{{amount}} {{currency}} per unit',
    PLAN_SIDE_MENU_PLAN_TRIAL_PERIOD_DAYS: '{{days}} Days',

    // Download Reports
    TITLE_REPORTS: 'Reports',
    TABLE_HEADER_REPORTS_NAME: 'Report Name',
    TABLE_HEADER_REPORTS_CURRENCY: 'Currency',
    TABLE_HEADER_REPORTS_LINK: 'Link',
    TABLE_HEADER_REPORTS_SETTLEMENT_DATE: 'Report Date',
    TABLE_REPORTS_DOWNLOAD_LINK: 'Download Report',

    UPDATE_REPORTS_SETTINGS: 'The user edited the Report settlement configurations of the account',
    REPORTS_TYPE: 'Settlement preference',
    SELECT_REPORTS_TYPE_TITLE: 'Select your reconciliation report type',
    SELECT_REPORTS_FILE_TYPE_TITLE: 'Reconciliation Report File Prefernces',
    SELECT_REPORTS_FILE_FORMAT_TYPE: 'Format type',
    SELECT_REPORTS_FILE_SEPARATOR_TPE: 'Separator type',
    CSV_FILE_PREFERENCES_TITLE: 'CSV file preferences',
    CSV_FILE_PREFERENCES_DESCRIPTION:
      'Reports are downloaded in CSV format by default and presented by columns - using commas to separate the data.\n You can choose a different separator.',

    reportsType: {
      DAILY: 'Daily',
      BY_SETTLEMENT: 'By settlement',
    },

    reportsFileType: {
      CSV: 'CSV',
      XLS: 'XLS',
    },

    filePreferences: {
      COMMA: 'Comma',
      PIPE: 'Pipe',
    },
    // Mass Invoices
    TITLE_INVOICES: 'Mass Invoice Reports',
    TABLE_HEADER_INVOICES_ID: 'Batch ID',
    TABLE_HEADER_INVOICES_NAME: 'Report Name',
    TABLE_HEADER_INVOICES_LINK: 'Link',
    TABLE_HEADER_INVOICES_STATUS: 'Status',
    TABLE_HEADER_INVOICES_TYPE: 'Type of file',
    TABLE_INVOICES_DOWNLOAD_LINK: 'Download',
    INVOICES_UPLOAD_CSV_BTN: 'Upload CSV',
    INVOICES_PROCESS_TAKES: 'This process takes ',
    INVOICES_ONCE_REPORT_IS_READY: 'you once the report is ready.',
    INVOICES_EMAIL_WILL_BE_SENT: 'your report. An email will be sent to',
    INVOICES_BE_PATIENT: 'Please be patient, We are preparing',
    INVOICES_PREPARE_REPORT: 'Preparing your report...',

    // Invoices Drilldown
    TITLE_DRILLDOWN: 'Mass Payments',
    TABLE_HEADER_DRILLDOWN_AMOUNT: 'Amount',
    TABLE_HEADER_DRILLDOWN_CURRENCY: 'Currency',
    TABLE_HEADER_DRILLDOWN_PAYMENT_METHOD_TYPE: 'Payment Method Type',
    TABLE_HEADER_DRILLDOWN_STATUS: 'Status',
    TABLE_HEADER_DRILLDOWN_ERROR_CODE: 'Error Code',
    TABLE_HEADER_DRILLDOWN_REDIRECT_URL: 'Redirect URL',
    TABLE_HEADER_DRILLDOWN_PAYCODE: 'Paycode',
    TABLE_HEADER_DRILLDOWN_PAYMENT_ID: 'Payment ID',
    DRILLDOWN_BTN_CLOSE: 'Close',
    DRILLDOWN_BTN_DOWNLOAD: 'Download',
    DOWNLOAD_ERROR_MESSAGE:
      'Something went wrong, please try again later.\nIf this problem persists, please contact Customer Support.',

    // EWallets
    TITLE_EWALLETS: 'Wallets',
    TITLE_CONTACT: 'Wallets contacts',
    TABLE_HEADER_EWALLET_ID: 'Wallet ID',
    TABLE_HEADER_EWALLET_CONTACT_ID: 'Contact ID',
    TABLE_HEADER_EWALLET_FULL_NAME: 'Full Name',
    TABLE_HEADER_EWALLET_FIRST_NAME: 'First name',
    TABLE_HEADER_EWALLET_LAST_NAME: 'Last name',
    TABLE_HEADER_EWALLET_SOURCE_WEALLET: 'Source Ewallet',
    TABLE_HEADER_DESTINATION_CARD: 'Source Card Number',
    TABLE_HEADER_CARD_TO_CARD_DESTINATION: 'Destination Card',
    TABLE_HEADER_EWALLET_PHONE_NUMBER: 'Phone Number',
    TABLE_HEADER_EWALLET_KYC: 'IDV Status',
    TABLE_HEADER_EWALLET_STATUS: 'Wallet Status',
    TABLE_HEADER_EWALLET_UPDATED_AT: 'Updated At',
    TABLE_HEADER_EWALLET_REFERENCE_ID: 'Reference ID',
    EWALLET_ID: 'ID',
    EWALLET_NAME: 'Name',
    EWALLET_FULL_NAME: 'Full Name',
    EWALLET_FIRST_NAME: 'First Name',
    EWALLET_LAST_NAME: 'Last Name',
    EWALLET_REFERENCE_ID: 'Reference ID',
    EWALLET_PHONE_NUMBER: 'Phone Number',
    EWALLET_IDV_STATUS: 'IDV Status',
    EWALLET_STATUS_ACTIVATE: 'Activate',
    EWALLET_STATUS_DEACTIVATE: 'Deactivate',
    EWALLET_DATE_UPDATED_AT: 'Updated At',
    EWALLET_UPDATED_AT: 'Updated At',
    EWALLET_CARDS: 'Cards',
    EWALLET_CARD_UPDATED: 'Card updated date',
    EWALLET_IBAN: 'IBAN',
    EWALLET_VIRTUAL_ACCOUNTS: 'Virtual Accounts',
    EWALLET_CARD_ADDED_DATE: 'Card added date',
    EWALLET_CARD_UPDATED_DATE: 'Card updated date',
    EWALLET_IBAN_ADDED_DATE: 'Bank added date',
    EWALLET_IBAN_UPDATED_DATE: 'Bank updated date',
    EWALLET_VIEW_CARDS: 'View cards',
    EWALLET_KYC: 'KYC',
    EWALLET_BALANCE: 'Balance',
    EWALLET_EWALLET_BALANCE: 'Wallet Balances',
    EWALLET_STATUS: 'Status',
    EWALLET_MAX_BALANCE: 'Balance',
    TABLE_HEADER_EWALLET_TYPE: 'Type',
    TABLE_HEADER_EWALLET_ACCOUNT_ID: 'Account ID',
    TABLE_HEADER_EWALLET_ACCOUNT_CURRENCY: 'Currency',
    TABLE_HEADER_EWALLET_ACCOUNT_BALANCE: 'Account Balance',
    TABLE_HEADER_EWALLET_ACCOUNT_DIRECTION: 'Is Negative Balance',
    TABLE_HEADER_EWALLET_ACCOUNT_ON_HOLD_BALANCE: 'On Hold Balance',
    TABLE_HEADER_EWALLET_ACCOUNT_RECEIVED_BALANCE: 'Received Balance',
    TABLE_HEADER_EWALLET_ACCOUNT_LIMIT: 'Limit',
    EWALLET_CATEGORY: 'Category',
    EWALLET_LAST_TRANSACTION: 'Last Transaction',
    EWALLET_CONTACTS: 'Wallet Contacts',
    EWALLET_CONTACTS_RBA: 'Account contacts',
    EWALLET_DOCUMENTS: 'Wallet Documents',

    // eWallet - contacts tab
    TABLE_HEADER_EWALLET_GENDER: 'Gender',
    TABLE_HEADER_EWALLET_MARITAL_STATUS: 'Marital status',
    TABLE_HEADER_EWALLET_HOUSE_TYPE: 'House type',
    TABLE_HEADER_EWALLET_CONTACT_TYPE: 'Contact type',
    TABLE_HEADER_EWALLET_EMAIL: 'Email',
    TABLE_HEADER_EWALLET_ID_TYPE: 'ID type',
    TABLE_HEADER_EWALLET_ID_NUM: 'ID number',
    TABLE_HEADER_EWALLET_DATE_OF_BIRTH: 'Date of birth',
    TABLE_HEADER_EWALLET_NATIONALITY: 'Nationality',
    TABLE_HEADER_EWALLET_ADDRESS: 'Address',
    TABLE_HEADER_EWALLET_CITY: 'City',
    TABLE_HEADER_EWALLET_STATE: 'State',
    TABLE_HEADER_EWALLET_ZIP: 'Zip',
    EWALLET_TYPE: 'Type',
    EWALLET_TYPE_CLIENT: 'Client',
    TRANSACTIONS: 'Transactions',
    ACTIVITY: 'Activity',
    NO_BALANCE_NO_ACCOUNTS_TEXT: 'No funds have been transferred to this wallet.',
    EWALLET_NO_TRANSACTIONS_TEXT: 'No transactions have been made by this wallet',
    EWALLET_NO_TRANSACTION_WITH_CREATE: 'You can easily create your first Payment!',
    UPLOAD_DOCUMENT: 'Upload Document',

    // eWallets - IDV Check
    TITLE_EWALLETS_IDV_CHECKS: 'IDV Checks',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_WALLET_ID: 'Wallet ID',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_CONTACT_ID: 'Contact ID',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_DATE_OF_CHECK: 'Date of Check',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_FIRST_NAME: 'First Name',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_LAST_NAME: 'Last Name',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_ISSUING_COUNTRY: 'Issuing Country',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_DATE_OF_BIRTH: 'Date of Birth',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_ID_NUMBER: 'ID Number',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_ID_TYPE: 'ID Type',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_ID_TYPE_NAME: 'ID Type Name',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_ID_VALIDITY: 'ID Valid',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_PHOTO_SIMILARITY: 'Photo Match',
    TABLE_HEADER_EWALLETS_IDV_CHECKS_GENDER: 'Gender',

    // IDV Checks SideMenu
    IDV_CHECKS_SIDE_MENU_HEADER: 'IDV Check',
    IDV_CHECKS_SIDE_MENU_NAME: 'preview_title',
    IDV_CHECKS_SIDE_MENU_DETAILS: 'IDV Details',
    IDV_CHECKS_SIDE_MENU_WALLET_ID: 'Wallet ID',
    IDV_CHECKS_SIDE_MENU_CONTACT_ID: 'Contact ID',
    IDV_CHECK_SIDE_MENU_DATE_OF_CHECK: 'Date of Check',
    IDV_CHECK_SIDE_MENU_FIRST_NAME: 'First Name',
    IDV_CHECK_SIDE_MENU_LAST_NAME: 'Last Name',
    IDV_CHECK_SIDE_MENU_ISSUING_COUNTRY: 'Issuing Country',
    IDV_CHECK_SIDE_MENU_DATE_OF_BIRTH: 'Date of Birth',
    IDV_CHECK_SIDE_MENU_ID_NUMBER: 'ID #',
    IDV_CHECK_SIDE_MENU_ID_TYPE: 'ID Type',
    IDV_CHECK_SIDE_MENU_ID_VALIDITY: 'ID Valid',
    IDV_CHECK_SIDE_MENU_ID_PHOTO_SIMILIARITY: 'Photo Match',
    IDV_CHECKS_SIDE_MENU_RESULTS: 'Results',
    IDV_CHECKS_SIDE_MENU_FILES: 'Files',
    IDV_CHECKS_SIDE_MENU_DOCUMENTS: 'Documents',
    IDV_CHECK_SIDE_MENU_GENDER: 'Gender',
    IDV_CHECK_SIDE_MENU_SUCCESS: 'Success',
    IDV_CHECK_SIDE_MENU_VIEW: 'View',
    IDV_CHECK_SIDE_MENU_SELFIE: 'Selfie',
    IDV_CHECK_SIDE_MENU_DOCUMENT_FRONT: 'Document Front',
    IDV_CHECK_SIDE_MENU_DOCUMENT_BACK: 'Document Back',
    IDV_CHECK_SIDE_MENU_DOCUMENTS: 'Documents',

    // eWallets - all contacts
    TITLE_CONTACTS: 'Contacts',
    TABLE_HEADER_CONTACT_ID: 'Contact ID',
    TABLE_HEADER_CONTACT_FULL_NAME: 'Full Name',
    TABLE_HEADER_CONTACT_FIRST_NAME: 'First Name',
    TABLE_HEADER_CONTACT_LAST_NAME: 'Last Name',
    TABLE_HEADER_CONTACT_TYPE: 'Contact Type',
    TABLE_HEADER_CONTACT_CREATED_AT: 'Created At',
    TABLE_HEADER_CONTACT_COUNTRY: 'Country',
    TABLE_HEADER_CONTACT_DATE_OF_BIRTH: 'Date of Birth',
    TABLE_HEADER_CONTACT_EMAIL: 'Email',
    TABLE_HEADER_CONTACT_WALLET_ID: 'Wallet ID',
    TABLE_HEADER_CONTACT_GENDER: 'Gender',
    TABLE_HEADER_CONTACT_IDENTIFICATION_TYPE: 'Identification Type',
    TABLE_HEADER_CONTACT_IDENTIFICATION_NUMBER: 'Identification Number',
    TABLE_HEADER_CONTACT_PHONE_NUMBER: 'Phone Number',
    TABLE_HEADER_CONTACT_IDV_STATUS: 'IDV Status',
    TABLE_HEADER_CONTACT_COMPLIANCE_PROFILE: 'Compliance Profile',

    // Account Details - Bank Accounts
    TABLE_HEADER_BANK_ACCOUNTS_TITLE: 'Bank Account',
    TABLE_HEADER_BANK_ACCOUNTS_BANK_NAME: 'Bank Name',
    TABLE_HEADER_BANK_ACCOUNT_IDENTIFIER: 'Account Identifier',
    TABLE_HEADER_BANK_ACCOUNTS_ACCOUNT_NUMBER: 'Bank Account Number',
    TABLE_HEADER_BANK_ACCOUNTS_CURRENCY: 'Currency',
    TABLE_HEADER_BANK_ACCOUNTS_COUNTRY: 'Country',
    TABLE_HEADER_BANK_ACCOUNTS_SETTLEMENT_FREQUENCY: 'Settlement Frequency',
    TABLE_HEADER_BANK_ACCOUNTS_MIN_SETTLEMENT_AMOUNT: 'Min. Settlement Amount',
    TABLE_HEADER_BANK_ACCOUNTS_STATIC_REFERENCE_ID: 'Reference ID',
    REF_ID_IS_IRREVERSIBLE: 'Ref ID is irreversible',
    STATIC_REFERENCE_ID_INVALID_LENGTH: 'Reference ID must be between 3 and 45 characters',
    TABLE_HEADER_BANK_ACCOUNTS_EWALLET_TOKEN: 'Ewallet token',

    // Card Tokenization Links
    TABLE_HEADER_CARD_TOKENIZATION_LINK_ID: 'ID',
    SUGGESTION_CARD_TOKENIZATION_LINK_ID: 'ID of the Hosted Page Card Token',
    SUGGESTION_CARD_TOKENIZATION_LINK_CUSTOMER_NAME: 'Name of the customer',
    SUGGESTION_CARD_TOKENIZATION_LINK_CUSTOMER_ID: 'ID of the customer',

    // Payment Links
    TABLE_HEADER_PAYMENT_LINKS_REFERENCE_ID: 'Reference ID',
    TABLE_HEADER_PAYMENT_LINKS_AMOUNT_IS_EDITABLE: 'Amount Is Editable',
    TABLE_HEADER_PAYMENT_LINKS_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_PAYMENT_LINKS_CREATED_AT: 'Created At',
    TABLE_HEADER_PAYMENT_LINKS_AMOUNT: 'Amount',
    TABLE_HEADER_PAYMENT_LINKS_CURRENCY: 'Currency',
    TABLE_HEADER_PAYMENT_LINKS_COUNTRY: 'Country',
    TABLE_HEADER_PAYMENT_LINKS_URL: 'Payment Link',

    // Payment Links Sidemenu
    PAYMENT_LINK_SIDEMENU_TITLE: 'Payment Link',
    PAYMENT_LINK_SIDEMENU_DESC: 'A payment link was created on {{createdAt}}',
    PAYMENT_LINK_SIDEMENU_DETAILS: 'Payment Link Details',
    PAYMENT_LINK_SIDEMENU_LANGUAGE: 'Language',
    PAYMENT_LINK_SIDEMENU_EXPIRATION: 'Expiration Date',
    PAYMENT_LINK_SIDEMENU_AMOUNT_PREFERENCE: 'Amount Preference',
    PAYMENT_LINK_SIDEMENU_OPEN_AMOUNT: 'Open Amount',
    PAYMENT_LINK_SIDEMENU_SET_AMOUNT: 'Set Amount',

    //Payment Links details page
    PAYMENT_LINK_DETAILS_PAGE_SUMMARY: 'A payment link was created on {{date}}',
    PAYMENT_LINK_DETAILS_PAGE_TOTAL_COLLECTED_AMOUNT: 'Total Collected Amount',

    PAYMENT_LINK_DETAILS_PAGE_CREATED_AT: 'Created At',
    PAYMENT_LINK_DETAILS_PAGE_STATUS: 'Status',
    PAYMENT_LINK_DETAILS_PAGE_AMOUNT_PREFERENCE: 'Amount Preference',
    PAYMENT_LINK_DETAILS_PAGE_AMOUNT_PREFERENCE_SET_AMOUNT: 'Set Amount',
    PAYMENT_LINK_DETAILS_PAGE_OPEN_AMOUNT: 'Open Amount',
    PAYMENT_LINK_DETAILS_PAGE_AMOUNT: 'Amount',
    PAYMENT_LINK_DETAILS_PAGE_CURRENCY: 'Currency',
    PAYMENT_LINK_DETAILS_PAGE_COUNTRY: 'Country',
    PAYMENT_LINK_DETAILS_PAGE_PAYMENT_CATEGORY: 'Payment Category',
    PAYMENT_LINK_DETAILS_PAGE_PAYMENT_METHOD: 'Payment Method',
    PAYMENT_LINK_DETAILS_PAGE_PAYMENT_DESCRIPTION: 'Payment Description',
    PAYMENT_LINK_DETAILS_PAGE_MERCHANT_EXPIRATION_DATE: 'Expiration Date',
    PAYMENT_LINK_DETAILS_PAGE_MERCHANT_REFERENCE_ID: 'Merchant Reference ID',
    PAYMENT_LINK_DETAILS_PAGE_PAYMENT_LINK_DETAILS: 'Payment Link Details',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_DETAILS: 'Customer Details',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_ID: 'Customer ID',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_FULL_NAME: 'Full Name',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_EMAIL: 'Email',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_COUNTRY: 'Country',
    PAYMENT_LINK_DETAILS_PAGE_CUSTOMER_PHONE: 'Phone Number',
    PAYMENT_LINK_DETAILS_VIEW_QR_CODE: 'View QR Code',

    // Products
    PRODUCT_ID: 'Product ID',
    SHIPPABLE: 'Shippable',
    SUGGESTION_PRODUCT_ID: 'Rapyd generated Product Identifier',
    SUGGESTION_PRODUCT_GENERAL: 'As defined by the user',
    PRODUCT_DETAILS: 'Product Details',
    PRODUCT_NAME: 'Product Name',
    IMAGES: 'Images',
    INACTIVE: 'Inactive',
    DIMENSIONS: 'Dimensions',
    HEIGHT: 'Height',
    WIDTH: 'Width',
    LENGTH: 'Length',
    WEIGHT: 'Weight',
    UNIT_LABEL: 'Unit Label',
    YES: 'Yes',
    NO: 'No',
    PRODUCT_SIDE_MENU_HEIGHT: 'Height:',
    PRODUCT_SIDE_MENU_WIDTH: 'Width:',
    PRODUCT_SIDE_MENU_LENGTH: 'Length:',
    PRODUCT_SIDE_MENU_WEIGHT: 'Weight:',
    DELETE_PRODUCT: 'Delete Product',
    DELETE_PRODUCT_MESSAGE: 'Are you sure you want to delete this product?',
    DELETE_PRODUCT_FAILURE_MESSAGE:
      'There was an error deleting {{id}}, {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    DELETE_PRODUCT_SUCCESS_MESSAGE: 'The product {{id}}, {{name}} was successfully deleted',
    CHECKOUT_PAGE_NOT_SUPPORTED:
      'Currently, only single plan, fixed price subscriptions are supported by   payment pages.',
    CANCEL_SUBSCRIPTION_SUCCESS_MESSAGE:
      'The Subscription {{id}}, {{name}} was successfully canceled',
    CREATE_PRODUCT: 'Create Product',
    CREATE_PRODUCT_TITLE: 'Create New Product',
    CREATE_PRODUCT_SUB_TITLE: 'Define the characteristics of the product',
    CREATE_PRODUCT_DROP_YOUR_IMAGES: 'Drop your images here',
    CREATE_PRODUCT_MAX_IMAGES_TO_UPLOAD: 'Up to 3 images',
    CREATE_PRODUCT_FAILURE_MESSAGE:
      'There was an error creating {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    CREATE_PRODUCT_SUCCESS_MESSAGE: 'The product {{name}} was successfully created',
    CREATE_PRODUCT_ERROR_UPLOADING_IMAGE_MESSAGE: '*One or more of the files could not be uploaded',
    TOOLTIP_CUSTOMER_STATEMENT_DESCRIPTION:
      "The customer's statement description. Limited to 22 characters.",
    EDIT_PRODUCT: 'Edit Product',
    UPDATE_PRODUCT_SUCCESS_MESSAGE: 'The product {{id}}, {{name}} was successfully updated',
    ACTIVATE_PRODUCT_SUCCESS_MESSAGE: 'The product {{id}}, {{name}} was successfully activated',
    DEACTIVATE_PRODUCT_SUCCESS_MESSAGE: 'The product {{id}}, {{name}} was successfully deactivated',
    UPDATE_PRODUCT_FAILURE_MESSAGE:
      'There was an error updating {{id}}, {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    ACTIVATE_PRODUCT_FAILURE_MESSAGE:
      'There was an error activating {{id}}, {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    DEACTIVATE_PRODUCT_FAILURE_MESSAGE:
      'There was an error deactivating {{id}}, {{name}}. Please try again, if this problem persists, <0>contact support</0>',
    ACTIVATE_PRODUCT: 'Activate Product',
    DEACTIVATE_PRODUCT: 'Deactivate Product',
    ACTIVATE_PRODUCT_BODY: 'Are you sure you want to activate this product?',
    DEACTIVATE_PRODUCT_BODY: 'Are you sure you want to deactivate this product?',
    productTypes: {
      services: 'Services',
      goods: 'Goods',
    },
    CREATE_NEW_PRODUCT: 'Create New Product',
    CREATE_ACCOUNT: 'Create Account',
    ASSOCIATED_PLANS: 'Associated Plans',
    PRODUCT_SIDE_MENU_NO_PLANS: 'No Associated Plans',
    CREATE_PRODUCT_WRONG_FILE_TYPE_MESSAGE:
      'File not supported, try type .jpg, .jpeg, .png, .gif, .webp instead.',

    // Plans
    CREATE_PLAN_TITLE: 'Create a Pricing Plan',
    CREATE_PLAN_DESCRIPTION: 'To create a new pricing plan select one of the plan types below',
    CREATE_PLAN: 'Create Plan',
    CREATE_SPECIFIC_PLAN: 'Create {{type}} Plan',
    PLAN_NAME: 'Plan Name',
    PRICE: 'Price',
    BILLING_PERIOD: 'Billing Period',
    FREE_TRIAL_OPTIONAL: 'Free Trial (Optional)',
    planType: {
      netflix: 'Fixed Price',
      kvish_6: 'Pay-As-You-Go',
      aws: 'Simple Tiered',
      water_bill: 'Graduated Tiered Pricing',
    },
    DAYS: 'Days',
    planInterval: {
      day: 'Daily',
      week: 'Weekly',
      month: 'Monthly',
      year: 'Yearly',
    },
    PER: 'Per',
    roundTypes: {
      up: 'Up',
      down: 'Down',
    },
    ROUND: 'Round',
    TIER_NUMBER: 'Tier Number',
    FIRST_UNIT: 'First Unit',
    LAST_UNIT: 'Last Unit',
    PER_UNIT: 'Per Unit',
    TIER: 'Tier',
    TIER_PAYMENT_DESCRIPTION: 'based on plan tiers charged {{interval}}',
    TIERS: 'Tiers',
    ADD_NEW_TIER: 'Add New Tier',
    DELETE_TIER: 'Delete Tier',
    NETFLIX_TOOLTIP: 'A flat fee charged on a weekly, monthly or yearly basis',
    KVISH_6_TOOLTIP: 'Charge a simple per-unit or per user cost',
    AWS_TOOLTIP:
      'Usage based pricing with tiers, charge the same price for each unit based on the total number of units',
    WATER_BILL_TOOLTIP: 'Usage based pricing with tiers, charge a different price for some units',
    PLAN_ERROR_MUST_BE_BIGGER_THAN: 'Last unit must be bigger than first unit',
    UNITS: 'Units',
    UNIT: 'Unit',
    PLAN_ID: 'Plan ID',
    CREATE_PLAN_FAILURE_MESSAGE:
      'There was an error creating the plan. Please try again, if this problem persists, <0>contact support</0>',
    CREATE_PLAN_SUCCESS_MESSAGE:
      'The plan was successfully created. It can now be added to a subscription',
    CREATE_SUBSCRIPTION_SUCCESS_MESSAGE: 'The Subscription was successfully created',
    CHOOSE_PRICING_PLAN_TITLE: 'Choose a Pricing Plan',
    CHOOSE_PRICING_PLAN_BODY:
      'You can select multiple pricing plans if they use the same currency, interval and trial period',
    TIERED_PRICING: 'Tiered Pricing',
    CREATE_PLAN_DISCLAIMER: 'Please note this plan requires using our <0>Usage Record API<0>',
    CREATE_PLAN_USAGE_RECORD_API: 'Usage Record API',
    planExample: {
      price: {
        fixed: 'XX.XX',
        range: 'XX.XX-XX.XX',
      },
      currency: 'USD',
      usage: {
        interval: 'Per Interval',
        use: 'Per Use',
        uses: 'Per X Uses',
        firstUses: 'For the First XX Uses',
      },
      nickname: {
        fixed: 'Charge a Flat Rate Per Subscription, License or Membership',
        perUse: 'Charge a Flat Rate Per-Unit or per Use',
        perUses:
          'Charge a Rate That Changes Dynamically Based on the Total Number of Units or Uses',
        perTier: 'Charge a Different Rate for Uses Based on Their Tier',
      },
      checkListElement: {
        timePeriods: 'Pay Weekly, Monthly or Yearly',
        fixedRate: 'Fixed Rate',
        trial: 'Option for a Trial',
        perUse: 'Price per Use Or # Of Uses',
        pricingTiers: 'Define Pricing Tiers',
        sameRate: 'All Units Charged the Same Rate',
        differentRate: 'Units May be Charged a Different Rate',
      },
    },

    // Create Invoices
    CREATE_MASS_INVOICE: 'Create Mass Payments',
    UPLOAD_A_CSV_FILE: 'Upload CSV file',
    SELECT_PLAYMENT_TYPE: 'Select payment type',
    WITH_A_PRESENT_FORMAT: 'For the format, see ',
    SELECT_THE_PREFERRED: 'Select the preferred',
    PAYMENT_TYPE: 'payment type',
    PAYMENT_TYPE_EXAMPLE: '(URL, Code, etc.)',
    RECEIVE_A_NOTIFICATION: 'Receive a notification',
    EMAIL_FILE_IS: 'email that the file is',
    READY: 'ready',
    SIGN_IN_TO_PORTAL: 'Sign in to the portal',
    AND_DOWNLOAD: 'and download',
    YOUR_REPORT: 'your report',
    PAYMENT: 'Payment',
    CHECKOUT: 'Checkout',
    SELECT_PAYMENT_TYPE_DROPDOWN: 'Select...',
    START_UPLOAD: 'Start Upload',
    CREATE_INVOICES_CANCEL: 'Cancel',
    FILE_UPLOAD_MASS_INVOICE: 'To upload a file, drag it here or browse.',
    FILE_UPLOAD_MASS_PAYOUT: 'To upload files, drag them here or browse.',
    FILE_UPLOAD_MULTIPLE: 'Upload up to 50 files',
    BROWSE: 'browse',
    FILE_SIZE_ERROR: 'File is too large',
    INVLID_FILE_TYPE: 'Invalid file type',
    UPLOAD_SERVER_ERROR: 'Invalid parameters or file structure',
    SAMPLE_FILE: 'Sample File',
    PAYMENT_METHOD_TYPE: 'Payment Method Type',
    HOSTED_PAGE: 'Hosted Page',
    PAY_VIA: 'Pay via',
    ERROR_DOWNLOADING_SAMPLE_FILE_HEADER: 'Error Downloading Sample File',
    ERROR_DOWNLOADING_SAMPLE_FILE_MESSAGE:
      'There was an error downloading the sample file you selected. Please try again, If the problem persists, please <0>contact support</0>..',
    ERROR_NO_PAYMENT_METHDOS:
      'Country and Currency combination is not supported by any of your payment method types.  To add payment method types <0>contact support</0>.',

    SANDBOX_UPLOAD_LIMIT: '*Sandbox environment supports the upload of files of up to 10 rows',
    RESET_YOUR_PASSWORD: 'Reset Your Password',
    HOW_RESET_PASSWORD: 'How would you like to reset your password?',
    RESET_PASSWORD_WITH_PHONE: 'Reset your password using phone number',
    RESET_PASSWORD_WITH_EMAIL: 'Reset your password using email address',
    SETUP_NEW_PASSWORD: 'Setup New Password',
    LETS_START: `Let's Start`,

    // Invoices Finish
    INVOICES_FINISH_TITLE: 'finish',
    INVOICES_FINISH_COMPLETE: 'Upload Complete',
    INVOICES_FINISH_PREPARING_FILES:
      'We are preparing your files, please be patient. You will receive ',
    INVOICES_FINISH_EMAIL_LINK: 'an email containing a link to the file in the next 15 minutes',
    INVOICES_FINISH_BACK_HOME: 'Back home',

    // Payouts Finish
    PAYOUTS_FINISH_TITLE: 'Create Mass payouts',
    PAYOUTS_FINISH_COMPLETE: 'Upload Complete',
    PAYOUTS_FINISH_PREPARING_FILES: 'Your payouts are currently being processed',
    PAYOUTS_FINISH_EMAIL_LINK: 'you will be notified via email when the file is ready to download',
    PAYOUTS_FINISH_BACK_HOME: 'Back home',
    PAYOUTS_FINISH:
      'Your payouts are being processed. When the summary is ready for download, you will receive an email.',

    // Download File
    TITLE_FILE_DOWNLOAD: 'File Download',
    WAIT_WHILE_PREPARING: 'Please wait while we prepare your files for download...',
    GO_TO_PORTAL: 'Go to portal',
    BENEFICIARY: 'Beneficiary',
    SENDER: 'Sender',
    PAYOUT: 'Payout',
    DOWNLOAD_PAYOUT_PROOF_PDF: 'Download Proof Of Payout',
    SELECT_CATEGORY: 'Select Category',
    BENEFICIARY_FIELDS: 'Beneficiary Fields',
    SENDER_FIELDS: 'Sender Fields',
    PAYOUT_FIELDS: 'Payout Fields',
    CHOOSE_SAMPLE_FILE: 'Choose Sample File',
    SELECTED_SAMPLE_FILES: 'Selected Sample Files',
    NO_SAMPLE_FILES: 'No sample files selected for download',

    // Download faild
    DOWNLOAD_EXPIRED: 'Your download link has expired',
    DOWNLOAD_EXPIRED_TEXT:
      'You will need to go back to the client portal, and export the data again.',
    DOWNLOAD_FAILED: 'Something went wrong',
    DOWNLOAD_FAILED_TEXT:
      'Please try downloading the file again. If the problem persists, you will need to try and export the data again.',
    BACK_TO_PORTAL: 'Back to Portal',

    // Invitation password expired
    INVITATION_PASSWORD_EXPIRED: 'Link expired',
    INVITATION_PASSWORD_EXPIRED_BTN: 'Back home',
    INVITATION_PASSWORD_EXPIRED_TEXT:
      'Your password reset link has expired. Please go to the sign in page to reset your password.',

    //  Method types
    METHOD_TYPES: {
      COLUMN_EXPLANATIONS: {
        IS_CANCELABLE:
          'Indicates whether a payment made with this payment method can be canceled. Response only.',
        IS_EXPIRABLE:
          'Indicates whether the merchant can set an expiration time for the customer to complete the payment. Response only.',
        IS_ONLINE: 'Indicates whether the payment is completed immediately online. Response only.',
        IS_REFUNDABLE: 'Indicates whether the payment method type supports refunds.',
      },
      CARD_VIEW: 'Card view',
      TABLE_VIEW: 'Table view',
      PAYMENT_GRID_VIEW_HEADER: 'Tell us where and how do you want to collect funds?',
      PAYMENT_TABLE_VIEW_HEADER:
        'The following payment methods may require additional details or documents in order to activate them. request any of the payment method categories by clicking the ‘Request Access’ button.',
      PAYOUT_GRID_VIEW_HEADER: 'Tell us where and how do you want to disburse funds?',
      PAYOUT_TABLE_VIEW_HEADER:
        'These payout methods are active and can be used for disbursing funds.',
      SUPPORTED_CATEGORIES: 'Supported Categories',
      UNSUPPORTED_CATEGORY: 'Category not currently supported in selected country',
      WORLD_WIDE_CREDIT_CARD_PMT_SUPPORT:
        'Visa and Mastercard are accepted worldwide.  See below for local card providers.',
      DISABLED_PAYMENT: 'Disabled payment will not appear in the checkout',
      SELECT_PAYMENTS_METHOD_TYPES: 'Select where and how do you want to collect funds',
      ACTIVATE_PAYMENT_METHOD: 'Activate payment method',
      ACTIVATE_PAYMENT_METHOD_CONFIRMATION:
        'Are you sure you want to activate this payment method?',
      DISABLE_PAYMENT_METHOD: 'Disable payment method',
      DISABLE_PAYMENT_METHOD_CONFIRMATION: 'Are you sure you want to disable this payment method?',
      DISABLED_CATEGORY: 'Category not currently supported in selected countries',
      PAYMENT_CATEGORY_NOT_SUPPORTED: 'There are no payment methods related to the search criteria',
      PAYOUT_CATEGORY_NOT_SUPPORTED: 'There are no payouts methods related to the search criteria',
    },

    // Payments Details

    PAYMENT_DETAILS_ID: 'Payment ID',
    PAYMENT_DETAILS_AMOUNT: 'Paid Amount',
    PAYMENT_DETAILS_ORIGINAL_AMOUNT: 'Requested Amount: {{amount}}',
    PAYMENT_DETAILS_METHOD_TYPE_CATEGORY: 'Category: {{type}}',
    PAYMENT_DETAILS_FX_RATE: 'Exchange Rate',
    PAYMENT_DETAILS_REQUESTED_AMOUNT: 'Received Amount',
    PAYMENT_DETAILS_REQUESTED_AMOUNT_TOOLTIP:
      'The amount and currency added to your balance, minus any fees and after currency exchange',
    PAYMENT_DETAILS_STATUS: 'Status',
    PAYMENT_DETAILS_MERCHANT_REF_ID: 'Merchant Ref ID',
    PAYMENT_DETAILS_REFUNDED_AMOUNT: 'Refunded Amount',
    PAYMENT_DETAILS_PAYMENT_METHOD: 'Payment Method Type',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE: 'Payment Initiation Type',
    PAYMENT_DETAILS_TRACE_NUMBER: 'Trace Number',
    PAYMENT_DETAILS_PAYMENT_METHOD_TYPE_CATEGORY: 'Category',
    PAYMENT_DETAILS_PAID_AT_DATE: 'Paid At',
    PAYMENT_DETAILS_EXPIRATION_DATE: 'Expired At',
    PAYMENT_DETAILS_DATE: 'Date Created',
    PAYMENT_DETAILS_PERSONAL_DETAILS: 'Payment Details',
    PAYMENT_CHOOSE_COLUMNS_TOOLTIP: 'Choose Columns',
    PAYMENT_CREATE_PAYMENT_TOOLTIP: 'Create Payment',
    PAYMENT_DETAILS_FAILURE_MESSAGE: 'Failure Reason',
    PAYMENT_DETAILS_FEE: 'Total Fees',
    PAYMENT_DETAILS_FLOW_TYPE: 'Flow Type',
    PAYMENT_DETAILS_METADATA: 'Metadata',
    PAYMENT_DETAILS_REFUNDED: 'Refunded',
    PAYMENT_DETAILS_PAYER_DETAILS: 'Payer Details',
    PAYMENT_DETAILS_CUSTOMER_ID: 'Customer ID',
    PAYMENT_DETAILS_CUSTOMER_NAME: 'Name',
    PAYMENT_DETAILS_CUSTOMER_PHONE: 'Phone Number',
    PAYMENT_DETAILS_CUSTOMER_ADDRESS: 'Address',
    PAYMENT_DETAILS_CUSTOMER_EMAIL: 'Email',
    PAYMENT_DETAILS_CUSTOMER_DESCRIPTION: 'Description',
    PAYMENT_DETAILS_CUSTOMER_DEFAULT_PAYMENT_METHOD: 'Default Payment Method',
    PAYMENT_DETAILS_DEFAULT_DESCRIPTION: 'This payment is currently in status - {{status}}',
    PAYMENT_DETAILS_CANCEL_PAYMENT: 'Cancel Payment',
    PAYMENT_DETAILS_NO_CUSTOMER_INFO: 'Customer information is not available.',
    PAYMENT_DETAILS_VIEW_PAYCODE: 'View',
    PAYMENT_DETAILS_PAYCODE: 'Paycode',
    PAYMENT_DETAILS_HISTORY: 'History',
    PAYMENT_DETAILS_HISTORY_VIEW_RULE: 'View Rule',
    PAYMENT_DETAILS_HISTORY_COMMENT: 'Comment: {{comment}}',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE_CUSTOMER_PRESENT: 'Customer Present',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE_RECURRING: 'Recurring',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE_INSTALLMENT: 'Installment',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE_UNSCHEDULED: 'Unscheduled',
    PAYMENT_DETAILS_PAYMENT_INITIATION_TYPE_MOTO: 'Moto',
    PAYMENT_DETAILS_EWALLET: 'Ewallet',
    PAYMENT_DETAILS_EWALLETS: 'Ewallets',
    PAYMENT_DETAILS_CARD_BIN: 'Card BIN',
    PAYMENT_DETAILS_CARD_COUNTRY: 'Card Country',
    PAYMENT_DETAILS_CARD_TYPE: 'Card Type',
    PAYMENT_DETAILS_CARD_EXPIRATION_DATE: 'Card Expiration Date',
    PAYMENT_DETAILS_CUSTOMER_DETAILS: 'Customer Details',
    PAYMENT_DETAILS_ERROR_DETAILS: 'Transaction Error Details',
    PAYMENT_DISPUTE_DETAILS_ORIGINAL_AMOUNT: 'Transaction Amount: {{amount}}',
    PAYMENT_DISPUTE_SUBMIT_EVIDENCE: 'Submit Evidence',
    PAYMENT_DISPUTE_APPROVE_DISPUTE: 'Approve Dispute',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_TITLE: 'Accept Dispute',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_BODY:
      'Are you sure you want to approve this disputed transaction: \n {{disputeToken}} \n This action cannot be reversed.',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_MESSAGE_TITLE: 'Dispute accept Request Approved',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_MESSAGE_BODY: 'The Dispute has been approved',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_MESSAGE_TITLE_ERROR: 'Dispute accept Request Failed',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_MESSAGE_BODY_ERROR: 'The Dispute not been Accepted',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_MESSAGE_HEAD_TITLE: 'Submit Evidence',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_SUBMIT_EVIDENCE_TITLE: 'Continue on desktop',
    PAYMENT_DISPUTE_APPROVE_DISPUTE_SUBMIT_EVIDENCE_BODY:
      'Our mobile version does not support submitting dispute evidence. \n Please submit it on the desktop version.',

    PAYMENT_UNDER_REVIEW_UPDATE_MESSAGE_TITLE: 'Transaction update Request Approved',
    PAYMENT_UNDER_REVIEW_UPDATE_MESSAGE_BODY: 'The Transaction status has been changed',
    PAYMENT_UNDER_REVIEW_UPDATE_MESSAGE_TITLE_ERROR: 'Transaction update Request Failed',
    PAYMENT_UNDER_REVIEW_UPDATE_MESSAGE_BODY_ERROR: 'The Transaction status has not been changed',

    HIDE_CREDENTIALS: 'Hide Credentials',
    SHOW_CREDENTIALS: 'Show Credentials',
    CANCEL_PAYMENT_TOAST_TITLE: 'Cancel Payment Request Approved',
    CANCEL_PAYMENT_TOAST_BODY: 'The Payment has been Canceled',
    CANCEL_PAYMENT_FAILED_TITLE: 'Cancel Payment Request Failed',
    CANCEL_PAYMENT_FAILED_BODY: 'The Payment not been Canceled',

    transactionHistory: {
      reason: 'The {{type}} was approved and created. Reason: {{reason}}',
      inReview: 'The {{type}} was placed in review by Rapyd Protect. ',
      approvedRP: 'The {{type}} was approved by Rapyd Protect.',
      approved: 'The {{type}} was approved and created.',
      threeDSRequired: 'The {{type}} was required to complete 3D Secure authorization.',
    },

    // Payment Side Menu
    PAYMENT_DETAILS: 'Payment Details',
    PAYMENT_DISPUTED: 'Disputed',
    PRE_DISPUTED: 'Pre-Disputed',

    PAYMENT_METHOD_NOT_REFUNDABLE: "Payment method doesn't support refunds",

    PAYMENT_SIDE_MENU_ACTIVE: `A {{payment_method_type_category}} payment request was sent to {{customer_name}} `,
    PAYMENT_SIDE_MENU_CLOSED: {
      withCustomerName: `A {{payment_method_type_category}} payment was made by {{customer_name}}`,
      withoutCustomerName: `A {{payment_method_type_category}} payment was made`,
    },
    PAYMENT_SIDE_MENU_CANCELLED: `The {{payment_method_type_category}} payment request that was sent to {{customer_name}} was cancelled`,
    PAYMENT_SIDE_MENU_ERROR: 'There was an error completing the payment request',
    PAYMENT_SIDE_MENU_EXPIRED: '',
    PAYMENT_SIDE_MENU_ACTIVE_NOT_CAPTURED: `A {{payment_method_type_category}} authorization was created for {{customer_name}} `,

    PAYMENT_SIDE_MENU_REJECTED: `The {{type}} payout to {{beneficiary_full_name}} that was made by {{payer_full_name}} was rejected`,

    PAYMENT_SIDE_MENU_IN_PROGRESS: `The {{type}} payout to {{beneficiary_full_name}} that was made by {{payer_full_name}} is currently in progress, it should created soon`,
    PAYMENT_SIDE_MENU_PENDING: `The {{type}} payout that was made by {{payer_full_name}} was created, but the funds have not yet been transferred to {{beneficiary_full_name}}`,

    PAYMENT_SIDE_MENU_CANCEL_PAYMENT: 'Cancel Payment',
    PAYMENT_SIDE_MENU_COMPLETE_PAYMENT: 'Complete Payment',
    PAYMENT_SIDE_MENU_REFUND: 'Create Refund',
    PAYMENT_SIDE_MENU_CAPTURE_PAYMENT: 'Capture Payment',
    PAYMENT_SIDE_MENU_DETAILS: 'See all details',
    PAYMENT_UNKNOWN_CUSTOMER: 'an unknown customer',
    PAYOUT_COMPLETED_SUCCESS_MODAL_HEADER: 'Payout Completed',
    PAYOUT_COMPLETED_SUCCESS_MODAL_MESSAGE: '{{id}} has been completed',
    PAYOUT_COMPLETED_ERROR_MODAL_HEADER: 'Error Completing Payout',
    RELEASE_FUNDS_ERROR_MODAL_HEADER: 'Error Releasing Funds',
    RELEASE_FUNDS_SUCCESS_MODAL_HEADER: 'Funds Released',
    RELEASE_FUNDS_SUCCESS_MODAL_MESSAGE:
      '{{release_amount}} {{currency}} were released from: <br/> {{id}}',
    PAYOUT_COMPLETED_ERROR_MODAL_MESSAGE:
      'We were unable to Close the payout. Please try again.<br/>If you get this error again, please <0>contact support</0>',
    PAYOUT_COMPLETED_AUDIT_DESCRIPTION: 'The user manually completed a payout through the portal',
    PAYMENT_SIDE_MENU_CHANGE_PAYMENT_STATUS: 'Change Status',
    PAYMENT_SIDE_MENU_REVERSE_PAYMENT: 'Reverse Payment',
    PAYOUT_REJECTED_SUCCESS_MODAL_HEADER: 'Payout Rejected',
    PAYOUT_REJECTED_SUCCESS_MODAL_MESSAGE: '{{id}} has been rejected',
    PAYOUT_SIDE_MENU_CHANGE_PAYOUT_STATUS: 'Change Status',
    PAYOUT_SIDE_MENU_REJECT_PAYOUT: 'Reject Payout',

    // Change Payment Status Modal
    CHANGE_PAYMENT_STATUS_MODAL_HEADER: 'Change Status',
    CHANGE_PAYMENT_STATUS_MODAL_REJECT: 'Reject',
    CHANGE_PAYMENT_STATUS_MODAL_CANCEL: 'Cancel',
    CHANGE_PAYMENT_STATUS_MODAL_COMPLETE: 'Complete',

    // Change Payout Status Modal
    CHANGE_PAYOUT_STATUS_MODAL_HEADER: 'Change Status',
    CHANGE_PAYOUT_STATUS_MODAL_COMPLETE: 'Complete',
    CHANGE_PAYOUT_STATUS_MODAL_CANCEL: 'Cancel',
    CHANGE_PAYOUT_STATUS_MODAL_REJECT: 'Reject',

    // Webhook Events
    WEBHOOK_URL: 'http://www.exampleurl.com',
    WEBHOOK_URL_INVALID: 'Invalid URL format',

    // Google pay
    GOOGLE_PAY: {
      HEADER: 'Google Pay',
      SUB_HEADER: 'Activate Google Pay in Rapyd Checkout:',
    },

    createPayout: {
      backNavigationModalHeader: 'Return to a previous step?',
      backNavigationModalDescription:
        'Making changes to the previous steps will delete any current progress.',
      backNavigationModalConfirmButton: 'Go back a step',
      backNavigationModalCancelButton: 'Cancel',

      noPayoutMethodsModalHeader: 'No payout methods are available.',
      noPayoutMethodsModalDescription:
        "We're sorry, but there are no payout methods available with the options you selected. Please review your preferences and try a different combination.",
      noPayoutMethodsModalConfirmButton: 'Modify Selection',

      senderDetails: 'Sender details',
      senderId: 'Sender ID',
      senderName: 'Sender name',
      senderCountry: 'Sender country',
      senderCurrency: 'Sender currency',
      senderEntityType: 'Sender entity type',
      additionalDetails: 'Additional details',

      beneficiaryDetails: 'Beneficiary details',
      beneficiaryId: 'Beneficiary ID',
      beneficiaryName: 'Beneficiary name',
      beneficiaryCountry: 'Beneficiary country',
      beneficiaryEntityType: 'Beneficiary entity type',

      ewalletProvider: 'eWallet provider',
      walletId: 'Wallet ID',

      recreatePayout: 'Recreate payout',
      payoutSuccessModalHeader: 'Your payout was successfully created.',
      payoutId: 'Payout ID',
      payoutFailureModalHeader: 'Error completing payout',
      payoutValueIsHigherThanBalance: 'Payout value is higher than available balance',

      // New create payout flow
      oldVersionText: 'Our new create payouts is here! For the classic version',
      oldVersionLink: 'Click here',
      title: 'Create payout',
      nextButton: 'Next',
      submitForApproval: 'Submit for approval',
      submitButton: 'Create payout',
      backButton: 'Back',
      tabs: {
        payoutDetails: 'Payout details',
        payoutMethod: 'Payout method',
        senderAndBeneficiary: 'Sender & Beneficiary',
        beneficiaryDetails: 'Beneficiary details',
        confirmation: 'Confirmation',
      },
      payoutDetailsStep: {
        title: 'Payout details',
        subtitle: 'Please fill up payout details',
        sourceOfFundsToggleLabel: 'Source of funds',
        shouldUseCustomSender: 'Pay for someone else',
        sourceOfFundsToggleCompanyBalance: 'Company balance',
        sourceOfFundsToggleEndUserWallet: 'End user wallet',
        sourceOfFundsFieldLabel: 'Source of funds',
        fromFieldLabel: 'From',
        toFieldLabel: 'To',
        sentAmountFieldLabel: 'Sent amount',
        availableBalance: 'Available balance:',
        receivedAmountFieldLabel: 'Received amount',
        currencyFieldLabel: 'Currency',
        beneficiaryEntityTypeFieldLabel: 'Beneficiary entity type',
        additionalFields: 'Additional fields',
        preview: {
          title: 'Payout details',
          from: 'From:',
          to: 'To:',
          sentCurrency: 'Sent currency:',
          receivedCurrency: 'Received currency:',
          fx: 'FX:',
        },
      },
      payoutMethodStep: {
        title: 'Payout method type',
        subtitle: 'Getting to know your business',
        payoutCategoryFieldLabel: 'Payout category',
        payoutCategoryFieldOptionsLabels: {
          bank: 'Bank',
          card: 'Card',
          cash: 'Cash',
          ewallet: 'Ewallet',
          rapydEwallet: 'Rapyd Ewallet',
        },
        payoutMethodTypeFieldLabel: 'Payout method type',
        infoBannerTitle: 'Arrival time',
      },
      senderAndBeneficiaryStep: {
        title: 'Sender & Beneficiary',
        subtitle: 'Please define sender and beneficiary',
        titleOnlyBeneficiary: 'Beneficiary',
        subtitleOnlyBeneficiary: 'Please define beneficiary',
        formSenderLabel: 'Sender',
        formSenderIncompatible:
          'The sender has a different {{fieldNames}} than selected on the first step. Change the sender or update the fields on the first step.',
        formSenderMissingRequiredFields:
          'This sender is not compatible with this payout method. Select another sender or complete the fields below to create a new sender',
        formCreateSender: 'Create new sender',
        formSenderRequiredFields: 'Additional required sender fields',
        formBeneficiaryLabel: 'Beneficiary',
        formBeneficiaryIncompatible:
          'The beneficiary has a different {{fieldNames}} than selected on the first step. Change the beneficiary or update the fields on the first step.',
        formBeneficiaryMissingRequiredFields:
          'This beneficiary is not compatible with this payout method. Select another beneficiary or complete the fields below to create a new beneficiary',
        formBeneficiaryWrongIncompatibleCardPOMT:
          'Please note that the chosen beneficiary does not currently have any saved card details.',
        formExistingBeneficiaryCardPOMT:
          'To create a payout with a card, please use an existing beneficiary with pre-defined card details.',
        formCreateBeneficiary: 'Create new beneficiary',
        formBeneficiaryRequiredFields: 'Additional required beneficiary fields',
        formAdditionalFields: 'Additional fields',
        formDescription: 'Description',
        formDescriptionTooltip: 'Payout purpose description',
        formMerchantReferenceId: 'Merchant reference ID',
        formMerchantReferenceIdTooltip:
          'Merchant reference IDs can be defined for future reference. Limited to 255 characters.',
        formStatementDescriptor: 'Statement descriptor',
        formStatementDescriptorTooltip: 'Information to be displayed in the beneficiary statement',
        preview: {
          senderTitle: 'Sender details',
          beneficiaryTitle: 'Beneficiary details',
          name: 'Name:',
          entityType: 'Entity type:',
          country: 'Country:',
          currency: 'Currency:',
          referenceId: 'Reference ID:',
          senderID: 'Sender ID:',
          beneficiaryID: 'Beneficiary ID:',
        },
        invalidAddress:
          'The combined length of the following fields exceeds the maximum of 32 characters. Please fix them accordingly in order to create the payout successfully.',
      },
      confirmationStep: {
        title: 'Confirmation',
        subtitle: 'Review transaction details before confirming payout',
        amountTitle: 'Amount',
        category: 'Category:',
        payoutMethod: 'Payout method:',
        senderDescriptionTitle: 'Sender',
        senderID: 'Sender ID:',
        beneficiaryID: 'Beneficiary ID:',
        senderDescriptionFrom: 'From:',
        fullName: 'Full Name:',
        senderDescriptionCurrency: 'Currency:',
        senderDescriptionEntityType: 'Entity type:',
        beneficiaryDescriptionTitle: 'Beneficiary',
        beneficiaryDescriptionTo: 'To:',
        beneficiaryDescriptionCurrency: 'Currency:',

        type: 'Type:',
        bankName: 'Bank name:',
        accountNumber: 'Account number:',
        walletID: 'Wallet ID:',
        beneficiaryDescriptionEntityType: 'Entity type:',
        beneficiaryEmailLabel: 'Notify the beneficiary by email (optional)',
        beneficiaryEmailPlaceholder: 'Beneficiary email address',
        checkboxLabel: 'I confirm the payout details above',
      },
      draftSuccessModal: {
        title: 'Payout submitted for approval!',
        subtitle: 'An approver has been notified to further review it.',
      },
      successModal: {
        header: 'Payout sent successfully',
        description: '{{amount}} {{currency}} sent to {{beneficiaryName}}. View <0>payout</0>.',
        buttonText: 'Ok, got it!',
      },
      payoutQuarantineModal: {
        header: {
          [ApiErrorCodes.REQUEST_UNDER_REVIEW_RP]: 'Payout is under Rapyd Protect review',
          [ApiErrorCodes.REQUEST_DECLINED_RP]: 'Payout was blocked by Rapyd Protect',
        },
        description: {
          [ApiErrorCodes.REQUEST_UNDER_REVIEW_RP]:
            'A Rapyd Protect Rule has placed your payout under review. Please review your payout details to approve or decline this payout.',
          [ApiErrorCodes.REQUEST_DECLINED_RP]:
            'A Rapyd Protect Rule has blocked your payout. Please review the payout details for more information.',
        },
        actionText: 'To review your current Rapyd Protect Rules, <0>Click Here</0>',
      },
    },

    // Apple pay

    APPLE_PAY: {
      STATUS: 'Apple Pay Status',
      HEADER: 'Apple Pay',
      SUB_HEADER: 'Activate Apple Pay in Rapyd Checkout:',
      COMPLETE_KYB: {
        BUTTON: 'Complete KYB',
        TEXT: 'Apple Pay cannot be activated until you complete the KYB form',
      },
      NOT_REGISTERED: {
        OR: 'OR',
        REGISTER_WITH: 'REGISTER WITH',
      },
      REGISTER_FAILURE: {
        ERROR_HEADER: 'Error Completing Action',
        ERROR_BODY:
          'There was an error registering for Apple Pay. If this problem persists, please <0>contact support</0>',
      },
      UPDATE_FAILURE: {
        ERROR_HEADER: 'Error Completing Action',
        ERROR_BODY:
          'There was an error update Apple Pay activation status. If this problem persists, please <0>contact support</0>',
      },
      HOST: {
        MAIN_HEADER: 'Apple Pay',
        SUB_HEADER: 'To enable Apple Pay on your own domain or app, you must first add it below.',
      },
      WEB_DOMAINS: {
        HEADER: 'Web Domains',
        ADD_DOMAIN: 'Add Domain',
        NAME: 'Domain Name',
        DATE: 'Created At',
      },
      CERTIFY_APP: {
        HEADER: 'IOS Certificates',
        ADD_CERTIFICATE: 'Add Certificate',
        DOMAIN: 'Domain Name',
        EXPIRATION_DATE: 'Expired At',
      },
      VERIFY_DOMAIN: {
        HEADER: 'Verify Domain',
        SUB_HEADER:
          'If you are not using The Rapyd API or Toolkit and want to enable Apple Pay on your own domain or app, follow these steps:',
        ENTER_DOMAIN:
          'Enter the main domain on which you would like to use apple pay, for example, www.rapyd.net , or shop.rapyd.net',
        DOWNLOAD_FILE: 'Click “Download” to download the file that will be used in the next step',
        HOST_FILE:
          'Upload the file you just downloaded to the domain you provided in step 1.  Host it on this specific path:',
        HOST_FILE_URL:
          'https://{{hostFileUrlDomain}}/.well-known/apple-developer-merchantid-domain-association',
        INFO: 'After completing this action click on the “Verify” button below.  This will check that the downloaded file was indeed uploaded to the domain in the correct path, validating the domain provided as yours.',
        CANCEL: 'CANCEL',
        VERIFY: 'VERIFY',
        ERROR_HEADER: 'Error Verify Domain',
        ERROR_BODY:
          'We were unable to verify your domain.  Please confirm that you followed the installation instructions correctly and try again. If this problem persists, please contact support.',
        AUDITING: 'A user verified a domain for use of Apple Pay',
        NO_DOMAINS: 'No Apple Pay Domains',
      },
      CERTIFY_APPLICATION: {
        STEP1: 'Download your CSR File HERE',
        STEP2: 'Go <0>HERE</0>',
        STEP3: `Select the Merchant ID you'd like to add this certificate to, then click <b>'Create Certificate'</b> in the <b>Apple Pay Payment Processing Certificate section</b>.`,
        STEP4: `When it prompts you to upload a Certificate Signing Request, choose the <b>.certSigningRequest</b> file you just downloaded.`,
        STEP5: `Verify your certificate details are correct. First, click Activate to enable the certificate, and then click Download to save it locally.`,
      },
      VERIFY_IOS_APP: {
        UPLOAD_LABEL:
          'If you have completed the previous actions upload your Apple certificate here',
        CONTINUE: 'Continue <0>in the guide</0> to integrate Apple Pay into your app.',
        ERROR_HEADER: 'Error Certifying App',
        ERROR_MESSAGE:
          'We were unable to certify your app.  Please confirm that you followed the installation instructions correctly and try again.  if this problem persists, please <0>contact support</0>.',
      },
    },

    // Close account section

    CLOSE_ACCOUNT: {
      SECTION: {
        HEADER: 'Close your account',
        BODY: 'Please note, by closing your account you and all the accounts users will not be able to login or access any reports or perform actions through the client portal, API or any other integration.',
        BUTTON: 'Close My Account',
      },
      MODAL: {
        HEADER: 'Account Closure Confirmation',
        BODY: 'Are you sure you want to close your account?  In doing so you will not longer be able to: <br/> 1. Access the client portal <br/> 2. View or download payment reports <br/> 3. Submit new evidence for disputes <br/> 4. Create or complete transactions of any kind <br/> 5. Perform actions via API, plugins or hosted solutions <br/> 6. Update business information',
        BUTTONS: {
          CANCEL: 'Cancel',
          CONFIRM: 'Confirm',
        },
      },
      SUCCESS_MODAL: {
        DELETE_ACCOUNT_HEADER: 'Account Deleted',
        DELETE_ACCOUNT_MESSAGE: 'Your account has been successfully deleted.',
        DISABLE_ACCOUNT_HEADER: 'Account Disabled',
        DISABLE_ACCOUNT_MESSAGE:
          'Your account has been disabled.  It will be closed after review by support.  Until then you can still login and view reports and perform some administrative actions. <br/> If you have unsettled funds, make sure that you have added a bank account in order to receive a settlement.  Please note, your account cannot be deleted until all funds have been settled.',
        OK: 'OK',
      },
    },

    // Bank Account section
    HEADER_BANK_ACCOUNT: 'Bank Accounts',
    NO_BANK_ACCOUNT: 'No bank account defined',
    CREATE_BANK_ACCOUNT_BTN: 'Add Bank Account',
    ADD_BANK_ACCOUNT: 'Add Bank Account',
    ACCOUNT_TYPE: 'Account Type',
    EDIT_BANK_ACCOUNT: 'Edit Bank Account',
    SETTLEMENT_TERMS_MODAL_LINK:
      'Provide your bank account details in order to receive settlements. <0>Settlement Terms</0>',
    SETTLEMENT_TERMS_MODAL_TITLE: 'Settlement terms',
    SETTLEMENT_TERMS_MODAL_CONTENT: {
      WITH_SETTLEMENT_TIME:
        'After your Bank Account has been added and your account has been approved, you will automatically receive settlements.\n\nYour settlements will be finalized based on the settlement configuration that you define for each Bank account added. This includes the settlement interval (Daily, Weekly or Monthly) and the minimum settlement amount.\n\nPlease note that after a settlement has been finalized, it will be sent out up to {{numberOfSettlementDays}} {{daysString}} later.\n\nAfter being sent out it can take up to 8 business days until it appears in your account.',
      WITHOUT_SETTLEMENT_TIME:
        'After your Bank Account has been added and your account has been approved, you will automatically receive settlements.\n\nYour settlements will be finalized based on the settlement configuration that you define for each Bank account added. This includes the settlement interval (Daily, Weekly or Monthly) and the minimum settlement amount.\n\nAfter being sent out it can take up to 8 business days until it appears in your account.',
    },
    EDIT_SETLLEMEMT_PREFERENCES_MODAL_TITLE: 'Select Settlement Frequency And Amount',
    EDIT_SETLLEMEMT_PREFERENCES_MODAL_SUB_TITLE: 'Set the schedule for your automatic settlements',
    EDIT_SETLLEMEMT_PREFERENCES_MODAL_FOOTER:
      'Please note:\n Settlements are held up to {{numberOfSettlementDays}} {{daysString}} before being sent out and may take up to 8 business days to be received in your account',
    SETLLEMENT_FREQUENCY_TIME: { DAILY: 'Daily', WEEKLY: 'Weekly', MONTHLY: 'Monthly', OFF: 'Off' },
    EDIT_SETLLEMEMT_MIN_AMOUNT_ERROR:
      'The min. settlement amount must be greater than or equal to {{ min_amount }}',
    SELECT_DAY: 'Select Day',
    EDIT_SETLLEMEMT_PREFERENCES_MONTHLY_DESCRIPTION: 'Every 1st of the month',
    EDIT_SETLLEMEMT_PREFERENCES_TOOLTIP:
      'Increase to a higher min settlement amount than agreed on your merchant terms',
    SETTELMENT_CONFIGURATION_SUCCESS_MODAL_HEADER: 'Settlement Preferences Approved',
    SETTELMENT_CONFIGURATION_SUCCESS_MODAL_BODY:
      'Your settlement preferences was succesfully updated.',
    SETTELMENT_CONFIGURATION_FAILURE_MODAL_HEADER: 'Settlement Preferences Rejected',
    SETTELMENT_CONFIGURATION_FAILURE_MODAL_BODY: 'We could not update your settlement preferences.',
    EDIT_SETLLEMEMT_CONFIGURATION_ACTION: 'Edit Settlement Preferences',
    ADD_BANK_ACCOUNT_MODAL_BENEFICIARYY_NAME_TOOLTIP: 'Must match your company name',

    BACK_ACCOUNT_TO_SETTLE: 'Send settlement to',
    REQUEST_SETTLEMENT_BUTTON: 'Request Settlement',
    REQUEST_SETTLEMENT_HEADER: 'Request a settlement',
    REVIEW_SETTLEMENT_BUTTON: 'Review Settlement',
    REVIEW_SETTLEMENT_DESCRIPTION: 'Please review your settlement details below before confirming.',
    CREATE_SETTLEMENT_DESCRIPTION_WITHOUT_SELECTED_BANK_ACCOUNT:
      'Settle collected funds into your designated bank account.',
    CREATE_SETTLEMENT_DESCRIPTION:
      'Settle collected funds into your designated bank account. A minimum settlement of {{minAmount}} {{currencyCode}} is required between all currencies.',
    SETTLEMENT_AMOUNTS: 'Settlement amounts',
    CREATE_SETTLEMENT_SUCCESS_MODAL_TITLE: 'Settlement successfully created!',
    CREATE_SETTLEMENT_SUCCESS_MODAL_MESSAGE:
      'Your funds should arrive within the next 8 business days once they are processed.',
    REQUEST_SETTLEMENT_STATUSES: 'Settlement Request Status',
    SUCCESS_CURRENCIES_DESCRIPTION: 'A settlement for the following currencies was created:',
    FAIL_CURRENCIES_DESCRIPTION: 'A settlement for the following currencies was failed:',
    NO_BANK_SUPPORT_CURRENCY: 'Set up a bank account in the same currency to settle this balance',
    CREATE_SETTLEMENT_AUDIT_LOG_DESCRIPTION: 'The user settled funds from the account',
    MIN_AMOUNT_IS_NOT_SATISFIED: 'The settlement minimum amount is not satisfied',

    // Login Details
    LOGIN_DETAILS: 'Login Details',
    SECURE_LOGIN: 'Secure Login',
    CHANGE_MFA_PREFERENCE: 'Change MFA Preference',
    CHANGE_HOW_YOU_DO_ADDITIONAL_VERIFICATION: 'Change how you do additional verification',
    SELECT_DEFAULT_SECURITY_VERIFICATION_METHOD: 'Select your default security verification method',

    BUSINESS: 'Business',
    PERSONAL: 'Personal',
    COUNTRY_OF_RESIDENCE_OF_ACCOUNT: 'Country of Residence of Account Holder',
    COUNTRY_OF_BANK: 'Country Of Bank',
    CUSTOMER_COUNTRY: 'Country of Customer',

    // Bank Account Details
    BANK_ACCOUNT_MODAL_TITLE: 'Confirm Action',
    BANK_ACCOUNT_MODAL_MSG_1: 'Are you sure you want to delete this bank account?',
    BANK_ACCOUNT_MODAL_MSG_2: 'You will no longer be able to send payments to it.',
    BANK_ACCOUT_MODAL_NO: 'No',
    BANK_ACCOUT_MODAL_YES: 'Yes',

    // Add Bank Account Side Panel && Form
    BANK_DETAILS: 'Bank Details',
    CURRENCY_OF_ACCOUNT: 'Currency of Account',
    PAYOUT_METHOD_TYPE: 'Payout Method Type',
    FIRST_NAME: 'First Name',
    SWIFT_CODE: 'BIC(SWIFT) Code',
    BANK_NAME: 'Bank Name',
    BANK_COUNTRY: 'Country',
    BANK_CITY: 'Bank City',
    BANK_COUNTRY: 'Bank Country',
    MY_ACCOUNT_CURRENCY_COMBINATION_ERROR:
      'Currency and Country combination is not supported. For more information, please contact support',
    MY_ACCOUNT_CURRENCY_COMBINATION_ERROR_TITLE_MOBILE: 'Country and Currency Details',
    MY_ACCOUNT_CURRENCY_COMBINATION_ERROR_MOBILE:
      'Country and currency combination is not supported For more information contatct support',
    NO_SETTLEMENT_CURRENCY: 'No Settlement Currencies, Please contact support',
    MY_ACCOUNT_COUNTRY_ERROR: 'This Country is not supported',
    CREATE_BANK_ACCOUNT_ERROR_HEADER: 'Bank Account could not be added',
    UPDATE_BANK_ACCOUNT_ERROR_HEADER: 'Bank Account could not be saved',
    ADD_BANK_ACCOUNT_IBAN_NOT_VALID: 'IBAN not found, please confirm it is correct',

    COMPANY_NAME: 'Company Name',
    ADDRESS: 'Address',
    CITY: 'City',
    STATE: 'State',
    ZIP: 'Zip',
    LINE_1: 'Line 1',
    STREET_ADDRESS_1: 'Street Address 1',
    STREET_ADDRESS_2: 'Street Address 2',
    NAME: 'Name',
    POSTAL_CODE: 'Postal Code',
    COUNTRY_OF_RESIDENCE: 'Country of Residence',
    NEXT: 'Next',
    BACK: 'Back',
    SKIP: 'Skip',
    REPORTING_INFO: 'Reporting Information',
    ACCOUNT_NICKNAME: 'Account Nickname',
    ACCOUNT_NUMBER: 'Account Number',
    COMPANY_PHONE_NUMBER: 'Company phone number',
    HOVER_TXT_NAME_OF_ACCOUNT:
      'Internal Name for differentiating the account, example US eCommerce',
    HOVER_TXT_REPORTING_INFO: 'Rapyd financial reports use these values to identify the account',
    ERROR_GET_REQUIRED_FIELDS:
      'Error retrieving data, please try again at a later time.  if this problem persists, please <0>contact support</0>',

    // Message Modal
    ERROR: 'Error',
    ACTION_COMPLETED_HEADER: 'Action completed',
    ACTION_NOT_COMPLETED_HEADER: 'Action not completed',
    ACTION_NOT_COMPLETED_MESSAGE:
      'There was an error completing this request.<br/> Please try again at a later time, if the problem persists, please <0>contact support</0>.',
    ACTION_NOT_COMPLETED_MESSAGE_MOBILE:
      'There was an error completing this request. Please try again at a later time, if the problem persists, please contact support.',
    BANK_ACCOUNT_WAS_NOT_CREATED: 'Bank Account was not created',
    ADD_BANK_ACCOUNT_VALIDATION_ERROR: "One or more of the values you've provided is not valid",
    ERROR_BANK_ACCOUNT_ALREADY_LINKED_MESSAGE: 'This bank account is already linked.',
    CHANGES_WERE_NOT_SAVED: 'Changes were not saved',
    MESSAGE_MODAL_CONTACT_SUPPORT: 'Contact Support',
    MESSAGE_MODAL_CLOSE: 'Close',
    MESSAGE_MODAL_TRY_AGAIN: 'Try Again',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    SOMETHING_WENT_WRONG_PLEASE_CONTACT_SUPPORT: 'Something went wrong, please contact support',
    CARD_ACTIVATED: 'Card ***{{cardNumber}} has been Activated',
    CARD_BLOCKED: 'Card ***{{cardNumber}} has been Blocked',
    CARD_UNBLOCKED: 'Card ***{{cardNumber}} has been Unblocked',
    MASS_UPLOAD_ERROR_HEADER: 'Unable to Complete upload',
    MASS_UPLOAD_ERROR_MESSAGE:
      'One or more of the uploaded files was in an unsupported format.  Please make sure all files are CSV and try again.',
    SUPPORTED_CURRENCIES_HEADER: 'Supported Currencies',

    // Developers tab
    TAB_DEVELOPERS: 'Developers',
    TAB_DEVELOPERS_CREDENTIALS: 'Credentials Details',
    TAB_DEVELOPERS_WEBHOOKS: 'Webhooks',
    TITLE_DEVELOPERS: 'Developers',
    DEVELOPERS_MAIN_TXT: 'Define your callback URL and the events that will trigger it.',
    PRODUCTION_CREDENTIALS_NO_ACCESS:
      'Production Credentials can only be viewed by the Account owner.',
    VIEW_SANDBOX_CREDENTIALS: 'View Sandbox Credentials',

    // Mass Payouts
    TAB_MASS_PAYOUTS: 'Mass Payouts',
    TITLE_PAYOUTS: 'Mass Payout Reports',
    TITLE_BREADCRUMB_CREATE_PAYOUTS: 'Create Mass Payouts',
    TABLE_HEADER_PAYOUTS_ID: 'Batch ID',
    TABLE_HEADER_PAYOUTS_NAME: 'Report Name',
    TABLE_HEADER_PAYOUTS_FAILED_TRANSACTIONS: 'Failed Transactions',
    TABLE_HEADER_PAYOUTS_SUCCESSFUL_TRANSACTIONS: 'Successful Transactions',
    TABLE_HEADER_PAYOUTS_NO_OF_TRANSACTIONS: 'Number of Transactions',
    TABLE_HEADER_PAYOUTS_STATUS: 'Status',
    TABLE_HEADER_PAYOUTS_LIST_INSTRUCTIONS_VALUES: 'Paycode',
    PAYOUTS_SAMPLE_FILES_BTN: 'Sample Files',
    PAYOUTS_SAMPLE_FILES_LINK: `Sample File`,
    PAYOUTS_UPLOAD_CSV_BTN: 'Upload CSV',
    CREATE_PAYOUT_THE: `the `,
    FILES_IN_BATCH: 'Files in batch',
    FILL_OUT_CSV_FILE: `
      Fillout CSV file with all
      the required information
      using the
    `,
    FORMAT: ` format`,
    SELECT_FILES_1: 'Upload a CSV file for',
    SELECT_FILES_2: `
      each country and
      payout method`,
    SELECT_FILES_3: 'You can upload up to 10 files or 20 MB.',

    SAMPLE_FILES: 'Sample Files',
    DOWNLOAD: 'Download',
    SAMPLE_FILES_PAYOUT_TYPE: 'Payout Type',
    SAMPLE_FILES_ENTITY_TYPE: 'Entity Type',
    SAMPLE_FILES_DROPDOWN_LABEL: 'Select Country',
    DROP_OR_UPLOAD: 'Drop or Upload your files here',

    // Mass Payouts side panel
    MASS_PAYOUTS_STATUS: 'Status',
    MASS_PAYOUTS_UPLOADED_BY: 'Uploaded by',

    MASS_PAYOUTS_NUM_OF_TRANSACTIONS: 'Number of Transactions',
    MASS_PAYOUTS_TOTAL_OF_TRANSACTIONS: 'Total',
    MASS_PAYOUTS_SUCCESSFUL_TRANSACTIONS: 'Successful',
    MASS_PAYOUTS_FAILED_TRANSACTIONS: 'Failed',
    MASS_PAYOUTS_FILES_IN_BATCH: 'Files in Batch',
    MASS_PAYOUTS_BTN_FAILED_TRANSACTIONS: 'Errors',
    DOWNLOAD_FAILED_TRANSACTIONS: 'Download Failed Transactions',
    MASS_PAYOUTS_BTN_DOWNLOAD_TRANSACTIONS: 'Full Report',
    ERROR_DOWNLOADING_SAMPLE_FILES_HEADER: 'Error Downloading Sample Files',
    ERROR_DOWNLOADING_SAMPLE_FILES_MESSAGE:
      'There was an error downloading the sample file you selected.  Please try again,  If the problem persists, try downloading each sample file individually.',

    // Mass Payouts tooltip
    MASS_PAYOUTS_PROCESS_TAKES: 'This process takes ',
    MASS_PAYOUTS_PREPARING_REPORT_MESSAGE:
      'Please be patient, we are preparing your report. An email will be sent to you once the report is ready.',
    MASS_PAYOUTS_PREPARE_REPORT: 'Preparing your report...',

    // Mass Payouts Modal
    CURRENCY: 'Currency',
    ENTITY_TYPE: 'Entity Type',
    BASE_CURRENCY: 'Base Currency',
    SENT_CURRENCY: 'Sent Currency',
    RECEIVED_CURRENCY: 'Received Currency',
    BASE_CURRENCY_INFO: 'The currency from which the FX transfer will be calculated',
    STATEMENT_DESCRIPTOR: 'Statement Descriptor',

    // Mass Payouts - Create mass payoyt
    COLLAPSE: 'Collapse',
    EXPAND: 'Expand',
    BATCH_UPLOAD: 'Batch_Upload',
    BATCH_FILE_INPUT_TITLE: 'Batch file name',
    MASS_UPLOAD_FILE_SIZE_ERROR_HEADLINE: 'File size limit reached',
    MASS_UPLOAD_TOO_MANY_FILES_HEADLINE: 'Too many files',
    MASS_UPLOAD_INVLID_FILE_TYPE_HEADLINE: 'Invalid file type',
    MASS_UPLOAD_SERVER_ERROR: 'Invalid parameters or file structure',
    MASS_UPLOAD_DIFFERENT_TYPES: 'You can only upload one file type on each upload',

    // Mass Payouts - choose cols side menu
    CHOOSE_COLS: 'Choose Columns',
    PAYMENT_DETAILS_GROUP_TITLE: 'Payment Details',
    BENEFICIARY_DETAILS_GROUP_TITLE: 'Beneficiary Details',
    SENDER_DETAILS_GROUP_TITLE: 'Sender Details',
    CHOOSE_COLS_PANEL_APPLY_BTN: 'Apply',
    CHOOSE_COLS_PANEL_CANCEL_BTN: 'Cancel',

    // Escrow Side Menu
    ESCROW_SIDE_MENU_DETAILS: 'Escrow Details',
    ESCROW_SIDE_MENU_RELEASE_DAYS: 'Days to Release',
    ESCROW_SIDE_MENU_LAST_PAYMENT_COMPLETION: 'Last Payment Completion',
    ESCROW_SIDE_MENU_HELD_AMOUNT: 'Held Amount',
    ESCROW_SIDE_MENU_HELD: 'Held',
    ESCROW_SIDE_MENU_RELEASE: 'Release',
    ESCROW_SIDE_MENU_RELEASED_AMOUNT: 'Released Amount',
    ESCROW_SIDE_MENU_PAYMENT_ID: 'Payment ID',
    ESCROW_SIDE_MENU_STATUS: 'Status',
    ESCROW_SIDE_MENU_UPDATED_AT: 'Last Update',
    ESCROW_SIDE_MENU_EWALLETS: 'Wallets',
    ESCROW_SIDE_MENU_RELEASES: 'Releases',
    ESCROW_SIDE_MENU_RELEASE_CTA: 'Release Funds',
    ESCROW_SIDE_MENU_TOTAL: 'Total',
    ESCROW_SIDE_MENU_NO_RELEASES: 'No funds were released from this escrow.',

    // Payouts Table
    TAB_PAYOUTS: 'Payouts',
    TAB_CREATE_PAYOUT: 'Create Payout',
    TAB_DISBURSE: 'Disburse',
    TAB_COLLECT: 'Collect',
    TAB_CORPORATE_CARDS: 'Corporate cards',
    TAB_IDV_RESULTS: 'IDV Results',
    TITLE_BREADCRUMB_PAYOUTS_LIST: 'Payouts',
    TABLE_HEADER_PAYOUTS_LIST_ID: 'Payout ID',
    TABLE_HEADER_PAYOUTS_LIST_TYPE: 'Payout Type',
    TABLE_HEADER_PAYOUTS_LIST_METHOD_TYPE: 'Payout Method Type',
    TABLE_HEADER_PAYOUTS_LIST_AMOUNT: 'Amount',
    TABLE_HEADER_PAYOUTS_LIST_AMOUNT_RECEIVED: 'Amount Received',
    TABLE_HEADER_PAYOUTS_LIST_CURRENCY_RECIEVED: 'Currency Received',
    TABLE_HEADER_PAYOUTS_LIST_AMOUNT_SENT: 'Amount Sent',
    TABLE_HEADER_PAYOUTS_LIST_CURRENCY: 'Currency',
    TABLE_HEADER_PAYOUTS_LIST_CURRENCY_RECEIVED: 'Currency Received',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_CURRENCY: 'Currency Sent',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_AMOUNT: 'Amount Sent',
    TABLE_HEADER_PAYOUTS_LIST_STATUS: 'Status',
    TABLE_HEADER_PAYOUTS_LIST_ENTITY_TYPE_SENDER: 'Sender Entity Type',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_COUNTRY: 'Sender Country',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_ID: 'Sender ID',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_FULL_NAME: 'Sender Full Name',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_FIRST_NAME: 'Sender First Name',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_LAST_NAME: 'Sender Last Name',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_ID: 'Beneficiary ID',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_COUNTRY: 'Beneficiary Country',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_FULL_NAME: 'Beneficiary Full Name',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_FIRST_NAME: 'Beneficiary First Name',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_LAST_NAME: 'Beneficiary Last Name',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_ENTITY_TYPE_BENEFICIARY: 'Beneficiary Entity Type',
    TABLE_HEADER_PAYOUTS_LIST_DATE_OF_COM: 'Completed At',
    TABLE_HEADER_PAYOUTS_LIST_REFERENCE_ID: 'Merchant Reference ID',
    TABLE_HEADER_PAYOUTS_LIST_ERROR_CODE: 'Error Code',
    TABLE_HEADER_PAYOUTS_LIST_BENEFICIARY_PHONE_NUMBER: 'Beneficiary Phone Number',
    TABLE_HEADER_PAYOUTS_LIST_SENDER_PHONE_NUMBER: 'Sender Phone Number',
    TABLE_HEADER_PAYOUTS_LIST_PAYCODE: 'Paycode',
    TABLE_HEADER_PAYOUTS_DESCRIPTION: 'Description',
    TABLE_HEADER_PAYOUTS_PAYOUT_WITH_FX: 'Payout With FX',

    // Payouts Drill Down
    PAYOUT_DETAILS_ID: 'Payout ID',
    PAYOUT_DETAILS_AMOUNT: 'Amount',
    PAYOUT_DETAILS_CURRENCY: 'Currency',
    PAYOUT_DETAILS_STATUS: 'Status',
    PAYOUT_DETAILS_COMPLETED_AT: 'Completed At',
    PAYOUT_DETAILS_TYPE: 'Type',
    PAYOUT_DETAILS_METHOD_TYPE_TYPE: 'Method',
    PAYOUTS_DETAILS_TITLE: 'Details',
    PAYOUT_DETAILS_FEE: 'Total Fees',
    CANCEL_PAYOUT: 'Cancel Payout',
    PAYOUT_DETAILS_MERCHANT_REFERENCE_ID: 'Merchant Ref ID',
    PAYOUT_DETAILS_TRACE_NUMBER: 'Trace Number',

    // Beneficiaries Table
    TAB_BENEFICIARIES: 'Beneficiaries',
    PAYOUT_DETAILS_BENEFICIARY_DETAILS: 'Beneficiary Details',
    PAYOUT_DETAILS_BENEFICIARY_ID: 'ID',
    PAYOUT_DETAILS_BENEFICIARY_FULL_NAME: 'Full name',
    PAYOUT_DETAILS_BENEFICIARY_ENTITY_TYPE: 'Entity type',
    PAYOUT_DETAILS_BENEFICIARY_BANK_NAME: 'Bank Name',
    PAYOUT_DETAILS_BENEFICIARY_ACCOUNT_NUMBER: 'Account Number',
    PAYOUT_DETAILS_BENEFICIARY_EWALLET_TOKEN: 'Wallet ID',
    PAYOUT_DETAILS_BENEFICIARY_EWALLET_PROVIDER: 'eWallet Provider',
    PAYOUT_DETAILS_BENEFICIARY_IBAN: 'IBAN',
    PAYOUT_DETAILS_BENEFICIARY_BIC_SWIFT: 'Bic Swift',

    PAYOUT_DETAILS_SENDER_DETAILS: 'Sender Details',
    PAYOUT_DETAILS_PAYOUT_METHOD_DETAILS: 'Payout method details',
    PAYOUT_DETAILS_SENDER_ENTITY_TYPE: 'Entity Type',
    PAYOUT_DETAILS_SENDER_ID: 'ID',
    PAYOUT_DETAILS_SENDER_FULL_NAME: 'Full name',
    PAYOUT_DETAILS_SENDER_ADDRESS: 'Address',
    PAYOUT_DETAILS_SENDER_CITY: 'City',
    PAYOUT_DETAILS_SENDER_STATE: 'State',
    PAYOUT_DETAILS_SENDER_POSTCODE: 'Postcode',
    PAYOUT_DETAILS_SENDER_PHONE_NUMBER: 'Phone Number',
    PAYOUT_DETAILS_SENDER_EMAIL: 'eMail',
    PAYOUT_DETAILS_SENDER_PURPOSE_CODE: 'Purpose Code',
    PAYOUT_DETAILS_SENDER_SOURCE_OF_INCOME: 'Source of Income',

    // Payouts Side Menu
    PAYOUT_SIDE_MENU_COMPLETED: `The {{type}} payout by {{payer_full_name}} to {{beneficiary_full_name}} was Completed`,
    PAYOUT_SIDE_MENU_CREATED: `{{payer_full_name}} created a {{type}} payout to {{beneficiary_full_name}}`,
    PAYOUT_SIDE_MENU_REJECTED: `The {{type}} payout to {{beneficiary_full_name}} that was made by {{payer_full_name}} was rejected`,
    PAYOUT_SIDE_MENU_ERROR: `There was an error processing the payout request by {{payer_full_name}} to {{beneficiary_full_name}}`,
    PAYOUT_SIDE_MENU_CANCELLED: `The {{type}} payout to {{beneficiary_full_name}} that was made by {{payer_full_name}} was cancelled`,
    PAYOUT_SIDE_MENU_IN_PROGRESS: `The {{type}} payout to {{beneficiary_full_name}} that was made by {{payer_full_name}} is currently in progress, it should created soon`,
    PAYOUT_SIDE_MENU_PENDING: `The {{type}} payout that was made by {{payer_full_name}} was created, but the funds have not yet been transferred to {{beneficiary_full_name}}`,
    PAYOUT_SIDE_MENU_CANCEL_PAYOUT: 'Cancel Payout',
    PAYOUT_SIDE_MENU_DETAILS: 'See all details',
    PAYOUT_SIDE_MENU_COMPLETE_PAYOUT: 'Complete Payout',
    PAYOUT_SIDE_MENU_TRANSACTION_IDS: `Transaction ID's`,

    // Beneficiaries Table
    BENEFICIARIES_TABLE_TITLE: 'Beneficiaries',
    TABLE_HEADER_BENEFICIARIES_ID: 'Beneficiary ID',
    TABLE_HEADER_BENEFICIARIES_ALIAS: 'Name',
    TABLE_HEADER_BENEFICIARIES_ENTITY_TYPE: 'Entity Type',
    TABLE_HEADER_BENEFICIARIES_CURRENCY: 'Currency',
    TABLE_HEADER_BENEFICIARIES_CREATED_AT: 'Created At',
    TABLE_HEADER_BENEFICIARIES_METHOD_TYPE: 'Payout Method Type',
    TABLE_HEADER_BENEFICIARIES_METHOD_TYPE_CATEGORY: 'Payout Category',
    TABLE_HEADER_BENEFICIARIES_MERCHANT_REFERENCE_ID: 'Reference ID',

    // Senders Table
    TAB_SENDERS: 'Senders',
    SENDERS_TABLE_TITLE: 'Senders',
    TABLE_HEADER_SENDERS_ID: 'Sender ID',
    TABLE_HEADER_SENDERS_NAME: 'Name',
    TABLE_HEADER_SENDERS_COUNTRY: 'Country',
    TABLE_HEADER_SENDERS_CURRENCY: 'Currency',
    TABLE_HEADER_SENDERS_ENTITY_TYPE: 'Entity Type',
    TABLE_HEADER_SENDERS_REFERENCE_ID: 'Reference ID',
    TABLE_HEADER_SENDERS_CREATED_AT: 'Created At',

    // eWallet Transactions Table
    TITLE_TRANSACTIONS: 'Transactions',
    TABLE_HEADER_TRANSACTIONS_ID: 'Transaction ID',
    TABLE_HEADER_TRANSACTIONS_DIRECTION: 'Direction',
    TABLE_HEADER_TRANSACTIONS_TYPE: 'Type',
    TABLE_HEADER_TRANSACTIONS_AMOUNT: 'Amount',
    TABLE_HEADER_TRANSACTIONS_ORIGINAL_AMOUNT: 'Original amount',
    TABLE_HEADER_TRANSACTIONS_CURRENCY: 'Currency',
    TABLE_HEADER_TRANSACTIONS_STATUS: 'Status',
    TABLE_HEADER_TRANSACTIONS_CARD_NUMBER: 'Card Number',
    TABLE_TRANSACTIONS_CARD_AUTHORIZATION_STATUS: 'Card authorization status',
    TABLE_TRANSACTIONS_PAYMENT_STATUS: 'Payment status',
    TABLE_TRANSACTIONS_PAYOUT_STATUS: 'Payout status',
    TABLE_TRANSACTIONS_REFUND_STATUS: 'Refund status',
    TABLE_TRANSACTIONS_NOTE: 'Note',

    // TABLES_COLUMNS_CATEGORY_NAMES
    EWALLET_DETAILS: 'Wallet Details',
    ACCOUNT_DETAILS: 'Account Details',
    PAYOUT_DETAILS: 'Payout Details',
    SENDER_DETAILS: 'Sender Details',
    BENEFICIARY_DETAILS: 'Beneficiary Details',
    // Issued Card Transactions Table
    TITLE_ISSUED_CARDS_TRANSACTIONS: 'Issued Card Transactions',
    TITLE_ISSUED_CARDS: 'Issued Cards',
    TABLE_HEADER_ISSUED_CARDS_ID: 'Transaction ID',
    TABLE_HEADER_ISSUED_CARDS_CIT_TOKEN: 'CIT Token',
    TABLE_HEADER_ISSUED_CARDS_AMOUNT: 'Amount',
    TABLE_HEADER_ISSUED_CARDS_CURRENCY: 'Currency',
    TABLE_HEADER_ISSUED_CARDS_DIRECTION: 'Direction',
    TABLE_HEADER_ISSUED_CARDS_STATUS: 'Status',
    TABLE_HEADER_ISSUED_CARDS_EWALLET_ID: 'Wallet ID',
    TABLE_HEADER_ISSUED_CARDS_CONTACT_NAME: 'Contact Name',
    TABLE_HEADER_ISSUED_CARDS_CONTACT_FIRST_NAME: 'Contact First Name',
    TABLE_HEADER_ISSUED_CARDS_CONTACT_LAST_NAME: 'Contact Last Name',
    TABLE_HEADER_ISSUED_CARDS_CONTACT_PHONE_NUMBER: 'Contact Phone Number',
    TABLE_HEADER_ISSUED_CARDS_CARD_NUMBER: 'Last 4 digits',
    TABLE_HEADER_ISSUED_CARDS_AUTHORIZATION_NUMBER: 'Authorization Number',
    TABLE_HEADER_ISSUED_CARDS_POS_NAME_LOCATION: 'POS Name & Location',
    TABLE_HEADER_ISSUED_CARDS_MERCHANT_CATEGORY_CODE: 'Merchant Category Code',
    TABLE_HEADER_ISSUED_CARDS_PROGRAM_ID: 'Program ID',
    TABLE_HEADER_ISSUED_CARDS_PROGRAM_FRIENDLY_NAME: 'Program name',
    TABLE_HEADER_ISSUED_CARDS_ENTRY_MODE: 'Entry Mode',
    TABLE_HEADER_ISSUED_CARDS_TRANSACTION_TYPE: 'Transaction Type',
    TABLE_HEADER_ISSUED_CARDS_CARD_ID: 'Card ID',
    TABLE_HEADER_ISSUED_CARDS_SYSTEMS_TRACE_AUDIT_NUMBER: 'Systems Trace Audit Number',
    AUTHORIZED_BY: 'Authorized By',
    ISSUED_CARDS_COLUMNS_TOOLTIP: 'Choose Columns',
    ISSUED_CARDS_CARD_DETAILS: 'Card Details',
    BLOCK_CARD: 'Block Card',
    BLOCK_CARD_CONFIRMATION_TEXT:
      "You're about to block your card. You'd be able to restore the card in the future but some information might be lost.",
    BLOCK_CARD_SUCCESS_TITLE: 'Card was successfully blocked',
    BLOCK_CARD_SUCCESS_TEXT: 'Card ****{{last4}} has been blocked',
    UNBLOCK_CARD: 'Unblock Card',
    UNBLOCK_CARD_CONFIRMATION_TEXT:
      'Unblock this card to enable it again and perform new transactions.',
    UNBLOCK_CARD_SUCCESS_TITLE: 'Card was successfully unblocked',
    UNBLOCK_CARD_SUCCESS_TEXT: 'Card ****{{last4}} has been unblocked',
    UNBLOCK_CARD_NOT_ALLOWED_TITLE: 'Looks like you already have an active corporate card',
    UNBLOCK_CARD_NOT_ALLOWED_TEXT:
      'Corporate cards are limited to 1 card per account. Removing this limitation is on our roadmap.',
    ACTIVATE_CARD: 'Activate Card',
    RESET_PIN: 'Reset PIN',
    ISSUED_CARDS_STATUS: 'Status',
    ISSUED_CARDS_CREATION_DATE: 'Creation date',
    ISSUED_CARDS_ACTIVATION_DATE: 'Activation date',
    ISSUED_CARDS_ORIGINAL_AMOUNT: 'Original Amount: ',
    ISSUED_CARDS_REFUNDED_AMOUNT: 'Refunded Amount: ',

    // Issuing Requests List
    TITLE_ISSUING_REQUESTS: 'Issuing Requests',
    NO_REQUESTS: 'You currently have no requests',

    // Transactions tab
    TAB_TRANSACTIONS: 'Transactions',
    TAB_CREATE: 'Create',

    // Refunds Side Menu
    REFUNDS_SIDE_MENU_TITLE: 'Refund',
    REFUNDS_SIDE_MENU_STATUS: 'Status',
    REFUNDS_SIDE_MENU_REFUND_DETAILS: 'Refund Details',
    REFUNDS_SIDE_MENU_ORIGINAL_PAYMENT_DETAILS: 'Original Payment Details',
    REFUNDS_SIDE_MENU_REFUND_REASON: 'Reason',
    REFUNDS_SIDE_MENU_PAYMENT_ID: 'Payment ID',
    REFUNDS_SIDE_MENU_PAID_AT: 'Paid At',
    REFUNDS_SIDE_MENU_PAID_AMOUNT: 'Paid Amount',
    REFUNDS_SIDE_MENU_PAYMENT_METHOD_TYPE: 'Payment Method Type',
    REFUNDS_SIDE_MENU_PAYER_DETAILS: 'Payer Details',
    REFUNDS_SIDE_MENU_PAYER_NAME: 'Name',
    REFUNDS_SIDE_MENU_PAYER_PHONE_NUMBER: 'Phone Number',
    REFUNDS_SIDE_MENU_PAYER_EMAIL: 'Email',
    REFUNDS_SIDE_MENU_COMPLETE_REFUND_BTN: 'Complete Refund',
    REFUNDS_SIDE_MENU_DETAILS_BTN: 'See all details',
    REFUNDS_SIDE_MENU_CATEGORY: 'Category',
    REFUNDS_SIDE_MENU_COMPLETE_REFUND_BTN_TOOLTIP: `This payment method requires the customer to take certain actions to receive the refund.
      After they are done, you must manually change the status of the refund to complete`,
    REFUNDS_SIDE_MENU_UNKNOWN_PAYMENT: 'Payer information not available.',

    REFUNDS_SIDE_MENU_COMPLETED: `Was refunded from a  {{payment_amount}} {{currency}} payment.`,
    REFUNDS_SIDE_MENU_REJECTED: `The request for refund failed. Failure reason: {{reason}}.`,
    REFUNDS_SIDE_MENU_PENDING: `A request for refund of {{currency}} {{amount}} has been
    received but is not yet complete.`,
    REFUNDS_SIDE_MENU_PARTIAL_REFUND: 'Partial Refund',
    REFUNDS_SIDE_MENU_FULL_REFUND: 'Full Refund',

    // Refunds details
    REFUNDS_DETAILS_TITLE: 'Refund',
    REFUNDS_DETAILS_STATUS: 'Status',
    // issuing cards table
    TABLE_HEADER_ISSUING_CARD_ID: 'Card ID',
    TABLE_HEADER_ISSUING_CARD_TOKEN: 'Card Token',
    TABLE_HEADER_ISSUING_CONTACT_NAME: 'Contact Name',
    TABLE_HEADER_ISSUING_CONTACT_FIRST_NAME: 'Contact First Name',
    TABLE_HEADER_ISSUING_CONTACT_LAST_NAME: 'Contact Last Name',
    TABLE_HEADER_ISSUING_CONTACT_TYPE: 'Contact Type',
    TABLE_HEADER_ISSUING_PHONE_NUMBER: 'Phone Number',
    TABLE_HEADER_ISSUING_EWALLET_ID: 'Wallet ID',
    TABLE_HEADER_ISSUING_STATUS: 'Status',
    TABLE_HEADER_ISSUING_ASSIGNED_AT: 'Assigned At',
    TABLE_HEADER_ISSUING_ACTIVATED_AT: 'Activated At',
    TABLE_HEADER_ISSUING_CARD_NUMBER: 'Card Number',
    TABLE_HEADER_ISSUING_EXIPRATION_DATE: 'Expiration Date',
    TABLE_HEADER_ISSUING_SUB_BIN: 'Sub BIN',
    TABLE_HEADER_ISSUING_CARD_TYPE: 'Type',
    TABLE_HEADER_ISSUING_LAST_4_DIGITS: 'Last 4 digits',
    TABLE_HEADER_ISSUING_CARD_PROGRAM_ID: 'Program ID',
    TABLE_HEADER_ISSUING_CARD_PROGRAM_FRIENDLY_NAME: 'Program name',
    TABLE_HEADER_ISSUING_CARD_TRACKING_ID: 'Tracking ID',

    // issuing cards request
    ISSUING_REQUEST_SIDE_MENU_HEADER: 'Issuing Request',
    TABLE_HEADER_ISSUING_REQUEST_ID: 'ID',
    TABLE_HEADER_ISSUING_REQUEST_CREATED_AT: 'Request Date',
    TABLE_HEADER_ISSUING_REQUEST_NUMBER_OF_CARDS: 'Number Of Cards',
    TABLE_HEADER_ISSUING_REQUEST_PROGRAM_NAME: 'Program Name',
    TABLE_HEADER_ISSUING_REQUEST_PROGRAM_ID: 'Program ID',
    TABLE_HEADER_ISSUING_REQUEST_USER_EMAIL: 'Requesting User (email)',
    TABLE_HEADER_ISSUING_REQUEST_COUNTRY: 'Country',
    TABLE_HEADER_ISSUING_REQUEST_PERSON_NAME: 'Contact',
    TABLE_HEADER_ISSUING_REQUEST_PHONE_NUMBER: 'Contact Phone Number',
    TABLE_HEADER_ISSUING_REQUEST_STATUS: 'Status',

    // Protect payments table
    TAB_BLOCKED: 'Blocked',
    TABLE_HEADER_BLOCKED_PAYMENTS_QUARANTINE_ID: 'Quarantine ID',
    TABLE_HEADER_BLOCKED_PAYMENTS_QUARANTINE_ID_SEARCH: 'ID of the quarantined transaction',
    TABLE_HEADER_BLOCKED_PAYMENTS_CREATED_AT: 'Created At',
    TABLE_HEADER_BLOCKED_PAYMENTS_PAYMENT_METHOD_TYPE: 'Payment Method Type',
    TABLE_HEADER_BLOCKED_PAYMENTS_PAYMENT_METHOD_CATEGORY: 'Category',
    TABLE_HEADER_BLOCKED_PAYMENTS_AMOUNT: 'Amount',
    TABLE_HEADER_BLOCKED_PAYMENTS_CURRENCY: 'Currency',
    TABLE_HEADER_BLOCKED_PAYMENTS_STATUS: 'Status',
    TABLE_HEADER_BLOCKED_PAYMENTS_MERCHANT_REF_ID: 'Merchant Reference ID',
    TABLE_HEADER_BLOCKED_PAYMENTS_COUNTRY: 'Country',
    TABLE_HEADER_BLOCKED_PAYMENTS_CUSTOMER_ID: 'Customer ID',
    TABLE_HEADER_BLOCKED_PAYMENTS_ERROR_CODE: 'Error Code',
    TABLE_HEADER_BLOCKED_PAYMENTS_ERROR_CODE_SEARCH: 'Reason for reviewing the transaction',
    TABLE_HEADER_BLOCKED_PAYMENTS_PAYMENT_ID: 'Payment ID',

    // Protect payouts table
    TITLE_PROTECTED_PAYOUTS: 'Payouts',
    TABLE_HEADER_BLOCKED_PAYOUTS_QUARANTINE_ID: 'Quarantine ID',
    TABLE_HEADER_BLOCKED_PAYOUTS_QUARANTINE_ID_SEARCH: 'ID of the quarantined transaction',
    TABLE_HEADER_BLOCKED_PAYOUTS_CREATED_AT: 'Created At',
    TABLE_HEADER_BLOCKED_PAYOUTS_PAYOUT_TYPE: 'Category',
    TABLE_HEADER_BLOCKED_PAYOUTS_PAYOUT_METHOD_TYPE: 'Payout Method Type',
    TABLE_HEADER_BLOCKED_PAYOUTS_AMOUNT: 'Amount',
    TABLE_HEADER_BLOCKED_PAYOUTS_CURRENCY: 'Currency',
    TABLE_HEADER_BLOCKED_PAYOUTS_STATUS: 'Status',
    TABLE_HEADER_BLOCKED_PAYOUTS_MERCHANT_REF_ID: 'Merchant Reference ID',
    TABLE_HEADER_BLOCKED_PAYOUTS_SENDER_FULL_NAME: 'Sender Full Name',
    TABLE_HEADER_BLOCKED_PAYOUTS_SENDER_ID: 'Sender ID',
    TABLE_HEADER_BLOCKED_PAYOUTS_BENEFICIARY_FULL_NAME: 'Beneficiary Full Name',
    TABLE_HEADER_BLOCKED_PAYOUTS_BENEFICIARY_ID: 'Beneficiary ID',
    TABLE_HEADER_BLOCKED_PAYOUTS_ERROR_CODE: 'Error Code',
    TABLE_HEADER_BLOCKED_PAYOUTS_ERROR_CODE_SEARCH: 'Reason for reviewing the transaction',
    TABLE_HEADER_BLOCKED_PAYOUTS_PAYOUT_ID: 'Payout ID',
    TABLE_HEADER_BLOCKED_PAYOUTS_CUSTOMER_ID: 'Customer ID',

    //Coupons table
    TABLE_HEADER_COUPONS_DURATION: 'Duration',
    TABLE_HEADER_COUPONS_DISCOUNT_TYPE: 'Discount type',
    TABLE_HEADER_COUPONS_REDEEM_DATE: 'Redeem date',
    TABLE_HEADER_COUPONS_TOTAL_REDEMPTION: 'Times Redeemed',
    TABLE_HEADER_COUPONS_MAX_REDEMPTIONS: 'Maximum Redemptions',
    TABLE_HEADER_COUPONS_REDEEM_BY: 'Redeem Date',

    // Protect Under Review
    TAB_UNDER_REVIEW: 'Under Review',
    TABLE_HEADER_UNDER_REVIEW_TRANSACTION_ID: 'Transaction ID',
    TABLE_HEADER_UNDER_REVIEW_CREATED_AT: 'Created At',
    TABLE_HEADER_UNDER_REVIEW_TRANSACTION_TYPE: 'Transaction type',
    TABLE_HEADER_UNDER_REVIEW_AMOUNT: 'Amount',
    TABLE_HEADER_UNDER_REVIEW_CATEGORY: 'Category',
    TABLE_HEADER_UNDER_REVIEW_PAYMENT_METHOD_TYPE: 'Payment Method Type',
    TABLE_HEADER_UNDER_REVIEW_SOURCE: 'Source',
    TABLE_HEADER_UNDER_REVIEW_CURRENCY: 'Currency',
    TABLE_HEADER_UNDER_REVIEW_PAYOUT_TYPE: 'Payout Type',
    TABLE_HEADER_UNDER_REVIEW_COUNTRY: 'Country',
    TABLE_HEADER_UNDER_REVIEW_MERCHANT_REF_ID: 'Merchant Reference ID',
    TABLE_HEADER_UNDER_REVIEW_CUSTOMER_ID: 'Customer ID',
    COMPLIANCE: 'Operation',
    RAPYD_PROTECT: 'RapydProtect',

    // Protect Lists
    LISTS: 'Lists',
    TABLE_HEADER_RAPYD_PROTECT_LISTS_LIST_NAME: 'List Name',
    TABLE_HEADER_RAPYD_PROTECT_LISTS_LAST_UPDATED: 'Last Updated',
    TABLE_HEADER_RAPYD_PROTECT_LISTS_DESCRIPTION: 'Description',
    TABLE_HEADER_RAPYD_PROTECT_LISTS_NUMBER_OF_ITEMS: 'Number Of Items',
    CLEAR_LIST_HEADER: 'Clear',
    CLEAR_LIST_MESSAGE: 'Are you sure you want to clear all items in this list?',
    CLEAR_LIST_VALUES_ERROR: 'An error has occurred while clearing list values',
    RAPYD_PROTECT_LISTS_SUB_TITLE:
      'Add and remove values to predefined lists that can be referenced by your rules.',

    // Protect List Details
    LIST_DETAILS_NAME: 'List Name',
    LIST_DETAILS_TYPE: 'List Type',
    TITLE_RAPYD_PROTECT_LIST_DETAILS: 'List Details',
    TABLE_HEADER_RAPYD_PROTECT_LIST_DETAILS_VALUE: 'Value',
    TABLE_HEADER_RAPYD_PROTECT_LIST_DETAILS_DATE_ADDED: 'Date Added',
    TABLE_HEADER_RAPYD_PROTECT_LIST_DETAILS_EXPIRATION: 'Expiration Date',
    LIST_DETAILS_VALUE_TO_ADD: 'Value to add',
    LIST_DETAILS_EXPIRATION_CHECKBOX: 'Expiration Date',
    LIST_DETAILS_EXPIRATION_DATE: 'Date',
    LIST_DETAILS_EXPIRATION_TIME: 'Time',
    EDIT_LIST_VALUE: 'Edit List Value',
    ADD_LIST_VALUE: 'Add List Value',
    REMOVE_ITEM_FROM_LIST: 'Delete',
    LIST_DETAILS_ADD_ERROR_TITLE: 'Error Adding Value',
    LIST_DETAILS_ADD_ERROR_MESSAGE:
      'An error occurred while trying to add the request value to the list. Please review your submission and try again. If the problem persists please <0>contact support</0>.',
    LIST_DETAILS_ADD_ERROR_MESSAGE_MOBILE:
      'An error occurred while trying to add the request value to the list. Please review your submission and try again.',
    LIST_DETAILS_ADD_VALUE_SUCCESS_TITLE: 'Action Successful',
    LIST_DETAILS_ADD_VALUE_SUCCESS_MESSAGE:
      'The value {{list_value}} was successfully added to the list.',
    LIST_DETAILS_ADD_VALUE_SUCCESS_MESSAGE_EXPIRATION:
      'The value will remain in the list until {{expiration_date}}',
    LIST_DETAILS_ADD_VALUE_SUCCESS_MESSAGE_NO_EXPIRATION:
      'The value will remain in the list indefinitely',
    LIST_DETAILS_ADD_ANOTHER_VALUE: 'Add Another Value',
    LIST_DETAILS_REMOVE_VALUE_HEADER: 'Remove Value from List',
    LIST_DETAILS_REMOVE_VALUE_MESSAGE: 'Are you sure you want to remove value {{value}} from list?',
    PROTECT_RULES: 'Protect Rules',
    LAST_UPDATE: 'Last Update',
    LAST_UPDATED: 'Last Updated',
    CONTACT_SUPPORT: 'Contact Support',
    OPEN: 'Open',
    CLOSED: 'Closed',

    // Card fingerprint
    ALLOWED_CARDS: 'Allowed Cards',
    BLOCK_CARDS: 'Blocked Cards',
    ALLOWED: 'Allowed',
    BLOCKED: 'Blocked',
    REMOVE_FROM_LIST: 'Remove from list',
    ADD_CARD_TO_LIST_SUCCESS_TITLE: 'Action Successful',
    ADD_CARD_TO_LIST_SUCCESS_MESSAGE: 'Card was added to the Approved/Blocked Card List',

    // Rule audit log
    RULE_AUDIT_LOG_DESCRIPTION:
      'A detailed list of all the changes made to this rule since creation',
    TABLE_HEADER_RULE_AUDIT_AUDITED_AT: 'Date of Action',
    TABLE_HEADER_RULE_AUDIT_USER: 'User',
    TABLE_HEADER_RULE_DIFF_DELTA: 'Action',
    RULE_CHANGED: 'Rule Changed',
    RULE_CREATED: 'Rule Created',
    STATUS_CHANGED: 'Status changed from {{from}} to {{to}}',
    DESCRIPTION_CHANGED: 'Description Changed',
    CHANGED_FROM: 'Changed From',
    SIMULATION_PERFORMED: 'Simulation Performed',

    // VirtualaccountBankRow component

    VIRTUAL_ACCOUNT_BANK_ROW: {
      ACCOUNT_NUMBER: 'Account Number:',
      BENEFICIARY_NAME: 'Beneficiary Name:',
      SORT_CODE: 'Sort Code:',
      BIC: 'BIC:',
      COUNTRY: 'Country:',
      IBAN: 'IBAN:',
      VIEW_TRANSACTION: 'View Transactions',
      ACCOUNT_CURRENCY: 'Account Currency:',
      ISSUING_ID: 'Issuing ID:',
      ADDRESS: 'Address:',
      BANK: 'Bank:',
      ZIP: 'Zip:',
      COPY_ALL_TO_CLIPBOARD: 'Copy All To Clipboard',
      COPY_ALL: 'Copy All',
      ACCOUNT_NAME: 'Account Name:',
    },

    VIRTUAL_ACCOUNT_BANK_ROW_EXTRA_FIELD: {
      // below fields are column names which are dynamically received from API
      COUNTRY_ISO: 'Country ISO:',
      ABA_ROUTING_NUMBER: 'ABA:',
      BSB_CODE: 'BSB:',
    },

    // Issuing Cards - Reset Pin modal
    RESET_PIN_MODAL_HEADER: 'Reset PIN',
    RESET_PIN_MODAL_NEW_PIN: 'New PIN',
    RESET_PIN_MODAL_RESET: 'Confirm',
    RESET_PIN_MODAL_CANCEL: 'Cancel',
    RESET_PIN_MODAL_ACTION_COMPLETED: 'Action Complete',
    RESET_PIN_MODAL_SUCCESS_MSG: `The PIN number for card ****{{cardNumber}} has been successfully reset`,
    RESET_PIN_MODAL_ERR_HEADER: `Error Completing Request`,
    RESET_PIN_MODAL_ERR_MSG:
      'We were unable to reset the PIN for card ****{{cardNumber}} <br/> Please try again at a later time',

    // Transactions Wallets table
    TRANSACTIONS_WALLETS_TITLE: 'Wallet Transactions',
    TRANSACTIONS_WALLETS_TRANSACTION_ID: 'Transaction ID',
    TRANSACTIONS_WALLETS_TYPE: 'Type',
    TRANSACTIONS_WALLETS_AMOUNT: 'Amount',
    TRANSACTIONS_WALLETS_BAI_TOKEN: 'Bank Account Issuing Token',
    TRANSACTIONS_WALLETS_BAIT_TOKEN: 'Bank Account Issuing Transaction Token',
    TRANSACTIONS_WALLETS_ORIGINAL_AMOUNT: 'Original amount',
    TRANSACTIONS_WALLETS_CURRENCY: 'Currency',
    TRANSACTIONS_WALLETS_STATUS: 'Status',
    TRANSACTIONS_WALLETS_DIRECTION: 'Direction',
    TRANSACTIONS_WALLETS_EWALLET: 'Wallet ID',
    TRANSACTIONS_WALLETS_NAME: 'Name',
    TRANSACTIONS_WALLETS_FIRST_NAME: 'First name',
    TRANSACTIONS_WALLETS_LAST_NAME: 'Last name',
    TRANSACTIONS_WALLETS_PHONE_NUMBER: 'Phone Number',
    TRANSCATIONS_WALLETS_NOTE: 'Note',
    TRANSACTIONS_WALLETS_IBAN: 'IBAN',
    TRANSACTIONS_WALLETS_REFERENCE_IBAN: 'Reference IBAN',
    TRANSACTIONS_WALLETS_ACCOUNT_NAME: 'Sender Account Name',
    TRANSACTIONS_WALLETS_SORT_CODE: 'Sender Sort Code',
    TRANSACTIONS_WALLETS_ACCOUNT_NUMBER: 'Sender Account Number',
    TRANSACTIONS_WALLETS_REMITTER_REFERENCE: 'Sender Remitter Reference',
    TRANSACTIONS_WALLETS_RECEIVING_IBAN: 'Receiving IBAN',
    TRANSACTIONS_WALLETS_RECEIVING_IBAN_NOTE: 'Receiving IBAN Note',
    TRANSACTIONS_WALLETS_RECEIVING_ACCOUNT_REF_ID: 'Receiving Account Ref ID',
    TRANSACTIONS_WALLETS_SENDER_NAME: 'Sender Name',
    TRANSACTIONS_WALLETS_TRANSACTION_TOKEN: 'Transaction ID',
    WALLET_FINAL_BALANCE: 'Balance',

    // Auditing table
    AUDITING_TITLE: 'Audit Log',
    AUDITING_DATE_OF_ACTION: 'Date of Action',
    AUDITING_USER: 'User',
    AUDITING_ROLE: 'Role',
    AUDITING_ACTION: 'Action',
    AUDITING_ACTION_TYPE: 'Action Type',
    AUDITING_ACTION_ID: 'ID',
    AUDITING_STATUS: 'Status',
    AUDITING_PAGE_URL: 'Page URL',
    AUDITING_IP: 'IP',
    AUDITING_DEVICE: 'Device',
    AUDITING_BROWSER: 'Browser',
    AUDITING_LOCATION: 'Location',

    // Auditing - side menu
    AUDITING_ACTION_DETAILS_LABEL: 'Action Details',
    AUDITING_USER_DETAILS_LABEL: 'User Details',
    AUDITING_USER_ADDITIONAL_INFORMATION: 'Additional Information',
    AUDITING_DESCRIPTION: 'Description',

    // Auditing - action description
    AUDITING_CHANGED_PERSONAL_DETAILS: `The user changed their name from {{old_first_name}} {{old_last_name}} to {{new_first_name}} {{new_last_name}}`,
    AUDITING_CHANGED_PASSWORD: 'The user changed their password',
    AUDITING_CHANGED_BUSINESS_DETAILS: `The user changed the accounts Legal Business name from {{old_business_name}} to {{new_business_name}}\n and/or The user changed the accounts VAT/IVA number from {{old_tax_id}} to {{new_tax_id}}`,
    AUDITING_CREATE_BANK_ACCOUNT: 'The user added a new bank account to the account',
    AUDITING_CREATE_BANK_ACCOUNT_FIELD_LABEL: 'New Account:',
    AUDITING_UPDATE_BANK_ACCOUNT_FIELD_LABEL: 'Edited Fields:',
    AUDITING_UPDATE_BANK_ACCOUNT: `The user edited information pertaining to {{old_account_name}}`,
    AUDITING_DELETE_BANK_ACCOUNT_LABEL: `Account Number:`,
    AUDITING_DELETE_BANK_ACCOUNT: `The user deleted the bank account {{old_account_name}}`,
    AUDITING_SAVE_CHECKOUT_CONFIG: `The user changed elements of the Checkout Customization`,
    AUDITING_PAYMENT_LINK_DEACTIVATED: 'The user deactivated a payment link',
    AUDITING_EDIT_SETTLEMENT_CONFIGURATION_BANK_ACCOUNT: `The user edited the bank account's settlement configurations`,

    AUDITING_UPDATE_ALLOWED_USER_DOMAINS:
      'The user made changes to the approved list of domains for inviting users',
    AUDITING_INVITE_NEW_USER: 'The user has invited a new user',
    AUDITING_INVITE_NEW_USER_LABEL: 'Invited User:',
    AUDITING_EDIT_USER: `The user has changed the role of {{full_name}} from {{old_role}} to {{new_role}}`,
    AUDITING_DELETE_USER: `The user has deleted user with email {{email}}`,
    AUDITING_EWALLET_CREATE: 'A new eWallet with a new Contact was created',

    AUDITING_UPDATED_CONTACT_DESCRIPTION: 'An existing contact was updated',
    AUDITING_UPDATED_FIELDS_CONTACT_ID: 'Contact ID:',
    AUDITING_UPDATED_FIELDS_WALLET_ID: 'Wallet ID:',
    AUDITING_UPDATED_FIELDS_UPDATED_FIELDS: 'Updated Fields:',
    AUDITING_UPDATED_FIELDS_EMAIL: 'Email:',
    AUDITING_UPDATED_FIELDS_SEND_NOTIFICATIONS: 'Contact removed from notification list:',
    AUDITING_UPDATED_FIELDS_FIRST_NAME: 'First name:',
    AUDITING_UPDATED_FIELDS_LAST_NAME: 'Last name:',
    AUDITING_UPDATED_FIELDS_GENDER: 'Gender:',
    AUDITING_UPDATED_FIELDS_IDENTIFICATION_NUMBER: 'Identification number:',
    AUDITING_UPDATED_FIELDS_IDENTIFICATION_TYPE: 'Identification type:',
    AUDITING_UPDATED_FIELDS_PHONE_NUMBER: 'Phone number:',
    AUDITING_UPDATED_FIELDS_DATE_OF_BIRTH: 'Date of birth:',
    AUDITING_UPDATED_FIELDS_LINE_1: 'Street address 1:',
    AUDITING_UPDATED_FIELDS_LINE_2: 'Street address 2:',
    AUDITING_UPDATED_FIELDS_STATE: 'State:',
    AUDITING_UPDATED_FIELDS_ZIP: 'Zip:',
    AUDITING_UPDATED_FIELDS_CITY: 'City:',
    AUDITING_UPDATED_FIELDS_COUNTRY: 'Country:',
    AUDITING_UPDATED_FIELDS_NATIONALITY: 'Nationality',
    AUDITING_UPDATED_FIELDS_TRANSACTION_PERMISSION: 'Transaction permission',
    AUDITING_UPDATED_FIELDS_TRANSACTION_PERMISSIONS: 'Transaction permissions',
    AUDITING_UPDATED_FIELDS_ROLE_IN_COMPANY: 'Role in company',

    AUDITING_ADD_CONTACT_DESCRIPTION: 'A new contact was added to an existing wallet',
    AUDITING_ADD_FIELD_CONTACT_NAME: 'Contact Name:',
    AUDITING_ADD_FIELD_WALLET: 'Wallet:',

    AUDITING_DELETE_CONTACT_DESCRIPTION: 'An existing contact was deleted from a wallet',
    AUDITING_DELETE_FIELD_CONTACT_NAME: 'Contact name',
    AUDITING_DELETE_FIELD_WALLET: 'Wallet ID',
    AUDITING_DELETE_FIELD_CONTACT: 'Contact ID',

    AUDITING_ADD_REMOVE_WEBHOOK:
      'The user has Added and/or Removed actions that trigger the webhook URL',
    AUDITING_EDITED_WEBHOOK_URL: `The user has changed the Webhook URL`,
    AUDITING_EDITED_WEBHOOK_URL_REMOVED_EVENTS: 'Removed Events',
    AUDITING_EDITED_WEBHOOK_URL_ADDED_EVENTS: 'Added Events',
    AUDITING_ROTATE_API_KEYS_DESCRIPTION: 'The user performed or scheduled an Api keys rotation',
    AUDITING_ROLLBACK_API_KEYS_DESCRIPTION: 'The user performed an Api keys rollback',

    AUDITING_EXPORT_TABLE: `The user has exported data from the {{type}} table`,
    AUDITING_MASS_INVOICE_CREATE_UPLOAD: 'The user successfully uploaded a Mass Payments file',

    AUDITING_DOWNLOAD_SAMPLE_FILE: `A {{type}} sample file was downloaded`,
    AUDITING_DOWNLOAD_REPORT: `The user downloaded a {{type}} report`,

    AUDITING_MASS_PAYOUTS_CREATE_UPLOAD: 'The user successfully uploaded a Mass Payouts file',
    AUDITING_REPORT_ID: 'Report ID',
    AUDITING_REPORT_NAME: 'Report Name',

    AUDITING_GROUP_PAYMENT_PAYMENTS_LIST: 'Payments:',
    AUDITING_GROUP_PAYMENT_PAYMENTS_REFUNDED_LIST: 'Payments refunded:',
    AUDITING_GROUP_PAYMENT_REFUND_SUM: 'Sum of Refund:',

    AUDITING_CANCEL_PAYMENT: 'Payment was cancelled',
    AUDITING_REJECT_PAYMENT: 'Payment was rejected',
    AUDITING_REVERSE_PAYMENT: 'Payment was reversed',

    AUDITING_CANCEL_PAYOUT: 'Payout was cancelled',

    AUDITING_CREATE_PAYMENT: 'The user created a payment',

    AUDITING_CREATE_REFUND: 'Refund was completed',

    AUDITING_FULL_REFUND: 'A full refund was issued.',

    AUDITING_PARTIAL_REFUND: 'A partial refund was issued.',

    AUDITING_COMPLETED_REFUND: 'Refund was completed',

    AUDITING_ACTIVATE_CARD: 'Card {{card_bin}}****{{card_number}} was Activated',

    AUDITING_BLOCKED_CARD: 'Card {{card_bin}}****{{card_number}} was blocked',

    AUDITING_UNBLOCKED_CARD: 'Card {{card_bin}}****{{card_number}} was unblocked',

    AUDITING_EWALLET_ACTIVATED: 'Wallet was activated',
    AUDITING_EWALLET_DEACTIVATED: 'Wallet was deactivated',

    AUDITING_RESET_PIN_SUCCESS: 'Success- User changed the PIN {{card_id}}',

    AUDITING_CANCEL_GROUP_PAYMENT: 'The user canceled the Group payment',

    AUDITING_REFUND_GROUP_PAYMENT: 'The user refunded all payments in a group payment',

    AUDITING_EWALLET_UPDATE: 'The user updated fields in a Wallet',

    AUDITING_RELEASE_FUNDS_FROM_ESCROW: 'The user released funds from a payment that was in Escrow',

    AUDITING_CHECKOUT_SAVE_LOGO_ADDED: 'Logo Added',
    AUDITING_CHECKOUT_SAVE_LOGO_REMOVED: 'Logo Removed',
    AUDITING_CHECKOUT_SAVE_COLOR_CHANGE: 'Color Changed to #{{new_color}}',
    AUDITING_CHECKOUT_SAVE_SUPPORT_PHONE_CHANGE: 'Support Phone Changed to {{new_phone_number}}',
    AUDITING_CHECKOUT_SAVE_SUPPORT_EMAIL_CHANGE: 'Support Email Changed to {{new_support_email}}',
    AUDITING_CHECKOUT_SAVE_SUPPORT_WEBSITE_CHANGE: 'Support Website',
    AUDITING_CHECKOUT_SAVE_PRIVECY_POLICY: 'Privacy Policy',
    AUDITING_CHECKOUT_SAVE_ORGANIZATION_TERMS: 'Terms & Conditions',
    AUDITING_CHECKOUT_SAVE_PAYMENT_METHODS_ADD_REMOVE: 'Payment Methods Added/Removed',
    AUDITING_CHECKOUT_SAVE_PAYMENT_METHOD_ADDED: 'Added',
    AUDITING_CHECKOUT_SAVE_PAYMENT_METHOD_REMOVED: 'Removed',
    AUDITING_CHECKOUT_SAVE_CTA_TEXT_OPTION: 'Button Text',

    AUDITING_UPDATED_FIELDS: 'Updated Fields:',
    AUDITING_CHANGE_FROM_TO: '{{fieldName}} Changed from {{oldValue}} to {{newValue}}',
    AUDITING_CHANGE_ADDED: '{{fieldName}} {{value}} Added',
    AUDITING_CHANGE_REMOVED: '{{fieldName}} {{value}} Removed',
    AUDITING_DISABLE_RULE: 'The user disabled an existing rule',
    AUDITING_ENABLE_RULE: 'The user enabled an existing rule',
    AUDITING_DELETE_RULE: 'The user deleted an existing rule',
    AUDITING_UPDATE_RULE: 'The user updated an existing rule',
    AUDITING_ADD_RULE: 'The user created a new rule under Rapyd Protect',
    AUDITING_ADD_COMMENT_PREFIX: 'The user added a comment to {{related_item_type}}',
    AUDITING_FROM_TO: 'from {{oldValue}} to {{newValue}}',
    AUDITING_TO: 'to {{newValue}}',
    AUDITING_QUARANTINE_DECLINE_TRANSACTION:
      'The user blocked a transaction that was under review by Rapyd Protect',
    AUDITING_QUARANTINE_APPROVE_TRANSACTION:
      'The user approved a transaction that was under review by Rapyd Protect',
    AUDITING_COLLECT_CERTIFICATION: 'The user requested to certify their Collect API integration',
    AUDITING_CREATE_HOSTED_PAGE_FOR_PAYMENT:
      'The user create a hosted page for completing a payment',

    AUDITING_CREATE_PAYOUT: 'The user created a payout',

    AUDITING_DELETE_EWALLET: 'Ewallet has been deleted by user',

    AUDITING_CREATE_CUSTOMER: 'A new customer was created, {{id}}',

    AUDITING_VERIFY_IDV: 'A new IDV verification was initiated',

    AUDITING_REPLACE_IDV_CARD: 'The user has replaced card',

    AUDITING_ADD_IDV_CARD: 'The user has added card',

    AUDITING_RENEW_IDV_SUBSCRIPTION: 'The user has renewed subscription',

    AUDITING_CANCEL_IDV_SUBSCRIPTION: 'The user has canceled subscription',

    AUDITING_CREATE_VIRTUAL_IBAN: 'The user has created an IBAN',

    AUDITING_CREATE_VIRTUAL_ACCOUNT: 'The user has created a virtual account',

    AUDITING_CREATE_CAPTURED_PAYMENT: 'The user has created a captured payment',

    AUDITING_UPDATE_CUSTOMER:
      'The user has changed the payment method defined as the default for the customer',

    AUDITING_UPDATE_CUSTOMER_EDIT_ADDRESS: 'The user has changed the addresses',

    AUDITING_UPDATE_CUSTOMER_ADD_ADDRESS: 'The user has added an address',

    AUDITING_DELETE_CUSTOMER: 'An existing customer was deleted',

    AUDITING_CUSTOMER_ADD_CARD: 'A new payment method was added to a customer',
    AUDITING_CUSTOMER_DELETE_CARD: 'A payment method was removed from a customer',

    AUDITING_ISSUING_REQUEST: 'A request to issue physical cards was submitted',

    AUDITING_ISSUING_REQUEST_NUMBER_OF_CARDS: 'Number of Cards',
    AUDITING_ISSUING_REQUEST_CONTACT: 'Contact',
    AUDITING_ISSUING_REQUEST_CARD_PROGRAM: 'Card Program',

    AUDITING_FUNDING_REQUEST: 'A request to fund the clients account was submitted',

    AUDITING_FUNDING_REQUEST_BANK: 'Bank',
    AUDITING_FUNDING_REQUEST_AMOUNT: 'Amount',

    AUDITING_DELETE_BENEFICIARY_REQUEST: 'The user deleted an inactive beneficiary',
    AUDITING_DELETE_BENEFICIARY_NAME_LABEL: `Beneficiary Name:`,
    AUDITING_DELETE_BENEFICIARY_ID_LABEL: `Beneficiary Id:`,

    AUDITING_DELETE_SENDER_REQUEST: 'The user deleted an inactive sender',
    AUDITING_DELETE_SENDER_NAME_LABEL: `Sender Name:`,
    AUDITING_DELETE_SENDER_ID_LABEL: `Sender Id:`,

    AUDITING_CREATE_SENDER_REQUEST: ' The user created a new sender',
    AUDITING_CREATE_SENDER_NAME_LABEL: `Sender Name:`,
    AUDITING_CREATESENDER_ID_LABEL: `Sender Id:`,

    AUDITING_CREATE_WALLET_EWALLET_ID: 'Ewallet Id',
    AUDITING_CREATE_WALLET_CONTACT_ID: 'Contact Id',
    AUDITING_CREATE_WALLET_CONTACT_FIRST_NAME: 'Contact First Name',
    AUDITING_CREATE_WALLET_CONTACT_LAST_NAME: 'Contact Last Name',

    AUDITING_REQUEST_ACCESS_PMT: 'A user request access to a no-active payment method',
    AUDITING_REQUEST_ACCESS_POMT: 'A user request access to a no-active payout method',
    AUDITING_PMT_ACTIVATED: 'A deactivated Payment method was activated by a user',
    AUDITING_POMT_ACTIVATED: 'A deactivated Payout method was activated by a user',
    AUDITING_PMT_DEACTIVATED: 'An Active Payment method was deactivated by a user',
    AUDITING_POMT_DEACTIVATED: 'An Active Payout method was deactivated by a user',

    AUDITING_CREATE_CUSTOMER_COUPON: 'A Coupon was added to an existing customer',
    AUDITING_COUPON_ID_LABEL: 'Coupon Id',
    AUDITING_CREATE_COUPON_DURATION: 'Duration',
    AUDITING_DELETE_COUPON: 'The coupon was deleted',
    AUDITING_CREATE_COUPON_DISCOUNT: 'Discount',
    AUDITING_CREATE_COUPON_MAX_REDEMPTION: 'Max redemptions',
    AUDITING_CREATE_COUPON_REDEEM_BY: 'Redeem by date',
    AUDITING_CREATE_COUPON: 'A coupon was created',

    AUDITING_CREATE_CUSTOMER_COUPON_CUSTOMER_ID: 'Customer ID:',
    AUDITING_CREATE_CUSTOMER_COUPON_CUSTOMER_NAME: 'Customer Name:',
    AUDITING_CREATE_CUSTOMER_COUPON_DISCOUNT: 'Discount:',
    AUDITING_CREATE_CUSTOMER_DISCOUNT_PERCENT: '{{value}}% off',
    AUDITING_CREATE_CUSTOMER_COUPON_DURATION: 'Duration:',
    AUDITING_CREATE_CUSTOMER_COUPON_DURATION_REPEATING: 'Repeating for {{months}} months',
    AUDITING_GENERAL_ERROR: 'An error occurred while trying to complete the action-error code:',
    AUDITING_THRESHOLDS_UPDATED:
      'The user tried to update the minimum thresholds for a client wallet',
    AUDITING_ISSUE_CARD: 'The user has issued a corporate card',
    // Auditing Product

    AUDITING_DELETE_PRODUCT: 'An existing product was deleted',
    AUDITING_CREATE_PRODUCT: 'A new product was created',
    AUDITING_UPDATE_PRODUCT: 'An existing product was updated',
    AUDITING_ACTIVATE_PRODUCT: 'A previously inactive product was activated',
    AUDITING_DEACTIVATE_PRODUCT: 'An active product was deactivated',

    // Auditing Plan

    AUDITING_CREATE_PLAN: 'A Pricing plan to be used for subscriptions was created',

    // Auditing Subscription

    AUDITING_CREATE_SUBSCRIPTION: 'The user create a subscription',
    AUDITING_GENERATE_SUBSCRIPTION_HOSTED_PAGE:
      'The user create a hosted page for completing a subscription payment',
    GENERATE_SUBSCRIPTION_HOSTED_PAGE:
      'The user create a hosted page for completing a subscription payment',

    AUDITING_CONVERT_CURRENCIES: 'The user converted currency within their account',
    // Auditing Dispute
    AUDITING_DISPUTE_ACCEPTED_DESCRIPTION: 'A disputed payment was accepted by a user',
    AUDITING_DISPUTE_CHALLENGE_DESCRIPTION:
      'Evidence was submitted by the user to challenge a disputed payment',

    AUDITING_DISPUTE_PAYMENT_ID: 'Payment ID',
    AUDITING_DISPUTE_DISPUTE_ID: 'Dispute ID',
    DELETE_ORGANIZATION: 'Organization deleted by the owner',
    DISABLE_ORGANIZATION: 'Organization disabled by the owner',

    // Auditing helpdesk
    AUDITING_CREATE_TICKET_DESCRIPTION:
      'The user submitted a support ticket through the Contact us page',
    AUDITING_CREATE_TICKET_ID: 'Ticket ID',

    // Auditing Transfer FX
    AUDITING_TRANSFER_WITH_FX: `The user made a transfer between wallets with a currency conversion.
      Transferred {{sell_amount}} {{sell_currency}} to {{buy_amount}} {{buy_currency}},\n Originating Wallet: {{source_ewallet}}\n Receiving Wallet: {{destination_ewallet}}`,

    // Auditing edit setllement configuration
    FREQUENCY: 'Frequency',
    FREQUENCY_WEEKLY_DAY: 'Frequency weekly day',
    MIN_SETTLEMENT_AMOUNT: 'Min. settlement amount',

    //Auditing Users Roles
    AUDITING_CREATE_USER_ROLE: 'A new customized user role was created',
    AUDITING_EDIT_USER_ROLE: 'A customized user role was edited',
    AUDITING_DELETE_USER_ROLE: 'A customized user role was deleted',
    AUDITING_USERS_ROLE_ROLE_NAME: `Role Name:`,

    // Auditing Update Subscription
    AUDITING_UPDATE_SUBSCRIPTION_FIELD_LABEL: 'Edited Fields:',
    AUDITING_UPDATE_SUBSCRIPTION_OLD_PAYMENT_METHOD: 'Previous payment method',
    AUDITING_UPDATE_SUBSCRIPTION_PAYMENT_METHOD: 'Payment Method',

    // Confirmation modal
    CONFIRM_MODAL_YES: 'Yes',
    CONFIRM_MODAL_NO: 'No',
    CONFIRM_MODAL_CONFIRM: 'Confirm',
    CONFIRM_MODAL_CANCEL: 'Cancel',
    ACTIVATE_CARD_HEADER: `Activate Card`,
    ACTIVATE_CARD_MESSAGE: `Do you want to activate card number ***{{card_number}}<br/>This action <strong>cannot</strong> be reversed`,
    BLOCK_CARD_HEADER: `Block Card`,
    BLOCK_CARD_MESSAGE: `Do you want to block card number ***{{card_number}}<br/>This action <strong>can</strong> be reversed`,
    UNBLOCK_CARD_HEADER: `Unblock Card`,
    UNBLOCK_CARD_MESSAGE: `Do you want to unblock card number ***{{card_number}}<br/>This action <strong>can</strong> be reversed`,
    CANCEL_PAYOUT_HEADER: 'Cancel Payout',
    CANCEL_PAYMENT_HEADER: 'Cancel Payment',
    CANCEL_GROUP_PAYMENT_HEADER: 'Cancel Group Payment',
    PAYCODE_HEADER: 'Paycode',
    CREATE_PAYMENT_HEADER: 'Create Payment',
    CREATE_PAYMENT_SUCCESS_HEADER: 'Payment Created',
    CREATE_PAYMENT_FAILURE_HEADER: 'Payment Request was rejected',
    CREATE_PAYMENT_ERROR_HEADER: 'Create Payment Error',
    CREATE_PAYMENT_ERROR_MESSAGE:
      'There was an error creating your payment, please try again at a later time',
    CANCEL_PAYOUT_MESSAGE:
      'Are you sure you want to cancel this payout?<br/>{{payout_amount}} {{currency}} will NOT be paid to {{beneficiary_name}}',
    ACTION_CONFIRMED: 'Action Confirmed',
    PAYOUT_CANCELED: '<b>{{payout_id}}</b><br/> has been canceled',

    PAYMENT_CANCELED: '<b>{{payment_id}}</b><br/> has been canceled',

    PAYMENT_REJECTED: '<b>{{payment_id}}</b><br/> has been rejected',
    PAYMENT_REVERSED: '<b>{{payment_id}}</b><br/> has been reversed',

    GROUP_PAYMENT_CANCELED_HEADER: 'Group Payment Cancelled',
    GROUP_PAYMENT_CANCELED_BODY: '<b>{{group_payment_id}}</b><br/> was successfully cancelled.',
    GROUP_PAYMENT_ERROR_HEADER: 'Error Cancelling Group Payment',
    GROUP_PAYMENT_ERROR_BODY:
      'There was an error trying to cancel the group payment, please try again at a later time',
    CANCEL_PAYMENT_MESSAGE: `Are you sure you want to cancel this payment? <b>{{payment_id}}</b> will no longer be active`,
    CANCEL_GROUP_PAYMENT_MESSAGE: 'Cancel the following payments:',

    CREATE_GROUP_PAYMENT_REFUND_HEADER: 'Create Refund',
    CREATE_GROUP_PAYMENT_REFUND_BODY: `Complete refund of <b>{{amount}}</b> from {{group_payment_id}}?`,

    REFUND_GROUP_PAYMENT_SUCCESS_HEADER: 'Group Payment Refunded',
    REFUND_GROUP_PAYMENT_SUCCESS_BODY: `The following payments were successfully refunded: <br/> <b>{{payments_id}}</b>`,

    REFUND_GROUP_PAYMENT_ERROR_HEADER: 'Unable to Refund Group Payment',
    REFUND_GROUP_PAYMENT_ERROR_BODY:
      'There was an error trying to refund the group payment, please try again at a later time',

    // Cancel Payment modal
    CANCEL_PAYMENT_NO_BTN: 'No',
    CANCEL_PAYMENT_YES_BTN: 'Yes',
    CANCEL_PAYMENT_TITLE: 'Cancel Payment',

    // Cancel Group Payment modal
    CANCEL_GROUP_PAYMENT_NO_BTN: 'No',
    CANCEL_GROUP_PAYMENT_YES_BTN: 'Yes',

    // Dynamically Create Inputs Fields Names
    DYNAMICALLY_CREATE_INPUTS_REASON: 'Reason',
    //CardDetailsSideMenu
    CARD_DETAILS_SIDE_MENU_USER_NAME: 'Full Name',
    CARD_DETAILS_SIDE_MENU_CARD_NUMBER: 'Card Number',
    CARD_DETAILS_SIDE_MENU_EXPIRATION_DATE: 'Expiration Date',
    CARD_DETAILS_SIDE_MENU_STATUS: 'Status',
    CARD_DETAILS_SIDE_MENU_DEACTIVATE_CARD: 'Deactivate Card',
    CARD_DETAILS_SIDE_MENU_TRACKING_ID: 'Tracking ID',
    CARD_DETAILS_SIDE_MENU_CARD_TOKEN: 'Card Token',
    // EwalletSideMenu
    EWALLET_SIDE_MENU_TAB: 'Wallet',
    CARDS_SIDE_MENU_TAB: 'Issuing',
    PAYMENT_METHODS_SIDE_MENU_TAB: 'Payment Methods',
    NOTIFICATIONS_SIDE_MENU_TAB: 'Notifications',
    EWALLET_PREVIEW_DETAILS_LABEL: 'Wallet Details',
    EWALLET_PREVIEW_USER_NAME: 'Full Name',
    EWALLET_PREVIEW_PHONE_NUMBER: 'Phone Number',
    EWALLET_PREVIEW_REFERENCE_ID: 'Reference ID',
    EWALLET_PREVIEW_STATUS: 'Status',
    EWALLET_PREVIEW_TAPE: 'Type',
    EWALLET_PREVIEW_BALANCES: 'Balances',
    EWALLET_PREVIEW_TRANSACTIONS: 'Transactions',
    EWALLET_PREVIEW_TRANSACTIONS_SEE_ALL: 'See all transactions',
    EWALLET_PREVIEW_DETAILS_BTN: 'Details',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate',
    REQUEST_ACCESS: 'Request Access',
    REQUEST_ACCESS_ADD_PMT_OR_POMT: 'And',
    ACCOUNT_ACTIVATION_REQUIRED: 'Account Activation Required',
    EWALLET_MODAL_ACTIVATION_MESSAGE: 'Ewallet {{id}} has been activated',
    EWALLET_MODAL_DEACTIVATION_MESSAGE: 'Ewallet {{id}} has been deactivated',
    EWALLET_ACTIVATION_COMPLETION_QUESTION_HEADER:
      'Are you sure you want to Activate this Ewallet?',
    EWALLET_DEACTIVATION_COMPLETION_QUESTION_HEADER:
      'Are you sure you want to Deactivate this Ewallet?',
    EWALLET_ACTIVATION_QUESTION_HEADER: 'Activate eWallet',
    EWALLET_DEACTIVATION_QUESTION_HEADER: 'Deactivate eWallet',
    EWALLET_DELETE_QUESTION_HEADER: 'Delete eWallet',
    EWALLET_DELETE_COMPLETION_QUESTION_HEADER: 'Are you sure you want to delete ewallet {{id}}',
    EWALLET_DELETION_MESSAGE: 'Ewallet {{id}} has been deleted',
    EWALLET_SEE_ALL_DETAILS: 'See all details',
    TRANSFER_FUNDS: 'Transfer Funds',
    ADD_FUNDS: 'Add Funds',
    TRANSFER_FUNDS_MODAL_HEADLINE: 'Transfer Funds Between Wallets',
    TRANSFER_FUNDS_MODAL_SUB_HEADLINE:
      'Select the wallet type you would like to transfer funds to or from',
    CLIENT_WALLETS: 'Client Wallets',
    PERSONAL_OR_COMPANY_WALLETS: 'Personal or Company Wallets',
    FROM_WALLET: 'From Wallet',
    CHANGE_DIRECTION: 'Change Direction',
    TRANSFER_TO: 'Transfer To',
    TRANSFER_FROM: 'Transfer From',
    TRANSFER_WITH_FX: 'Transfer with FX',
    APPLICATION_DETAILS: 'Application Details',
    APPLICATION_TOKEN: 'Application Token',
    APPLICATION_TYPE: 'Application Type',
    APPLICATION_STATUS: 'Application Status',
    APPLICATION_CREATED_AT: 'Application Created At',
    APPLICATION_UPDATED_AT: 'Application Updated At',

    // ContactSideMenu
    CONTACT_DETAILS: 'Contact',
    CONTACT_CARDS: 'Cards',
    CONTACT_PREVIEW_PERSONAL_DETAILS_LABEL: 'Contact Details',
    CONTACT_PREVIEW_FULL_NAME: 'Full Name',
    CONTACT_PREVIEW_CONTACT_TYPE: 'Contact Type',
    CONTACT_PREVIEW_CONTACT_CREATED_AT: 'Created At',
    CONTACT_PREVIEW_CONTACT_EMAIL: 'Email',
    CONTACT_PREVIEW_CONTACT_WALLET: 'Ewallet',
    CONTACT_PREVIEW_CONTACT_PHONE: 'Phone Number',
    CONTACT_PREVIEW_CONTACT_ADDRESS: 'Contact Address',
    CONTACT_PREVIEW_IDV_DETAILS_LABEL: 'IDV Details',
    CONTACT_PREVIEW_DOB: 'Date of Birth',
    CONTACT_PREVIEW_GENDER: 'Gender',
    CONTACT_PREVIEW_IDENTIFICATION_TYPE: 'Identification Type',
    CONTACT_PREVIEW_IDENTIFICATION_NUMBER: 'Identification Number',
    CONTACT_PREVIEW_IDV_VALID: 'IDV Valid',
    CONTACT_PREVIEW_PHOTO_MATCH: 'Photo Match',
    CONTACT_CARDS_NO_CARDS_ASSOCIATED: 'There are no cards associated to this contact',
    CONTACT_PAYMENT_METHODS_NO_CARDS_ASSOCIATED:
      'There are no Payment Methods associated to this contact',
    VIEW_TRANSACTIONS: 'View Transactions',
    BACK_TO_CONTACT_TAB: 'Back to Contact tab',
    CONTACT_ADD_CARD_BUTTON: 'Add Card',
    VERIFY_IDENTITY: 'Verify Identity',
    STORE_IDENTITY: 'Store Files',
    CONTACT_PREVIEW_COMPLIANCE_PROFILE: 'Compliance Profile',

    // BeneficiariesSideMenu
    BENEFICIARIES_SIDE_MENU_SECTION_BENEFICIARY_DETAILS: 'Beneficiary Details',
    BENEFICIARIES_SIDE_MENU_SECTION_PAYOUT_METHOD: 'Payout Method',
    BENEFICIARIES_SIDE_MENU_SECTION_EMPTY_PAYOUT_METHOD: 'No payout methods found',
    BENEFICIARIES_SIDE_MENU_SECTION_LAST_5_PAYOUTS: 'Last 5 Payouts',
    BENEFICIARY_SIDE_MENU_ADDITIONAL_DATA: 'Additional Data',
    BENEFICIARIES_SIDE_MENU_MERCHANT_REFERENCE_ID: 'Reference ID',
    BENEFICIARIES_SIDE_MENU_BENEFICIARY_ALIAS: 'Name',
    BENEFICIARIES_SIDE_MENU_BENEFICIARY_BENEFICIARY_ENTITY_TYPE: 'Entity Type',
    BENEFICIARIES_SIDE_MENU_BENEFICIARY_BENEFICIARY_METHOD_TYPE_CATEGORY: 'Payout Method Category',
    BENEFICIARIES_SIDE_MENU_BENEFICIARY_CURRENCY: 'Currency',
    BENEFICIARIES_SIDE_MENU_ADDRESS: 'Beneficiary Address',
    BENEFICIARIES_SIDE_MENU_SECTION_PAYOUT_DETAILS: 'Payout Details',
    BENEFICIARIES_SIDE_MENU_NO_PAYOUTS: 'No payouts have been made by this beneficiary',
    BENEFICIARIES_SIDE_MENU_SEE_ALL_PAYOUTS: 'See all payouts',
    BENEFICIARIES_SIDE_MENU_NO_PAYOUT_DETAILS: 'No beneficiary fields found',
    ACCOUNT_NUMBER_NOT_AVAILABLE: 'Account Number Unavailable',
    BENEFICIARIES_SIDE_MENU_SECTION_ERROR_PAYOUT_METHOD: 'Error retrieving payout method',

    // Senders SideMenu
    SENDER_SIDE_MENU_HEADER: 'Sender',
    SENDERS_SIDE_MENU_SECTION_SENDER_DETAILS: 'Sender Details',
    SENDERS_SIDE_MENU_SECTION_ADDRESS: 'Sender Address',
    SENDERS_SIDE_MENU__ADDITIONAL_DATA: 'Additional Data',
    SENDERS_SIDE_MENU_SECTION_NAME: 'Name',
    SENDERS_SIDE_MENU_SECTION_COUNTRY: 'Country',
    SENDERS_SIDE_MENU_SECTION_CURRENCY: 'Currency',
    SENDERS_SIDE_MENU_SECTION_ENTITY_TYPE: 'Entity Type',
    SENDERS_SIDE_MENU_SECTION_REFERENCE_ID: 'Reference ID',
    SENDERS_SIDE_MENU_SECTION_CREATED_AT: 'Created At',

    // Virtual Account Sidemenu
    VA_TITLE: 'Virtual Account',

    // Unable to add card modal
    UNABLE_TO_ADD_CARD_HEADER: 'Cannot add card',
    UNABLE_TO_ADD_CARD_MESSAGE:
      'The Contact must pass an IDV check before they can have a card issued to them',

    // Create refund modal
    CREATE_REFUND: 'Create Refund',
    FULL_REFUND: 'Full Refund',
    PARTIAL_REFUND: 'Partial Refund',
    COMPLETE_REFUND: 'Complete Refund',
    CANCEL_REFUND: 'Cancel',
    REFUND: 'Refund',
    REASON_PLACEHOLDER: 'Type your reason',
    REFUND_CREATED: 'A refund of {{amount}} {{currency}} has been issued to <0>{{payment}}</0>',
    COMPENSATION: 'Compensation',
    VALUE_IS_BIGGER_THAN_HELD_AMOUNT: 'Value is bigger than held amount',
    REFUND_AMOUNT: 'Refund Amount',
    CREATE_REFUND_MODAL_REFUND_AMOUNT_ERROR:
      'The refunded amount must be lower than or equal to {{ amount }} {{ currency }}',

    // Release Funds modal
    RELEASE_FUNDS: 'Release Funds',
    FULL_RELEASE: 'Full Release',
    PARTIAL_RELEASE: 'Partial Release',
    RELEASE_BY_AMOUNT: 'Release By Amount',
    HELD_AMOUNT: 'Held Amount',
    TOTAL_HELD: 'Total Held',
    AMOUNT_TO_BE_RELEASE: 'Amount to be released',
    INVALID_AMOUNT_TO_RELEASE: 'Invalid amount for release in wallet',

    CANCEL: 'Cancel',
    APPLY: 'Apply',
    SEARCH: 'Search',

    // Add card modal
    addCard: {
      header: 'Add Card to Contact',
      confirmCardNumber: 'Confirm Card Number',
      cardNumber: 'Card Number',
      contactDetails: 'Contact Details',
      cardDetails: 'Card Details',
      note: 'This action is permanent, you will not be able to associate this card to another contact',

      failureModalHeader: 'Error Connecting Card',
      failureModalBody:
        'The card you tried to add was either already associated to a contact or was not found',

      successModalHeader: 'Card Successfully Added',
      successModalBody: `Card ***********{{card_number}} was associated to {{first_name}} {{last_name}} <br/> The Card is still Inactive`,
    },

    // Create payout Modal
    createPaymentLinkModal: {
      header: 'Create payment link',
      subHeader:
        'Create a payment page, send it to various recipients, and allow them to make multiple payments on it.',
      step2: {
        toggleButtonPrimary: 'Set amount',
        toggleButtonSecondry: 'Open amount',
        openAmountDescription: 'The payment amount will be set by the recipient',
        checkBoxDescription: 'Allow your recipients to modify your chosen amount',
      },
      messageModal: {
        successHeader: 'Reusable payment link created',
        successBody:
          'A payment link was successfully created with your required payment parameters. Payments will appear in the Payments table after they have been completed.',
        failureModalHeader: 'Error creating payment link',
        categoryErrorModalBody:
          'The country, currency and category combination you selected does not have any supported payment method types, change one of these parameters and try again. To view a list of available payment method go to Payment method table',
      },
    },

    //Notify on create payout modal
    notifyOnCreatePayout: {
      payoutCreatedSuccessfully: 'Your Payout was successfully created.',
      subtitle: 'You can notify your beneficiary via email that a payout was created',
      notifyBeneficiary: 'Notify Beneficiary',
      beneficiaryEmailAddress: 'Beneficiary Email Address',
      payoutConfirmationSent: 'Email Sent Successfully!',
      tooltip: 'Invalid email address',
    },

    // Additional Fields Modal
    additionalFieldsModal: {
      header: 'Additional Fields',
      phoneNumber: 'Phone Number',
      email: 'Email',
      bankName: 'Bank Name',
      bankCode: 'Bank Code',
      clabe: 'CLABE',
      accountNumber: 'Account Number',
      iban: 'IBAN',
      bicSwift: 'BIC/SWIFT',
      merchantRefId: 'Merchant Ref ID',
      identificationType: 'Identification Type',
      identificationValue: 'Identification Value',
      bankAccountHolderName: 'Bank Account Holder Name',
    },

    updateMfaPreferenceModal: {
      header: {
        totp: 'Authenticator App',
        otp: 'Please Enter Code',
        subTotp: 'Set your authenticator app',
      },
      description: 'Change your default security verification method',
      setUp: 'Set up one of these options',
    },
    AUTHENTICATOR_APP: 'Authenticator app',
    SMS_AUTHENTICATION: 'SMS Authentication',

    ACTIVE: 'Active',

    // Complete refund modal
    COMPLETE_REFUND_HEADER: 'Complete Refund',
    COMPLETE_REFUND_MESSAGE: `Are you sure you want to complete this refund?`,
    REFUND_COMPLETED: '<b>{{token}}</b> has been completed.',

    // Refund reasons
    REASON: 'Reason',
    REFUND_DUPLICATE: 'Duplicate',
    REFUND_FRAUDULENT: 'Fraudulent',
    REFUND_REQUESTED_BY_CUSTOMER: 'Requested by customer',
    REFUND_OTHER: 'Other',

    // Filter Area
    FILTER: 'Filter',
    FILTER_DESCRIPTION: 'Choose filters that will be applied to all queries in the Table.',
    FILTER_FIELD: 'Field',
    FILTER_CONDITION: 'Condition',
    FILTER_VALUE: 'Value',
    FILTER_FROM: 'From',
    FILTER_TO: 'To',
    FILTER_CANCEL: 'Cancel',
    FILTER_APPLY: 'Apply',
    FILTER_CLEAR_ALL: 'Clear All',
    FILTER_REACHED_MAXIMUM: `You've reached the maximum number of filters you can add`,
    DROPDOWN_SELECTED: 'Selected',
    SAVE_FILTER_SET: 'Save Filter Set',
    SAVE_YOUR_FILTER_SET: 'Save Your Filter Set',
    NAME_YOUR_FILTER: 'Please name your filter set',
    FILTER_SET_NAME: 'Filter Set Name',
    IS_SHARED: 'Share This Filter Set Across Your Organization',
    FILTER_DELETE: 'Delete Filter Set',
    DELETE_FILTER_SET_MODAL_HEADER: 'Are you sure you want to delete this filter set?',
    DELETE_FILTER_SET_MODAL_BODY: 'By clicking "delete" you will permanetly delete this filter set',
    FILTER_SET_CREATE_FAILURE_HEADER: 'Filter Set Not Saved',
    FILTER_SET_CREATE_FAILURE_BODY:
      'A set filter already exists with this name, try a different one',
    FILTER_SET_DELETE_FAILURE_HEADER: 'Filter Set Not Deleted',
    FILTER_SET_DELETE_FAILURE_BODY: "Your filter set couldn't delete. Try again",
    SELECT_FILTER_GROUP: 'Select Filter Group',
    SELECT_TIME_FRAME: 'Select Time Frame',
    SET_REQUIRED_DATES: 'Set Required Dates',
    // Filter Area conditions
    IS_EQUAL_TO: 'is equal to',
    IS_NOT_EQUAL_TO: 'is not equal to',
    IS_GREATER_THAN: 'is greater than',
    IS_LESS_THAN: 'is less than',
    IS_BETWEEN: 'is between',
    IS_EXACTLY: 'is exactly',
    IS: 'is',
    IS_NOT: 'is not',
    CONTAINS: 'contains',
    DOES_NOT_CONTAIN: 'does not contain',
    IS_NOT_EMPTY: 'is not empty',
    IS_BEFORE: 'is before',
    IS_AFTER: 'is after',
    ONE_OF_THE_FOLLOWING: 'one of the following',

    QUESTIONNAIRE_TIMESTAMP: 'Last saved {{date}}',
    REFUND_COMPLETION_QUESTION_HEADER: 'Refund Completion',
    REFUND_COMPLETION_QUESTION_MESSAGE: 'Are you sure you want to Complete this Refund?',
    REFUND_COMPLETION_RESPONSE_HEADER_SUCCESS_HEADER: 'Refund Completion Succeeded',
    REFUND_COMPLETION_RESPONSE_SUCCESS_MESSAGE:
      'Refund <b>{{refund_token}}</b> has been completed successfully',
    REFUND_COMPLETION_RESPONSE_HEADER_FAILURE_HEADER: 'Refund Completion Failed',
    REFUND_COMPLETION_RESPONSE_FAILURE_MESSAGE: 'Refund {{refund_token}} completion failed',

    // Onboarding questionnaire
    QUESTIONNAIRE_ON_BOARDING_FINANCIAL_TITLE:
      'Select the paragraph that mostly describes your business',
    QUESTIONNAIRE_TITLE_COMPANY_INFO: 'Company Information',
    QUESTIONNAIRE_CONTROLLING_PERSON_TITLE_EXPLAIN:
      'e.g. Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, ect.',
    QUESTIONNAIRE_TITLE_PRIMARY_AUTH: 'Primary Authorized User',
    QUESTIONNAIRE_TITLE_SHAREHOLDERS: 'Shareholder Information',
    QUESTIONNAIRE_TITLE_FINANCIAL: 'Financial Compliance',
    QUESTIONNAIRE_TITLE_DETAILED_ACTIVITY: 'Detailed Activity',
    QUESTIONNAIRE_TITLE_MSB: 'Money Service Business',
    QUESTIONNAIRE_NO_BUSINESS_OWNER_TITLE: 'No business owner',
    QUESTIONNAIRE_NO_BUSINESS_OWNER_PARAGRAPH:
      'Since there are no significant Beneficial owners in the business, please provide details of the CEO and CFO',
    QUESTIONNAIRE_BUSINESS_OWNERS_TITLE: '{{ownersNumber}} business {{owner}}',
    QUESTIONNAIRE_BUSINESS_OWNERS_PARAGRAPH:
      'Please provide the personal details of these beneficial owners',
    QUESTIONNAIRE_BUSINESS_OWNERS_ADD_PERSON_COMPANY: 'Add a person or a company',
    QUESTIONNAIRE_BUSINESS_OWNERS_EDIT_PERSON_COMPANY: 'Edit {{name}} details',
    QUESTIONNAIRE_BUSINESS_OWNERS_ADD_PERSON_COMPANY_CEO: 'Add CEO details',
    QUESTIONNAIRE_BUSINESS_OWNERS_ADD_PERSON_COMPANY_CFO: 'Add CFO details',
    QUESTIONNAIRE_BUSINESS_OWNERS_ADD_PERSON_COMPANY_CCO: 'Add CCO details',
    QUESTIONNAIRE_ON_BOARDING_CHOOSE_ENTITY: 'Choose Entity',
    QUESTIONNAIRE_ON_BOARDING_PERSON: 'Person',
    QUESTIONNAIRE_ON_BOARDING_COMPANY: 'Company',
    QUESTIONNAIRE_ON_BOARDING_COMPANY_NAME: 'Name of Legal Entity that has ownership in Company',
    QUESTIONNAIRE_ON_BOARDING_PERCENT_COMPANY: 'Percentage ownership in Company',
    QUESTIONNAIRE_ON_BOARDING_HOW_MANY: 'How many?',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_REG_NUM: 'Business Registration Number',
    QUESTIONNAIRE_BUSINESS_OWNERS_ADD_CONTROLLING_PERSON: 'Add Controlling Person',
    QUESTIONNAIRE_BUSINESS_OWNERS_EDIT_CONTROLLING_PERSON:
      'Edit Controlling Person {{name}} details',
    QUESTIONNAIRE_ON_BOARDING_PERCENT_CONTROLLING_PERSON_TOOLTIP:
      'A controlling person is defined as an executive officer or senior manager (e.g. Chief Executive Officer, Chief Financial Officer, Chief Operating Officer,  Managing Member, General Partner, President, Vice President or Treasurer) or any other individual who regularly performs similar functions.',
    QUESTIONNAIRE_SAVE: 'Save',
    QUESTIONNAIRE_DONE: 'Done',
    QUESTIONNAIRE_SAVE_AND_CONTINUE: 'Save and Continue',
    QUESTIONNAIRE_USE_RAPYD_FOR: 'I would like to use Rapyd for',
    QUESTIONNAIRE_BUSINESS_NAME: 'Official Business Name',
    QUESTIONNAIRE_ADDITIONAL_BUSINESS_NAME: 'Additional Names',
    QUESTIONNAIRE_STATEMENT_DESCRIPTOR: 'Statement Descriptor',
    QUESTIONNAIRE_BUSINESS_ADDRESS: 'Street Address',
    QUESTIONNAIRE_BUSINESS_CITY: 'City',
    QUESTIONNAIRE_BUSINESS_POST_CODE: 'Post Code',
    QUESTIONNAIRE_BUSINESS_STATE: 'State',
    QUESTIONNAIRE_BUSINESS_COUNTRY: 'Country',
    QUESTIONNAIRE_MAILING_ADDRESS: 'Mailing Address (If different)',
    QUESTIONNAIRE_REGISTRATION_COUNTRY: 'Country of Registration',
    QUESTIONNAIRE_STATEMENT_DESCRIPTOR_EXPLAIN:
      'The business name a customer will see on their card statements',
    QUESTIONNAIRE_INCORPORATION_NUMBER: 'Business Incorporation Number',
    QUESTIONNAIRE_YEAR_ESTABLISHED: 'Year Established',
    QUESTIONNAIRE_YEARS_IN_BUSINESS: 'Years in Business',
    QUESTIONNAIRE_TAX_ID_ALL_FLOWS: 'Tax Number (TAX ID/VAT/IVA)',
    QUESTIONNAIRE_EU_VAT_ID: 'EU VAT ID',
    QUESTIONNAIRE_TAX_ID: 'Tax ID',
    QUESTIONNAIRE_TAX_ID_EXPLAIN: 'The ID you use for Tax purposes. Provide if relevant',
    QUESTIONNAIRE_REGISTRATION_COUNTRY_EXPLAIN:
      'Defined at signup, if not correct, contact support',
    QUESTIONNAIRE_BUSINESS_PHONE_NUMBER: 'Business Phone Number',
    QUESTIONNAIRE_WEBSITE: 'Website',
    QUESTIONNAIRE_ACTIVITIES: 'Description of Business',
    QUESTIONNAIRE_ACTIVITIES_EXPLAIN:
      'Provide a brief background about your business and the type of products and services you provide to your end-customers',
    QUESTIONNAIRE_SERVICES: 'Industry',
    QUESTIONNAIRE_SERVICES_PROVIDED: 'Services Provided',
    QUESTIONNAIRE_SUB_MCC: 'Merchant type category',
    QUESTIONNAIRE_NAICS: 'NAICS Code',
    QUESTIONNAIRE_ANNUAL_REVENUE: 'Approx. Annual Revenue (USD)',
    QUESTIONNAIRE_TRANSACTION_VALUE: 'Average Transaction Value',
    QUESTIONNAIRE_ENTITY_TYPE: 'Entity Type',
    QUESTIONNAIRE_CERTIFICATE_OF_INCORPORATION: 'Company Incorporation Documents',
    QUESTIONNAIRE_CERTIFICATE_OF_INCORPORATION_SG: 'ACRA Document',
    QUESTIONNAIRE_SHAREHOLDER_CERTIFICATE: 'Shareholder Certificate',
    QUESTIONNAIRE_PROOF_OF_ADDRESS: 'Proof of Address',
    QUESTIONNAIRE_ADDITIONAL_PERSON: 'Additional Person',
    QUESTIONNAIRE_COMPANY_NAME: 'Company Name',
    QUESTIONNAIRE_FULL_NAME: 'Full Name',
    QUESTIONNAIRE_FIRST_NAME: 'First Name',
    QUESTIONNAIRE_LAST_NAME: 'Last Name',
    QUESTIONNAIRE_TITLE_AUTH_USER: 'Job Title',
    QUESTIONNAIRE_EMAIL_ADDRESS: 'Email Address',
    QUESTIONNAIRE_PHONE_NUMBER: 'Phone Number',
    QUESTIONNAIRE_MOBILE_PHONE_NUMBER: 'Mobile Phone Number',
    QUESTIONNAIRE_SOCIAL_SECURITY_NUMBER: 'Social Security Number',
    QUESTIONNAIRE_RESIDENTIAL_ADDRESS: 'Residential Address',
    QUESTIONNAIRE_DATE_OF_BIRTH: 'Date of Birth',
    QUESTIONNAIRE_ID_COUNTRY: 'ID Issuing Country',
    QUESTIONNAIRE_ID_TYPE: 'ID Type',
    QUESTIONNAIRE_PROOF_OF_ADDRESS_TYPE: 'Proof of Address type',
    QUESTIONNAIRE_DATE_OF_INCORP: 'Date of Incorporation',
    QUESTIONNAIRE_TITLE: 'Job Title',
    QUESTIONNAIRE_JOB_TITLE_PLACEHOLDER: 'CEO, COO, VP BizDev',
    QUESTIONNAIRE_ID_NUMBER: 'ID Number',
    QUESTIONNAIRE_IDENTITY_PROOF: 'Front of Document',
    QUESTIONNAIRE_IDENTITY_PROOF_IMG_FACE: 'Headshot',
    QUESTIONNAIRE_IDENTITY_PROOF_IMG_FACE_EXPLAIN: 'Photo of the persons face',
    QUESTIONNAIRE_IDENTITY_PROOF_BACK: 'Back of Document',
    QUESTIONNAIRE_IDENTITY_PROOF_EXPLAIN:
      'Acceptable documents:\nPassport\nGovernment issued ID\nDriver’s Licence',
    QUESTIONNAIRE_ADDRESS_PROOF: 'Proof of Address',
    QUESTIONNAIRE_ADDRESS_PROOF_EXPLAIN_INDIVIDUAL:
      "Please provide a utility bill or a rental agreement under the individual's name dated to the last 3 months",
    QUESTIONNAIRE_ADDRESS_PROOF_EXPLAIN_COMPANY:
      "Please provide a utility bill or a rental agreement under the company's name dated to the last 3 months",
    QUESTIONNAIRE_MANAGEMENT_YEARS: 'Management Experience in Years',
    QUESTIONNAIRE_NUMBER_OF_OWNERS_OR_COMPANIES:
      'The number of individuals or companies with at least a 25% stake in the company',
    QUESTIONNAIRE_NUMBER_OF_OWNERS: 'The number of people with at least a 25% stake in the company',
    QUESTIONNAIRE_NUMBER_OF_AT_LEAST_25:
      'The number of individuals or companies with at least a 25% stake in the company',
    QUESTIONNAIRE_STAKE_IN_COMPANY: 'Stake in company (%)',
    QUESTIONNAIRE_CEO_DETAILS: 'CEO details',
    QUESTIONNAIRE_CFO_DETAILS: 'CFO details',
    QUESTIONNAIRE_COO_DETAILS: 'COO details',
    QUESTIONNAIRE_CCO_DETAILS: 'CCO details',
    QUESTIONNAIRE_SINGLE_PERSON_DETAILS: 'Person details',
    QUESTIONNAIRE_CONTROLLING_PERSON_DETAILS: 'Controlling Person details',
    QUESTIONNAIRE_BENEFICIAL_OWNER: 'Beneficial owner',
    QUESTIONNAIRE_PEPS:
      'Are any of the shareholders, partners, directors, officers or legal representatives Politically Exposed Persons (PEPs)?',
    QUESTIONNAIRE_PEPS_NAMES: 'Please provide their names',
    QUESTIONNAIRE_CRIMINAL_INVESTIGATIONS:
      'Has the Company or any of its principals been subject to any criminal investigations, law enforcement proceedings, regulatory inquiries, convictions, consent decrees or similar actions by any government agencies within the past five (5) years?',
    QUESTIONNAIRE_LICENSE_OR_AUTHORIZATION:
      'Does the business need a license or authorization to operate?',
    QUESTIONNAIRE_YES: 'Yes',
    QUESTIONNAIRE_NO: 'No',
    QUESTIONNAIRE_LICENSE_OR_AUTHORIZATION_FILE: 'Business License',
    QUESTIONNAIRE_BANKING_REGULATOR: 'Regulator for banking and prudential matters',
    QUESTIONNAIRE_AML_REGULATOR: 'Regulator for AML/CTF matters',
    QUESTIONNAIRE_AML_PROGRAM:
      'Does the business maintain an Anti-Money Laundering (AML) Compliance Program manual or handbook?',
    QUESTIONNAIRE_AML_PROGRAM_FILE: 'Anti Money Laundering Compliance Manual',
    QUESTIONNAIRE_COMPLIANCE_NAME:
      'What is the name of your designated legal or compliance officer?',
    QUESTIONNAIRE_COMPLIANCE_EMAIL:
      'What is the email of your designated legal or compliance officer?',
    QUESTIONNAIRE_GOVERMENT_EXAM:
      "Do government agencies or regulators examine or audit your business' compliance program?",
    QUESTIONNAIRE_AML_APPROVED:
      'Is the AML compliance program approved by the Board or a senior committee?',
    QUESTIONNAIRE_LEGAL_REGULATORY:
      'Does the business have a legal and regulatory compliance program that includes a designated officer that is responsible for coordinating and overseeing the AML framework?',
    QUESTIONNAIRE_WRITTEN_POLICIES:
      'Has the business developed written policies documenting the processes that they have in place to prevent, detect and report suspicious transactions?',
    QUESTIONNAIRE_INTERNAL_AML_AUDIT:
      'In addition to inspections by government supervisors and inspectors, does the company have an internal audit function or other independent third party that assesses the AML policies and practices on a regular basis?',
    QUESTIONNAIRE_EXTERNAL_AUDITOR: 'Name of Internal Auditor',
    QUESTIONNAIRE_SHELL_BANKS_POLICY:
      'Does the business have a policy prohibiting accounts / relationships with shell Banks?',
    QUESTIONNAIRE_ENSURE_SHELL_BANKS:
      'Does the business have policies to reasonably ensure that they will not conduct transactions with or on behalf of shell banks through any of its accounts or products?',
    QUESTIONNAIRE_PRIVACY_POLICY:
      'Does the business have a privacy policy (including record retention procedures) that comply with applicable law?',
    QUESTIONNAIRE_RISK_BASED_ASSESSMENT:
      'Does the business have a risk-based assessment of its customer base and their transactions?',
    QUESTIONNAIRE_APPROPRIATE_EDD:
      'Does the business determine the appropriate level of enhanced due diligence (EDD) necessary for those categories of customers and transactions that the business has reason to believe pose a heightened risk of illicit activities?',
    QUESTIONNAIRE_IDENTIFICATION_PROCESS:
      'Has the business implemented processes for the identification of those customers on whose behalf it maintains or operates accounts or conducts transactions?',
    QUESTIONNAIRE_CUSTOMERS_INFO:
      "Does the business have a requirement to collect information regarding its customers' business activities?",
    QUESTIONNAIRE_CUSTOMERS_AML:
      "Does the business assess its customers' AML policies and practices?",
    QUESTIONNAIRE_CUSTOMER_INFO_REVIEW:
      'Does the business have a process to review and, where appropriate, update customer information relating to high risk client information?',
    QUESTIONNAIRE_CUSTOMER_IDENTIFICATION_RECORD:
      'Does the business have procedures to establish a record of each new customer, noting their identification documents and ‘KYC’ information?',
    QUESTIONNAIRE_CUSTOMER_TRANSACTION_ASSESSMENT:
      'Does the business complete a risk-based assessment to understand the normal and expected transactions of its customers?',
    QUESTIONNAIRE_SUSPICIOUS_TRANSACTIONS_POLICY:
      'Does the business have policies or practices for the identification and reporting of transactions that are required to be reported to the authorities?',
    QUESTIONNAIRE_CASH_TRANSACTIONS_OVERSEEING:
      'Where cash transaction reporting is mandatory, does the business have procedures to identify transactions structured to avoid such obligations?',
    QUESTIONNAIRE_CUSTOMERS_TRANSACTIONS_VERIFICATION:
      'Does the business screen customers and transactions against lists of persons, entities or countries issued by government or competent authorities?',
    QUESTIONNAIRE_BANKS_LICENSE:
      'Does the business have policies to reasonably ensure that it only operates with correspondent banks that posses licences to operate in their countries of origin?',
    QUESTIONNAIRE_SUSPICIOUS_ACTIVITY_MONITORING:
      'Does the business have a monitoring program for unusual and potentially suspicious activity?',
    QUESTIONNAIRE_AML_TRAINING:
      'Does the business provide AML training to employees on the identification and reporting of transactions that must be reported to government authorities?',
    QUESTIONNAIRE_TRAINING_SESSIONS_RECORDS:
      'Does the business retain records of its training sessions including attendance records and relevant training materials used?',
    QUESTIONNAIRE_UPDATE_AML_LAWS:
      'Does the business communicate new AML-related laws or changes to existing AML-related policies or practices to relevant employees?',
    QUESTIONNAIRE_THIRD_PARTIES:
      'Does the business employ third parties to carry out some of its functions?',
    QUESTIONNAIRE_THIRD_PARTIES_AML_TRAINING:
      'Does the business provide AML training to the relevant third parties that includes: (1)Identification and reporting of transactions that must be reported to government authorities, (2)Examples of different forms of money laundering involving the products and services, (3)Internal policies to prevent money laundering.',
    QUESTIONNAIRE_WILL_BE_PARTIALLY_SAVED_TITLE: 'Questionnaire will be partially saved',
    QUESTIONNAIRE_WILL_BE_PARTIALLY_SAVED_PARAGRAPH: `Questionnaire has been saved without the following fields that did not have a valid response: {{errors}}\n\nDo you wish to continue?`,
    QUESTIONNAIRE_ON_BOARDING_COMPLETE_APPLICATION_HEADER: 'Complete Your Application',
    QUESTIONNAIRE_ON_BOARDING_COMPLETE_APPLICATION_BODY:
      'Before you can fully activate your account, we need to know a bit more about you and your business.  This information is required for compliance with regulatory and business requirements and must be completed by a senior executive.',
    QUESTIONNAIRE_ON_BOARDING_GET_STARTED_HEADER: 'Company Information',
    QUESTIONNAIRE_ON_BOARDING_GET_STARTED_BODY:
      'Provide some basic information about your business',
    QUESTIONNAIRE_ON_BOARDING_PRIMARY_AUTH_USER_HEADER: 'Primary Authorized User',
    QUESTIONNAIRE_ON_BOARDING_PRIMARY_AUTH_USER_BODY:
      'Provide personal details about the person who will serve as "Account Owner".  This person must be authorized to sign on behalf of the business',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_OWNER_HEADER: 'Shareholder Information',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_OWNER_BODY:
      'Provide personal details about the people with a significant stake in the company.',
    QUESTIONNAIRE_ON_BOARDING_FINANCIAL_COMPLIANCE_HEADER: 'Financial Compliance',
    QUESTIONNAIRE_ON_BOARDING_FINANCIAL_COMPLIANCE_BODY:
      'Complete a questionnaire about your company’s Anti-Money Laundering policies and procedures.',
    QUESTIONNAIRE_ON_BOARDING_REVIEW_APPLICATION_HEADER: 'Review your application',
    QUESTIONNAIRE_ON_BOARDING_REVIEW_APPLICATION_BODY:
      'You’re almost done. By submitting your application, you agree to our <0>Service Agreement</0> and certify that the information you provided is complete and correct and you are authorized by your company to provide it.',
    QUESTIONNAIRE_ON_BOARDING_WELL_DONE_HEADER: 'KYB Submitted',
    QUESTIONNAIRE_ON_BOARDING_WELL_DONE_BODY: `Thank you for submitting your KYB form. We are currently reviewing your application and will let you know if any additional information is required
      As a next step in integrating with Rapyd, we encourage you to start testing our products in the Sandbox environment.
      Please note that while the application review can take up to 30 days, you can already start collecting payments from your customers.
      If you have questions about the next steps of your integration, please feel free to contact us at <0>support.rapyd.net</0>`,
    QUESTIONNAIRE_ON_BOARDING_CHECKBOX_LABEL_IS_INSTITUTE:
      'I am a financial institution registered outside of the US (requires additional compliance information)',
    QUESTIONNAIRE_ON_BOARDING_BUTTON_START: 'Start Application',
    QUESTIONNAIRE_ON_BOARDING_BUTTON_SAVE_FOR_LATER: 'Save for Later',
    QUESTIONNAIRE_ON_BOARDING_BUTTON_CREATE_ACCOUNT: 'Submit',
    QUESTIONNAIRE_ON_BOARDING_BUTTON_REVIEW_FORM: 'Review',
    QUESTIONNAIRE_ON_BOARDING_PROGRESS_BAR_TITLE: 'Your Progress',
    QUESTIONNAIRE_ON_BOARDING_PROGRESS_BAR_HAVE_COMPLETED: 'have complete',
    QUESTIONNAIRE_ON_BOARDING_BACK_TO_ACCOUNT: 'Back to My account',
    QUESTIONNAIRE_INCORPORATION_CERTIFICATE_EXPLAIN:
      'Acceptable documents:\nPrivate Companies\nArticles and Memorandum of Incorporation\nCompany Incorporation/Registration Certificate\nPublic Companies - Latest annual report',
    QUESTIONNAIRE_INCORPORATION_CERTIFICATE_EXPLAIN_SG: 'Must be from the last 3 months',
    QUESTIONNAIRE_BUSINESS_NAME_PLACEHOLDER: 'The Acme Corporation',
    QUESTIONNAIRE_BUSINESS_ADDRESS_PLACEHOLDER: '121 Main St',
    QUESTIONNAIRE_MAILING_ADDRESS_PLACEHOLDER: '121 Main St, New York, NY, 06002, USA',
    QUESTIONNAIRE_BUSINESS_INCORPORATION_NUMBER_PLACEHOLDER: '2345667',
    QUESTIONNAIRE_YEAR_ESTABLISHED_PLACEHOLDER: '1970',
    QUESTIONNAIRE_YEARS_IN_BUSINESS_PLACEHOLDER: '5',
    QUESTIONNAIRE_BUSINESS_ACTIVITIES_PLACEHOLDER:
      'What products or services do you sell, who are your customers, and when do you charge them?',
    QUESTIONNAIRE_TAX_ID_PLACEHOLDER: '123456789',
    QUESTIONNAIRE_PHONE_NUMBER_PLACEHOLDER: '242-3963',
    QUESTIONNAIRE_BIRTHDAY_PLACEHOLDER: 'dd/mm/yyyy',
    QUESTIONNAIRE_OPTIONAL_PLACEHOLDER: 'Optional',
    QUESTIONNAIRE_WEBSITE_PLACEHOLDER: 'www.mywebsite.com',
    QUESTIONNAIRE_FILE_TYPE_NOT_SUPPORTED:
      'Invalid file type. please upload a file of type .jpg, .png, .jpeg, .pdf or .tif.',
    QUESTIONNAIRE_ON_BOARDING_CHECKBOX_LABEL_IS_US:
      'I plan to collect or disburse funds in the United States and I am a registered entity in the United States',
    QUESTIONNAIRE_ON_BOARDING_CHECKBOX_LABEL_IS_MSB:
      'I am currently registered with FinCEN as a Money Service Business (MSB)',
    QUESTIONNAIRE_ON_BOARDING_DETAILED_ACTIVITY_HEADER: 'Detailed Activity',
    QUESTIONNAIRE_ON_BOARDING_DETAILED_ACTIVITY_BODY:
      'Provide additional insights regarding the classification of the company and the services it provides',
    QUESTIONNAIRE_ON_BOARDING_MSB_HEADER: 'Money Service Business',
    QUESTIONNAIRE_ON_BOARDING_MSB_BODY:
      'Provide details and documentation about the financial services your company provides',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_REG_MSB:
      'Is the Company currently registered with FinCEN as a Money Service Business (MSB)?',
    QUESTIONNAIRE_ON_BOARDING_MSB_INIT_DATE_REG: 'Date of Initial Registration as a MSB',
    QUESTIONNAIRE_ON_BOARDING_MSB_INIT_DATE_LAST_RENEW:
      'Date of Last Renewal of FinCEN registration',
    QUESTIONNAIRE_ON_BOARDING_MSB_HAS_AGENTS:
      'Is the Company an MSB that has agents that offer your services?',
    QUESTIONNAIRE_ON_BOARDING_MSB_HOW_MANY_AGENTS: 'How many Agents?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DESCRIBE_PRODUCT:
      'Product(s) or Service(s) Provided by You, the Agent, on Behalf of an MSB, Agent {{num}}:',
    QUESTIONNAIRE_ON_BOARDING_MSB_NAME_COMPANY:
      'Name of MSB Company for which You Act as an Agent, Agent {{num}}:',
    QUESTIONNAIRE_ON_BOARDING_MSB_FOCUESED_ON: 'Focused On',
    QUESTIONNAIRE_ON_BOARDING_MSB_CUSTOMER_BASE_INCLUDES: 'Your Customer base includes',
    QUESTIONNAIRE_ON_BOARDING_MSB_CUSTOMER_OR_MARKETS:
      'Customer Base or Market(s) served: include the supplemental information where applicable.',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_SHORT_TERM:
      'Does the Company offer Short Term Lending (for customers, employees, businesses,etc.)?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_SHORT_TERM_SELECT:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_BEHALF_OF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_HAVE_POLICY:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_REQ_MIN_LEN:
      'Do you have a required minimum length of term for the product offered?',
    QUESTIONNAIRE_ON_BOARDING_MSB_WHAT_IS_MIN_LEN: 'What is the type and minimum length of term?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING:
      "Does the Company offer Check Cashing (including money orders and traveler's checks) for customers, employees, businesses, etc.)?",
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_OFFER_SERVICES_ON_BEHALF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_HAVE_POLICY_DOLLAR:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_MAX_THRESHOLD:
      'What is the maximum threshold per person per day for this service?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_INDICATE_TYPE:
      'Indicate what type(s) of checks: Select all that apply.',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_LOCAL_PAYROLL:
      'Local payroll or U.S. Treasury checks only, and only for individuals',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_THIRD_PARTY:
      'All types of checks including third party checks, only for individuals',
    QUESTIONNAIRE_ON_BOARDING_MSB_DOES_OFFER_CHECK_CASHING_ALL_TYPES:
      'All types of checks, for individual and business',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_TRANS_TO_CUSTOMER:
      'Is the Company a Money Transmitter for Customers (wire transfer for customers through bank or agent)?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_TRANS_TO_CUSTOMER_FOREIGN_EXCHANGE:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_TRANS_TO_CUSTOMER_BEHALF_OF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_OWN_BEHALF: 'Own Behalf',
    QUESTIONNAIRE_ON_BOARDING_MSB_AGENT: 'Agent',
    QUESTIONNAIRE_ON_BOARDING_MSB_BOTH: 'Both',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_TRANS_TO_CUSTOMER_POLICY_DOLLAR_AMOUNT:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_TRANS_TO_CUSTOMER_MAX_THRES:
      'What is the maximum threshold per person per day for this service?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_DEALER_FOREIGN_EXCHANGE:
      'Is the Company a Dealer in Foreign Exchange (provide Foreign Currency Exchange to customers)?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_DEALER_FOREIGN_EXCHANGE_Q1:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_TRAVELERS_CHECKS:
      "Is the Company an Issuer or Seller of Traveler's checks?",
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_TRAVELERS_BEHALF_OF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_TRAVELERS_DOLLAR_AMOUNT:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_TRAVELERS_CHECKS_MAX_THRESHOLD:
      'What is the maximum threshold per person per day for this service?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_MONEY_ORDERS:
      'Is the Company an Issuer or Seller of Money Orders?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_MONEY_ORDERS_BEHALF_OF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',

    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_MONEY_ORDERS_POLICY:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_MONEY_ORDERS_MAX_THRESHOLD:
      'What is the maximum threshold per person per day for this service?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_REDEEMER_VALUE_CARDS:
      'Is the Company an Issuer/Seller/Redeemer of Stored Value Cards/Prepaid Access?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_REDEEMER_VALUE_CARDS_BEHALF_OF:
      'Do you offer this service on your own behalf, on behalf of an agent, or both?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_REDEEMER_VALUE_CARDS_POLICY:
      'Do you have a policy on the dollar amount that you provide these services for?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_ISSUER_SELLER_REDEEMER_VALUE_CARDS_MAX_THRESHOLD:
      'What is the maximum threshold per person per day for this service?',
    QUESTIONNAIRE_ON_BOARDING_MSB_HAVE_BSA:
      'Does the Company have a Bank Secrecy Act (BSA)/Anti Money Laundering Program?',
    QUESTIONNAIRE_ON_BOARDING_MSB_HAVE_BSA_NAME_OFFICER: 'Name of BSA Compliance Officer',
    QUESTIONNAIRE_ON_BOARDING_MSB_HAVE_BSA_OFFICER_CONTACT_INFO:
      'BSA Compliance Officer Contact Information',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB:
      'Is the Company licensed by any state to provide any MSB services?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_TOOLTIP:
      'It is your responsibility to check with the state department where your business is duly organized and operating to determine if you are subject to any state licensing requirements. If you are subject to state licensing and you fail to provide proof of licensure as described above within thirty days of account opening, termination of your account relationships may begin.',
    QUESTIONNAIRE_ON_BOARDING_MSB_PROVIDE_MSB_FILE: 'please provide ONE of the following below:',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_COPY_OF_LICENCE: 'Copy of license',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_DATE_LICENCE_NUMBER:
      'Date and License Numbers',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_APLICATIONS:
      'Copy of your completed, signed and dated license application(s) (If you have only recently applied)',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_REVENUE:
      'Indicate the percentage of gross revenues produced by the fees generated from the MSB products/services offered?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_REVENUE_DROPDOWN_INCIDENTAL:
      'Incidental to the overall business (less than 5% of gross revenue)',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_REVENUE_DROPDOWN_SIGNIFICANT:
      'Significant to the business (between 5% and 50% of gross revenue)',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_REVENUE_DROPDOWN_VERY_SIGNIFICANT:
      'Very significant to the business (greater than 50% of gross revenue)',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_LOCATION_MARKET_SERVED:
      'Location(s) and Market(s) served: include the supplemental information where applicable.',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_LOCATION_MARKET_SERVED_SINGLE_LOCATION:
      'Single location only',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_LOCATION_MARKET_SERVED_SINGLE_LOCATION_ONLINE_LEND:
      'Single location that offers online lending only',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_LOCATION_MARKET_SERVED_MULTI_LOCATION_IN_US:
      'Multiple locations, only within the U.S.',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_STATE_LICENCED_MSB_LOCATION_MARKET_SERVED_MULTI_LOCATION_IN_OUT_US:
      'Multiple locations, including outside the U.S.',
    QUESTIONNAIRE_ON_BOARDING_MSB_LIST_ALL_COUNTRIES: 'List Countries',
    QUESTIONNAIRE_ON_BOARDING_MSB_LIST_ALL_CITIES_STATES: 'List cities and states',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_MOBILE_OPS:
      'Does the Company engage in mobile operations that offer MSB services?',
    QUESTIONNAIRE_ON_BOARDING_MSB_IS_MOBILE_OPS_DESC:
      'Please provide description (e.g. Mobile catering business that cases check at a construction site)',
    QUESTIONNAIRE_ON_BOARDING_MSB_EXPECTED_ACTIVITY: 'Expected Activity',
    QUESTIONNAIRE_ON_BOARDING_MSB_DEPOSIT:
      'How much cash will you be depositing per month into your account(s)?',
    QUESTIONNAIRE_ON_BOARDING_MSB_WITHDRAW:
      'How much cash will you be withdrawing from your accounts per month?',
    QUESTIONNAIRE_ON_BOARDING_MSB_INCOMING_DOMESTIC:
      'What is the expected monthly dollar value of incoming domestic wires?',
    QUESTIONNAIRE_ON_BOARDING_MSB_OUTGOING_DOMESTIC:
      'What is the expected monthly dollar value of outgoing domestic wires?',
    QUESTIONNAIRE_ON_BOARDING_MSB_INCOMING_FOREIGN:
      'What is the expected monthly dollar value of incoming foreign wires?',
    QUESTIONNAIRE_ON_BOARDING_MSB_OUTGOING_FOREIGN:
      'What is the expected monthly dollar value of outgoing foreign wires?',
    QUESTIONNAIRE_ON_BOARDING_MSB_EXPECTED_INCOMING_ACH_PER_MONTH_TO_PARENT_MSB:
      'Which best describes your expected incoming ACH volume per month to your parent MSB?',
    QUESTIONNAIRE_ON_BOARDING_MSB_EXPECTED_OUTGOING_ACH_PER_MONTH_TO_PARENT_MSB:
      'Which best describes your expected outgoing ACH volume per month to your parent MSB?',
    QUESTIONNAIRE_ON_BOARDING_MSB_EXPECTED_INCOMING_ACH_PER_MONTH:
      'Which best describes your expected incoming ACH volume per month?',
    QUESTIONNAIRE_ON_BOARDING_MSB_EXPECTED_OUTGOING_ACH_PER_MONTH:
      'Which best describes your expected outgoing ACH volume per month?',
    QUESTIONNAIRE_ON_BOARDING_MSB_DESCRIBE_FACTORS_MAY_IMPACT:
      'Describe any external or seasonal factors that the Bank should understand that might impact expected transactions:',
    QUESTIONNAIRE_ON_BOARDING_MSB_ADDITIONAL_INFO:
      'Is there any additional information you would like to provide about the Company and/or the expected activity that will be conducted in your account?',
    QUESTIONNAIRE_ON_BOARDING_MSB_FINCEN_REG: 'FinCEN registration',
    QUESTIONNAIRE_ON_BOARDING_MSB_STATE_LICENCES_FOR_EACH_STATE:
      'State Licenses for each state wherein MSB operates',
    QUESTIONNAIRE_ON_BOARDING_MSB_SUMMERY_FEES_MSN_OFFERED:
      'Summary of fees for the MSB services offered',
    QUESTIONNAIRE_ON_BOARDING_MSB_SAMPLE_CUSTOMER_CONTRACTS:
      'Sample customer contract(s) shared by MSB with its customers',
    QUESTIONNAIRE_ON_BOARDING_MSB_SAMPLE_CUSTOMER_DISCLOSURES:
      'Sample customer disclosures regarding fees and interest rates for each MSB service',
    QUESTIONNAIRE_ON_BOARDING_MSB_ONSITE_INSPECTION_MSB:
      'On-site inspection of MSB (completed by third party)',
    QUESTIONNAIRE_ON_BOARDING_MSB_DROPDOWN_OPTION_NONE: 'None',
    QUESTIONNAIRE_ON_BOARDING_MSB_DROPDOWN_OPTION_LESS_50: 'Less than $50k cash in per month',
    QUESTIONNAIRE_ON_BOARDING_MSB_DROPDOWN_OPTION_BETWEEN_50_500:
      'Between $50k and $500k cash in per month',
    QUESTIONNAIRE_ON_BOARDING_MSB_DROPDOWN_OPTION_LESS_500: 'Less than $500k cash in per month',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_ASSOCIATION: 'Association/Estate/Trust',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_GOV: 'Government (Federal/State/Local)',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_INDIVIDUAL: 'Individual/Sole Proprietor',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_FINANCIAL: 'Financial Institution ',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_LLC: 'LLC',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_NON_PROFIT: 'Non Profit/Tax-Exempt (501C)',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_PARTNERSHIP: 'Partnership',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_PRIVATE_CORP: 'Private Corporation',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_PUBLIC_CORP: 'Publicly Traded Corporation',
    QUESTIONNAIRE_ON_BOARDING_ENTITY_TYPE_US_SEC_REG: 'SEC Registered Entity',
    QUESTIONNAIRE_ON_BOARDING_ARTICLE_OF_INCORP_FILE: 'Articles of Incorporation and By Laws',
    QUESTIONNAIRE_ON_BOARDING_ARTICLE_OF_ORG_FILE:
      'Articles of Organization and Operating Agreement',
    QUESTIONNAIRE_ON_BOARDING_IDS_ALL_PARTNERS_FILE: 'Identification of all partners',
    QUESTIONNAIRE_ON_BOARDING_FICTITIOUS_NAME_STATEMENT_FILE: 'Fictitious name statement',
    QUESTIONNAIRE_ON_BOARDING_IDS_ALL_PRINCIPALS_FILE: 'Identification of all principals',
    QUESTIONNAIRE_ON_BOARDING_ID_PRESIDENT_FILE: 'Identification of President',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_LIC_PRIM_STATE_FILE: 'Business Licenses for Primary states',
    QUESTIONNAIRE_ON_BOARDING_ORG_CHART_FILE: 'Capital Table/Organizational Chart',
    QUESTIONNAIRE_ON_BOARDING_ORG_CHART_FILE_TOOLTIP:
      'Please provide a Capital Table or an Organizational Chart which depicts the ownership structure of the company',
    QUESTIONNAIRE_ON_BOARDING_COLLECT_DISBURSE_VIA_ACH:
      'Will collection or disbursement be executed via ACH?',
    QUESTIONNAIRE_ON_BOARDING_ACH_COMPANY_NAME: 'ACH Company Name',
    QUESTIONNAIRE_ON_BOARDING_STATE_LIC_IN: 'States Licensed In',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_LIC: 'Business License',
    QUESTIONNAIRE_ON_BOARDING_BUSINESS_LIC_TOOLTIP:
      'Unless business is Sole Proprietor or DBA, for primary state and a list of states in which the business operates',
    QUESTIONNAIRE_FISCAL_YEAR_END: 'Fiscal year End',
    QUESTIONNAIRE_ON_BOARDING_MONTHLY_VOLUME_IN_UNITS: 'Monthly volume in units',
    QUESTIONNAIRE_ON_BOARDING_MONTHLY_VOLUME_IN_DOLLARS: 'Monthly volume in dollars',
    QUESTIONNAIRE_ON_BOARDING_MONTHLY_UNAUTH_RETURN_RATE_PERCENTAGE:
      'Unauthorized Return Rate Percentage',

    QUESTIONNAIRE_ON_BOARDING_SOLE_PROPRIETORSHIP: 'A Sole Proprietorship.',
    QUESTIONNAIRE_ON_BOARDING_PUBLIC_ACCOUNTING_FORM: 'A Registered public accounting firm.',
    QUESTIONNAIRE_ON_BOARDING_DEPARTMENT_US:
      'A Department or agency of the U.S., of any State, or of any political subdivision of a State.',
    QUESTIONNAIRE_ON_BOARDING_REG_FTC: 'Registered with the FTC.',
    QUESTIONNAIRE_ON_BOARDING_REG_SEC: 'Registered with the SEC.',
    QUESTIONNAIRE_ON_BOARDING_OPEN_FOR_PURCHASE:
      'Opening the account to finance the purchase or lease of equipment and for which payments are remitted directly by the financial institution to the vendor or lessor of the equipment.',
    QUESTIONNAIRE_ON_BOARDING_FED_REGULATED: 'A Federal or state Regulated Financial Institution.',
    QUESTIONNAIRE_ON_BOARDING_INSURANCE_REGULATED: 'A State regulated Insurance Company.',
    QUESTIONNAIRE_ON_BOARDING_PUBLIC_ACCOUNTING_FIRM:
      'A Public accounting firm registered under Section 102 of the Sarbanes-Oxley Act.',
    QUESTIONNAIRE_ON_BOARDING_ORGANIZED_US_LAW:
      'Organized under the laws of the U.S. or any State at least 51% of whose common stock or analogous equity interests are held in a listed entity.',
    QUESTIONNAIRE_ON_BOARDING_LISTED_STOCK:
      'An Entity (other than a bank) whose common stock or analogous equity interests are listed on the New York, American or NASDAQ stock exchanges.',
    QUESTIONNAIRE_ON_BOARDING_UNINCORPORATED_ASSOCIATION:
      'An Unincorporated Association (e.g. scout troop, youth sports league).',
    QUESTIONNAIRE_ON_BOARDING_A_TRUST: 'A Trust (Not formed by a state filing)',
    QUESTIONNAIRE_ON_BOARDING_FOREIGN_FINANCIAL:
      'A foreign financial institution established in a jurisdiction where the regulator of such institution maintains beneficial ownership information regarding such institution.',
    QUESTIONNAIRE_ON_BOARDING_AN_ESTATE:
      'An Estate, which exists without filing with the Secretary of State or equivalent office',
    QUESTIONNAIRE_ON_BOARDING_GOV_ENTITY: 'A U.S. & U.S. state government entity.',
    QUESTIONNAIRE_ON_BOARDING_NON_PROFIT:
      'An established nonprofit corporation or similar organization that has filed its organizational documents with the appropriate Secretary of State?',
    QUESTIONNAIRE_ON_BOARDING_IS_THE_COMPANY: 'Is the Company:',
    QUESTIONNAIRE_ON_BOARDING_EXPLANATION: 'Additional Questions:',
    QUESTIONNAIRE_ON_BOARDING_EXPLANATION_INFO:
      'If you answer yes to any of the following questions, please provide explanation in the box below.',
    QUESTIONNAIRE_ON_BOARDING_OFFICES_LOCATED_US: 'Are all offices located in the USA?',
    QUESTIONNAIRE_ON_BOARDING_OFFICES_LOCATIONS: 'Locations',
    QUESTIONNAIRE_ON_BOARDING_HAS_EVER:
      'Has the Company, any principal, officer, manager, or authorized representative ever:',
    QUESTIONNAIRE_ON_BOARDING_HAS_INDICATED:
      'Been indicted, arrested, or convicted of any crime other than minor traffic violations during the past ten years?',
    QUESTIONNAIRE_ON_BOARDING_HAS_HEARING:
      'Been the subject of an administrative hearing by any Department or Agency of the Federal Government or any State Government during the past ten years?',
    QUESTIONNAIRE_ON_BOARDING_HAS_BANKRUPTCY: 'Filed for Bankruptcy?',
    QUESTIONNAIRE_ON_BOARDING_HAS_INDICATED_ADDITIONAL_INFO: 'Additional Info',
    QUESTIONNAIRE_ON_BOARDING_HAS_BANKRUPTCY_ADDITIONAL_INFO: 'Additional Info',
    QUESTIONNAIRE_ON_BOARDING_HAS_ADDITIONAL_INFO: 'Additional Info',

    QUESTIONNAIRE_ON_BOARDING_IS_PRINCIPAL:
      'Is any principal, officer, manager, or authorized representative: (If yes, list the individual and country below.):',
    QUESTIONNAIRE_ON_BOARDING_IS_FOREIGN_POLITICAL:
      'A senior foreign political figure or family member of a senior foreign political figure?',
    QUESTIONNAIRE_ON_BOARDING_IS_FOREIGN_CORP:
      'A Senior Executive of a foreign corporation/entity?',
    QUESTIONNAIRE_ON_BOARDING_OFFSHORE_COMPANY:
      'Is this an Offshore Company or a foreign corporation/entity?',

    QUESTIONNAIRE_ON_BOARDING_FULL_NAME: 'Full Name',

    QUESTIONNAIRE_ON_BOARDING_IS_INTERNET_GAMBLING:
      'Is the Company involved in Internet Gambling (Reg GG)?',
    QUESTIONNAIRE_ON_BOARDING_EVIDENCE_GAMBLING_FILE:
      "Evidence of its legal authority to engage in the internet gambling business, such as (i) a copy of the Customer's license that expressly authorizes the Customer to engage in the Internet gambling business issued by the appropriate State or Tribal authority or, if the Customer does not have such a license, (ii) a reasoned legal opinion that demonstrates that the Customer's Internet gambling business does not involve restricted transactions;",
    QUESTIONNAIRE_ON_BOARDING_WRITTEN_COMMITMENT_FILE:
      'A written commitment by the Customer to notify the participant of any changes in its legal authority to engage in its Internet gambling business.',
    QUESTIONNAIRE_ON_BOARDING_THIRD_PARTY_CERT_FILE:
      'A third-party certification that the Customer’s systems for engaging in internet gambling business activities are reasonably designed to assure that the Customer’s internet gambling activities will remain within the licensed or otherwise lawful limits, including with respect to age or location verification.',
    QUESTIONNAIRE_ON_BOARDING_USED_FOR_NON_BUSINESS:
      'Will this account be used for any non-business purposes?',
    QUESTIONNAIRE_ON_BOARDING_IS_TELEMARKETING:
      'Will you conduct transactions involving telemarketing?',
    QUESTIONNAIRE_ON_BOARDING_IS_TOBACCO:
      'Will you conduct transactions involving the sale of tobacco, marijuana, pharma, or nutraceuticals?',
    QUESTIONNAIRE_ON_BOARDING_IS_PORN:
      'Will you conduct transactions involving pornography or adult activity?',
    QUESTIONNAIRE_ON_BOARDING_SELL_REDEEM_TRAVELERS_CHECKS:
      'Will you sell/redeem money orders, stored value cards, or travelers checks for your customers?',
    QUESTIONNAIRE_ON_BOARDING_TRANS_MONEY_TO_CUSTOMERS:
      'Will you transmit money for your customers?',
    QUESTIONNAIRE_ON_BOARDING_IS_CURRENCY_DEALER: 'Is this business a currency dealer or Exchange?',
    QUESTIONNAIRE_ON_BOARDING_IS_PSP: 'Is this business a professional services provider (PSP)?',
    QUESTIONNAIRE_ON_BOARDING_IS_OWN_ATM: 'Does this business own and/or operate ATM machines?',
    QUESTIONNAIRE_ON_BOARDING_WILL_CONDUCT_PAYROLL:
      'Will you conduct payroll transactions from the account?',
    QUESTIONNAIRE_ON_BOARDING_RECEIVES_FOREIGN_GOV_MONEY:
      'Is the Company affiliated with a foreign government or receives funds from a foreign government?',
    QUESTIONNAIRE_ON_BOARDING_RECEIVES_FOREIGN_GOV_MONEY_EXPLAIN: 'Please Explain',
    QUESTIONNAIRE_ON_BOARDING_PLEASE_EXPLAIN: 'Please Explain',
    QUESTIONNAIRE_ON_BOARDING_ADDITIONAL_REQ_FILE: 'Additional Required Files:',
    QUESTIONNAIRE_ON_BOARDING_EIN_FILE: 'EIN (SS-4 or W-9)',
    QUESTIONNAIRE_ON_BOARDING_MAJOR_POLICIES:
      'All major Policies & Procedures (BSA/AML/KYC, Cyber/Information/Data Security, etc.)',
    QUESTIONNAIRE_ON_BOARDING_MAJOR_REPORTS:
      'All major Reports & Examinations (SSAE16, Complaints, Audit, ACH, etc.) – if applicable',
    QUESTIONNAIRE_ON_BOARDING_THREE_MONTHS_BANK_STATEMENT: 'Bank Statement for last 3 months',
    MAX_FILES_REACHED: 'You are not allowed to upload more than {{maxFiles}} files.',
    QUESTIONNAIRE_ON_BOARDING_SHAREHOLDERS_CERT: "Shareholders' Certificate",
    QUESTIONNAIRE_ON_BOARDING_SHAREHOLDERS_CERT_TOOLTIP:
      "Shareholders' Certificate, or any other official equivalent document, that shows the percentages held by the entity",
    QUESTIONNAIRE_ON_BOARDING_SHAREHOLDERS_CERT_PERSON_TOOLTIP:
      "Please upload the Shareholders' Certificate, or any other official equivalent document, that shows the percentages held by the entity.",
    QUESTIONNAIRE_ON_BOARDING_ADDITIONAL_ENTITIES:
      'In case there are additional entities up the organizational structure, including natural persons, please add shareholders documents for all of them, Company Incorporation Documents for companies and ID and proof of address for individuals',
    QUESTIONNAIRE_ON_BOARDING_IS_CRYPTO:
      'Is the company engaged directly or indirectly in any cryptocurrency activities?',
    QUESTIONNAIRE_ON_BOARDING_IS_CRYPTO_PLEASE_EXPLAIN: 'Please explain',
    QUESTIONNAIRE_ON_BOARDING_IS_GAMBLING:
      'Is the company engaged directly or indirectly in any Gambling activities?',
    QUESTIONNAIRE_ON_BOARDING_IS_POS_NEEDED:
      'Are you interested in point of sale (POS) collection as well?',
    QUESTIONNAIRE_ON_BOARDING_IS_GAMBLING_PLEASE_EXPLAIN: 'Please explain',

    QUESTIONNAIRE_ERROR_MUST_BE_BIGGER_THAN: 'Value cannot be negative',

    QUESTIONNAIRE_PENDING_APPROVAL: 'Your Application is Pending Approval',
    QUESTIONNAIRE_PENDING_APPROVAL_MESSAGE:
      'Your application was successfully submitted\n' +
      'We’ll review your application and contact you shortly',

    QUESTIONNAIRE_SUBMIT_MESSAGE:
      'Click submit to begin the application review and account activation process',

    MOBILE_NOT_AVAILABLE_TITLE: 'Mobile not supported',
    MOBILE_NOT_AVAILABLE_BODY:
      'This version of the client portal is not supported on mobile. For best results, please switch to a desktop computer. \n' +
      '\n' +
      'If you still wish to proceed, tap the button below.',
    USE_DESKTOP_VERSION: 'Use desktop version',
    // Form progressBar
    FORM_PROGRESS_YOUR_PROGRESS: 'Your Progress',
    FORM_PROGRESS_COMPLETION: '{{percent}}% Completed',

    // Welcome message modal
    WELCOME_MODAL_HEADER: 'Welcome to The Rapyd Global Payments Network',
    WELCOME_MODAL_MESSAGE_BODY: `To fully activate your account and utilize all of Rapyd's products and features, complete our onboarding questionnaire under the "Activate My Account" tab"`,
    WELCOME_MODAL_HEADER_META: 'You can start accepting payments immediately.',
    WELCOME_MODAL_BTN_OK: 'Activate My Account',
    WELCOME_MODAL_BTN_CANCEL: 'Not Now',

    // SignUp Page
    SIGNUP_ACTIVATION_EXPIRED_HEADER: 'Link expired',
    SIGNUP_ACTIVATION_EXPIRED_CONTENT:
      'Your link has been expired. Please Try Logging In or Sign Up Again.',
    SIGN_UP: 'Sign Up',
    RESEND: 'Resend',
    EMAIL_NOT_RECEIVED: 'Didn’t receive the email?',
    LOG_IN: 'Log In',
    SIGNUP_INPUT_LABEL_FULL_NAME: 'Full Name',
    SIGNUP_INPUT_LABEL_FIRST_NAME: 'First Name',
    SIGNUP_INPUT_LABEL_LAST_NAME: 'Last Name',
    SIGNUP_INPUT_LABEL_EMAIL: 'Company email',
    SIGNUP_INPUT_LABEL_WEBSITE: 'Company Website',
    SIGNUP_INPUT_LABEL_ORG_NAME: 'Company Name',
    SIGNUP_INPUT_LABEL_PASSWORD: 'Password',
    SIGNUP_INPUT_LABEL_CONFIRM_PASSWORD: 'Confirm Password',
    SIGNUP_INPUT_LABEL_PHONE_NUMBER: 'Phone Number',
    ERROR_CONFIRM_PASSWORD_NO_MATCH: 'Passwords do not match',
    SIGNUP_LOGIN_TEXT: `Already have an account? `,
    SIGNUP_LOGIN_LINK: 'Sign In',
    SIGNUP_HEADER: 'Create Your Rapyd Account',
    SIGNUP_SUCCUSS_HEADER: 'Success!',
    SIGNUP_SUCCESS_HEADER: 'You’re all signed up!',
    SIGNUP_SUCCESS_DESCRIPTION:
      'Thanks for signing up to Rapyd. We’ve sent an email to {{email}} to activate your account.',
    SIGNUP_SUCCUSS_CONTENT:
      'Thank you for creating an account with Rapyd. An email has been sent to your inbox with steps on how to get started.',
    SIGN_UP_LABEL_AGREE_TO_TERMS_PREFIX: 'I agree to the ',
    SIGN_UP_LABEL_AGREE_TO_TERMS_LINK: 'Terms and Conditions',
    SIGN_UP_LABEL_LEGAL: 'Legal',
    SIGN_UP_LABEL_AGREE_TO_TERMS_SUFFIX: 'privacy policy',
    SIGN_UP_LABEL_PRIVACY_POLICY: 'Privacy Policy',
    SIGN_UP_AGREE_TO_TERMS_LABEL:
      'By signing up I agree to Rapyd <0>Network Rules</0>, <1>Privacy Policy</1> and <2>Data Privacy Agreement</2>',
    SIGN_UP_LABEL_RESTRICRED_BUSINESSES: 'Restricted Businesses',
    SIGN_UP_COUNTRY_TOOLTIP: 'The country where your business is registered',
    SIGN_UP_INCORPORATION_COUNTRY_TOOLTIP:
      'Select the country or region where your business is incorporated. If your business is not yet incorporated, we can help you register your company in Hong Kong',
    SIGNUP_PROMOCODE_CHECKBOX: 'I have a promo code',
    SIGNUP_PROMOCODE_INPUT: 'Promo Code',
    SIGNUP_DEVELOPER_CHECKBOX: 'I am a developer',
    COMPANY_WEBSITE: 'Company Website',
    COUNTRY_OF_INCORPORATION: 'Country of Incorporation',
    SIGN_UP_NO_INCORPORATION_TITLE: `By signing up, we'll help you register your company in Hong Kong.`,
    SIGN_UP_NO_INCORPORATION_SUBTITLE_DESCRIPTION: `No travel needed, just 15 minutes for you to complete the form. We do the rest! You'll get:<br>`,
    SIGN_UP_NO_INCORPORATION_SUBTITLE_FIRST_LIST_ITEM: `Business registration certificate<br>`,
    SIGN_UP_NO_INCORPORATION_SUBTITLE_SECOND_LIST_ITEM: `1 year registered office address<br>`,
    SIGN_UP_NO_INCORPORATION_SUBTITLE_THIRD_LIST_ITEM: `1 year company secretary<br>`,
    SIGN_UP_NO_INCORPORATION_SUBTITLE_FOURTH_LIST_ITEM: `Rapyd account<br>`,
    SIGN_UP_NO_INCORPORATION_LINK: `Learn more about our incorporation service.`,
    SIGN_UP_NO_INCORPORATION_BUTTON: 'Start My Incorporation',
    SIGN_UP_BUSINESS_ACCOUNT_TITLE: 'What Solutions Are You Looking For?',
    SIGN_UP_BUSINESS_ACCOUNT_TITLE_PHASE2: 'What Rapyd Solutions Fit Your Needs?',
    SIGN_UP_BUSINESS_ACCOUNT_DESCRIPTION:
      'Choose the option below that most closely fits your business.',
    SIGN_UP_BUSINESS_ACCOUNT_SUB_TITLE: `Don’t worry, you can add more capabilities later.`,
    SIGN_UP_BUSINESS_ACCOUNT_SMB_COLLECT_TITLE: 'Rapyd Collect',
    SIGN_UP_BUSINESS_ACCOUNT_SMB_COLLECT_DESCRIPTION: 'Accept Payments Globally.',
    SIGN_UP_BUSINESS_ACCOUNT_SMB_COLLECT_BUTTON: 'Start with Rapyd Collect',
    SIGN_UP_BUSINESS_ACCOUNT_SMB_BUSINESS_ACCOUNT_TITLE: 'Rapyd Business Account',
    SIGN_UP_BUSINESS_ACCOUNT_SMB_BUSINESS_ACCOUNT_DESCRIPTION:
      'Accept payments, load funds with a virtual account number, pay suppliers and business expenses from a single global account.',
    SIGN_UP_BUSINESS_ACCOUNT_SMB_BUSINESS_ACCOUNT_BUTTON: 'Start with a Rapyd Business Account',
    SIGN_UP_BUSINESS_ACCOUNT_ENTERPRISE_TITLE: 'Rapyd Enterprise',
    SIGN_UP_BUSINESS_ACCOUNT_ENTERPRISE_DESCRIPTION:
      'Custom integrated solutions for accepting payments, making payouts, issuing cards and holding funds globally.',
    SIGN_UP_BUSINESS_ACCOUNT_ENTERPRISE_BUTTON: 'Start with Rapyd Enterprise',
    SIGN_UP_BUSINESS_ACCOUNT_RAPYD_PROTECT: 'Rapyd Protect',
    WHATS_INCLUDED: `What's Included?`,
    COLLECT_PAYMENTS_GLOBALLY: 'Collect Payments Globally',
    PAYMENT_LINKS: 'Payment Links',
    AUTOMATIC_FUND_SETTLEMENTS: 'Automatic Fund Settlements',
    POWER_OF_RAPYD: 'All The Power Of Rapyd Payments',
    CORPORATE_CARDS: 'Corporate Cards',
    PRE_FUND_YOUR_ACCOUNT: 'Pre-Fund Your Account',
    SETTLEMENT_ON_DEMAND_ONLY: 'Settlement On Demand Only',
    COLLECT_PAYMENTS: 'Collect Payments',
    DISBURSE_PAYMENTS: 'Disburse Payments',
    CARD_ISSUING: 'Card Issuing',
    WALLETS: 'Wallets',
    AND_MORE: 'And More',
    SIGN_UP_BUSINESS_ACCOUNT_COMING_SOON: 'Coming soon to your region',
    SEND_PAYMENT_LINKS: 'Send Payment Links',
    PRE_BUILT_CHECKOUT: 'Pre-built Checkout',
    PRE_BUILT_SOFTWARE_INTEGRATIONS: 'Pre-built Software Integrations',
    CUSTOM_INTEGRATE_WITH_API: 'Custom integrate with API',
    PREVENT_FRAUD_WITH_RAPYD_PROTECT: 'Prevent fraud with Rapyd Protect',
    SETTLE_FUNDS_AUTOMATICALLY: 'Settle your funds automatically',
    ACCEPT_PAYMENTS_WITH_RAPYD_COLLECT: 'Accept Payments with Rapyd Collect',
    ISSUE_CORPORATE_CARDS_WITH_RAPYD_ISSUING: 'Issue Corporate Cards with Rapyd Issuing',
    FUNDS_TRANSFER_WITH_VIRTUAL_ACCOUNTS: 'Funds Transfer with Virtual Accounts',
    SETTLE_YOUR_FUNDS_ON_DEMAND: 'Settle your Funds on Demand',
    MAKE_PAYMENTS_WITH_RAPYD_DISBURSE: 'Make Payments with Rapyd Disburse',
    ISSUE_CARDS_WITH_RAPYD_ISSUING: 'Issue Cards with Rapyd Issuing',
    HOLD_FUNDS_WITH_RAPYD_WALLET: 'Hold Funds with Rapyd Wallet',
    SETUP_VIRTUAL_ACCOUNTS: 'Setup Virtual Accounts',
    PAY_SUPPLIERS_GLOBALLY: 'Pay Suppliers Globally',

    // GENERAL ERRORS
    SIGNUP_ERROR_INVALID_PARAMETERS: 'One of the parameters is invalid',
    SUBMIT_DISABLED_BUTTON_TOOLTIP: 'One of the following fields is missing or invalid',
    // Validator ERRORS
    ERROR_VALIDATOR_FULL_NAME: 'Invalid full name',
    ERROR_INVALID_PROMOCODE: 'Promo code is not valid',
    ERROR_MISSING_PROMOCODE: 'Promo code required to sign up for a POC account',
    // Create payment form
    CREATE_PAYMENT_AMOUNT: 'Amount',
    CREATE_PAYMENT_STATEMENT_DESCRIPTOR: 'Statement Descriptor',
    CREATE_PAYMENT_MERCHANT_REFERENCE_ID: 'Merchant Reference ID',
    CREATE_PAYMENT_RECEIPT_EMAIL: 'Receipt Email',
    CREATE_PAYMENT_COMPLETE_PAYMENT_URL: 'Complete Payment URL',
    CREATE_PAYMENT_ERROR_PAYMENT_URL: 'Error Payment URL',
    CREATE_PAYMENT_METADATA: 'Meta data',
    CREATE_PAYMENT_EXPIRATION: 'Expiration',
    CREATE_PAYMENT_DESCRIPTION: 'Description',
    CREATE_PAYMENT_CURRENCY: 'Currency',
    CREATE_PAYMENT_PAYMENT_METHOD: 'Payment Method',
    CREATE_PAYMENT_NO_PAYMENT_METHODE_FOR_COUNTRY_ERROR: 'This Country is not supported',
    CREATE_PAYMENT_PAYMENT_METHOD_ERROR: 'This payment method is not supported',
    CREATE_PAYMENT_OPTIONAL_FIELDS_LABEL: 'Optional Fields',
    CREATE_PAYMENT_REQUIRED_FIELDS_LABEL: 'Required Fields',
    CREATE_PAYMENT_PAYMENT_ID: 'Payment Id',
    CREATE_PAYMENT_PAYCODE: 'Paycode',
    CREATE_PAYMENT_REFERENCE_iD: 'Reference ID',
    CREATE_PAYMENT_EXPIRATION_DATE: 'Expiration Date',
    CREATE_PAYMENT_CHECKOUT_COMPLETE_URL: 'Complete URL',
    CREATE_PAYMENT_CHECKOUT_CANCEL_URL: 'Cancel URL',
    CREATE_PAYMENT_CHECKOUT_LANGUAGE: 'Language',
    CREATE_PAYMENT_SUBMIT_BTN: 'Create Payment',
    CREATE_PAYMENT_REQUEST_DECLINED_ERROR_HEADER: 'Payment Blocked',
    CREATE_PAYMENT_REQUEST_UNDER_REVIEW_ERROR_HEADER: 'Payment Under Review',

    // Create payment Link form
    CREATE_PAYMENT_LINK_HOLD_IN_ESCROW: 'Hold In Escrow',
    CREATE_PAYMENT_LINK_ESCROW_RELEASE_DAYS: 'Escrow Release Days',
    CREATE_PAYMENT_LINK_ESCROW_RELEASE_DAYS_MAX_ERROR:
      'Must be equal to or less than {{max_number}}',
    CREATE_PAYMENT_LINK_ESCROW_RELEASE_DAYS_TOOLTIP:
      'The number of days before the funds are automatically released from escrow. When not selected, funds have to be released manually. You can choose between 1-90 days',
    CREATE_PAYMENT_LINK_AUTHORIZE_ONLY: 'Authorize only',
    CREATE_PAYMENT_LINK_AMOUNT: 'Amount',
    CREATE_PAYMENT_LINK_CURRENCY: 'Currency',
    CREATE_PAYMENT_LINK_PAID_TO: 'Paid To',
    CREATE_PAYMENT_LINK_COUNTRY: 'Country',
    CREATE_PAYMENT_LINK_COUNTRY_DESCRIPTION: 'Customer location',
    CREATE_PAYMENT_LINK_PAYMENT_METHOD: 'Payment Method',
    CREATE_PAYMENT_LINK_OPTIONAL_FIELDS_LABEL: 'Optional Fields',
    CREATE_PAYMENT_LINK_REFERENCE_ID: 'Reference ID',
    CREATE_PAYMENT_LINK_REFERENCE_ID_DESCRIPTION: 'Identifier for the payment link',
    CREATE_PAYMENT_LINK_EXPIRATION_DATE: 'Expiration Date',
    CREATE_PAYMENT_LINK_COMPLETE_URL: 'Complete URL',
    CREATE_PAYMENT_LINK_CANCEL_URL: 'Cancel URL',
    CREATE_PAYMENT_LINK_LANGUAGE: 'Language',

    // Request payment method and payout method access
    REQUEST_ACCESS_PAYMENT_METHOD_DESCRIPTION:
      'Provide details about your use case and select up to five preffered payment methods.',
    REQUEST_ACCESS_PAYOUT_METHOD_DESCRIPTION:
      'Provide details about your use case and select up to five preffered payout methods.',
    COLLECT_FUNDS_FROM: 'I want to collect funds in',
    SEND_FUNDS_TO: 'I want to send funds to',
    USING: 'using',
    REQUEST_SUBMITTED: 'Thank you for submitting your request',
    REQUEST_SUCCESSFULLY_SUBMITTED:
      'Your request has been successfully submitted!\nWe will review your request and contact you as soon as possible.',
    NOT_ABLE_WHEN_PENDING:
      'Please note! By requesting access to the selected {{method_type_category}} methods,\nyou are requesting access to all related {{method_type_category}} methods.\nFor more information, contact support.',
    ACTIVATE_ACCOUNT_BEFORE_REQUEST_ACCESS:
      'To request access to additional Payment Methods, you must first activate your account',
    YOUR_REQUEST_IS_UNDER_REVIEW_PMT:
      'Your request for additional Payment Methods is currently under review',
    YOUR_REQUEST_IS_UNDER_REVIEW_POMT:
      'Your request for additional Payout Methods is currently under review',
    REQUEST_ACCESS_PMT: 'Payment Method',
    REQUEST_ACCESS_POMT: 'Payout Method',
    PAYMENT_METHOD_COUNTRIES: 'Payment Method Countries',
    PAYOUT_METHOD_COUNTRIES: 'Payout Method Countries',
    ACTIVATE_YOUR_ACCOUNT: 'Activate Your Account',
    COUNTRY_NOT_SUPPORTED: 'Country Not Supported',
    PAYER_COUNTRY: 'Payer Country',

    // Balance details tab
    BALANCE_DETAILS_NO_CARDS_ADDED: 'No <b>cards</b> added',
    BALANCE_DETAILS_NO_BANK_ADDED: 'No <b>bank</b> accounts added',
    BALANCE_DETAILS_NO_IBAN: 'You currently do not have an IBAN',

    NO_FUNDS: 'No Funds',
    NO_FUNDS_WALLET_DESCRIPTION: 'No payments have been completed yet.',
    NO_FUNDS_GENERAL_WALLET_DESCRIPTION:
      'No payments have been completed yet.  Consider performing the following actions:',
    NO_FUNDS_GENERAL_DISBURSE_DESCRIPTION:
      'Your account has not yet been funded.  Consider performing the following actions:',
    NO_FUNDS_DISCLAIMER:
      '*Request Access to Virtual Account - Rapyd can create a virtual bank account which you can fund your account by transferring funds to.',
    REQUEST_ACCESS_DESCRIPTION: 'Request Access to Virtual Account*',
    FUND_YOUR_ACCOUNT_DESCRIPTION: 'Fund your Account',
    REQUEST_ISSUED_CARDS_DESCRIPTION: 'Request Issued Cards',
    CREATE_PAYMENT_URL_DESCRIPTION: 'Create a Payment URL',
    VIEW_INSTALLATION_KEYS_DESCRIPTION: 'View your\n Installation Keys',
    ACTIVATE_PLUGIN_DESCRIPTION: 'Activate a Plugin',

    // Balance side menu thresholds
    BALANCE_SIDE_MENU_WALLET_THRESHOLDS: 'Minimum Threshold',
    BALANCE_SIDE_MENU_CONTACTS_TO_NOTIFY: 'Contacts to Notify',
    BALANCE_SIDE_MENU_EDIT_THRESHOLDS: 'Edit Thresholds',
    BALANCE_SIDE_MENU_EDIT_CONTACTS: 'Edit Contacts',
    ADD_CONTACT: 'Add Contact',
    ADD_CONTACT_FIRST_NAME: 'First Name',
    ADD_CONTACT_LAST_NAME: 'Last Name',
    ADD_CONTACT_EMAIL: 'Email',
    ADD_NEW_CONTACT: 'New',
    ADD_EXISTING_CONTACT: 'Existing',
    ADD_CONTACT_FULL_NAME: 'Full Name',
    ADD_CONTACT_PHONE_NUMBER: 'Phone Number',
    EXISTING_CONTACTS: 'Contacts',
    ADD_CONTACT_BUTTON: 'Add Contact',
    EDIT_THRESHOLD: 'Edit Thresholds',
    WALLET_THRESHOLDS_EXPLANATION:
      'Be notified when your wallet balance goes below the following thresholds in each currency',
    NO_CONTACTS: 'No contacts selected to be notified',
    WALLET_THRESHOLD_AMOUNT: 'Amount',
    ERROR_UPDATE_THRESHOLD_HEADER: 'Error Updating Threshold',
    ERROR_UPDATE_THRESHOLD_BODY:
      'There was an error updating the notification threshold for {{currenices}}.  Please try again at a later time, if the problem persists, please <0>contact support</0>',
    ERROR_UPDATE_WALLET_CONTACT_NOTIFICATION_HEADER: 'Error Updating Wallet Contact Notifications',
    ERROR_UPDATE_WALLET_CONTACT_NOTIFICATION_BODY:
      'There was an error updating the wallet notifications for {{contactsMails}}.  Please try again at a later time, if the problem persists, please <0>contact support</0>',
    ERROR_CREATE_CONTACT: 'Unable to Create Contact, check all input parameters and try again',
    ERROR_UPDATE_CONTACT: 'Unable to Update Contact, check all input parameters and try again',
    ERROR_REMOVE_CONTACT:
      'Unable to remove the Contact, Please try again at a later time, if the problem persists, please <0>contact support</0>',
    AUDITING_REMOVED_THRESHOLD: 'removed minimum threshold',
    AUDITING_CURRENCY_THRESHOLD_UPDATED_TO: 'to',
    AUDITING_CURRENCY_THRESHOLD_UPDATED_FROM: 'from',

    // Search suggestions
    SUGGESTION_COUNTRY: '2 letter country code',
    SUGGESTION_CURRENCY: '3 letter currency code',
    SUGGESTION_REQUESTED_CURRENCY: '3 letter currency code',
    SUGGESTION_DATE: 'DD Month, YYYY, HH:MM format',
    SUGGESTION_REFERENCE_ID: 'Reference ID',
    SUGGESTION_ROLE: 'Administrator, Editor, Basic',
    SUGGESTION_PAYMENT_METHOD: 'Code of the payment method',
    SUGGESTION_PAYMENT_METHODS_NAME: 'Name of the payment method',
    SUGGESTION_PAYMENT_METHODS_CATEGORY: 'Cash, Bank Transfer, Redirect, ect.',
    SUGGESTION_PAYMENT_METHODS_FLOW_TYPE: 'How the payment is completed',
    SUGGESTION_PAYMENT_METHODS_STATUS: 'Live or Not Live',
    SUGGESTION_PAYMENT_DESCRIPTION: 'Description',
    SUGGESTION_ACCOUNT_BALANCE_WALLET_ID: 'Rapyd issued wallet identifier',
    SUGGESTION_ACCOUNT_BALANCE_BALANCE: 'Sum of funds in the account',
    SUGGESTION_ACCOUNT_BALANCE_CATEGORY: 'Financial product the wallet is associated to',
    SUGGESTION_ACCOUNT_BALANCE_ACCOUNT_ID: 'Rapyd issued account identifier',
    SUGGESTION_USERS_FIRST_NAME: 'First name of the user',
    SUGGESTION_USERS_LAST_NAME: 'Last name of the user',
    SUGGESTION_USERS_EMAIL_ADDRESS: 'Email address of the user',
    SUGGESTION_AUDITING_ID: 'Rapyd issued event ID',
    SUGGESTION_AUDITING_USER: 'Email address of the user',
    SUGGESTION_AUDITING_ACTION: 'Action performed by the user',
    SUGGESTION_AUDITING_STATUS: 'Success or Error',
    SUGGESTION_AUDITING_PAGE_URL: 'Page on which the action was done',
    SUGGESTION_AUDITING_IP: 'Address of user that performed action',
    SUGGESTION_AUDITING_BROWSER: 'Used by the user that performed the action',
    SUGGESTION_PAYMENTS_ID: 'Rapyd issued payment Identifier',
    SUGGESTION_PAYMENTS_CATEGORY: 'Cash, Bank Transfer, Bank Redirect, ect.',
    SUGGESTION_PAYMENTS_ORIGINAL_AMOUNT: 'Original payment amount requested',
    SUGGESTION_PAYMENTS_PAID_AMOUNT: 'Amount that was paid by end user',
    SUGGESTION_PAYMENTS_STATUS: 'Active, Cancelled, Error, Closed',
    SUGGESTION_PAYMENTS_MERCHANT_REF_ID: 'ID that was defined by the Seller',
    SUGGESTION_PAYMENTS_REFUNDED_AMOUNT: 'Amount that was refunded',
    SUGGESTION_PAYMENTS_STATEMENT_DESCRIPTOR: 'Purchase details',
    SUGGESTION_PAYMENTS_METADATA: 'Seller defined metrics',
    SUGGESTION_REFUNDS_ID: 'Rapyd issued refund Identifier',
    SUGGESTION_REFUNDS_AMOUNT: 'Amount that seller refunded',
    SUGGESTION_REFUNDS_STATUS: 'Completed, Pending, Rejected',
    SUGGESTION_REFUNDS_PAYMENT_ID: 'Rapyd issued identifier of payment that was refunded',
    SUGGESTION_TEXTUAL_CODE: 'Textual code for completing the transaction',
    SUGGESTION_PAYOUT_PAYOUT_TYPE: 'Card, Cash, eWallet, Bank',
    SUGGESTION_PAYOUT_PAYOUT_ID: 'Payout ID',
    SUGGESTION_PAYOUT_PAYOUT_AMOUNT: 'Amount of the payout',
    SUGGESTION_PAYOUT_PAYOUT_CURRENCY: '3 letter currency code',
    SUGGESTION_PAYOUT_PAYOUT_STATUS: 'Status',
    SUGGESTION_PAYOUT_PAYOUT_METHOD_TYPE: 'Code of the payout method',
    SUGGESTION_PAYOUT_PAYOUT_REFERENCE_ID: 'ID that was defined by the payout initiator',
    SUGGESTION_PAYOUT_PAYOUT_SENDER_FULL_NAME: 'Full name of the Payer',
    SUGGESTION_PAYOUT_PAYOUT_DESCRIPTION: 'Description',

    SUGGESTION_PAYOUT_PAYOUT_SENDER_CURRENCY: '3 letter currency code',
    SUGGESTION_PAYOUT_PAYOUT_SENDER_AMOUNT: 'Amount Sent',
    SUGGESTION_PAYOUT_PAYOUT_SENDER_COUNTRY: '2 letter country code',
    SUGGESTION_PAYOUT_PAYOUT_SENDER_ID: 'Rapyd issued sender Identifier',
    SUGGESTION_PAYOUT_PAYOUT_BENEFICIARY_FULL_NAME: 'Full name of the Beneficiary',
    SUGGESTION_PAYOUT_PAYOUT_BENEFICIARY_ID: 'Rapyd issued beneficiary Identifier',
    SUGGESTION_PAYOUT_PAYOUT_BENEFICIARY_COUNTRY: '2 letter country code',
    SUGGESTION_PAYOUT_PAYOUT_ENTITY_TYPE: '2 letter country code',

    SUGGESTION_WALLETS_TRANSACTION_ID: 'Rapyd issued transaction Identifier',
    SUGGESTION_WALLETS_AMOUNT: 'Amount of the Transaction',
    SUGGESTION_WALLETS_BAI_TOKEN: 'Bank Account issuing Token',
    SUGGESTION_WALLETS_CURRENCY: '3 letter currency code',
    SUGGESTION_WALLETS_STATUS: 'Status of the Transaction',
    SUGGESTION_WALLETS_TYPE: 'Description of the transaction',
    SUGGESTION_WALLETS_DIRECTION: 'In or Out',
    SUGGESTION_WALLETS_PHONE_NUMBER: 'Phone number',
    SUGGESTION_WALLETS_NAME: 'Name associated to the wallet that transacted',
    SUGGESTION_WALLETS_ID: 'Rapyd issued wallet Identifier',
    SUGGESTION_TRANSACTION_REASON: 'Transaction Reason',
    SUGGESTION_IBAN_NOTE: 'Reference IBAN',

    SUGGESTION_WALLETS_ISSUING_CARD_ID: 'Rapyd issued card Identifier',
    SUGGESTION_WALLETS_ISSUING_CARD_TOKEN: 'Rapyd issued card Token',
    SUGGESTION_WALLETS_ISSUING_CONTACT_FIRST_NAME: 'First Name of Card Holder',
    SUGGESTION_WALLETS_ISSUING_CONTACT_LAST_NAME: 'Last Name of Card Holder',
    SUGGESTION_WALLETS_ISSUING_LAST_4_DIGITS: 'of the card',
    SUGGESTION_WALLETS_ISSUING_PHONE_NUMBER: 'of the card holder',
    SUGGESTION_WALLETS_ISSUING_EWALLET_ID: 'Rapyd issued wallet Identifier associated to the card',
    SUGGESTION_WALLETS_ISSUING_COUNTRY: '2 Letter country code',
    SUGGESTION_WALLETS_ISSUING_SUB_BIN: '2 digit number associated to the card',

    SUGGESTION_ISSUED_CARDS_CURRENCY: '3 letter currency code',
    SUGGESTION_ISSUED_CARDS_CARD_NUMBER: 'of the card',
    SUGGESTION_ISSUED_CARDS_AUTHORIZATION_NUMBER: 'Provided by the issuer',
    SUGGESTION_ISSUED_CARDS_EWALLET_ID: 'Wallet ID',
    SUGGESTION_ISSUED_CARDS_CONTACT_NAME: 'Name of card holder',
    SUGGESTION_ISSUED_CARDS_PHONE_NUMBER: 'of the card holder',
    SUGGESTION_ISSUED_POS_NAME_LOCATION: 'POS Name & Location',

    SUGGESTION_ISSUED_MERCHANT_CATEGORY_CODE: 'Merchant Category Code',
    SUGGESTION_ISSUED_PROGRAM_ID: 'Program ID',
    SUGGESTION_ISSUED_TRANSACTION_TYPE: 'Transaction ID',

    SUGGESTION_USERS_INVOICES_NAME: 'As defined by the uploader',
    SUGGESTION_USERS_INVOICES_ID: 'Rapyd issued Batch ID',
    SUGGESTION_USERS_PAYOUTS_ID: 'Rapyd issued Batch ID',
    SUGGESTION_USERS_PAYOUTS_NAME: 'As defined by the uploader',

    SUGGESTION_CUSTOMER_ID: 'Rapyd Issued identifier of the Customer',
    SUGGESTION_CUSTOMER_NAME: 'Name of the Customer',
    SUGGESTION_CUSTOMER_DEFAULT_PAYMENT_METHOD: 'Used when the payment method is not specified',
    SUGGESTION_CUSTOMER_DESCRIPTION: 'A text description of the customer',
    SUGGESTION_CUSTOMER_EMAIL: 'of the customer',
    SUGGESTION_CUSTOMER_WALLET: 'ID of the eWallet that is linked to the customer',
    SUGGESTION_CUSTOMER_PHONE_NUMBER: `Customer's primary phone number`,
    SUGGESTION_ESCROW_ID: 'Rapyd Issued identifier of the Escrow Payment',
    SUGGESTION_ESCROW_PAYMENT_ID: 'Rapyd Issued identifier of the Payment',

    SUGGESTION_REPORTS_NAME: 'Settlement, Reconciliation, ect.',
    SUGGESTION_REPORTS_ID: 'Rapyd issued Report ID',
    SUGGESTED_FILTERS: 'Suggested Filters',

    SUGGESTION_IDV_WALLET_ID: 'Rapyd issued Wallet ID',
    SUGGESTION_IDV_ID_NUMBER: 'ID number that appears on the document',
    SUGGESTION_IDV_ID_TYPE: 'Driver License, Passport, etc.',

    SUGGESTION_CONTACT_FULL_NAME: 'Name of the contact',
    SUGGESTION_CONTACT_FIRST_NAME: 'First name of the contact',
    SUGGESTION_CONTACT_LAST_NAME: 'Last name of the contact',
    SUGGESTION_CONTACT_EMAIL: 'Email of the contact',
    SUGGESTION_CONTACT_PHONE_NUMBER: 'Phone number of the contact',
    SUGGESTION_CONTACT_ID: 'Rapyd Issued ID of the Contact',
    SUGGESTION_CONTACT_TYPE: 'Personal or Business',
    SUGGESTION_CONTACT_COUNTRY: '2 letter country code',
    SUGGESTION_CONTACT_WALLET: 'Rapyd issued Wallet ID',
    SUGGESTION_CONTACT_GENDER: 'Male, Female or Other',
    SUGGESTION_CONTACT_IDENTIFICATION_TYPE: 'Passport, Drivers License, ect.',
    SUGGESTION_CONTACT_IDENTIFICATION_NUMBER: 'Document number',

    // Group Payments Suggestions
    SUGGESTION_GROUP_PAYMENTS_ID: 'Rapyd Issued identifier of the Group Payment',
    SUGGESTION_GROUP_PAYMENTS_DESCRIPTION: 'of the Group Payment',
    SUGGESTION_GROUP_PAYMENTS_REFERENCE_ID: 'Client defined ID of the Group Payment',

    // Beneficiaries Suggestions
    SUGGESTION_BENEFICIARIES_ID: 'Rapyd issued beneficiary identifier',
    SUGGESTION_BENEFICIARIES_ALIAS: 'Name of the Person or Company',
    SUGGESTION_BENEFICIARIES_ENTITY_TYPE: 'Individual or Company',
    SUGGESTION_BENEFICIARIES_CURRENCY: '3 letter currency code',
    SUGGESTION_BENEFICIARIES_CREATED_AT: 'DD Month, YYYY, HH:MM format',
    SUGGESTION_BENEFICIARIES_METHOD_TYPE: 'Beneficiary’s Default Payout Method',
    SUGGESTION_BENEFICIARIES_METHOD_TYPE_CATEGORY: 'Bank, Card, Cash, ect',
    SUGGESTION_BENEFICIARIES_MERCHANT_REFERENCE_ID: 'Beneficiary ID as defined by the user',

    // Senders Suggestions
    SUGGESTION_SENDER_ID: 'Rapyd sender`s identifier',
    SUGGESTION_SENDER_NAME: 'Alias for sender',
    SUGGESTION_SENDER_COUNTRY: 'Country of sender',
    SUGGESTION_SENDER_CURRENCY: '3 letter currency code',
    SUGGESTION_SENDER_ENTITY_TYPE: 'Individual or Company',
    SUGGESTION_SENDER_REFERENCE_ID: 'Sender’s Reference ID',
    SUGGESTION_CREATED_AT: 'DD Month, YYYY, HH:MM format',

    // No Cards To Show
    NO_CARDS_TO_SHOW: 'No Cards Or IBAN To Show',
    NO_CARDS_ASSOCIATED: 'There are no cards associated to this wallet',
    BACK_TO_WALLET_TAB: 'Back to Wallet tab',
    // Transfer funds modal
    DESTINATION_WALLET: 'To',
    ORIGINATING_WALLET: 'From',
    CURRENCY_SELECT_LABEL: 'Currency',
    MODAL_SUCCESSFUL_HEADER: 'Transfer Successful',
    MODAL_SUCCESSFUL_HEADER_TRANSFER: 'Successful Transfer',
    MODAL_FAILED_HEADER: 'Error Completing Transfer',
    SUCCESSFUL_TRANSFER_MODAL_BODY: 'The transfer of {{amount}} {{currency}} was sent successfully',
    ERROR_TRANSFER_MODAL_BODY:
      'There was an error completing the transfer request from {{source}} to {{target}}. <br> Please try again at a later time',
    TRANSFER_MODAL_HEADER: 'Transfer Funds',
    // Transfer funds audit
    BENEFICIARY_WALLET: 'Beneficiary Wallet',
    SENDER_WALLET: 'Sender Wallet',
    AMOUNT_TRANSFERRED: 'Amount Transferred',
    TRANSFER_FUND_BETWEEN_WALLETS:
      'The user transferred funds between a Client Wallet and a Customer Wallet',

    NO_AVAILABLE_FUNDS_IN_WALLET: 'No funds available to transfer from this wallet',
    AVAILABLE_BALANCE: 'Available balance',

    // Spalsh Message
    SPALSH_MSG_STICKY_TEXT: 'Welcome to Rapyd',
    SPALSH_MSG_FULL_MSG_HEADER: 'Your Account is Currently Limited',
    SPALSH_MSG_FULL_MSG_LINK: 'More Info',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_1:
      'As a limited account you can collect payments totaling $2500.',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_2:
      'Once you have reached that limit, you will not be able to collect additional payments.',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_3:
      'In order to transfer the funds you collected to your bank account, remove account limits and utilize additional Rapyd Products, you are required to activate your account by submitting the ',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_3_QUESTIONNAIRE_LINK: 'KYB Questionnaire',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_4: 'For more information view our documentation ',
    SPALSH_MSG_FULL_MSG_CONTENT_TEXT_4_RAPYD_API_LINK: 'HERE',
    // settlements tabs
    SETTLEMENTS_TAB: 'Settlements',
    SETTLEMENTS_TAB_NEXT_PAYMENTS: 'Next Payments',
    SETTLEMENTS_TAB_HISTORY: 'History',

    // settlements history table
    TABLE_HEADER_SETTLEMENTS_HISTORY_SETTLEMENT_AMOUNT: 'Settlement Amount',
    TABLE_HEADER_SETTLEMENTS_HISTORY_SETTLEMENT_CURRENCY: 'Settlement Currency',
    TABLE_HEADER_SETTLEMENTS_HISTORY_ACCOUNT_ID: 'Account ID',
    TABLE_HEADER_SETTLEMENTS_HISTORY_ACCOUNT_NUMBER: 'Account Number',
    TABLE_HEADER_SETTLEMENTS_HISTORY_DATE_PAID: 'Date Paid',
    TABLE_HEADER_SETTLEMENT_REFERENCE_ID: 'Settlement Reference ID',
    SUGGESTION_AMOUNT_SETTLEMENTS: 'Amount of payment',
    SUGGESTION_ACCOUNT_SETTLEMENTS: 'Bank account number',
    SUGGESTION_BANK_NAME: 'Name of bank of the account',

    // settlements next payments
    SETTLEMENTS_HEADER_SCHEDULED_FOR: 'Scheduled for ',
    SETTLEMENTS_HEADER_GROUP_BY_DATE: 'Date',
    SETTLEMENTS_HEADER_GROUP_BY_ACCOUNT: 'Account',
    SETTLEMENTS_HEADER_BANK_ACCOUNT: 'Bank Account ',
    SETTLEMENTS_HEADER_NO_SETTLEMENTS: 'No Settlement History',
    SETTLEMENTS_HEADER_NO_SETTLEMENTS_NEXT_PAYMENTS: 'No Settlement Next Payments',
    SETTLEMENTS_GROUP_BY: 'Group By',
    SETTLEMENTS_NEXT_PAYMENTS_DISCLAIMER:
      'Settlement amount is approximate and may be subject to a reserve cut, based on your client agreement',

    // mass beneficieries
    MASS_BENEFICIARY_UPLOAD_CSV:
      'To generate multiple Bank Account submission pages upload a csv file with the email and entity type (Individual or Company) or each beneficiary using the',
    MASS_BENEFICIARY_DOWNLOAD_SAMPLE: ' Sample file template',
    MASS_BENEFICIARY_UPLOAD_TO_PAGE:
      'Fill out and upload the file on this page, select an expiration date for the generated links and submit the file',
    MASS_BENEFICIARY_STAGE_THREE:
      'Beneficiaries will recieve an email from Rapyd with a link to a hosted page in which they can saftley add their bank account details.',
    MASS_BENEFICIARY_STAGE_FOUR:
      'Each beneficiary will recieve a Rapyd Beneficiary ID which can be used for all future payouts.',
    MASS_BENEFICIARY_SUBMIT: 'Submit',
    MASS_BENEFICIARY_SUCCESS_MODAL:
      'Your file has been successfully uploaded. View the status of your beneficiaries by clicking on the corresponding Batch ID',
    MASS_BENEFICIARY_SUCCESS_MODAL_HEADER: 'Upload Complete',
    MASS_BENEFICIARY_PICK_EXPIRATION_DATE: 'Select Expiration Date',
    TABLE_HEADER_MASS_BENEFICIARY_ID: 'Batch ID',
    TABLE_HEADER_MASS_BENEFICIARY_ORIGINAL_NAME: 'FIle Name',
    TABLE_HEADER_MASS_BENEFICIARY_STATUS: 'Status',
    TABLE_HEADER_MASS_BENEFICIARY_CREATED_AT: 'Created At',

    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_ID: 'Beneficiary ID',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_EMAIL: 'Email',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_ENTITY_TYPE: 'Entity type',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_PAYOUT_METHOD_TYPE: 'Payout Method Type',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_STATUS: 'Status',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_COMPLETED_AT: 'Completed At',
    TABLE_HEADER_MASS_BENEFICIARY_RECORDS_LINK: 'Link',

    MASS_BENEFICIARY_FINISH_TITLE: 'Finish',
    MASS_BENEFICIARY_FINISH_COMPLETE: 'Upload Complete',
    MASS_BENEFICIARY_PREPARING_FILES:
      'Your file has been successfully uploaded, to view the status of your beneficiaries go to History',
    MASS_BENEFICIARY_BACK_HOME: 'Back home',
    VIEW_PDF: 'View PDF',

    DOWNLOAD_AS_PDF: 'Download as PDF',
    DOWNLOAD_AS_CSV: 'Download as CSV',
    DOWNLOAD_AS_SAT: 'Download as SAT',

    EXPORT_REPORT_TYPE: 'What file format do you want?',
    PDF: 'PDF',
    CSV: 'CSV',

    // CUSTOMER SIDE MENU
    CUSTOMER_SIDE_MENU_HEADER: 'Customer',
    CUSTOMER_SIDE_MENU_SECTION_CUSTOMER_DETAILS: 'Customer details',
    CUSTOMER_SIDE_MENU_SECTION_COUPONS: 'Coupons',
    CUSTOMER_SIDE_MENU_NAME: 'Name',
    CUSTOMER_SIDE_MENU_DESCRIPTION: 'Description',
    CUSTOMER_SIDE_MENU_EMAIL: 'Email',
    CUSTOMER_SIDE_MENU_PHONE_NUMBER: 'Phone Number',
    CUSTOMER_SIDE_MENU_CREATED_AT: 'Created At',
    CUSTOMER_SIDE_MENU_INVOICE_PREFIX: 'Invoice PreFix',
    CUSTOMER_SIDE_MENU_DISCOUNT: 'Discount',
    CUSTOMER_SIDE_MENU_ADDRESSES: 'Customer Addresses',
    CUSTOMER_SIDE_MENU_SECTION_PAYMENT_METHODS: 'Payment Methods',
    CUSTOMER_SIDE_MENU_SECTION_LAST_5_PAYMENTS: 'Last 5 Payments',
    CUSTOMER_SIDE_MENU_SEE_ALL_PAYMENTS: 'See All Payments',
    CUSTOMER_SIDE_MENU_NO_PAYMENTS: 'No payments have been made by this customer',
    CUSTOMER_SIDE_MENU_NO_PAYMENTS_METHODS: 'No payments methods found',
    CUSTOMER_SIDE_MENU_PAYMENTS_METHODS_IS_DEFAULT: 'Default',
    CUSTOMER_ADDRESS: 'Customer Addresses card',
    CUSTOMER_PAYMENTS_WIDGET_DESCRIPTION: 'View payments Details in one table',

    CHANGE_DEFAULT_PAYMENT_METHOD_HEADER: 'Change Default Payment Method',
    CHANGE_DEFAULT_PAYMENT_METHOD_MESSAGE:
      'This action will make this payment method the default payment method for the customer <b>{{customerName}}</b>',
    SUCCESSFUL_ACTION: 'Successful Action',
    CHANGE_DEFAULT_PAYMENT_METHOD_SUCCESS: 'The default payment method was successfully changed',
    CHANGE_CUSTOMER_ADDRESS: 'Address was successfully changed',
    ADD_CUSTOMER_ADDRESS: 'Address was successfully added',
    MAKE_DEFAULT: 'Make Default',
    ERROR_COMPLETING_ACTION: 'Error Completing Action',
    DELETE_PAYMENT_METHOD_HEADER: 'Delete Payment method',
    DELETE_PAYMENT_METHOD_MESSAGE:
      'Are you sure you want to delete this payment method?  You will no longer be able to use it',
    DELETE_PAYMENT_METHOD_SUCCESS: 'The payment method was successfully deleted',
    PREVIOUS_DEFAULT_PAYMENT_METHOD: 'Previous Default Payment Method',
    NEW_DEFAULT_PAYMENT_METHOD: 'New Default Payment Method',
    PREVIOUS_ADDRESS: 'Previous Address',
    NEW_ADDRESS: 'New Address',
    COUPONS: 'Coupons',
    LAST_FIVE_SUBSCRIPTIONS_ADDED: 'Last 5 Subscriptions Added',
    SUBSCRIPTION_ADDED_SIDE_MENU_NO_SUBSCRIPTION: 'No Added Subscriptions',

    // Coupon Side Menu + Details page
    COUPON_SIDE_MENU_DETAILS_BUTTON: 'See all details',
    COUPON_SIDE_MENU_DETAILS_STATUS: 'Status',
    COUPON_SECTION_COUPON_DETAILS: 'Coupon details',
    COUPON_ID: 'Coupon ID',
    COUPON_DURATION: 'Duration',
    COUPON_DISCOUNT_TYPE: 'Discount Type',
    COUPON_REDEEM_DATE: 'Redeem Date',
    COUPON_MAX_NUMBER_OF_USES: 'Max Number of Use',
    COUPON_DURATION_IN_MONTHS: 'Number of Months',
    COUPON_MAX_REDEMPTIONS: 'Maximum Redemptions',
    COUPON_TOTAL_NUMBER_OF_USES: 'Times Redeemed',

    couponsDetailsPage: {
      subscriptionAttachedCoupons: {
        tabHeader: 'Subscriptions',
        columns: {
          attachedAt: 'Attached At',
          subscriptionId: 'Subscription ID',
          subscriptionStatus: 'Subscription Status',
          numberOfUses: 'Number of Coupon Uses',
        },
      },
      customerAttachedCoupons: {
        tabHeader: 'Customers',
        columns: {
          attachedAt: 'Attached At',
          customerId: 'Customer ID',
          numberOfUses: 'Number of Coupon Uses',
        },
      },
      DetailsSummary: 'A coupon was created for {{couponDiscount}}',
    },

    // support ticket details page
    SUPPORT_TICKET_PAGE_RIBBON_HEADER: 'Support Page',
    SUPPORT_TICKET_PAGE_TICKET_NUMBER_HEADER: 'Ticket Number: {{ticketNumber}}',
    SUPPORT_TICKET_PAGE_TICKET_LAST_UPDATED: 'Last Updated {{lastUpdated}}',
    SUPPORT_TICKET_PAGE_STATUS: 'Status',
    SUPPORT_TICKET_PAGE_SEVERITY: 'Severity',
    SUPPORT_TICKET_PAGE_CONTACT_NAME: 'Contact Name',
    SUPPORT_TICKET_PAGE_CREATED_AT: 'Created At',
    SUPPORT_TICKET_PAGE_CASE_SUBJECT: 'Subject',
    SUPPORT_TICKET_PAGE_CASE_OWNER: 'Case Owner',
    SUPPORT_TICKET_PAGE_DESCRIPTION_HEADER: 'Description:',
    SUPPORT_TICKET_PAGE_COMMENTS_NUMBER: 'Comments:',
    SUPPORT_TICKET_PAGE_FORM_SEND_BUTTON: 'Send',
    SUPPORT_TICKET_PAGE_FORM_PLACEHOLDER: 'Add a comment',
    SUPPORT_TICKET_PAGE_ATTACHED_FILES: 'Attached Files:',
    SUPPORT_TICKET_ADD_COMMENT_SUCCESS_MODAL_HEADER:
      'This ticket has been updated with your comment',
    SUPPORT_TICKET_ADD_COMMENT_SUCCESS_MODAL_BODY:
      'You successfully added a new comment attached to this ticket.',
    SUPPORT_TICKET_UPLOAD_FILE_SUCCESS_MODAL_HEADER:
      'The file has been successfully uploaded to this ticket',
    SUPPORT_TICKET_UPLOAD_FILE_SUCCESS_MODAL_BODY:
      'You successfully added a new file attached to this ticket.',
    SUPPORT_TICKET_UPLOAD_FILE_HEADER: 'Upload File For This Ticket',
    SUPPORT_TICKET_PAGE_JS: 'JS',
    SUPPORT_TICKET_PAGE_DRAG_DROP_MSG: 'Drop your file here',
    SUPPORT_TICKET_PAGE_MAIL_SUBJECT: 'Subject:',
    SUPPORT_TICKET_PAGE_ATTACHED_IMG:
      'An image is attached. It can be viewed in the attached files.',

    // sandbox home
    SANDBOX_TITLE_HOME: 'Home',
    SANDBOX_WELCOME_HEADER: 'Welcome, {{name}}',
    SANDBOX_GET_STARTED: 'Some helpful links to get you started',
    SANDBOX_SIGNUP: 'Create Production Account',
    SANDBOX_VIEW_OUR: 'View our',
    SANDBOX_VIEW_API_DOCS: ' API documentation',
    SANDBOX_TEST_OUR_API: 'Test our API using your {{userEnv}} credentials',
    SANDBOX_SIGN_UP_TITLE: 'Get your production credentials',
    SANDBOX_LEARN: 'Learn about our products',
    SANDBOX_LEARN_MORE: 'Learn more',
    SANDBOX_COLLECT_DESCRIPTION: 'Accept cash, ewallets, cards, or bank \n transfers',
    SANDBOX_DISBURSE_DESCRIPTION: 'Send individual \nor mass payouts',
    SANDBOX_WALLETS_DESCRIPTION: 'Create a white-labeled ewallet for consumers\nor businesses',
    SANDBOX_ISSUING_DESCRIPTION: 'Issue physical or virtual cards to  consumers or businesses',
    SANDBOX_SIGN_UP_QUICK_TITLE: 'Quick Sign-up',
    SANDBOX_SIGN_UP_QUICK_DESCRIPTION: 'Create a free account.',
    SANDBOX_SIGN_UP_INTEGRATION_TITLE: 'Build with Rapyd',
    SANDBOX_SIGN_UP_INTEGRATION_DESCRIPTION: 'Get sandbox API keys.',
    SANDBOX_SIGN_UP_EXPEND_TITLE: 'Start accepting and disbursing payments',
    SANDBOX_SIGN_UP_EXPEND_DESCRIPTION: "Use Rapyd's API or pre-built solutions.",

    QUICK_SETUP: 'Quick Setup',
    QUICK_SETUP_BODY: 'Immediately get an API Key and begin integrating our API or SDK',
    NO_DEPOSIT_REQUIRED: 'No deposit required',
    JUST_ADD_CARD: 'Just add a credit card and start checking',

    BENEFICIARY_DETAILS_BUTTON: 'See all details',
    CREATE_BENEFICIARY: 'Create Beneficiary',
    CREATE_BENEFICIARY_MODAL_MERCHANT_REFERENCE_ID: 'Merchant reference ID',
    CREATE_BENEFICIARY_COMBINATION_ERROR_TITLE:
      'There is no payout methods available for this sender/beneficiary combination. Please try other options.',
    CREATE_BENEFICIARY_HEADER: 'Create Beneficiary',
    CREATE_BENEFICIARY_MODAL_TITLE: 'Create New Beneficiary',
    CREATE_BENEFICIARY_MODAL_SUBTITLE: 'Add a new beneficiary to send funds to.',
    CREATE_BENEFICIARY_MODAL_NAVIGATION_BENEFICIARY_DETAILS: 'Beneficiary Details',
    CREATE_BENEFICIARY_MODAL_NAVIGATION_ADDITIONAL_DETAILS: 'Additional Details',
    CREATE_BENEFICIARY_MODAL_ENTITY_TYPE: 'Entity Type',
    CREATE_BENEFICIARY_MODAL_INDIVIDUAL: 'Individual',
    CREATE_BENEFICIARY_MODAL_COMPANY: 'Company',
    CREATE_BENEFICIARY_MODAL_COMPANY_NAME: 'Company Name',
    CREATE_BENEFICIARY_MODAL_REG_NUM: 'Registration Number',
    CREATE_BENEFICIARY_MODAL_FIRST_NAME: 'First Name',
    CREATE_BENEFICIARY_MODAL_LAST_NAME: 'Last Name',
    CREATE_BENEFICIARY_MODAL_ID_TYPE: 'ID Type',
    CREATE_BENEFICIARY_MODAL_DEFAULT_SENDER: 'Use <b>{{defaultSenderName}}</b> as Default Sender ',
    CREATE_BENEFICIARY_MODAL_DEFAULT_SENDER_TOOLTIP:
      'Check this box if you want to you’ll make regular payouts from <b>{{defaultSenderName}}</b> to this Beneficiary.',
    CREATE_BENEFICIARY_MODAL_SENDER_ENTITY_TYPE: 'Sender Entity Type',
    CREATE_BENEFICIARY_MODAL_SENDER_COUNTRY: 'Country',
    CREATE_BENEFICIARY_MODAL_PAYOUT_ERROR_TITLE: 'Country and currency not supported',
    CREATE_BENEFICIARY_MODAL_PAYOUT_ERROR_SUBTITLE:
      'Please select a different country and currency.',
    CREATE_BENEFICIARY_MODAL_SENDER_CURRENCY: 'Currency',
    CREATE_BENEFICIARY_MODAL_ID_NUMBER: 'Identification Number',
    CREATE_BENEFICIARY_MODAL_ID_TYPE_IDENTIFICATION: 'Identification Id',
    CREATE_BENEFICIARY_MODAL_ID_TYPE_PASSPORT: 'International Passport',
    CREATE_BENEFICIARY_MODAL_ID_TYPE_RESIDENCE_PERMIT: 'Residence Permit',
    CREATE_BENEFICIARY_MODAL_ID_TYPE_SOCIAL_SECURITY_NUMBER: 'Social Security Number',
    CREATE_BENEFICIARY_MODAL_ID_TYPE_WORK_PERMIT: 'Work Permit',
    CREATE_BENEFICIARY_MODAL_MERCHANT_REF_ID: 'Reference ID (Optional)',
    CREATE_BENEFICIARY_MODAL_PAYOUT_METHOD: 'Payout Method',
    CREATE_BENEFICIARY_MODAL_CATEGORY: 'Payout Category',
    CREATE_BENEFICIARY_BACK_BTN: 'Back',
    CREATE_BENEFICIARY_NEXT_BTN: 'Next',
    CREATE_BENEFICIARY_CONFIRM_BTN: 'Confirm',
    CREATE_BENEFICIARY_SUCCESS_MODAL_TITLE: 'Beneficiary created!',
    CREATE_BENEFICIARY_SUCCESS_MODAL_SUBTITLE:
      '<b>{{beneficiaryName}}</b> can now receive funds from Senders with matching Payout Method details.',
    CREATE_BENEFICIARY_SUCCESS_MODAL_PRIMARY_BUTTON: 'View Details',
    CREATE_BENEFICIARY_SUCCESS_MODAL_SECONDARY_BUTTON: 'Close',
    PHONE_NUMBER: 'Phone Number',
    CREATED: 'Created',
    COMPLETED: 'Completed',
    PAYCODE: 'Paycode',
    VIEW: 'View',
    FULL_NAME: 'Full Name',
    DATE_OF_BIRTH: 'Date Of Birth',
    IDENTIFICATION_TYPE: 'Identification Type',
    IDENTIFICATION_NUMBER: 'Identification Number',
    CONFIRM: 'Confirm',
    CLOSE: 'Close',
    APPROVE: 'Approve',
    DECLINE: 'Decline',
    EDIT_TABLE: 'Edit Table',
    EDIT_ROWS: 'Edit Rows',
    EDIT_COLUMNS: 'Edit Columns',
    CHOICES: 'Choices',
    CHOSEN: 'Chosen',
    AVAILABLE_CURRENCIES: 'Available Currencies',
    SELECTED_CURRENCIES: 'Selected Currencies',
    SELECT_ALL: 'Select All',
    NUMBERS_ONLY: 'Numbers Only',
    NUMBERS_DO_NOT_MATCH: 'Numbers do not match',
    TYPE: 'Type',
    METHOD: 'Method',

    DRIVER_LICENSE: "Driver's License",
    IDENTITY_CARD: 'Identity Card',
    PASSPORT: 'Passport',
    PERMANENT_RESIDENT_CARD: 'Permanent Resident Card',
    REFUGEE_TRAVEL_DOC: 'Refugee Travel Doc',
    SOCIAL_SECURITY_CARD: 'Social Security Card',
    DOMESTIC_VISA: 'Domestic Visa in Foreign Passport',

    GROUP_BY: 'Group By',
    REQUEST_DATE: 'Request Date',
    STATUS: 'Status',
    PENDING: 'Pending',
    OUT_FOR_DELIVERY: 'Out For Delivery',
    DELIVERED: 'Delivered',
    NUMBER_OF_CARDS: '#of Cards',
    CONTACT_PERSON: 'Contact Person',
    ADD_COMMENT: 'Add Comment',
    NO_COMMENTS: 'No Comments Yet',
    NO_COMMENTS_DESCRIPTION: 'You can add comments and tag your teammates',
    TYPE_YOUR_COMMENT: 'Type your comment',
    ADD_COMMENT_SIDE_MENU: 'Add Comment',
    LAST_COMMENT_SIDE_MENU: 'Last Comments',
    NO_COMMENTS_SIDE_MENU: 'No Comments Created',
    REASON_OPTIONAL: 'Reason (optional)',
    AMOUNT: 'Amount',
    PAYMENT_CATEGORY: 'Payment Category',
    PAYOUT_CATEGORY: 'Payout Category',
    NONE: 'None',
    LIMIT_BY: 'Limit By',
    VISUAL_CODES: 'Visual Codes',
    DATE: 'Date',
    TOTAL: 'Total',

    ADD_COMMENT_MODAL_SELECT: 'Select...',
    ADD_COMMENT_MODAL_TAG_TEMMATES: 'Tag Teammates',
    ADD_COMMENT_MODAL_SIDE_MENU: 'Select',
    SIDE_MENU_DETAILS_TAB: 'Details',

    MY_ACCOUNT_NO_BALANCES: 'You currently have no balances',
    MY_ACCOUNT_PREVIEW_TOOLTIP: 'Preview',
    MY_ACCOUNT_BALANCE_ROW_LAST_TRANSACTION: 'Last Transaction',
    MY_ACCOUNT_BALANCE_ROW_WALLET: 'Wallet',
    MY_ACCOUNT_BALANCE_ROW_CATEGORY: 'Category',
    WALLET_DETAILS: 'Wallet Details',
    SETTELMENT_CONFIGURATION: 'Settlement Configuration',
    WALLET_CONTACT: 'Wallet Contact',
    WALLET_THRESHOLDS: 'Wallet Thresholds',
    WALLET_THRESHOLDS_RBA: 'Balance thresholds',
    BANK_ACCOUNT: 'Bank Account',
    VIRTUAL_ACCOUNTS: 'Virtual Accounts',
    VIRTUAL_ACCOUNTS_RBA: 'Local receiving accounts',
    VIRTUAL_ACCOUNTS_SUBHEADER_RBA:
      'Local receiving accounts allow you to receive funds through your customer’s local banking network.',
    CARDS_EMPTY: 'No cards have been issued',
    IBANS_EMPTY: 'No virtual accounts have been issued',
    THRESHOLDS_EMPTY: 'No wallet thresholds have been defined',
    THRESHOLDS_EMPTY_RBA: 'No minimum balance thresholds have been defined for this balance',
    BANKS_EMPTY: 'No bank accounts have been added',
    MINIMUM_SETTLEMENT: 'Minimum Settlement',
    WALLETS: 'Wallets',
    CARD: 'Card',
    CASH: 'Cash',
    BANK_TRANSFER: 'Bank Transfer',
    SUBTOTAL: 'Amount',
    TRANSACTION_FEE: 'Transaction Fee',
    EXCHANGE_FEE: 'Exchange Fee',
    EXCHANGE_RATE: 'Exchange Rate',
    ORDER_TOTAL: 'Payment Total',

    AMOUNT_RELEASED: 'Amount Released',
    PAYMENT_ID: 'Payment ID',
    PAGE_TOKEN: 'Page Token',
    REFUND_ID: 'Refund ID',
    PAYOUT_ID: 'Payout ID',

    ON_HOLD: 'On Hold',
    RELEASED: 'Released',
    DECLINED: 'Declined',
    RELEASED_FAILED: 'Released Failed',
    SOURCE: 'Source',
    CATEGORY: 'Category',
    MERCHANT_REFERENCE_ID: 'Merchant Reference Id',
    DESCRIPTION: 'Description',
    SUMMARY: 'Summary',
    EXPIRATION_DATE: 'Expiration Date',
    SELECT_ACTION: 'Select Action',
    PAYMENT_METHOD: 'Payment Method',
    COMMENTS: 'Comments',
    ADD_CARD: 'Add Card',
    CREATE_IBAN: 'Create IBAN',
    CREATE_VIRTUAL_IBAN: 'Create Virtual ACCOUNT',
    CREATE_VIRTUAL_ACCOUNT: 'Create Virtual Account',
    CREATE_VIRTUAL_ACCOUNT_RBA: 'Add local receiving account',
    CREATE_VIRTUAL_ACCOUNT_DESCRIPTION:
      'Virtual Accounts allow you to collect funds to your wallet through external bank transfers',
    REQUEST_CARD: 'Request Card',
    IBAN_LIMIT_REACHED: '5 IBAN limit reached',
    REPLACE_CARD: 'Replace Card',
    CARD_TYPE: 'Card Type',
    CARD_HOLDER: 'Cardholder',
    NAME_ON_CARD: 'Name On Card',
    REVIEW_CARD_DETAILS:
      'Please review your new card details carefully before continuing to the next step.',
    REVIEW: 'Review',
    SAVE: 'Save',
    UNDO: 'Undo',
    REPLACE: 'Replace',
    NO_PAYMENT_METHOD_FOR_COUNTRY_ERROR: 'This Country is not supported',
    RAPYD_FEES: 'Rapyd Fees',
    RAPYD_FEES_TOOLTIP_TEXT: 'Fees collect by Rapyd from the Merchant',
    MERCHANT_FEES: 'Merchant Fees',
    MERCHANT_FEES_TOOLTIP_TEXT: 'Additional fees defined and collected by the merchant',
    CARD_FINGERPRINT: 'Card Fingerprint',
    ADD_TO_LIST: 'Add to list',
    SIMULATE_BANK_TRANSFER: 'Simulate Bank Transfer',
    SUBMIT_REQUEST: 'Submit Request',
    DELETE_BANK_ACCOUNT: 'Delete Bank Account',

    APPROVE_TRANSACTION: 'Approve Transaction',
    DECLINE_TRANSACTION: 'Decline Transaction',
    TRANSACTION_DETAILS: 'Transaction Details',
    TEST_DATA_BANNER: 'Test Data - Any Action Will Affect Sandbox Environment Only',
    CARD_EXPIRATION_DATE: 'Card Expiration Date',
    CARD_BRAND: 'Card Brand',
    VIEW_CARD_DETAILS: 'View Card Details',
    RAPYD_RISK_SCORE: 'Rapyd Risk Score',
    SECURITY_INFORMATION: 'Security Information',

    IP_ADDRESS: 'IP Address',
    DEVICE_FINGERPRINT: 'Device Fingerprint',
    INTERFACE: 'Interface',
    RAPYD_CHANNEL: 'Rapyd Channel',
    API: 'API',

    VIEW_WALLET: 'View Wallet',
    VIEW_PROGRAM: 'View Program',
    PHYSICAL_CARDS: 'Physical Cards',
    CHARGED: 'Charged',
    AUTHORIZATION_NUMBER: 'Authorization Number',
    REMOTE_AUTHORIZATION_NUMBER: 'Remote Authorization Number',
    CARD_NUMBER: 'Card Number',
    BANK_NUMBER: 'Bank Number',
    SETTLEMENT_FREQUNECY: 'Settlement Frequency',
    MIN_SETTLEMNT_AMOUNT: 'Min. Settlement Amount',
    MIN_SETTLEMNT_AMOUNT_WITHOUT_DOT: 'Min Settlement Amount',
    MERCHANT_DETAILS: 'Merchant Details',
    POS_NAME_LOCATION: 'POS Name & Location',
    MCC_CODE: 'MCC Code',
    MCC_NAME: 'MCC Name',
    TRANSACTION_ID: 'Transaction ID',
    CARD_AUTHORIZATION_ID: 'Card Authorization ID',
    ORIGINAL_AMOUNT: 'Original Amount',
    FX_RATE: 'FX Rate',
    ENTRY_MODE: 'Entry Mode',
    TRANSACTION_TYPE: 'Transaction Type',
    CARD_DETAILS: 'Card Details',
    CARD_ID: 'Card ID',
    PROGRAM_ID: 'Program ID',
    BIN_NUMBER: 'Bin Number',
    REVERSAL: 'Reversal',
    REVERSED: 'Reversed',
    REFUNDED: 'Refunded',
    ADJUSTMENT: 'Adjustment',
    PROTECT_SCORE: 'Protect Score',
    HISTORY: 'History',
    DETAILS_HISTORY_COMMENT: 'Comment: {{comment}}',
    SENDER_AMOUNT: 'Sender Amount',
    SENT: 'Sent',
    RECEIVED: 'Received',
    UNNAMED: 'Unnamed',
    TO_BE_RECEIVED: 'To be Received',
    PAYOUT_METHOD: 'Payout Method Type',
    PAYOUT_METHOD_NAME: 'Payout Method Name',
    BENEFICIARY_ID: 'Beneficiary ID',
    BENEFICIARY_ENTITY_TYPE: 'Beneficiary Entity Type',
    WALLET_ID: 'Wallet ID',
    EWALLET_PROVIDER: 'eWallet Provider',
    METADATA: 'Meta Data',
    PARTIAL_PAYMENT: 'Partial Payment',
    REQUESTED: 'Requested',
    PAID: 'Paid',
    PAYMENT_METHOD_NAME: 'Payment Method Name',
    PAYMENT_ORIGIN: 'Payment Origin',
    CHECKOUT_TOKEN: 'Checkout Token',
    EWALLET: 'Ewallet',
    REFUNDED_AMOUNT: 'Refunded Amount',
    PAYER_DETAILS: 'Payer Details',
    CUSTOMER_ID: 'Customer ID',
    EMAIL: 'Email',
    PHONE: 'Phone',
    DEFAULT_PAYMENT_METHOD: 'Default Payment Method',
    REVERSAL_REASON: 'Reversal Reason',
    USER_NAME: 'User Name',
    SUCCESS: 'Success',
    PASSWORD: 'Password',
    CODE: 'Code',
    REPORTING_MONTH: 'Reporting Month',
    REPORT_FILE_NAME: 'Report File Name',
    CARD_ON_FILE: 'card on file',
    PAYMENT_PAGE: 'generate payment page',
    REGION: 'Region',
    COUNTRIES: 'Countries',
    SUPPORTED_CURRENCIES:
      'The supported currencies for {{pmtName}} accepted in {{country}} are:\n<b>{{currencies}}</b>',
    TICKET_NUMBER: 'Ticket #',
    SUBJECT: 'Subject',

    issueCardAuthorizationDetails: {
      title: 'Issued Card Transaction Details',
      successDescription:
        'A {{transaction_type}} of {{amount}} {{currency}} was successfully completed by {{contact_name}} with the card ending with {{card_last_digits}}',
      errorDescription:
        'There was an error completing the {{transaction_type}} of {{amount}} {{currency}} by {{contact_name}} with the card ending in {{card_last_digits}}',
    },

    payoutDetails: {
      activeDescription:
        '{{senderName}} created a payout request of {{amountAndCurrency}} via {{payoutType}} to {{beneficiaryName}}.',
      closedDescription:
        '{{amountAndCurrency}} were paid via {{payoutType}} by {{senderName}} to {{beneficiaryName}}.',
      canceledDescription:
        'The payout request of {{amountAndCurrency}} via {{payoutType}} that was made by {{senderName}} was canceled.',
      errorDescription:
        'The payout request by {{senderName}} of {{amountAndCurrency}} via {{payoutType}} to {{beneficiaryName}} was unsuccessful.',
      pendingDescription:
        'The payout request of {{amountAndCurrency}} via {payoutType}} that was made by {{senderName}} was created, but the funds have not yet been transferred to {{beneficiaryName}}.',
      defaultDescription:
        'On {{createdAt}}, {{amountAndCurrency}} {{payoutType}} to {{beneficiaryName}}. Currently the payout is {{status}}.',
    },

    paymentDetails: {
      activeDescription:
        'A {{paymentMethodTypeCategory}} payment request of {{originalAmountWithCurrency}} was sent to {{customerName}}.',
      closedDescription:
        'A {{paymentMethodTypeCategory}} payment of {{amountAndCurrency}} was made by {{customerName}}.',
      closedCardDescription: {
        withCustomerName:
          'A {{paymentMethodTypeCategory}} payment of {{amountAndCurrency}} was made by {{customerName}} with a card ending in {{last4}}.',
        withoutCustomerName:
          'A {{paymentMethodTypeCategory}} payment of {{amountAndCurrency}} was made with a card ending in {{last4}}.',
      },
      canceledDescription:
        'The {{paymentMethodTypeCategory}} payment request that was sent to {{customerName}} was canceled.',
      errorDescription: 'There was an error completing the payment request.',
      reversalDescription: 'This transaction was reversed due to  {{paymentCancelReason}}.',
      defaultDescription: 'This payment is currently in status - {{status}}.',
      activeNotCapturedDescription:
        'A {{paymentMethodTypeCategory}} authorization of {{originalAmountWithCurrency}} was created for {{customerName}}.',
    },

    refundDetails: {
      closedDescription:
        '{{amountAndCurrency}} was refunded from a {{originalAmountWithCurrency}} payment. Payment ID: {{paymentId}}',
      pendingDescription:
        'A request for refund of {{amountAndCurrency}} from payment ID: {{paymentId}} has been received but is not yet complete.',
      rejectedDescription:
        'The request for refund of {{amountAndCurrency}} from payment ID: {{paymentId}} failed. Failure reason: {{reason}}.',
    },

    // Error page
    ERROR_PAGE_HEADER: 'Something went wrong',
    ERROR_PAGE_SUB_HEADER: 'There is a technical issue with the action you are trying to perform',
    ERROR_PAGE_DETAILS:
      'Please try again at a later time. If the problem persists, please <0>contact support</0>.',
    ERROR_PAGE_RAPYD_HOME: 'Rapyd Home',
    ERROR_PAGE_SUPPORT: 'Customer Support',
    ERROR_CATEGORY_PAYOUT_METHODS_NOT_SUPPORTED:
      'Category not supported, select another or <0>contact support</0>',
    COULD_NOT_FIND_PAGE: "We couldn't find the page",
    RETURN_TO_PREVIOUS_PAGE:
      'You can return to the previous page, visit our home page or <0>contact support.</0>',

    // Home dashboard
    payments_created: 'Payments Created',
    payoutslist_created: 'Payouts Created',
    payoutslist_completed: 'Payouts Completed',
    payments_completed: 'Payments Completed',
    PAYMENTS_CREATED: 'Payments Created',
    PAYOUTS_CREATED: 'Payouts Created',
    PAYOUTS_COMPLETED: 'Payouts Completed',
    PAYMENTS_COMPLETED: 'Payments Completed',
    HOME_OVERVIEW: 'Overview',
    HOME_NEXT_MESSAGE: 'Next Message',
    HOME_BALANCE: 'Balance',
    HOME_BALANCE_ACCOUNT: 'Account',
    HOME_SHOW_ALL: 'Show all',
    HOME_MORE: 'more',
    HOME_FUNDS_OVERVIEW: 'Settlements Overview',
    HOME_NEXT_WITHDRAW: 'Next withdraw in {{days}} days',
    HOME_AVAILABLE_TO_PAYOUT: 'Available to payout',
    HOME_ON_THE_WAY_TO_THE_BANK: 'On the way to the bank',
    HOME_LAST_WITHDRAW: 'Last Withdraw',
    HOME_LAST_UPDATED: 'Last updated at {{lastUpdated}}',
    HOME_TRANSACTIONS_TYPES: 'View',
    HOME_QUICK_ACTIONS: 'Quick Actions',
    HOME_BANK_ACCOUNTS: 'Bank Accounts',
    HOME_EDIT_ACCOUNT_DETAILS: 'Edit Account Details',
    HOME_INVITE_USERS: 'Invite Users',
    HOME_INVITE_USERS_SUB_TITLE: 'Invite your team members to use the Client Portal',
    HOME_INVITE_ACTION: 'Invite',
    HOME_FUNDING_REQUESTS: 'Funding Request',
    HOME_FUNDING_REQUESTS_SUB_TITLE:
      'Funding Request Pre-fund your wallet in order to conduct payouts',
    HOME_FUNDING_REQUESTS_ACTION: 'Request',
    HOME_CUSTOMIZE_CHECKOUT: 'Customize Checkout',
    HOME_CUSTOMIZE_CHECKOUT_SUB_TITLE: 'Add your company’s branding to our hosted payment pages',
    HOME_CUSTOMIZE_CHECKOUT_ACTION: 'Customize',
    HOME_LAST_WEEK: 'Last Week',
    HOME_BALANCE_NO_DATA: 'No results found',
    HOME_ACTIVATE_MY_ACCOUNT: 'Activate your account',
    HOME_ACTIVATE_MY_ACCOUNT_ACTION: 'Activate',
    HOME_ACTIVATE_MY_ACCOUNT_SUB_TITLE:
      'Complete the KYB questionnaire to remove your account limits',

    SENDER_DETAILS_BUTTON: 'More details',
    SENDERS_DETAILS: 'Sender Details',
    SENDERS_DETAILS_DEFAULT_SENDER_ACRONYM: 'D',
    NO_PAYOUT_METHODS_AVAILABLE: 'No Payout Methods Available',
    ALL_SENDERS: 'All Senders',
    PAYOUT_METHODS: 'Payout Methods',
    RECENT_PAYOUTS: 'Recent Payouts',
    CREATE_SENDER: 'Create Sender',
    CREATE_SENDER_BENEFICIARY_ENTITY_TYPE: 'Beneficiary entity type',
    CREATE_SENDER_MODAL_SUB_HEADLINE:
      'Add a new sender with payout method details to create new payouts from.',
    CREATE_SENDER_MODAL_PAYOUT_METHOD_DESCRIPTION:
      'Some payout methods may require additional information. By adding the relevant payout methods now, you can fill in the additional information without having to create a new sender later.',
    CREATE_SENDER_MODAL_NAVIGATION_SENDER_DETAILS: 'Create Sender',
    CREATE_SENDER_MODAL_NAVIGATION_PAYOUT_METHOD: 'Payout Method',
    CREATE_SENDER_MODAL_NAVIGATION_ADDITIONAL_DETAILS: 'Additional Details',

    payout_custom_validations: {
      max_length_no_special_chars:
        'The value cannot contain any special characters or be longer than {{max}} characters.',
      all_char_with_max_length: 'Value exceeded {{max}} characters limit',
      max_address_combined_length:
        'The combined length of the City, State and Post code exceeds the maximum of {{maxLength}} characters.',
      max_name_combined_length:
        'The total length of the first name, last name exceeds the maximum allowed limit of {{maxLength}} characters.',
      all_char_value_in_between: 'Value can be between {{min}} to {{max}} characters',
      all_char_value_or: 'Value can be {{min}} or {{max}} characters',
      hk_chats_bank: {
        beneficiary: {
          bic_swift_hk: 'Invalid BIC/SWIFT value format.',
          bic_swift_hk_mismatch: 'Bank country does not match with the beneficiary country.',
        },
      },
    },

    PLUGINS: 'Plugins',
    ACTIVATE_PLUGIN: 'Activate Plugin',
    PLUGINS_SETTINGS_MESSAGE: 'View and enable available 3rd party plugins',
    PLUGINS_HEADER: 'Plugins',
    PLUGINS_ACTIVATE_PLUGIN: 'Activate Plugin',
    PLUGINS_ACCOUNT_ACTIVATION_REQUIRED: 'Activate your account to enable plugins',
    PLUGINS_DEACTIVATE_PLUGIN: 'Deactivate',
    PLUGINS_ACTIVATED: 'Activated',
    PLUGINS_VIEW_KEYS: 'View Keys',
    PLUGINS_VIEW_INSTRUCTIONS: 'View Instructions',
    PLUGINS_INSTRUCTIONS_SANDBOX_DISCLAIMER:
      '*Please note you are in the sandbox environment, the credentials provided are for testing purposes only. For production credentials toggle back to the production environment',
    PLUGINS_DEACTIVATE_MODAL_HEADER: 'Deactivate Plugin',
    PLUGINS_DEACTIVATE_MODAL_MSG: 'Are you sure you want to deactivate {{pluginName}} plugin?',
    PLUGIN_NOT_AVAILABLE_FOR_COUNTRY: 'plugin not available for your country',
    PLUGIN_SUPPORTED_COUNTRIES: 'Supported Countries',
    PLUGIN_SUPPORTED_PAYMENT_METHODS: 'Supported Payment Methods',
    SUPPORTED_PAYOUT_METHODS: 'Supported Payout Methods',
    PLUGIN_CONNECTION_REQUIRED:
      'The Rapyd plugin is active, however your {{name}} account has not yet been connected.',
    PLUGIN_CONNECT_ACCOUNT: 'Connect Account',
    PLUGIN_VALIDATE_CONNECTION: 'Validate Connection',
    PLUGIN_KEYS_HEADER: 'Plugin Keys',
    PLUGIN_INSTRUCTIONS_HEADER: 'Connection Required',
    OK: 'OK',
    PLUGIN_ACTIVATED: 'Plugin Activated',
    PLUGIN_CONNECTION_REQUIRED_TITLE: 'Connection Required',
    PLUGIN_ACTIVATE_SWITCH: 'Active',
    PLUGIN_SANDBOX_NOTE: '- only for sandbox environment',
    PLUGIN_CONNECTED_ACTIVATED_TOOLTIP: 'Plugin Active and Connection validated',
    PLUGIN_ERROR_HEADER: 'Error Connecting Account',
    PLUGIN_ERROR_MSG:
      'An error occurred while attempting to link to your {{pluginName}} account.  Please try again at a later time.  If the problem persists, please <0>contact support</0>',
    LIVE: 'Live',
    ACTION_REQUIRED: 'Action Required to Activate',
    PLUGIN_CONNECTION_VALIDATED: 'Connection Validated',
    PLUGIN_INSTALLATION_GUIDE: ' Installation Guide',
    TEST_CREDENTIALS: 'Test Credentials',
    LIVE_CREDENTIALS: 'Live Credentials',

    IBAN_CARD_COPY_TO_CLIPBOARD: 'Copy to clipboard',
    IBAN_CARD_COPIED: 'Copied',

    BIC_SWIFT_CODE_IF_RELEVANT: 'BIC SWIFT Code (If relevant)',
    BENEFICIARY_NAME_IF_RELEVANT: 'Beneficiary name (If relevant)',
    // no data
    NOTHING_TO_SEE_HERE: 'Nothing to see here',
    noData: {
      noAccountDetails: 'There are no account details yet',
      youDontHaveAny: 'You do not have any yet.',
      feelFreeToCheck: 'Feel free to check in here soon',
    },

    RECOMMENDED_TO_FILL_OUT_ALL: 'It is recommended to fill out all known fields',
    ADD_BUSINESS_DETAILS: 'Add Business Details',
    ALL_FIELDS_OPTIONAL: 'All fields are optional',
    PROVIDE_MAILING_CONTACT_ADDRESS: 'Provide the mailing address of the contact',
    PROVIDE_CONTACT_DETAILS: 'Provide details of the main contact within the company',
    PROVIDE_MAILING_ADDRESS_DETAILS:
      'Provide the mailing address of the contact added in the previous step',
    WALLET_NAME: 'Wallet Name',
    DATE_OF_ESTABLISHMENT: 'Date of Establishment',
    REGISTRATION_NUMBER: 'Registration Number',
    GENDER: 'Gender',
    NATIONALITY: 'Nationality',
    CREATE_WALLET_SUCCESS_HEADER: 'New Wallet Created',
    CREATE_WALLET_SUCCESS_MESSAGE: 'A new ewallet was successfully created. <0>{{ewallet_id}}</0>',
    DEACTIVATE_PAYMENT_LINK_SUCCESS_MODAL_HEADER: 'Payment Link Deactivated Successfully',
    THRESHOLD: 'Threshold',
    CONTACT_TO_NOTIFY_MENU: 'Contacts to notify',
    CONTACTS_TO_NOTIFY: 'Contacts To Notify',
    EDIT_THRESHOLD_NOTIFICATION_EXPLANATION:
      'The following contacts will be notified via email when your wallet balance goes below one of the defined thresholds',
    NOTIFICATIONS: 'Notifications',
    ADD_BUSINESS_ADDRESS: 'Add Business Address',
    SAME_ADDRESS: 'Same as business Address',
    EVERY: 'every',
    EQUIVALENT: 'equivalent',

    // NOTIFICATIONS TYPES MAPPING

    NOTIFICATIONS_SETTINGS_DESCRIPTION_AND_NAME: {
      DESCRIPTION_KYB_STATUS: "KYB Application's staus changed",
      NAME_KYB_STATUS: 'Application Status Changed',

      DESCRIPTION_PAYMENT_BLOCKED: 'payment blocked descripiton',
      NAME_PAYMENT_BLOCKED: 'Payment Blocked',

      DESCRIPTION_PAYMENT_PUT_UNDER_REVIEW: 'payment put under review descripiton',
      NAME_PAYMENT_PUT_UNDER_REVIEW: 'Payment Put Under Review',

      DESCRIPTION_DISPUTE: 'dispute description',
      NAME_DISPUTE: 'Dispute',

      DESCRIPTION_PAYMENT_METHOD_STATUS: 'payment method status description',
      NAME_PAYMENT_METHOD_STATUS: 'Payment Methods Status',

      DESCRIPTION_PAYOUT_BLOCKED: 'payout blocked description',
      NAME_PAYOUT_BLOCKED: 'Payout Blocked',

      DESCRIPTION_PAYOUT_PUT_UNDER_REVIEW: 'payout put under review description',
      NAME_PAYOUT_PUT_UNDER_REVIEW: 'Payout Put Under Review',

      DESCRIPTION_PAYOUT_METHOD_STATUS: 'payout method status description',
      NAME_PAYOUT_METHOD_STATUS: 'Payout Method Status',

      DESCRIPTION_PAYOUT_CANCELED: 'A payout that was previous created was canceled',
      NAME_PAYOUT_CANCELED: 'Payout Canceled',

      DESCRIPTION_PAYOUT_COMPLETED: 'The status of a payout change to "complete"',
      NAME_PAYOUT_COMPLETED: 'Payout Completed',

      DESCRIPTION_CLIENT_WALLET_FUNDED: 'Funds were successfully added to a client wallet',
      NAME_CLIENT_WALLET_FUNDED: 'Client Wallet Funded',

      NAME_KYB_SUBMITTED: 'KYB Submitted',
      DESCRIPTION_KYB_SUBMITTED: 'KYB Application was submitted',

      NAME_DISPUTES_SUMMARY: 'Payments Disputed',
      DESCRIPTION_DISPUTES_SUMMARY: 'A payment was disputed in the last 24 hours',

      NAME_FILE_READY_FOR_DOWNLOAD: 'Export File',
      SETTINGS_FILE_READY_FOR_DOWNLOAD: 'Exported file is ready for download',

      NAME_MASSPAYOUTS_FILE_PROCESSED: 'Mass payouts',
      SETTINGS_MASSPAYOUTS_FILE_PROCESSED: 'Mass payouts file has been processed',

      NAME_MASSINVOICE_FILE_PROCESSED: 'Mass payments',
      SETTINGS_MASSINVOICE_FILE_PROCESSED: 'Mass payments file has been processed',

      NAME_MENTION_COMMENT: 'Comment mention',
      DESCRIPTION_MENTION_COMMENT: 'A teammate mentioned you on a comment',

      NAME_MAINTENANCE: 'Maintenance',
      DESCRIPTION_MAINTENANCE: 'Maintenance affecting one of the Rapyd services you use ',

      NAME_DOWNTIME: 'Downtime',
      DESCRIPTION_NAME_DOWNTIME: 'An outage affected one of the Rapyd services you use',

      DESCRIPTION_SETTLEMENT_COMPLETED: 'A settlement payout has been completed to our accoount',
      NAME_SETTLEMENT_COMPLETED: 'Settlement completed',

      DESCRIPTION_ESCROW_PAYMENT_RELEASED: 'An escrow payment was released',
      NAME_ESCROW_PAYMENT_RELEASED: 'Escrow payment released',
    },

    // NOTIFICATIONS CATEGORY
    NOTIFICATION_CATEGORY_NAME_MY_ACCOUNT: 'My Account',
    NOTIFICATION_CATEGORY_NAME_COLLECT: 'Collect',
    NOTIFICATION_CATEGORY_NAME_DISBURSE: 'Disburse',
    NOTIFICATION_CATEGORY_NAME_PAYMENTS: 'Payments',
    NOTIFICATION_CATEGORY_NAME_GENERAL: 'General',

    // NOTIFICATIONS LIST/SIDE MENU

    NOTIFICATIONS_LIST: {
      TITLE_PAYOUT_CANCELED: 'Payout Canceled',
      DESCRIPTION_PAYOUT_CANCELED: 'The following payout: {{payout_id}} was canceled',
      CTA_PAYOUT_CANCELED: 'View Payout',

      TITLE_PAYOUT_COMPLETED: 'Payout Completed',
      DESCRIPTION_PAYOUT_COMPLETED: 'The following payout: {{payout_id}} was completed',
      CTA_PAYOUT_COMPLETED: 'View Payout',

      TITLE_CLIENT_WALLET_FUNDED: 'Client Wallet Funded',
      DESCRIPTION_CLIENT_WALLET_FUNDED:
        'Client Wallet {{wallet_ref_id}} was funded with {{funded_sum}}',
      CTA_CLIENT_WALLET_FUNDED: 'View Balance',

      TITLE_KYB_STATUS_CHANGED: 'Application Status Changed',
      DESCRIPTION_KYB_STATUS_CHANGED_APR: 'Your Application was approved',
      DESCRIPTION_KYB_STATUS_CHANGED_LAP: 'Your Application was approved',
      DESCRIPTION_KYB_STATUS_CHANGED_DEC: 'Your Application was declined',

      TITLE_NEW_CLIENT_PORTAL_VERSION: 'New client portal version',
      DESCRIPTION_NEW_CLIENT_PORTAL_VERSION: 'Client portal version {{version}} has been released!',
      CTA_NEW_CLIENT_PORTAL_VERSION: 'Release Notes',

      TITLE_KYB_SUBMITTED: 'KYB Submitted',
      DESCRIPTION_KYB_SUBMITTED: 'Your KYB application was submitted',

      TITLE_DISPUTES_SUMMARY: 'Payments Disputed',
      DESCRIPTION_DISPUTES_SUMMARY: 'One or more payments were disputed in the last 24 hours',
      CTA_DISPUTES_SUMMARY: 'View Disputes',

      TITLE_EXPORT_FAILED: 'Export File Failed',
      DESCRIPTION_EXPORT_FAILED: 'We failed to prepare your exported file',

      TITLE_FILE_READY_FOR_DOWNLOAD: 'Export File',
      DESCRIPTION_FILE_READY_FOR_DOWNLOAD: 'Your exported file is ready for download',
      SETTINGS_FILE_READY_FOR_DOWNLOAD: 'Exported file is ready for download',
      CTA_FILE_READY_FOR_DOWNLOAD: 'Download File',

      TITLE_MASSPAYOUTS_FILE_PROCESSED: 'Mass payouts',
      DESCRIPTION_MASSPAYOUTS_FILE_PROCESSED: 'Your mass payouts file has been processed',
      SETTINGS_MASSPAYOUTS_FILE_PROCESSED: 'Mass payouts file has been processed',
      CTA_MASSPAYOUTS_FILE_PROCESSED: 'View Status',

      TITLE_MASSINVOICE_FILE_PROCESSED: 'Mass payments',
      DESCRIPTION_MASSINVOICE_FILE_PROCESSED: 'Your mass payments file has been processed',
      SETTINGS_MASSINVOICE_FILE_PROCESSED: 'Mass payments file has been processed',
      CTA_MASSINVOICE_FILE_PROCESSED: 'View Status',

      TITLE_COMMENT_MENTION: 'Comment mention',
      DESCRIPTION_COMMENT_MENTION: '{{creatorFullName}} mentioned you in a comment ',
      CTA_COMMENT_MENTION: 'See Comment',

      TITLE_MAINTENANCE: 'Maintenance',
      DESCRIPTION_MAINTENANCE: 'Maintenance affecting one of the Rapyd services you use',

      TITLE_DOWNTIME: 'Downtime',
      DESCRIPTION_DOWNTIME: 'An outage affected one of the Rapyd services you use',

      TITLE_SETTLEMENT_COMPLETED: 'Settlement completed',
      DESCRIPTION_SETTLEMENT_COMPLETED: `Congratulations! A settlement payout for {{amount}} {{currency}} is on its way to you.`,
      CTA_SETTLEMENT_COMPLETED: 'See settlement',

      TITLE_PAYMENT_ESCROW_RELEASED: 'Escrow payment released',
      DESCRIPTION_PAYMENT_ESCROW_RELEASED: `Escrow payment {{payment_id}} was released`,
      CTA_PAYMENT_ESCROW_RELEASED: 'See payment',
    },

    NOTIFICATIONS_EMPTY_STATE_HEADLINE: 'No Notifications Yet!',
    NOTIFICATIONS_EMPTY_STATE_TEXT: `You don't have any notifications<br> yet. come back again soon!`,
    NOTIFICATIONS_EMPTY_STATE_SIDE_MENU_TEXT: `Notifications about your<br> activity will show up here.`,

    EXTERNAL_SUBSCRIBER_TABLE_HEADER: {
      FULLNAME: 'Full Name',
      EMAIL: 'Email Address',
      CATEGORIES: 'Categories',
    },

    EXTERNAL_SUBSCRIBER_SHOW_MORE_MODAL: {
      LIST_CATEGORIES: '{{formattedCategories}}',
      CATEGORIES_TITLE: 'Categories',
    },

    NOTIFICATIONS_ADD_EXTERNAL_SUBSCRIBER_MODAL: {
      TITLE: 'Add External User',
      SUB_TITLE: `Allow external contact to receive Rapyd notifications`,
      INVITE: 'Invite',
      CANCEL: 'Cancel',
      ERROR: {
        HEADER: 'External contact already exists',
        TEXT: 'This email address has already been associated with an external contact',
      },
    },

    NOTIFICATIONS_EDIT_EXTERNAL_SUBSCRIBER_MODAL: {
      TITLE: 'Notify External User',
      SUB_TITLE: `Allow {{full_name}} to receive Rapyd notifications`,
      CANCEL: 'Cancel',
      APPLY: 'Apply',
      SELECT_CATEGORIES: 'Select Categories...',
    },

    NOTIFICATIONS_EXTERNAL_SUBSCRIBER_SUCCESS_SUBSCRIBED: {
      HEADER: 'Successfully Subscribed',
      SUB_HEADER: 'You have successfully subscribed to Rapyd notifications from {{merchant_name}}',
      UNSUBSCRIBED_LINK: 'Subscribed by mistake? <0>Unsubscribe</0>',
    },
    NOTIFICATIONS_EXTERNAL_SUBSCRIBER_UNSUBSCRIBE: {
      HEADER: 'Unsubscribe From Notifications',
      SUB_HEADER: 'Use the button below to unsubscribe Rapyd notifications from {{merchant_name}}',
      CANCEL: 'Cancel',
      UNSUBSCRIBE: 'Unsubscribe',
    },
    NOTIFICATIONS_EXTERNAL_SUBSCRIBER_SUCCESS_UNSUBSCRIBED: {
      HEADER: 'Sorry To See You Go',
      SUB_HEADER: 'You have unsubscribed from Rapyd notifications of {{merchant_name}}',
      SUBSCRIBE: 'Subscribe again',
    },

    INCORPORATION_STATUS_TRACKER: {
      PAGE_HEADER: 'Incorporate Your Business',
      SUB_HEADER: `You'r almost there! One more step to complete your application.`,
      SUB_TEXT:
        'This is the fastest way to check the status of your application. Simply use the same login details you used during \n sign-up to access this dashboard.',
      APPLICATION_STATUS: 'Application Status',
      APPLICATION_FORM: {
        APPLICATION_FORM: 'Application Form',
        APPLICATION_COMPLETED: 'Your application form has been completed',
      },
      PAYMENT: {
        PAYMENT: 'Payment',
        PAYMENT_NOT_COMPLETED:
          'You application will not be processed until the following step has been completed.',
        PAYMENT_COMPLETED: 'You payment has been processed',
        PAYMENT_BOX: {
          TITLE: 'Payment',
          TEXT: 'We’ll need your payment details for the Company Registration fee. Continue to the payment page here.',
          ACT: 'Incomplete',
          ERR: 'Error',
          GO: 'Go',
          ERROR: 'Incomplete',
        },
      },
      APPLICATION_REVIEW: {
        APPLICATION_REVIEW: 'Application Review \n Avg. time: 1 day',
        APPLICATION_REVIEWING: 'Your application is being reviewed by our team.',
      },
      REVIEW_COMPLETED: {
        REVIEW_COMPLETED: 'Review Completed',
        REVIEW_COMPLETED_TEXT: 'Your application has completed its review.',
      },
    },
    INCORPORATION_CHECKOUT: {
      TITLE: 'Payment',
      SUB_TITLE:
        'Please enter your payment details below. This payment will be processed once your application has been approved.',
    },

    TEST_NUMBER: {
      iban: 'Test IBANs',
      bic_swift: 'Test BIC/SWIFT',

      IBAN: {
        IBAN: 'IBAN',
        HEADLINE: 'TEST IBAN',
        ERRORS: {
          COUNTRY: 'Country not supported or not entered.',
          CHARACTERS: 'The characters in the IBAN are not valid.',
          LENGTH: 'Length of IBAN is not valid',
        },
      },
      BIC_SWIFT: {
        BIC_SWIFT: 'BIC/SWIFT',
        HEADLINE: 'TEST BIC/SWIFT',
        ERRORS: {
          NOT_RECONGNIZED: 'The BIC/SWIFT number was not recognized.',
          LENGTH: 'Length of BIC/SWIFT is not valid, and must be either 8 or 11 characters long.',
        },
      },
    },

    // Card Programs
    CARD_PROGRAMS_TITLE: 'Card Programs',
    CARD_PROGRAMS_SELECTED_PROGRAMS: 'Selected Program',
    CARD_PROGRAMS_PROGRAM_DETAILS: 'Program Details',
    CARD_PROGRAMS_COUNTRY: 'Country',
    CARD_PROGRAMS_CURRENCY: 'Currency',
    CARD_PROGRAMS_CARD_TYPE: 'Card Type',
    CARD_PROGRAMS_SCHEME: 'Scheme',
    CARD_PROGRAMS_BIN_TYPE: 'Bin Type',
    CARD_PROGRAMS_BIN_NUMBER: 'Bin Number',
    CARD_PROGRAMS_CARDHOLDER_TYPE: 'Card Holder Type',
    CARD_PROGRAMS_PROGRAM_CUSTOMIZABLE_FIELDS: 'Customizable Fields',
    CARD_PROGRAM_REMOTE_AUTHORIZATION: 'Remote Authorization',
    CARD_PROGRAM_REMOTE_AUTHORIZATION_URL: 'Remote Authorization URL',
    CARD_PROGRAM_RESTRICTED_TO_CARD_CURRENCY: 'Restricted to Card Currency',
    CARD_PROGRAM_FX_ENABLED: 'FX Enabled',
    CARD_PROGRAM_3DS_ENABLED: '3DS Enabled',
    CARD_PROGRAMS_NO_PROGRAMS: 'No Card Programs to see',

    REFUNDS_DETAILS: 'Refund Details',
    ORIGINALLY_PAID: 'Originally Paid',
    RECEIPT_NUMBER: 'Receipt Number',
    ORIGINAL_PAYMENT_DETAILS: 'Original Payment Details',
    ORIGINAL_PAYMENT: 'Original Payment',
    PAID_AMOUNT: 'Paid Amount',
    SENDER_ID: 'Sender ID',
    CANCELABLE: 'Cancellable',
    NOT_AVAILABLE: 'Not available',
    AVAILABLE: 'Available',
    RESERVED: 'Reserved',
    CURRENCY_BALANCE: '{{currency}} balance',
    VIEW_CURRENCY_SUMMARY: 'View {{currency}} Summary',
    BALANCES: 'Balances',
    WALLET_TRANSACTIONS: 'Wallet Transactions',
    VIEW_ALL: 'View All',
    CONVERT_CURRENCY: 'Convert Currency',
    PARTIAL_REFUND: 'Partial Refund',
    FULL_REFUND: 'Full Refund',

    BUY_AMOUNT: 'Buy Amount',
    BUY_CURRENCY: 'Buy Currency',
    CONVERSION_ID: 'Conversion Id',
    FIXED_SIDE: 'Fixed Side',
    RATE: 'Rate',
    SELL_AMOUNT: 'Sell Amount',
    SELL_CURRENCY: 'Sell Currency',

    ACTION_SUCCESSFUL: 'Action successful',
    CANCEL_SUBSCRIPTION: 'Cancel Subscription',
    CANCEL_SUBSCRIPTION_MESSAGE: `All data you've added will be deleted when you cancel a subscription.`,
    RENEW_SUBSCRIPTION: 'Renew Subscription',
    DROP_YOUR_FILES: 'Drop your files here',
    SUBSCRIPTION: 'Subscription',

    REQUIRES_KYB_ACTIVATE_YOUR_ACCOUNT:
      "Your account isn't verified yet.  <0>Activate your account</0> to start transacting with Rapyd",

    PAYMENT_METHODS_DISCLAIMER:
      'This list shows payment methods active on your account. Toggle to the sandbox to see all available payment methods and <0>Contact Support</0> to add new methods to your account.',
    PAYOUT_METHODS_DISCLAIMER:
      'This list shows payout methods active on your account. Toggle to the sandbox to see all available payout methods and <0>Contact Support</0> to add new methods to your account',
    DISPUTE_DISCLAIMER:
      'The disputed amount(s) in the report will be debited from your account in accordance with Rapyd’s terms and conditions. If you wish to contest the charge please refer to the email you received and contact us at (<0>chargeback@rapyd.net</0>)',
    idv_remove_card_conformation_modal: {
      header: 'Confirm Card Removal',
      body: 'Are you sure you want to remove your card? Doing so will deactivate your subscription and charge this card with the unpaid balance.',
    },

    idv_confirm_replace_card_modal: {
      body: 'By replacing your card you will be cancelling any existing subscription associated to the original card and opening a new subscription with the new card.  Doing so will immediately charge the previous card with any unpaid balance.',
    },

    cancel_subscription: {
      body: 'Are you sure you want to cancel your subscription?  This action is permanent.  You will be charged for unpaid balance immediately',
      successful_modal_body: 'Your subscription was successfully cancelled.',
    },

    renew_subscription: {
      body: 'Renewing your subscription will open a new subscription on the card that is currently associated to your account.',
      successful_modal_body: 'Your subscription was successfully renewed.',
    },

    create_sender: {
      successHeader: 'Sender Created!',
      successDescription: `You can now create payouts from <b>{{senderName}}</b> to Beneficiaries with matching details.`,
      successPrimaryButton: 'View Sender',
      id: 'ID',
      last_name: 'Last Name',
      first_name: 'First Name',
      country: 'Country',
      entity_type: 'Entity Type',
      address: 'Address',
      name: 'Name',
      date_of_birth: 'Date Of Birth',
      phone_number: 'Phone number',
      currency: 'Currency',
      identification_type: 'Identification Type',
      identification_value: 'Identification Value',
      purpose_code: 'Purpose Code',
      beneficiary_relationship: 'Beneficiary Relationship',
      source_of_income: 'Source Of Income',
      occupation: 'Occupation',
      company_name: 'Company Name',
      company_registration_number: 'Company Registration Number',
      phone_country_code: 'Phone Country Code',
      postcode: 'Post Code',
      city: 'City',
      dateOfBirth: 'Date of Birth',
      addressPlaceHolder: '121 Main St',
      state: 'State',
      merchant_reference_id: 'Reference ID',
      is_default: 'Is Default Sender',
      make_default: 'Make Default',
      make_default_sender: 'Make Default Sender',
      set_default_sender: 'Set as Default Sender',
      add_payout_method_specific_information: 'Add Payout method specific information',
      sender_beneficiary_country_tooltip: 'Country you plan to send funds to',
      sender_beneficiary_currency_tooltip: 'Currency the beneficiary will receive',
      sender_beneficiary_entity_type_tooltip: 'Beneficiary entity type',
      set_default_sender_tooltip:
        'Set this Sender as Default if you will make regular payouts from this Sender.',
      default_sender_checkbox_tooltip:
        'The default sender is used only in the client portal, when creating payouts and beneficiaries',
      default: 'Default',
      use_default_sender: 'Use Default Sender',
      beneficiary_default_sender_checkbox_tooltip:
        'Use this if the country and the currency of the default sender match the sender that will be transferring funds to this beneficiary',
      beneficiary_sender_country: 'Sender Country',
      beneficiary_sender_currency: 'Sender Currency',
      beneficiary_sender_entity_type: 'Sender Entity Type',
      sender_table_icon: 'Default Sender',
      country_currency_compination_error_title: 'Country and currency not supported',
      country_currency_compination_error_subtitle:
        'Please select a different country and currency.',
      beneficiary_sender_combination_error_title:
        'There is no payout methods available for this sender/beneficiary combination. Please try other options.',
    },

    LAST_4_DIGITS: 'Last 4 Digits',
    CONTACT_NAME: 'Contact Name',
    PAYOUT_TYPE: 'Payout Type',
    CONTACT_FIRST_NAME: 'Contact First Name',
    CONTACT_LAST_NAME: 'Contact Last Name',
    REQUESTED_AMOUNT: 'Requested Amount',

    ENGLISH_US: 'English(US)',
    EN_US: 'EN(US)',
    PAY_WITH: 'Pay With',
    CHOOSE_CASH_PROVIDER: 'Choose Cash Provider',
    CREATE_HOSTED_PAGE_DESCRIPTION:
      'Generate a custom payment page and send it to a recipient to let them make a payment.',
    CREATE_PAYMENT_SUB_HEADER_DESCRIPTION: 'Collect card payments via <0> Virtual Terminal</0>',
    CREATE_HOSTED_PAGE_PAY_WITH_FX: 'Allow Payment With FX',
    CREATE_HOSTED_PAGE_HOLD_IN_ESCROW: 'Hold In Escrow',
    CREATE_HOSTED_PAGE_ESCROW_RELEASE_DAYS: 'Escrow Release Days',
    CREATED_HOSTED_PAGE_ESCROW_RELEASE_DAYS_MAX_ERROR:
      'Must be equal to or less than {{max_number}}',
    CREATED_HOSTED_PAGE_ESCROW_RELEASE_DAYS_TOOLTIP:
      'The number of days before the funds are automatically released from escrow. When not selected, funds have to be released manually. You can choose between 1-90 days',
    AUTHORIZE_ONLY: 'Authorize only',
    TWO_STEP_PAYMENT: 'Two-Step Payment',
    TWO_STEP_PAYMENT_ICON_TOOLTIP:
      'Two-Step Payment First Authorizes The Card, And When The Order is Shipped, You Ask Rapyd To Capture The Payment.',
    VT_TAB_ADDITIONAL_DETAILS: 'Additional Details',
    VT_TAB_SELECT_CUSTOMER: 'Select Customer',
    VT_PAYMENT_EXPIRATION_DATE: 'Payment Expiration Date',
    VT_STATEMENT_DESCRIPTOR_TOOLTIP:
      "Statement descriptor is the name that appears on your customers' credit card statements. Limited to 22 characters.",
    VT_CREATE_PAYMENT_METADATA_TOOLTIP:
      'Extra data that will be available when creating the payment',
    VT_MERCHANT_ID_TOOLTIP:
      'Merchant Reference IDs can be defined for future reference. Limited to 255 characters.',
    VT_PAYMENT_DESCRIPTION: 'Payment Transaction Description',
    VT_PAID_AMOUNT: 'Paid Amount',
    VT_RECEIVED_AMOUNT: 'Received Amount',
    VT_STEP1_SUBSTEP1_ERR_TITLE: 'Error',
    VT_ADVANCED_DETAILS: 'Advanced Details',
    CREATE_HOSTED_PAGE_YOU_GET: 'You Get',
    CREATE_HOSTED_PAGE_BUYERS_PAYS: 'Buyer Pays',
    CREATE_HOSTED_PAGE_DISCLAIMER: 'Calculated based on the current exchange rate and not locked',
    ISSUED_CARDS_STATUSES: {
      IMP: 'IMP',
      ACT: 'Active',
      BLO: 'Blocked',
      INA: 'Inactive',
      DIS: 'Disabled',
      DEL: 'Deleted',
    },
    PAYMENT_LINK_STATUSES: {
      ACT: 'Active',
      INA: 'Inactive',
    },
    timeframes: {
      week: 'week',
      day: 'day',
      hour: 'hour',
    },
    timeframeOptions: {
      last30Days: 'Last 30 days',
      last7Days: 'Last 7 days',
      last24Hours: 'Last 24 hours',
    },

    onBoarding: {
      getStarted: 'Lets Get Started',
      getStartedSubTitle: 'This will help us recommend the right tool for you.',
      getPaid: 'Get Paid',
      getPaidDescription: 'Collect now up to $2,500 before \n' + 'activating your account',
      activateAccount: 'Activate Your Account',
      activateAccountDescription:
        'Let’s get to know you and setup your account. Start getting payments today.',
      collectPayments: 'Collect Payments',
      verifyAccount: 'Verify Your Account',
      skipGetStartedPage: "I'll choose later",
    },

    getStartedOnboarding: {
      getStarted: 'Get Started',
      welcome: 'Welcome To Rapyd, {{merchantAlias}}!',
      welcomeDescription: 'Follow these steps to customize and activate your account.',
      activateYourAccount: 'Verify Your Rapyd Account',
      activateYourAccountDescription:
        'Fill out the required information about your business so you can start getting paid right away.',
      setUpYourAccount: 'Set Up Your Rapyd Account',
      setUpYourAccountDescription:
        'Add the required and optional information to set up your Rapyd account for the way your business works.',
      getPaid: 'Choose How to Collect Payments',
      getPaidDescription:
        'Explore the options for fund collection and activate those that fit your business.',
      actions: {
        addBankAccount: 'Add Your Bank Details ',
        addBankAccountDescription: 'Provide your bank account details to enable settlements.',
        requestVirtualAccount: 'Request a Virtual Account',
        requestVirtualAccountDescription:
          'Collect payments globally as if you have a local bank account.',
        requestCorporateVirtualCard: 'Request Business Card',
        requestCorporateVirtualCardDescription:
          'Request a virtual debit card for business expenses.',
        disabledRequestCorporateCardIssued: 'Reached the limit',
        disableKybRequired: 'Your account must be approved first',
        fundAccount: 'Fund Your Account',
        fundAccountDescription: 'Fund your account to make payouts.',
        shareVirtualAccountDetails: 'Share Virtual Account Details',
        shareVirtualAccountDetailsDescription: 'Share virtual account details',
        setUpBranding: 'Customize your Checkout Experience',
        setUpBrandingDescription:
          'Offer a familiar checkout experience to your customers by adding your logo, fonts and colors.',
        inviteTeamMembers: 'Invite Your Team Members',
        inviteTeamMembersDescription: 'Add users to your account and customize their permissions.',
        requestPayment: 'Request a Payment',
        requestPaymentDescription:
          'Generate a custom payment page to send to your customers with a link.',
        paymentLink: 'Create a Reusable Payment Link',
        paymentLinkDescription:
          'Accept multiple payments from various customers with reusable payment links you can copy, paste and send.',
        virtualTerminal: 'Virtual Terminal',
        virtualTerminalDescription:
          'Accept payments from customers over the phone, in person or by mail with no card present, using Virtual Terminal.',
        addPlugin: 'Setup a Third Party Plugin',
        addPluginDescription:
          'Find the Rapyd Payments Plugin that best fits your business needs and follow our easy install instructions.',
        disburse: 'Disburse Funds',
        disburseDescription: 'Create payouts',
        invite: 'Invite',
        requestCard: 'Request Card',
        addBankDetails: 'Add Bank Account',
        add: 'Add',
        createLink: 'Create Link',
        createPayment: 'Create Payment',
        createPayout: 'Create Payout',
        shareDetails: 'Share Details',
        customize: 'Customize',
        request: 'Request',
        fund: 'Fund',
        collectVirtually: 'Collect Virtually',
        setupPlugin: 'Setup Plugin',
      },
    },

    getStartedOnBoardingEnterpriseModal: {
      header: 'Tell us more about your business',
      subtitle: 'Get in touch so we know which payment tools you may need. ',
      moneyAmount: 'How much money does your business process each year?',
      tools: 'Which tools are you interested in?',
      feedbackTitle: 'How can we help you?',
      selectRange: 'Select a range',
      collectPayments: 'Collect \n Payments',
      collectPaymentsDescription: 'Accept payments online',
      wallets: 'Wallets',
      walletsDescription: 'White-label digital wallet',
      virtualAccounts: 'Virtual \n Accounts',
      virtualAccountsDescription: 'Collect via local bank accounts',
      disbursePayments: 'Disburse \n Payments',
      disbursePaymentsDescription: 'Move money globally',
      issuedCards: 'Issued \n Cards',
      issuedCardsDescription: 'Global card issuing platform',
      requestSubmitted: 'Submitted Successfully',
    },

    kycImageTypes: {
      face: 'Selfie',
      front_side: 'ID Front',
      back_side: 'ID Back',
    },

    paymentMethodTypes: {
      bank_redirect: 'Bank Redirect',
      bank_transfer: 'Bank Transfer',
      bank: 'Bank',
      card: 'Card',
      card_redirect: 'Card Redirect',
      cash: 'Cash',
      cash_redirect: 'Cash Redirect',
      ewallet: 'eWallet',
      eWallet: 'eWallet',
      rapyd_ewallet: 'Rapyd Wallet',
      card_to_card: 'Card to Card',
    },

    relativeDates: {
      today: 'Today',
      now: 'Now',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
      futureInDays: 'in {{difference}} days',
      pastInDays: '{{difference}} days ago',
      minsAgo: '{{value}} mins ago',
      hoursAgo: '{{value}} hours ago',
      yesterdayAt: 'Yesterday at {{value}}',
    },

    daysOfWeek: {
      SUN: 'Sunday',
      MON: 'Monday',
      TUE: 'Tuesday',
      WED: 'Wednesday',
      THU: 'Thursday',
      FRI: 'Friday',
      SAT: 'Saturday',
    },

    chartAreaWidgets: {
      collect: {
        barChartTitle: 'Value of Payments',
        pieChartTitle: 'Value Per Payment Method',
        dashboardName: 'Payments Dashboard',
        createdPayments: 'Created Payments',
        completedPayments: 'Completed Payments',
        createdRefunds: 'Created Refunds',
        lastExpiredPayments: 'Last 10 Expired Payments',
        lastRefundedPayments: 'Last 10 Refunded Payments',
        showAll: 'Show All',
        noPaymentsListDataText: 'No Payment data yet',
        noRefundsListDataText: 'No Refunded data yet',
      },
      disburse: {
        dashboardName: 'Disburse Dashboard',
        barChartTitle: 'Value of Payouts',
        pieChartTitle: 'Value Per Payout Method',
        createdPayouts: 'Created Payouts',
        completedPayouts: 'Completed Payouts',
        payoutErrors: 'Payout Errors',
        lastWithErrors: 'Last 10 Payouts with Errors',
        lastCanceled: 'Last 10 Canceled Payouts',
        seeAllWithErrors: 'See All Payouts with Errors',
        seeAllCanceled: 'See All Canceled Payouts',
      },
      home: {
        dashboardName: 'Home',
        lineChartTitle: 'Value of Transactions',
        paymentsCreated: 'Created payments',
        paymentsCompleted: 'Completed payments',
        fundsCollected: 'Collected Funds',
      },
      wallets: {
        numberOfActiveWallets: 'Number of Active Wallets',
        addedLast7Days: 'Wallets added last 7 days',
        balanceCurrency: 'Balance Currency',
        barChartTitle: 'Funds',
        pieChartTitle: 'Transaction Types',
        dashboardName: 'Wallets Dashboard',
        createdPayments: 'Created Payments',
        completedPayments: 'Completed Payments',
        createdRefunds: 'Created Refunds',
        lastTenTransactions: 'Last 10 Transactions',
        newestWallets: 'Top 10 Newest Wallets',
        seeAllTransactions: 'See All Transactions',
        seeAllWallets: 'See all Wallets',
        noWalletsTransactionsDataText: 'No Wallets Transactions data yet',
        noWalletsListDataText: 'No Wallets data yet',
        fund_in: 'Funds In',
        funds_out: 'Funds Out',
        idvSuccessRate: 'IDV Success Rate',
        walletsAddedLastWeek: 'Wallets added last 7 days',
        balance: 'Balance',
        client_balance: 'Client Balance',
        end_user_balance: 'End User Balance',
      },
      protect: {
        numberOfBlockTransactions: 'Number of Blocked Transaction',
        numberOfReviewedTransactions: 'Number of Under Review Transaction',
        numberOfAllowedTransactions: 'Number of Allowed Transaction',
        mostRecentBlocked: 'Blocked Transactions',
        mostRecentUnderReview: 'Under Review Transactions',
        seeAllBlocked: 'See All Blocked Transactions',
        seeAllUnderReview: 'See All Under Review Transactions',
        allowedTransactions: 'Allow Rate',
        blockedTransactions: 'Block Rate',
        reviewedTransactions: 'Review Rate',
        lineChartTitle: 'Hit Rate',
        pieChartTitle: 'Top Rules',
      },
      issuing: {
        numberOfCards: 'Cards',
        numberOfApprovedTransactions: 'Approved Transactions',
        numberOfFailedTransactions: 'Failed Transactions',
        failedTransactions: 'Failed Card Transactions',
        moreFailedTransactions: 'Show more',
        noFailedTransactions: 'No Failed Transactions To Show',
        blockedTransactions: 'Blocked Card Transactions',
        moreBlockedTransactions: 'Show more',
        noBlockedTransactions: 'No Blocked Transactions To Show',
        barChartTitle: 'Value of transactions per {{unit}}',
        pieChartTitle: 'Value of transactions by card program',
      },
    },

    fundingRequest: {
      title: 'Account Funding Request',
      amount: 'Amount to Fund',
      amountGuideline: 'minimum 1000 USD or equivalent',
      bankAccount: 'Rapyd Bank Account',
      proofOfTransfer: 'Proof of Transfer',
      beneficiaryName: 'Beneficiary Name',
      bankName: 'Bank Name',
      accountNumber: 'Account Number',
      iban: 'IBAN',
      route_code: 'Routing Number',
      swift: 'Swift',
      requestReceivedTitle: 'Funding Request Received',
      requestReceivedMessage:
        'Your funding request was received and will be reviewed shortly. Your account will be credited after we confirm that the funds were transferred to the relevant bank account.',
      wrongFileType:
        'Invalid file type. please upload a file of type .jpg, .png, .jpeg, .pdf or .tif.',
      slaText:
        '* Please note: Funds sent to Rapyd will be added to your account 1 business day after it was received by Rapyd’s bank',
      requestFunds: 'Request Funds',
      createFundingDescription:
        'This form should be filled out only after funds (minimum value $1000) have been transferred to a Rapyd approved Bank Account.  To view accounts, click on the Available Accounts button.',
      successModalHeader: 'Request Received',
      successModalMessage:
        "The request to fund your account has been received.  We will review the details of your request and fund your account 1 business day after verifying that the funds were received in one of Rapyd's designated bank accounts.",
    },

    maintenancePage: {
      header: "We'll be back soon!",
      info: 'The Rapyd Client Portal is temporarily unavailable due to maintenance.',
      moreInfo:
        'We will be back as soon as possible.<br> Thank you for your patience. For urgent matters, please',
      link: 'contact <0>Rapyd Customer Support.</0>',
      goToWebsite: 'Go to Rapyd website',
    },

    issuingCardRequestModal: {
      header: 'Request Cards',
      numberOfCards: 'Number Of Cards',
      deliveryAddress: 'Delivery Address',
      contactPersonName: 'Contact Person Name',
      contactPersonPhone: 'Contact Person Phone',
      successMessageHeader: 'Issuing Request Submitted',
      successMessageBody:
        'Your request for physical cards has been received. You can view the status of your requests <0>here</0>.',
      mustBeBiggerThanOne: 'Amount must be Bigger than 1',
      city: 'City',
      country: 'Country',
      state: 'State',
      program: 'Program',
      noProgramErrorModalHeader: 'Unable to Complete Action',
      noProgramErrorModalBody:
        'You are unable to make a issued card request because your account does not have any card programs defined.  To add a Card program, <0>contact support</0>.',
    },

    ruleCreator: {
      rulesDisplayTitle: 'Rules',
      addRule: 'Add Rule',
      createRule: 'Create Rule',
      editRule: 'Edit Rule',
      forCategory: ' for {{category}}',
      updateRule: 'Update Rule',
      saveDraft: 'Save as Draft',
      noRules: 'No Defined Rules',
      enableRule: 'Enable Rule',
      confirmStatusChangeHeader: '{{statusAction}} rule',
      confirmStatusChangeMessage: 'Are you sure you want to {{statusAction}} this rule?',
      ruleCreatedMessage: 'Your Rule has been created, but is currently disabled',
      ruleUpdatedMessage: 'Your Rule has been updated, but is currently disabled',
      changeStatusEnableErrorHeader: 'Unable to Activate Rule',
      changeStatusEnableErrorMessage:
        'Your rule did not pass validation, please edit and try again',
      addGroup: 'Add Group',
      deleteGroup: 'Delete Group',
      conditionError: 'Invalid or missing parameter',
      groupNumber: 'Group #{{number}}',
      ruleTypes: {
        allow: 'Allow',
        block: 'Block',
        review: 'Review',
        '3ds': '3D Secure',
      },
      addSubConditionInactiveTooltip: 'Must first add a primary condition',
      addSubConditionTooltip: 'Add a secondary condition',
      removeConditionInactiveTooltip: 'Cannot remove condition',
      removeConditionTooltip: 'Remove condition',
      removeSubConditionTooltip: 'Remove secondary condition',
      compareToOtherField: 'Compare to other field',
      compareToList: 'Compare to list',
      compareToFieldDescription: 'Compare the field to another field and not an absolute value',
      compareToListDescription: 'Search for the value in an predefined list of values',
      ruleTypesDescription: {
        allow: 'The transaction is allowed if it matches any of the following rules:',
        block:
          "The transaction is blocked if it matches any of the following rules and does not match any 'Allow' rule:",
        review:
          "The transaction is sent for review if it matches any of the following rules and does not match any 'Allow' rule or 'Block' rule:",
        '3ds':
          'The card transaction must go through 3D Secure authorization before being completed:',
      },
      ruleStatus: {
        Enable: 'Enabled',
        Disable: 'Disabled',
        Draft: 'Draft',
        Delete: 'Deleted',
      },
      descriptionChangedHeader: 'Rule Description Edit',
      descriptionChangedMessage: 'The rule description was successfully changed.',
      continueEditing: 'Continue Editing',
      done: 'Done',
    },

    subscriptionBuilder: {
      subscriptionBuilder: 'Subscription Builder',
      title: 'Create Your First Subscription',
      skip: 'Skip Builder',
      description:
        'Start your first subscription with these four simple steps and get started with subscriptions.',
      addProduct: 'Add A Product',
      addProductDescription:
        'Start your subscription by creating a product or choosing an existing one.',
      addProductAction: 'Add New Product',
      addPlan: 'Add A Plan',
      addPlanDescription: 'Add a pricing plan for your product or create a  new one.',
      addPlanAction: 'Create New Plan',
      addCustomer: 'Add A Customer',
      addCustomerDescription:
        'Add to your plan the customer you want to subscribe to or create a new one.',
      addCustomerAction: 'Add New Customer',
      createSubscription: 'Create A Subscription',
      createSubscriptionDescription:
        'When completed all the above you can easly create a subscription',
    },

    quarantineStatus: {
      HLD: 'On Hold',
      DEC: 'Blocked',
      REF: 'Release failed',
      REL: 'Released',
    },

    flaggedTransactionSideMenu: {
      transactionType: 'Transaction Type',
      amountAndCurrency: 'Amount and Currency',
      statementDescriptor: 'Statement Descriptor',
      triggeredRules: 'Triggered Rules',
      triggeredRule: 'Triggered Rule',
      description: `A {{category}} payment request was sent.`,
      descriptionPayout: `A {{type}} Payout request was sent.`,
      errorRetriveRuleDetailsTitle: 'Error Retrieving Rule',
      errorRetriveRuleDetailsBody:
        'The rule you are trying to view has been deleted and can no longer be viewed',
    },
    blockedIssuingCardTransactionsSideMenu: {
      description:
        'A payment by {{contact_name}} with the card ending in {{card_last_digits}} was blocked by Rapyd Protect',
    },
    auditMetadata: {
      protect_rule: {
        status: 'Rule Status',
        id: 'Rule ID',
        decision_type: 'Rule Outcome',
      },
      quarantine_update_transaction: {
        id: 'Transaction ID',
        reason: 'Reason',
      },
      create_comment: {
        body: 'Comment',
        related_item_id: 'Id',
      },
      upload_mass_beneficiary_file: {
        batch_id: 'Batch ID',
      },
    },
    auditCreateCommentRelatedItemTypeSuffix: {
      flaggedTransactions: 'a transaction that was under review',
      blockedTransactions: 'a transaction that was blocked',
      payoutTransactions: 'a transaction that is a payout',
      customer: 'customer',
    },
    beneficiariesEntityTypes: {
      company: 'Company',
      individual: 'Individual',
    },
    sendersEntityTypes: {
      company: 'Company',
      individual: 'Individual',
    },

    fxRates: {
      tableTitle: 'Exchange Rates For {{date}}',
      tableDisclaimer:
        '*The rates above solely reflect the benchmark rates and do not include the additional fees applied by Rapyd. <br /> For more details please review your Merchant Agreement.',
      selectedCurrencies: 'Selected Currencies  <b>(5 Max)</b>',
    },
    userEnvironments: {
      0: 'Production',
      1: 'Sandbox',
      5: 'Sandbox',
    },
    certification: {
      INT: {
        SPLASH_TEXT:
          'Want to improve your Service Level Agreement?  Certify Your Integration Account.',
        SPLASH_LINK: 'Details',
        HEADER: 'Integration Certification Process',
        TEXT: "It looks like you haven't certified your Rapyd Collect Integration, yet.\nDoing so will make you eligible for a higher level of customer support.\nTo complete the certification process, be sure to complete the below actions after submitting your request for certification.\n\nIntegration requirements:\n\n1. Executing <0>List Payment Methods by Country</0> as a prerequisite for payment creation.\n\n2. Execute <1>Get Payment Method Required Fields</1> as a prerequisite for payment creation.\n\n3. Complete 3 payments end to end.\n\nYou must complete at least 3 payments within 3 days after you submit your request.\nRapyd will review the payments to determine whether your integration is successful.\n\nWhen your integration is certified, it will be subject to Rapyd's Service Level Agreement.",
        CTA: 'Certify My Integration',
      },
      PEN: {
        SPLASH_TEXT:
          'Your Rapyd Collect integration is under review.  You will be notified soon regarding if you have been approved.',
        SPLASH_LINK: 'Details',
        HEADER: 'Waiting for Approval',
        TEXT: 'Your Rapyd Collect integration is currently in the process of being certified.\n\nYou will be notified of the results within 3-5 business days after you submitted your request.\n\nFor any questions, please contact Client Support at <0>support@rapyd.net</0>',
        CTA: 'Close',
      },
      CRT: {
        SPLASH_TEXT:
          "Your integration for Rapyd Collect has been certified. You are now subject to Rapyd's Service Level Agreement.",
        SPLASH_LINK: 'Details',
        HEADER: 'Rapyd Collect Integration Certified',
        TEXT: "Your integration for Rapyd Collect has been certified. You are now subject to Rapyd's Service Level Agreement.\n\nFor any questions, please contact support at <0>support@rapyd.net</0>",
        CTA: 'Hide Notification',
      },
      DEN: {
        SPLASH_TEXT:
          'Your integration was not certified. Please review and submit again when ready.',
        SPLASH_LINK: 'Details',
        HEADER: 'Certification Failed',
        TEXT: 'Your integration was not certified.\nThis could be for a number of reasons.\nReview the integration requirements and identify possible gaps.\nWhen you are ready, please reapply.\n\nIntegration requirements:\n\n1. Execute <0>List Payment Methods by Country</0> as a prerequisite for payment creation.\n\n2. Execute <1>Get Payment Method Required Fields</1> as a prerequisite for payment creation.\n\n3. Complete 3 payments end to end.\n\nYou must complete at least 3 payments within 3 days after you submit your request.\nRapyd will review the payments to determine whether your integration is successful.\n\nFor any questions, please contact Client Support at <2>support@rapyd.net</2>\n',
        CTA: 'Certify My Integration',
      },
    },
    createHostedPageModal: {
      successMessageBodyMobile: 'Your checkout page was created successfully',
      errorMessageBodyMobile: 'Unfortunately, your checkout page was not created',
      successMessageHeader: 'One-time link created',
      successMessageBody:
        'A payment link was successfully created with your required payment parameters. After the payment is completed you will be able to see it in the Payments table.',
      failureModalHeader: 'Error creating one-time payment link',
      categoryErrorModalBody:
        'The category or categories selected in this payment link are not supported by your customized on-time payment link page. Go to the <0>Contact us</0> to enable this categories.',
    },

    createSubscriptionHostedPageModal: {
      successMessageHeader: 'Subscription Payment Page Created',
      successMessageBody:
        'A hosted page for providing card details and completing the payment of a subscription was successfully created with your required payment parameters. After the payment is completed you will see the subscription as active in the subscriptions table',
      failureModalHeader: 'Error Creating Subscription Checkout Page',
    },

    // Billing Details section
    restrictedPage: {
      isUserRestricted: {
        header: "Sorry, you're not on the list",
        subheader: 'You do not have access to this page',
        message: 'To gain access privileges ask your account administrator or owner',
      },
      general: {
        header: "Sorry, I'm going to need to see some ID...",
        subheader:
          'Complete the KYB form under <0>{{link_label}}</0> <1/> to gain access to this and many more features',
        message: '',
      },
    },
    activityCenter: {
      types: {
        feature: 'New Feature',
        action: 'New Action',
        reminder: 'Reminder',
      },
      massBeneficiaryTokenization: {
        title: 'Mass Beneficiary Tokenization',
        message:
          'Have your beneficiaries provide their bank details themselves using our hosted solution',
        linkText: 'Create Mass Beneficiary',
      },
      createPayout: {
        title: 'Create a Payout',
        message:
          'No API necessary.  Create Payouts from your Rapyd account using our Payout Creator',
        linkText: 'Create Payout',
      },
      bankDetails: {
        title: 'Add your Bank Details',
        message: 'To accept settlements you’ll need to first add your bank account',
        linkText: 'Add Now',
      },
      createPayment: {
        title: 'Create Payments via the Client Portal',
        message:
          'You can create a payment URL though our Request Payment feature, or complete a payment yourself through our Virtual Terminal',
        linkText: 'Request Payment',
      },
    },
    verifyIdentityModal: {
      header: 'Verify Identity',
      country_of_document: 'Country of Document',
      document_type: 'Document Type',
      image_of_face: 'Image of Face',
      document_front: 'Document front',
      document_back: 'Document back',
      optional: '(optional)',
      reference_id: 'Reference ID',
      send_webhook: 'Send a webhook when results are available',
      CTA: 'Verify Identity',
      successful_modal_body:
        'Your identity verification request was successfully submitted.\nYour results can be viewed shortly in the IDV table.',
      STORE_IDS_CTA: 'Store Files',
      wrongFileType: 'Invalid file type. please upload a file of type .jpg, .png, .jpeg.',
      successful_modal_store_body:
        'The files you’ve summited have been stored. They can be viewed shortly in the IDV table or under the clicking on the Contact in the contact table.',
    },
    addIbanModal: {
      header: 'Create Virtual Account',
      description: 'Description (optional)',
      ref_id: 'Reference ID',
      ref_id_tooltip: 'Provide a name that identifies the user of the virtual account',
      CTA: 'Create',
      success_msg_with_iban: 'A new virtual account was created for the Wallet:',
      success_msg_without_iban: 'A new virtual account was created:',

      not_allowed_to_add_iban:
        'Your account does not have access to this feature.\nFor more information, please <0>contact support</0>',
    },

    currencyRate: {
      currency: 'Currency',
      rate: '1 {{sellCurrency}} = {{rate}} {{buyCurrency}}',
      combinationNotSupported: 'FX combination not supported',
      from: 'From',
      to: 'To',
      description: 'For Payouts, including markups',
      title: 'Base Currency',
    },
    capturePayment: {
      header: 'Capture Payment',
      amount_error: 'Invalid amount for capture in payment',
      fields: {
        receipt_email: 'Receipt Email',
        statement_descriptor: 'Statement Description',
        FULL_CAPTURE: 'Full',
        PARTIAL_CAPTURE: 'Partial',
      },
      submit: 'Capture Payment',

      success_modal: {
        header: 'Payment Captured',
        message: '{{amount}} {{currency_code}} was captured on <0>{{id}}</0>',
      },

      error_modal: {
        header: 'Action Failed',
      },
    },

    CAPTURE_FUNDS_LATER: 'Capture funds later',
    PAYMENT_WITH_FX: 'Payment With FX',
    REFUND_WITH_FX: 'Refund With FX',
    YOU_GET: 'You Get',
    EXCHANGE_RATE_IS: 'Exchange Rate',
    TO_WALLET: 'To Wallet',
    SENT_AMOUNT: 'Sent Amount',
    REFUNDED_CURRENCY: 'Refunded Currency',
    RECEIVED_AMOUNT: 'Received Amount',

    TAB_TOKENIZED_CARDS: 'Tokenized Cards',
    CARD_TOKEN: 'Card Token',
    CUSTOMER_TOKEN: 'Customer ID',
    LAST4_DIGITS: 'Last 4 digits',
    CVV_CHECK: 'CVV Check',
    ACS_CHECK: '3DS Checked',
    EXPIRATION_MONTH: 'Expiration Month',
    EXPIRATION_YEAR: 'Expiration Year',
    TOKENIZATION_DATE: 'Tokenization Date',
    SUGGESTION_CARD_TOKEN: 'Rapyd Issued Card ID',
    SUGGESTION_CUSTOMER_TOKEN: 'Rapyd Issued Identifier for the Customer',
    SUGGESTION_CARD_CUSTOMER_NAME: 'Name of Customer associated to the Card',
    SUGGESTION_LAST4_DIGITS: 'Last 4 digits- of the card',

    COUPON_PERCENTAGE_OFF: '{{value}}% OFF',
    COUPON_AMOUNT_OFF: '{{value}} {{currency}} OFF',
    SENDERS_SIDE_MENU_NO_PAYOUTS: 'No payouts have been made by this sender',
    COUPON_HEADER_DELETE: 'Delete coupon',
    DELETE_COUPON: 'Delete Coupon',
    ADD_COUPON_TO_SUBSCRIPTION: 'Add to subscription',
    ADD_COUPON_TO_SUBSCRIPTION_MODAL_HEADER: 'Add coupon to subscription',
    COUPON_DELETE_COMPLETION_QUESTION_HEADER: 'Are you sure you want to delete this coupon?',

    welcomeWizard: {
      countryNotSupported: 'Country Not Supported',
      welcomeMessage: 'Welcome to Rapyd',
      chooseCaseSubTitle: 'What is your use case?',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      requestAccess: 'Request Access',
      collectingFunds: {
        title: 'Accepting Payments',
      },
      disburse: {
        title: 'Sending Payouts',
        formTitle: 'Additional Information Required',
        subTitle: 'To request access to Rapyd Payouts,\n please provide the following information',
        sendFundsFrom: 'Send Funds From',
        to: 'To',
      },
      complexFinancialModel: {
        title: 'Complex Financial Model',
      },

      integrationType: {
        title: 'Select Integration Type:',
        pluginsTitle: 'Using a Store Plugin',
        ownIntegrationTitle: 'Using my own integration',
        noPluginSupportForCountry: 'No Plugins Support\n for your country of registry',
      },

      selectStore: {
        title: 'What store do you use ?',
      },

      selectPaymentCountry: {
        title: 'What countries do you want to collect funds in?',
      },

      selectPayoutCountry: {
        title: 'What countries do you want to send money to?',
      },

      importantInformation: {
        title: 'Important information',
        bullets: {
          creatingPayments: 'You can already start creating payments.',
          completeKYB:
            'You must complete the account activation application and be approved to receive a settlement',
          minimumSettlementUSD: 'Minimum settlement amount is {{value}} or equivalent',
          minimumSettlementEUR: 'Minimum settlement amount is {{value}} or equivalent',
          settlementsCountries:
            'Rapyd settles in the following currencies: {{currency}} <br> To bank accounts located',
          disburseFunds:
            'Only after activating your account, you can start sending and receiving funds',
          transferCorridors:
            'After account approval, countries for disbursing funds can be added only upon request',
          depositFundsCountries:
            'Your account can be funded by depositing funds to a bank in the following countries:',
        },
      },

      readyGetStarted: {
        title: 'Get Started',
        activatePlugin: 'Activate a Plugin',
        createPayment: 'Send Payment Request',
        businessInformation: 'Begin Account Activation',
        goToSandbox: 'Go to Sandbox',
        activateAccount: 'Begin Account Activation',
        goToDocumentation: 'Go to Documentation',
      },

      products: {
        title: 'What solutions are you interested in?',
        issuing: 'Issuing',
        issuingSubtitle: 'Issue physical or virtual cards',
        wallets: 'Wallets',
        walletsSubtitle: 'Managing sub accounts',
        multipleProducts: 'Multiple Products',
        multipleProductsSubtitle: 'Leverage numerous solutions together',
      },
      additionalInformation: {
        title: 'Please provide additional information',
        countries: 'Countries',
        currencies: 'Currencies',
        explainYourCase: 'Explain your use case',
      },

      thankYou: {
        title: 'Thanks for your interest in Rapyd',
        description:
          'A sales representative will reach out to you soon to provide you\n more information on setting up your account. \n\nIn the meantime you can use our Sandbox environment \nto test the Rapyd Fintech-as-a-Service Solution',
      },
    },

    ruleSimulation: {
      columns: {
        dateOfSimulation: 'Date of Simulation',
        ruleId: 'Rule ID',
        ruleCategory: 'Rule Category',
        simulationStatus: 'Simulation Status',
        hits: 'Hits',
        transactionsScanned: 'Transactions Scanned',
        ruleStatus: 'Rule Status',
        ruleType: 'Rule Type',
      },
      tab: 'Rule Simulations',
      simulate: 'Simulate',
      ruleSimulated: 'Rule Simulated',
      successModalHeader: 'Rule Sent to Simulation',
      successModalMessage:
        'The rule has been sent to our simulations engine.  Time of completion may vary depending on the complexity of the rule and the number of scanned transactions.  Results can be view in the “Rule Simulations” tab',
    },

    rapydBankAccounts: {
      columns: {
        bankName: 'Bank Name',
        country: 'Country',
        currency: 'Currency',
        beneficiaryName: 'Beneficiary Name',
        accountNumber: 'Account Number',
        iban: 'IBAN',
        swift: 'Swift',
        routeCode: 'Route Code',
        incorpoationNumber: 'Incorporation Number',
      },
    },

    ewalletAccountDocuments: {
      columns: {
        documentName: 'Document Name',
        createdAt: 'Date Uploaded',
      },
    },

    disputes: {
      columns: {
        disputeId: 'Dispute ID',
        amount: 'Amount',
        originalAmount: 'Original Amount',
        originalDisputeAmount: 'Original Dispute Amount',
        paymentId: 'Payment ID',
        category: 'Category',
        status: 'Status',
        disputeGatewayId: 'Dispute Gateway ID',
        ewalletId: 'eWallet ID',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        dueDate: 'Due Date',
        description: 'Description',
        is3dsAuthenticated: '3DS Authenticated',
        contested: 'Contested',
        preDisputed: 'Pre-Disputed',
        customerId: 'Customer ID',
      },
      authenticated: 'Authenticated',
      notAuthenticated: 'Not Authenticated',
      contested: 'Contested',
    },

    roles: {
      columns: {
        roleAlias: 'Role',
        users: 'Users',
      },
      viewRole: 'View Role',
      deleteRole: 'Delete Role',
      copyRole: 'Copy Role',
      createNewRole: 'Create New Role',
      permissionsExplanation: '{{topLevelCategory}} Permissions',
      deleteRoleForbidden: 'Role with active users cannot be deleted',
      noAvailablePermissions: 'No Available Permissions',
    },

    simulateIbanPayment: {
      header: 'Simulate Bank Transfer',
      message:
        'Select the amount and currency of your simulated transfer.  Make sure the relevant webhooks are active for the purpose of your test.',
      success_message: 'A Bank Transfer was successfully simulated for {{ewallet}}',
    },

    form_validators_errors: {
      required: 'Required',
      max_length: 'Must be {{value}} characters or less',
      exact_length: 'Must be {{value}} characters',
      illegalDateRange: '“From” date must be before “To” date',
      dateRangeTooLarge: 'Maximum allowed search range is {{value}} months',
      biggerThanZero: 'Must be bigger than zero',
      transactionAmountInvalid: 'transaction value must be greater than 0.00',
      nameExist: 'Name already exists, must be unique',
      nonEnglishLetter: 'Special characters are not supported',
      valueToHigh: 'Value is higher than available balance',
      cardNameInvalid: 'Card Name Invalid',
    },

    korta_authorisations: {
      header: 'Authorisations',
      id: 'Details',
      merchantId: 'Merchant ID',
      terminalId: 'Terminal ID',
      reference: 'Reference',
      amount: 'Amount',
      currency: 'Currency',
      type: 'Type',
      authorisationCode: 'Authorisation Code',
      settlementReference: 'Batch Reference',
      requestTime: 'Request Time',
      actionCode: 'Action Code',
      cardType: 'Card Type',
      status: 'Status',
      general_search: 'General Search',
      arn: 'ARN',
      arn_placeholder: 'Search by ARN number (23 characters)',
      merchantIdDropDown: 'Merchant',
      acquiringContractId: 'Acquiring contracts',
      terminalDropDown: 'Terminal',
      authType: 'Type',
      sale: 'Sale',
      refund: 'Refund',
      authStatus: 'Authorisation status',
      inProgress: 'In Progress',
      authorised: 'Authorised',
      captured: 'Captured',
      sent: 'Sent',
      captureDiffAmount: 'Captured different amount',
      re_auth: 'Re authorisation',
      reject: 'Rejected',
      from: 'From*',
      to: 'To*',
      fromTime: 'From Time*',
      toTime: 'To Time*',
      referenceField: 'Reference*',
      arnField: 'ARN*',

      createRefund: {
        successHeader: 'Action Successful',
        successMessage:
          '{{revAmount}} {{currency}} was refunded from the original payment of {{amount}} {{currency}}',
        errorHeader: 'Action Unsuccessful',
        errorMessage:
          'We were unable to complete the refund as requested.  Please look at the original payment details before trying again.  If the problem persists, please <0>contact support</0>',
        refundErrorHeader: 'Error Refunding Payment',
        refundCreatedThroughRapydErrorMessage:
          'The payment you are trying to refund was originally created through Rapyd.  To refund it locate the payment under Collect-->Payments and select "Create Refund" within the Payment side panel.',
      },
    },

    TRANSFER_DETAILS: 'Transfer Details',
    RECEIVED_AT: 'Received At',
    RECEIVING_IBAN: 'Receiving IBAN',
    RECEIVING_IBAN_REF: 'Receiving Account Ref ID',
    SENDER_INFORMATION: 'Sender Information',
    SENDER_ACCOUNT_NAME: 'Sender Account Name',
    SENDER_SORT_CODE: 'Sender Sort Code',
    SENDER_ACCOUNT_NUMBER: 'Sender Account Number',
    SENDER_REMITTER_REFERENCE: 'Sender Remitter Reference',
    DIRECTION: 'Direction',
    MERCHANT_CATEGORY_CODE: 'Merchant Category Code',
    SYSTEMS_TRACE_AUDIT_NUMBER: 'Systems Trace Audit Number',
    CONTACT_PHONE_NUMBER: 'Contact Phone Number',
    CIT_TOKEN: 'CIT Token',
    ewalletSettlementTransactionsSideMenu: {
      description: 'A bank transfer was made to {{iban_ref}}',
    },
    ewalletCardTransactionsSideMenu: {
      description: 'A Card payment was made by {{contact_name}}',
      description_anonymous: 'A Card payment was made',
    },
    ewalletBusinessEntityType: {
      sole_prop: 'Sole proprietorship',
      partnership: 'Partnership',
      company: 'Company',
      government: 'Government agency',
      charity: 'Charity',
      npo: 'Non-profit organization',
      association: 'Unincorporated business association',
      trust: 'Trust',
    },

    ewalletTransactionsTabsLinks: {
      all: 'All',
      issued_cards: 'Issued Cards',
      collect: 'Collect',
      disburse: 'Disburse',
      bank_transfer: 'Bank Transfer',
      other: 'Other',
      failed: 'Failed',
      card_to_card: 'Card to Card',
    },

    gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
      notApplicable: 'N/A',
    },

    role_in_company: {
      owner: 'Owner',
      agent: 'Agent',
      employee: 'Employee',
    },

    // SFTP
    SETUP_SFTP: 'Setup SFTP',
    SFTP_SETUP_REQUEST: 'Request SFTP Setup',
    SFTP_EXPLANATION:
      'Clients can receive reports via SFTP. \nPlease provide the following information:',
    SFTP_EXPLANATION_NOTE:
      'Please note, Rapyd uses 2048bit encryption when generating the public/private key pair. A public key will be provided once set-up is completed by our support team.',
    HOSTED_BY: 'Hosted By:',
    RAPYD: 'Rapyd',
    CLIENT: 'Client',
    IPS_TO_WHITELIST: 'IPs to Whitelist',
    IPS_TO_WHITELIST_CLIENT_HOST: 'Please whitelist the following IP addresses:',
    PUBLIC_KEY: 'Public Key:',
    IPS_TO_WHITELIST_DESCRIPTION: 'separate multiple IP with a comma',
    PUBLIC_KEY_DESCRIPTION:
      'Key used for the SSH encrypted connection, must be 2048 bit encryption level.<br/>Allowed file types: .pub, .txt',
    HOST_ADDRESS: 'Host Address',
    PORT: 'Port',
    USERNAME: 'Username',
    PASSWORD_REQUIRED: 'Password Required',
    FOLDER_PATH: 'Folder Path',
    RECONCILIATION_SFTP_REQUEST: 'A request to setup an SFTP connection was made',
    SFTP_REQUEST_SUCCESS_HEADER: 'SFTP request Received',
    SFTP_REQUEST_SUCCESS_BODY:
      'We have received your request to setup a SFTP connection.  Someone from support will contact you soon.',
    SFTP_DROP_YOUR_FILES: 'Drop your files here',

    notificationContent: {
      compliance: 'Your KYB request was {{status}}',
      service: 'Client portal version {{version}} has been released!',
    },

    // Dispute side menu
    DISPUTE_SIDE_MENU: {
      BUTTONS: {
        APPROVE_DISPUTE: 'Approve Dispute',
        SUBMIT_EVIDENCE: 'Submit Evidence',
      },
      SUMMARY_SECTION: {
        SUMMARY: 'Summary',
        CREATED_AT: 'Created At',
        STATUS: 'Status',
        DISPUTED_BY_CUSTOMER_NAME: 'A payment was disputed by {{customer_name}}',
        DESCRIPTION: 'Description',
        DETAILS: 'Dispute Details:',
        CATEGORY: 'Category',
      },
      DISPUTE_DETAILS_SECTION: {
        DISPUTE_DETAILS: 'Dispute Details',
        DISPUTE_AMOUNT: 'Dispute Amount',
        CATEGORY: 'Category',
        DESCRIPTION: 'Description',
        UPDATED_AT: 'Updated At',
        DUE_DATE: 'Due Date',
      },
      PAYMENT_DETAILS_SECTION: {
        PAYMENT_DETAILS: 'Payment Details',
        PAYMENT_ID: 'Payment ID',
        REQUESTED_AMOUNT: 'Requested Amount',
        PAYED_AMOUNT: 'Paid Amount',
        PAID_AT: 'Paid At',
        PAYMENT_ORIGIN: 'Payment Origin',
        DESCRIPTION: 'Description',
        MERCHANT_REFERENCE_ID: 'Merchant Reference ID',
        LAST_4_DIGITS: 'Last 4 digits',
        REFUNDED: 'Refunded',
      },
      PAYERS_DETAILS_SECTION: {
        PAYERS_DETAILS: 'Payers Details',
        CUSTOMER_NAME: 'Customer Name',
        CUSTOMER_PHONE_NUMBER: 'Customer Phone Number',
        CUSTOMER_EMAIL: 'Customer Email',
        IP_ADDRESS: 'IP Address',
      },
    },

    PAYMENT_METHOD_LIST: 'Default Payment Method:',
    EMAIL_CUSTOMER_LIST: 'E-mail:',
    CREATED_AT_CUSTOMER_LIST: 'Created at:',
    // Accept dispute

    ACCEPT_DISPUTE: {
      BUTTON: 'Accept Dispute',
      HEADER: 'Accept Dispute?',
      BODY: 'Are you sure you want to approve this disputed transaction?  This action cannot be reversed.',
      CTA_CONFIRM: 'Confirm',
      CTA_CANCEL: 'Cancel',
      CONFIRM_HEADER: 'Dispute Accepted',
      CONFIRM_BODY:
        'The dispute for {{payment_id}} of {{original_amount}} {{currency}} was accepted.',
      ERROR_HEADER: 'Error Completing Action',
      ERROR_BODY:
        'There was an error changing the status of this dispute.  Please try again later.  If this problem persists, please <0>contact support</0>',
    },

    // Disputes Evidence

    DISPUTE_CHALLENGE: {
      CHALLENGE_DISPUTE: 'Challenge Dispute',
      DISPUTE_DETAILS: 'Dispute Details',
      DISPUTE_AMOUNT: 'Dispute Amount',
      EXPLANATION: 'Explanation',
      RECOMMENDATIONS: 'Recommendations',
      REASON_FOR_CHALLENGE: 'Reason for Challenge',
      FILE: 'File',
      UPLOAD_ERROR_MORE_THEN_5_MB: 'File must be 5 MB or less',
      UPLOAD_ERROR_WRONG_FORMAT: 'Unsupported file format, please use pdf.',
      DESCRIPTION_OF_FILE: 'Description of file',
      ADD_FILE: 'Add a file',
      PAYMENT_REQUESTED: 'Payment requested',
      PAYMENT_PAID: 'Payment paid',
      DISPUTE_SEE_ALL_DETAILS: 'See All Details >',
      REMOVE_EVIDENCE: 'Remove file and description',
      REASON: 'Reason',
      REFUND_ALREADY_ISSUED: 'Refund already issued',
      OTHER: 'Other',
      SUBMIT_NOTE:
        '<b>Please note,</b> evidence can be submitted only once, so\nmake sure all relevant information is being provided',
      CHALLENGE: 'Challenge',
      reason_mapping: {
        [DISPUTE_REASONS.GENERAL]: {
          explanation:
            'This is an uncategorized dispute with few details on the reason for the dispute.',
          recommendations:
            'Contact the customer for additional details on why the transaction was disputed.<br/>Afterwards, set the dispute to a specific category, and follow the ‘What to do’ instructions for the category.',
        },
        [DISPUTE_REASONS.CARDHOLDER_DISPUTE]: {
          explanation: 'Initial cardholder dispute (MC)<br/>All other detailed reasons below',
          recommendations:
            'Contact the customer for dispute reasons. Set the corresponding category and follow the instructions.',
        },
        [DISPUTE_REASONS.CREDIT_NOT_PROCCESSED]: {
          explanation:
            'The customer claims that the purchased product was returned or the transaction was otherwise canceled, but not yet refunded or credited.',
          recommendations:
            'Provide evidence that the customer did not return the product according to the terms of the transaction or did not cancel the transaction within the permitted time.<br/>If a refund or credit will be given, specify the amount and date, and provide evidence that it is according to the card issuer’s regulations.',
        },
        [DISPUTE_REASONS.GOODS_OR_SERVICES_NOT_PROVIDE]: {
          explanation:
            'The customer claims they did not receive the products or services purchased.',
          recommendations:
            'Provide evidence that the customer received the products or services such as shipment tracking numbers, and delivery confirmation for tangible goods.<br/>For online services, provide evidence the service was used by the customer, and include the IP address of the customer.',
        },
        [DISPUTE_REASONS.PRODUCT_UNACCEPTEABLE]: {
          explanation:
            'The product or service was received but was defective, damaged, or not as described.',
          recommendations:
            'Provide evidence the product or services as described were undamaged, without defects including photos before and after packaging, and info on shipping for tangible goods.<br/>For services, provide evidence that the service was as described in the transaction.',
        },
        [DISPUTE_REASONS.SUBSCRIPTION_CANCELED]: {
          explanation:
            'The customer claims that you continued to charge them after a subscription was canceled.',
          recommendations:
            'Contact the customer to try to resolve the claim. If the claim is not resolved, provide evidence that the subscription was not canceled on the claimed date or not canceled according to the terms of the subscription. ',
        },
        [DISPUTE_REASONS.COUNTERFEIT_MERCHANDISE]: {
          explanation:
            'The merchandise was identified as counterfeit by the owner of the intellectual property, a government agency, or a neutral third-party expert',
          recommendations:
            'Provide evidence that the goods are genuine. Include information that proves the authenticity of the goods.',
        },
        [DISPUTE_REASONS.FRAUD]: {
          explanation:
            'Cardholder claims they didn’t authorize the payment. Card possibly lost or stolen and used to make a fraudulent purchase, or cardholder does not recognize the charge as it appears on the billing statement from the card issuer.',
          recommendations:
            'Contact the customer to clarify and resolve any purchase details, and if the claim is wrong, advise the customer to contact the card issuer, and cancel the dispute. Where the transaction is wrongfully claimed as fraudulent, provide info that IDV was done according to the card issuer’s rules and regulations. For online purchases, also include the IP address of the customer during the transaction.',
        },
        [DISPUTE_REASONS.PROCESSING_ERRORS]: {
          explanation:
            'One or more of these dispute reasons:<br/>(1) cardholder paid twice for the same transaction<br/>(2), cardholder was billed an incorrect amount<br/>(3) ATM-related issues<br/>(4) unauthorized fee was charged<br/>(5) foreign-exchange-related issues<br/>(6)improper surcharge is claimed by the customer',
          recommendations:
            'Provide evidence that the transaction was processed correctly according to the card issuer’s terms and the amount was accurate. Where the customer claims an erroneous transaction, provide evidence that an error did not occur and all stages of the transaction were authorized by the customer. ',
        },
        [DISPUTE_REASONS.AUTHORIZATION]: {
          explanation:
            '(1) authorization was required but not obtained<br/>(2) primary account number (PAN) does not exist<br/> (3) authorization chargeback protection time period expired, including either a or b:<br/><0>    (3a) In Europe, account was permanently closed before the chargebackwas processed</0><0>    (3b) in any other region, the issuer deemed account not to bein good standing</0>(4) A card-not-present authorization was declined by the issuer, and subsequently approved.Special exceptions to this may be in the issuer’s authorization manual.',
          recommendations:
            'Provide evidence that the transaction was authorized in accordance with the card issuer’s rules including info that the authorization was received on the day of the transaction, and did not include a tip on a previously authorized amount or any hidden fees.<br/>For subsequent approval on a previously declined transaction, provide evidence that the transaction was done according to the issuer’s authorization manual.',
        },
      },
    },

    //User Role

    korta_acquiring_contracts: {
      MERCHANT_DROPDOWN: 'Merchant',
      ACQUIRING_CONTRACT_ID: 'Acquiring Contract',
      MERCHANT: 'Merchant',
      MERCHANT_CATEGORY: 'Merchant category',
      RETAINER_RULE: 'Retainer rule',
      RETAINER_DAYS: 'Retainer days',
      RETAINER_PERCENTAGE: 'Retainer percentage',
      SETTLEMENT_RULES: 'Settlement rules',
      PAYMENT_RULE: 'Payment rule',
      DYNAMIC_PERIOD: 'Dynamic period',
      PAYMENT_DAYS: 'Payment days',
      WEEKLY_RULE: 'WEEKLY-RULE',
      DELIVERY_DATE_RULE: 'Delivery date rule',
      BASE_RULE: 'Base rule',
      SERVICE_CHARGE: 'Service charge',
      TYPE_OF_SERVICE_CHARGE: 'Type of service charge',
      GENERAL_SERVICE_CHARGE: 'General service charge (%)',
      COMMERCIAL_CARD_FEE: 'Commercial card fee (%)',
      GLOBAL_WHOLE_SALE_FEE: 'Global Whole Sale fee (%)',
      REFUND_SERVICE_CHARGE: 'Refund service charge (%)',
      ORIGINAL_CREDIT_SERVICE_CHARGE: 'Original credit service charge (%)',
      TRANSACTION_FEES: 'Transaction fees',
      CURRENCY: 'Currency',
      TRANSACTION_FEE: 'Transaction fee',
      REFUND_TRANSACTION_FEE: 'Refund transaction fee',
      ORIGINAL_CREDIT_TRANSACTION_FEE: 'Original credit transaction fee',
      CHARGEBACK_FEE: 'Chargeback fee',
      AUTHORISATION_FEE: 'Authorisation fee',
      FRAUD_FEE: 'Fraud fee',

      paymentRule: {
        D: 'Daily',
        W: 'Weekly',
        M: 'Monthly',
      },

      weeklyRule: {
        1: 'Monday to Sunday',
        2: 'Tuesday to Monday',
      },

      deliveryDateRule: {
        B: 'Transaction date',
        D: 'Delivery date',
      },

      baseRule: {
        0: 'First business day',
        1: 'Last holiday',
      },

      interchangeRate: {
        0: 'Normal service charge',
        1: 'Interchange++',
      },
    },
    requestCardDetails: {
      header: 'Request Card Details',
      body: 'Create a hosted page that can be sent to your customer and they can access to provide their card details',
      country: 'Country',
      CTA: 'Create Hosted Page',
      successMessageHeader: 'Card Tokenization Page Created',
      successMessageBody:
        'A hosted page for submitting credit card details was successfully created. Provide the link below to the customer who’s card details you want to tokenize and save for future use.',
      countryError: 'Country not supported',
      gotIt: 'Ok, Got It',
    },
    addCardToCustomer: {
      header: 'Add Card',
      body: 'Add a Card to the customer that can be used for making payments',
      country: 'Country',
      paymentMethod: 'Payment Method',
      currency: 'Currency',
      requiredFields: 'Required Fields',
      CTA: 'Submit',
      successMessageHeader: 'Card Added',
      successMessageBody: 'The Card was successfully added to the customer {{- customer_name}}',
      failedMessageHeader: 'Action unsuccessful',
      failedMessageBody:
        'The Card could not be added.  Check the payment method details provided and try again.  If the problem persists, please <0>contact support</0>',
      failedMessagePaymentMethodBody:
        'he Card could not be added because a required field was missing, or an extra, non allowed field was included.',
    },
    korta_merchant_agreements: {
      general_search: 'general_search',
      MERCHANT_DROPDOWN: 'Merchant',
      MERCHANT: 'Merchant',
      MERCHANT_ID: 'Merchant Id',
      NAME: 'Name',
      DAILY_NAME: 'Daily Name',
      SSN: 'SSN',
      ADDRESS: 'Address',
      CONTACT: 'Contact',
      EMAIL: 'Email',
      PHONE: 'Phone',
    },
    korta_settled_payments: {
      header: 'Settled payments',
      details: 'Details',
      chargeCurrency: 'Currency',
      netSettlement: 'Net settlement',
      deductions: 'Deductions',
      revenue: 'Revenue',
      settlementNumber: 'Settlement number',
      settlementDate: 'Settlement date',
      acquiringContractDescription: 'Description',
      agreementNumber: 'Agreement Number',
      from: 'From*',
      to: 'To*',
      merchantId: 'Merchant ID*',
      acquiringContractId: 'Acquiring contracts',
      exportHeader: 'Export',
    },
    korta_unsettled_payments: {
      header: 'Unsettled payments',
      details: 'Details',
      chargeCurrency: 'Currency',
      netSettlement: 'Net settlement',
      settlementNumber: 'Settlement number',
      settlementDate: 'Settlement date',
      acquiringContractDescription: 'Description',
      agreementNumber: 'Agreement Number',
      from: 'From*',
      to: 'To*',
      merchantId: 'Merchant ID*',
      acquiringContractId: 'Acquiring contracts',
    },
    korta_transactions: {
      header: 'Cleared Transactions',
      details: 'Details',
      transactionId: 'Transaction ID',
      merchantId: 'Merchant ID',
      terminalId: 'Terminal ID',
      transactionReference: 'Reference',
      transactionAmount: 'Amount',
      currency: 'Currency',
      transactionType: 'Type',
      authorisationCode: 'Authorisation Code',
      terminal: 'Terminal',
      transactionDate: 'Date',
      transactionTime: 'Time',
      maskedPan: 'Card Number',
      actionCode: 'Action Code',
      cardType: 'Card Type',
      acquiringContractIdField: 'Contract Id',
      inBatch: 'Incoming Batch',
      inBatchDate: 'Batch date from POS',
      inBatchReceivedDate: 'Batch receive date',
      inBatchReceivedTime: 'Batch receive time',
      outBatch: 'Outgoing batch',
      general_search: 'General Search',
      arn: 'ARN',
      arn_placeholder: 'Search by ARN number (23 characters)',
      merchantIdDropDown: 'Merchant*',
      acquiringContractId: 'Acquiring contracts',
      terminalDropDown: 'Terminal',
      sale: 'Sale',
      refund: 'Refund',
      from: 'From*',
      to: 'To*',
      referenceField: 'Reference*',
      reference: 'Reference',
      arnField: 'ARN*',
      cardNumber: 'Card Number',
      fromTime: 'From Time*',
      toTime: 'To Time*',
      merchantIdDropDownOptional: 'Merchant',
      lengthAllowedValidator: 'Card number must have 4,10 or 12+ digits',
    },

    korta_invoice: {
      SETTLED_PAYMENTS: 'Settled',
      UNSETTLED_PAYMENTS: 'Unsettled',
      UNSETTLED_MESSAGE:
        '* The settlement amount is an estimate. The amount payed out will change during final settlement.',
      SUMMARY: 'Summary',
      PAYMENT_TYPE: 'Payment Type: {{paymentType}}',
      TOTAL_REVENUE: 'Total Revenue',
      TOTAL_DEDUCTIONS: 'Total Deductions',
      NET_SETTLEMENT: 'Net Settlement',
      CATEGORY: 'Category',
      COUNT: 'Count',
      AMOUNT: 'Amount',
      SUB_TOTAL: 'Sub total:',
      merchantName: 'Company',
      merchantDailyName: 'Daily Name',
      merchantAddress: 'Address',
      merchantZip: 'Zip',
      merchantCity: 'City',
      merchantCountry: 'Country',
      merchantId: 'Merchant Id',
      agreementNumber: 'Contract Number',
      settlementNumber: 'Settlement Number',
      chargeCurrency: 'Currency',
      settlementDate: 'Date',
      period: 'Period',
      paymentDate: 'Payment Date',
      bankAccount: 'Bank Account',
    },

    korta_chargebacks: {
      header: 'Chargebacks',
      id: 'ID',
      businessEntity: 'Business entity',
      centralProcessingDate: 'Central processing date',
      dateCreated: 'Date created',
      statusOfChargeback: 'Chargeback status',
      acquiringContractId: 'Acquiring contract ID',
      transactionDate: 'Transaction date',
      transactionId: 'Transaction Id',
      transactionAmount: 'Transaction amount',
      transactionCurrency: 'Transaction currency',
      acquirerReferenceData: 'Acquirer reference data',
      chargebackAmount: 'Chargeback amount',
      chargebackCurrency: 'Chargeback currency',
      caseNumber: 'Case number',
      rolCaseNumber: 'Rol case number',
      messageFromMember: 'Message',
      reversalIndicator: 'Reversal indicator',
      sequenceNumber: 'Sequence number',
      chargebackReasonCode: 'Reason code',
      merchantId: 'Merchant id',
      merchantName: 'Merchant name',
      merchantDailyName: 'Merchant daily name',
      transactionReference: 'Transaction reference',
      cardNumber: 'Card number',
      general_search: 'General Search',
      merchantIdDropDown: 'Merchant ID*',
      from: 'From*',
      to: 'To*',
      status: 'Chargeback Status',
      reference: 'Reference',
      referenceField: 'Reference*',
      arn: 'ARN',
      arnField: 'ARN*',
      arn_placeholder: 'Search by ARN number (23 characters)',

      statuses: {
        1: 'Unprocessed',
        10: 'Closed - uncontested',
        100: 'Document only re-presentment',
        101: 'On Hold',
        102: 'Reversal of representment',
        2: 'In progress',
        3: 'Closed - won',
        4: 'Closed - lost',
        5: 'Arbitration',
        6: 'Documents sent',
        7: 'Pre-arb',
        8: 'Closed - approved',
        9: 'Duplicate',
      },
    },

    korta_incoming_batch: {
      header: 'Incoming Batches',
      details_header: 'Inbatch Details',
      tabs: {
        BATCH_DETAILS: 'Batch Details',
        CONFIRMED_TRANSACTIONS: 'Confirmed Transactions',
        UNCONFIRMED_TRANSACTIONS: 'Unconfirmed Transactions',
        CHANGE_HISTORY: 'Change History',
      },
      BATCH_DETAILS: 'Batch Details',
      MERCHANT_ID: 'Merchant Id',
      TERMINAL_NUMBER: 'Terminal Number',
      BATCH_REFERENCE: 'Batch Reference',
      TIME: 'Time',
      DATE_FROM_TERMINAL: 'Date From Terminal',
      DATE_RECEIVED: 'Date Received',
      TIME_RECEIVED: 'Time Received',
      AMOUNTS: 'Amounts',
      UNCONFIRMED_TRANSACTIONS: 'Unconfirmed Transactions',
      DEBIT_RECORDS_NUMBER: 'Nr. of debits',
      CREDIT_RECORDS_NUMBER: 'Nr. of credits',
      DEBIT_AMOUNT: 'Debit Amount',
      CREDIT_AMOUNT: 'Credit Amount',
      STATUS: 'Status',
      STATUS_TIME: 'Status Time',
      statuses: {
        P: 'OK',
        E: 'Error',
        X: 'Cancelled',
        H: 'Hold',
      },

      column: {
        id: 'Details',
        transactionId: 'Transaction Id',
        merchantId: 'Merchant Id',
        cardNumber: 'Card Number',
        date: 'Date',
        time: 'Time',
        amount: 'Amount',
        currency: 'Currency',
        type: 'Type',
        authCode: 'Auth Code',
        reference: 'Reference',
        outgoingBatch: 'Outgoing Batch',
        incomingBatch: 'Incoming Batch',
        terminal: 'Terminal',
        arn: 'Arn',
        cardType: 'Card Type',
        contractId: 'Contract Id',
        terminalId: 'Terminal Id',
      },

      table_columns: {
        details: 'Details',
        batchReference: 'Batch Reference',
        dateFromTerminal: 'Date From Terminal',
        dateReceived: 'Date Received',
        timeReceived: 'Time Received',
        debitRecordsNumber: 'Nr. of debits',
        creditRecordsNumber: 'Nr. of credits',
        status: 'Status',
        id: 'Batch Stamp',
        merchantId: 'Merchant ID',
        terminalNumber: 'Terminal Number',
        debitAmount: 'Debit Amount',
        creditAmount: 'Credit Amount',
        statusTime: 'Status Time',
        transactionsNumber: 'Nr. of transactions',
        outgoingBatches: 'Outgoing batches',
      },

      filters: {
        reference: 'Reference',
        general_search: 'General Search',
        merchantIdDropDown: 'Merchant',
        batchReference: 'Batch Reference',
        status: 'Status',
        from: 'From*',
        fromTime: 'From Time*',
        to: 'To*',
        toTime: 'To Time*',
      },
    },

    korta_settlement_accounts: {
      general_search: 'General Search',
      merchantIdDropDown: 'Merchant',
      acquiringContractId: 'Acquiring Contract',
      header: 'Settlement Accounts',
      transactionCurrency: 'Transaction Currency',
      settlementCurrency: 'Settlement Currency',
      accountNumber: 'Account Number',
      accountIdNumber: 'Account Id Number',
      swift: 'Swift',
    },
    korta_frauds: {
      id: 'ID',
      businessEntityName: 'Card scheme',
      acquiringContractId: 'Acquiring contract id',
      transactionId: 'Transaction id',
      fraudPostedDate: 'Posted date',
      transactionDate: 'Transaction date',
      transactionAmount: 'Amount',
      transactionCurrencyCode: 'Currency',
      dateCreated: 'Created',
      merchantName: 'Name',
      merchantDailyName: 'Daily name',
      acquirerReferenceNumber: 'Acquirer reference number',
      authorisationCode: 'Authorisation code',
      cardNumber: 'Card number',
      fraudType: 'Fraud type',
      chargebackPresent: 'Chargeback present',
      transactionReference: 'Transaction reference',
      merchantIdDropDown: 'Merchant*',
      from: 'From*',
      to: 'To*',
    },
    korta_icelandic_payments: {
      header: 'Icelandic payments',
      merchantIdDropdown: 'Merchant',
      customerIdDropdown: 'Customer',
      onlyUncomplete: 'Show only uncompleted',
      statusId: 'Status',
      dateType: 'Date type*',
      from: 'From*',
      to: 'To*',
      dateTypeOptionsEstimate: 'Estimated payment date',
      dateTypeOptionsOriginal: 'Original payment date',
      // Columns
      acquiringContractId: 'Acquiring contract id',
      customerId: 'Customer id',
      estimatedPaymentDate: 'Estimated payment date',
      merchantDailyName: 'Merchant daily name',
      merchantId: 'Merchant id',
      merchantName: 'Merchant name',
      originalPaymentDate: 'Original payment date',
      paymentAmount: 'Payment amount',
      paymentComment: 'Comment',
      paymentCreatedDate: 'Date created',
      paymentCurrency: 'Payment currency',
      paymentRequestId: 'Payment request id',
      paymentStatus: 'Payment status',
      paymentStatusId: 'Payment status id',
      receiverAccountNumber: 'Receiver account number',
      receiverNationalId: 'Receiver national id',
      settlementReportId: 'Settlement report id',
      transferAccountNumber: 'Transfer account number',
    },

    korta_outgoing_batch: {
      header: 'Outgoing Batches',
      view_transaction: 'View Transaction',
      incoming_batch: 'View Incoming Batch',
      batch_types: {
        visa: 'Visa',
        mastercard: 'Mastercard',
        korta: 'Korta',
        fgm: 'FGM',
        borgun: 'Borgun',
      },

      statuses: {
        S: 'Sent',
        C: 'OK',
        E: 'Error',
        X: 'Cancelled',
      },

      filters: {
        general_search: 'General Search',
        merchantIdDropDown: 'Merchant',
        status: 'Status',
        batchType: 'Batch Type',
        from: 'From*',
        fromTime: 'From Time*',
        to: 'To*',
        toTime: 'To Time*',
        reference: 'Reference',
        batchReference: 'Batch Reference',
      },

      column: {
        incomingBatchStamp: 'Batch Stamp',
        batchReference: 'Batch Reference',
        dateOfCreation: 'Date Of Creation',
        batchType: 'Batch Type',
        approvedNumber: 'Approved nr.',
        rejectedNumber: 'Rejected nr.',
        status: 'Status',
        merchantId: 'Merchant Id',
        timeOfCreation: 'Time Of Creation',
        receivingAcqMerchantNbr: 'Receiving Acq. nr.',
        debitAmount: 'Debit Amount',
        debitRecordsNumber: 'Nr. of debits',
        creditRecordsNumber: 'Nr. of credits',
        creditAmount: 'Credit Amount',
        approvedAmount: 'Approved Amount',
        rejectedAmount: 'Rejected Amount',
        submissionStamp: 'Submission Stamp',
        currency: 'Currency',
        statusTime: 'Status Time',
        transactionsNumber: 'Transactions',
        incomingBatch: 'Incoming Batch',
      },
    },

    korta_accounting_files: {
      header: 'Accounting files',
      merchantId: 'Merchant ID*',
      from: 'From*',
      fetchSinceLastTime: 'Fetch changes since last time',
      fetchByTime: 'Fetch by time period',
      to: 'To*',
      download: 'Download',
      emptyResult: 'No data returned',
      notSupportedKSG:
        'Accounting system of the selected merchant is currently only supported in KSG.',
    },

    korta_terms_agreement: {
      success_header: 'Success!',
      success_msg:
        'Thank you for approving our Terms and Conditions. Users to your account can now receive an invitation to connect to the Rapyd client portal.',
      expired: 'Your link has been expired.',
    },

    // Korta
    KORTA_TABLE_ERROR: 'An error occurred! Please try again Later',

    KORTA_FOUND_RECORDS: 'Found {{value}} records',

    KORTA_TOTAL_PAYMENT_AMOUNT: 'Total Payment Amount: {{value}}',

    // Korta Dashboard
    KORTA_RAPYD_ACCOUNT: 'Rapyd Korta Account',
    KORTA_ACCOUNT: 'Korta Account',
    KORTA_DASHBOARD_SALES_TODAY: 'Sales',
    KORTA_DASHBOARD_REJECTIONS_TODAY: 'Rejections',
    KORTA_DASHBOARD_TOTAL_SALES_TODAY: 'Total Sales Today',

    // Korta Authorization
    korta_common: {
      merchant_id: 'Merchant Id',
      default_currency: 'ANY',
      reference: 'Reference',
      reference_placeholder: 'Search by reference (30 characters)',
      less_options: 'Less Options',
      show_more: 'Show More',
    },
    KORTA_AUTHORIZATION_AUTHORISATION_DETAILS: 'Authorisation details',
    KORTA_AUTHORIZATION_CONTRACT_INFORMATION: 'Contract information',
    KORTA_AUTHORIZATION_MERCHANT_ID: 'Merchant Id',
    KORTA_AUTHORIZATION_ACQUIRING_CONTRACT_ID: 'Acquiring Contract Id',
    KORTA_AUTHORIZATION_AUTHORISATION_SUMMARY: 'Authorisation summary',
    KORTA_AUTHORIZATION_AUTHORISATION_CODE: 'Authorisation code',
    KORTA_AUTHORIZATION_FINAL_RESPONSE: 'Final response',
    KORTA_AUTHORIZATION_STATUS: 'Status',
    KORTA_AUTHORIZATION_REVERSAL_STATUS: 'Reversal status',
    KORTA_AUTHORIZATION_REVERSAL_AMOUNT: 'Reversal amount',
    KORTA_AUTHORIZATION_REVERSAL_TIME: 'Reversal time',
    KORTA_AUTHORIZATION_TRANSACTION_SUMMARY: 'Transaction summary',
    KORTA_AUTHORIZATION_TYPE: 'Type',
    KORTA_AUTHORIZATION_TERMINAL_ID: 'Terminal id',
    KORTA_AUTHORIZATION_REQUEST_TIME: 'Request time',
    KORTA_AUTHORIZATION_TERMINAL_TIME: 'Terminal time',
    KORTA_AUTHORIZATION_REFERENCE: 'Reference',
    KORTA_AUTHORIZATION_SETTLEMENT_REFERENCE: 'Settlement reference',
    KORTA_AUTHORIZATION_AMOUNT: 'Amount',
    KORTA_AUTHORIZATION_CVC: 'CVC',
    KORTA_AUTHORIZATION_CARDHOLDER_DATA: 'Cardholder data',
    KORTA_AUTHORIZATION_CARD_TYPE: 'Card type',
    KORTA_AUTHORIZATION_CARD_EXPIRATION_DATE: 'Card expiration date',
    KORTA_AUTHORIZATION_IP_INFORMATION: 'IP information',
    KORTA_AUTHORIZATION_REMOTE_IP: 'Remote IP',
    KORTA_AUTHORIZATION_CLIENT_IP: 'Client IP',
    KORTA_AUTHORIZATION_POS_DATA_CODE: 'POS data code',
    KORTA_AUTHORIZATION_DATA_CODE: 'Data code',
    KORTA_AUTHORIZATION_TRANSACTION_ENTRY_MODE: 'Transaction entry mode',
    KORTA_AUTHORIZATION_TERMINAL_CAPABILITY: 'Terminal capability',
    AUTHORIZATION_POSITION: 'Position',
    AUTHORIZATION_DESCRIPTION: 'Description',
    AUTHORIZATION_VALUE: 'Value',
    AUTHORIZATION_VALUE_DESCRIPTION: 'Value Description',

    // Role Category

    TABLE_HEADER_ROLE_CATEGORY_CATEGORY: 'Category',
    TABLE_HEADER_ROLE_CATEGORY_VIEW: 'View',
    TABLE_HEADER_ROLE_CATEGORY_EDIT: 'Edit',
    TABLE_HEADER_ROLE_CATEGORY_CREATE: 'Create',

    // Neat Landing Page

    LANDING_PAGE_TITLE: 'Smart Company Registration',
    LANDING_PAGE_SUBTITLE: `Hassle-free incorporation in Hong Kong for your company.<br> 
    Your business will be ready to go in a few days!`,
    LANDING_PAGE_BUTTON_DESCRIPTION: `Let's get started!`,
    LANDING_PAGE_WHY_INCORPORATE_WITH_RAPYD: 'Why incorporate with Rapyd?',
    LANDING_PAGE_REMOTE_SIGN_UP: 'Remote Sign Up',
    LANDING_PAGE_REMOTE_SIGN_UP_DESCRIPTION: `No travel needed, just 15 minutes for your to complete the online form. We'll do the rest!`,
    LANDING_PAGE_SIMPLE_AND_LOW_TAX_RATE: 'Simple & Low Tax Rate',
    LANDING_PAGE_SIMPLE_AND_LOW_TAX_RATE_DESCRIPTION:
      'Hong Kong is regarded as the freest economy in the world, with a low corporate tax rate.',
    LANDING_PAGE_FAST_SETUP: 'Fast Setup',
    LANDING_PAGE_FAST_SETUP_DESCRIPTION:
      'For ${{ feeAmount }} USD, you get a HK company and Rapyd account in one seamless process.',
    LANDING_PAGE_WHAT_YOU_COULD_DO_WITH_RAPYD: 'What you could do with a Rapyd account',
    LANDING_PAGE_LOCAL_PAYMENT_NETWORK: `World's largest local payment network`,
    LANDING_PAGE_LOCAL_PAYMENT_NETWORK_DESCRIPTION:
      'Accept and send to 900+ payment types in 100+ countries and growing. Perferct for any business with local or cross-border customers.',
    LANDING_PAGE_NO_CODE_SOLUTIONS: 'No Code Solutions',
    LANDING_PAGE_NO_CODE_SOLUTIONS_DESCRIPTION: `Pre-built payments solutions for any business.
      Create your Rapyd account and start sending payment requestes to customers today.`,
    LANDING_PAGE_SUPERCHARGED_API: 'Supercharged APIs',
    LANDING_PAGE_SUPERCHARGED_API_DESCRIPTION:
      'Build globally scalable FinTech applications from a single platform. The fastest and easiest way to accept payments worldwide.',

    // Korta Transaction

    KORTA_TRANSACTION_DETAILS: 'Transaction Details',
    TRANSACTION_DETAILS_TRANSACTIONS_TAB: 'Transactions',
    TRANSACTION_DETAILS_CARD_INFORMATION_TAB: 'Card Information',
    KORTA_TRANSACTION_CONTRACT_INFORMATION: 'Contract Information',
    KORTA_TRANSACTION_MERCHANT_NAME: 'Merchant Name',
    KORTA_TRANSACTION_MERCHANT_DAILY_NAME: 'Merchant Daily Name',
    KORTA_TRANSACTION_ACQUIRING_CONTRACT_ID: 'Acquiring Contract Id',
    KORTA_TRANSACTION_SUMMARY: 'Transaction Summary',
    KORTA_TRANSACTION_TRANSACTION_DATE: 'Transaction Date',
    KORTA_TRANSACTION_TRANSACTION_TIME: 'Transaction Time',
    KORTA_TRANSACTION_CARD_TYPE: 'Card Type',
    KORTA_TRANSACTION_AMOUNT: 'Amount',
    KORTA_TRANSACTION_CURRENCY: 'Currency',
    KORTA_TRANSACTION_TRANSACTION_TYPE: 'Transaction Type',
    KORTA_TRANSACTION_TYPE_EXTENSION: 'Type Extension',
    KORTA_TRANSACTION_TRANSACTION_IDENTITY: 'Transaction Identity',
    KORTA_TRANSACTION_ARN: 'ARN',
    KORTA_TRANSACTION_TRANSACTION_REFERENCE: 'Transaction Reference',
    KORTA_TRANSACTION_TRANSACTION_ID: 'Transaction Id',
    KORTA_TRANSACTION_AUTHORISATION_CODE: 'Authorisation Code',
    KORTA_TRANSACTION_TRANSACTION_ORIGIN: 'Transaction Origin',
    KORTA_TRANSACTION_OUTGOING_BATCH_STAMP: 'Outgoing Batch Stamp',
    KORTA_TRANSACTION_INCOMING_BATCH_STAMP: 'Incoming Batch Stamp',
    KORTA_TRANSACTION_TERMINAL_ID: 'Terminal Id',
    KORTA_TRANSACTION_STORE: 'Store',
    KORTA_TRANSACTION_TERMINAL: 'Terminal',
    KORTA_TRANSACTION_3DS_SECURE: '3DS Secure',
    KORTA_TRANSACTION_AUTHENTICATION_CODE: 'Authentication Code',
    KORTA_TRANSACTION_AUTHENTICATION_DESCRIPTION: 'Authentication Description',
    KORTA_TRANSACTION_AUTHENTICATION_VALUE: 'Authentication Value',
    KORTA_TRANSACTION_CARDHOLDER_DATA: 'Cardholder Data',
    KORTA_TRANSACTION_CARD_NUMBER: 'Card Number',
    KORTA_TRANSACTION_CARD_EXPIRATION_DATE: 'Card Expiration Date',
    KORTA_TRANSACTION_TRANSACTION_PRODUCT_DATA: 'Transaction Product Data',
    KORTA_TRANSACTION_SCHEME: 'Scheme',
    KORTA_TRANSACTION_PRODUCT_PLATFORM_TYPE: 'Product Platform Type',
    KORTA_TRANSACTION_PRODUCT_PLATFORM: 'Product Platform',
    KORTA_TRANSACTION_FUNDING_SOURCE_TYPE: 'Funding Source Type',
    KORTA_TRANSACTION_FUNDING_SOURCE: 'Funding Source',
    KORTA_TRANSACTION_REGION: 'Transaction Region',
    KORTA_TRANSACTION_MERCHANT_COUNTRY: 'Merchant Country',
    KORTA_TRANSACTION_ISSUER_COUNTRY: 'Issuer Country',
    KORTA_TRANSACTION_IS_INTRA_EEA: 'Is Intra EEA',
    KORTA_TRANSACTION_CROSS_REGION_TYPE: 'Cross Region Type',
    KORTA_TRANSACTION_CROSS_REGION_DESCRIPTION: 'Cross Region Description',
    KORTA_TRANSACTION_GLOBAL_WHOLE_SALE: 'Global Whole Sale',
    KORTA_TRANSACTION_IS_GLOBAL_WHOLE_SALE: 'Is Global Whole Sale',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_05: 'Transaction fully 3DS authenticated',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_06:
      'Authentication attempted by merchant (Stand in processing by VISA)',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_07: 'Non-authenticated e-commerce transaction',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_210: 'Non-authenticated e-commerce transaction',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_211: 'Authentication attempted by merchant but failed',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_212: 'Transaction fully 3DS authenticated',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_216: 'Not authenticated due to acquirer SCA exemption',
    KORTA_TRANSACTION_STATUS_DESCRIPTION_217:
      'Recurring transaction successfully 3DS authenticated',
    accountSetup: {
      title: 'Accounting setup',
      groupByBatchNumbers: 'Group daybook records by batch numbers',
      hideProjectedSettlementsFromOtherAcquirers: 'Hide projected settlements from other acquirers',
      hideCardType: 'Remove card type from batch numbers',
      accountingSystem: 'Accounting system',
      accountingMethod: 'Accounting method',
      dtoSectionDescription: 'Description',
      dtoSectionRecordText: 'Daybook record text',
      dtoSectionKey: 'Account key',
      dtoSectionSubKey: 'Subaccount key',
      oldestUnfetchedDate: 'Oldest date for un-fetched files',
      bookingTypesNames: {
        100: 'Sale',
        101: 'Sale MasterCard',
        102: 'Sale Maestro',
        103: 'Sale Visa',
        104: 'Sale Visa Electron',
        105: 'Sale JCB',
        106: 'Sale Diners',
        107: 'Sale Amex',
        108: 'Sale Discover',
        109: 'Sale Dankort',
        150: 'Sale debet cards',
        151: 'Sale credit cards',
        200: 'Fee',
        201: 'Fee Master Card',
        202: 'Fee Maestro',
        203: 'Fee Visa',
        204: 'Fee Visa Electron',
        205: 'Fee JCB',
        206: 'Fee Diners',
        207: 'Fee Amex',
        208: 'Fee Discover',
        209: 'Fee Dankort',
        250: 'Fee debet cards',
        251: 'Fee credit cards',
        300: 'Deposited',
        301: 'Debet card deposit',
        310: 'Deposited by Borgun',
        320: 'Creditcard deposit',
        400: 'Cents adjustment',
        401: 'Correction undefined',
        402: 'Correction chargeback',
        601: 'Dimension 1',
        602: 'Dimension 2',
        603: 'Dimension 3',
      },
    },

    simulators: {
      threeDsPayment: {
        description: 'Enter the code “123456" to simulate a 3DS confirmation of the card payment',
        inputCodeError: 'Wrong Code!',
      },
      completeBankPayment: {
        title: 'Login to simulate completing the payment',
        description: 'Select the action and test our properties',
      },
      errorModal: {
        header: 'Something Went Wrong',
        body: 'Make sure your payment token is valid and try again',
      },
    },
    rapydApiErrorMessage: {
      message: 'A description of all error codes can be viewed <0>HERE</0>',
    },
    createRefundModal: {
      fields: {
        calculationTypes: {
          full: 'Full Refund',
          proportional: 'Proportional Refund',
          custom: 'Custom Refund',
        },
        amountToBeRefunded: 'Amount to be refunded:',
        amountToBeSent: 'Amount to be sent',
        defineRefundIn: 'Define refund in',
      },
      errors: {
        errorModalHeader: 'Error Completing Refund',
        invalidRefundAmount: 'Refund amount greater than payment balance',
        fullyRefundedHeader: 'Payment Already Refunded',
        fullyRefundedBody: 'This payment has already been fully refunded',
      },
    },

    barChartLegend: {
      completedSettlements: 'Settlements Arrived',
      upcomingSettlements: 'Upcoming Settlements',
    },

    couponDuration: {
      once: 'One time',
      forever: 'Forever',
      repeating: 'Repeating',
      couponDurationInMonths: 'Repeating for {{value}} months',
    },

    createCouponModal: {
      customer_header: 'Add Coupon to Customer',
      header: 'Add Coupon',
      subtitle:
        'Add a coupon to a customer that can be used for recurring payments (subscriptions)',
      duration: 'Duration',
      duration_in_months: 'Number of Months',
      max_redemptions: 'Maximum Redemptions',
      max_redemptions_description:
        'The maximum number of times this coupon can be redeemed before it expires, in total, for all customers, subscriptions, and orders.',
      percentage: 'Percentage',
      value: 'Value',
      percent_off: 'Percent Off',
      amount_off: 'Amount Off',
      currency: 'Currency',
      redeem_by: 'Redeem By',
      discount_type: 'Discount Type',
      number_of_uses: 'Number of uses',
      number_of_uses_description:
        'The number of times a customer or subscription can redeem a coupon.',
      number_of_months: 'Define number of months of use',
      number_of_months_description:
        'The number of months that the coupon remains valid after its creation.',
    },
    deactivatePaymentLinkModal: {
      header: 'Are you sure you want to deactivate this payment link?',
      subtitle:
        'Once deactivated, you will not be able to reactivate this payment link. \n You will be able to create a new payment link instead',
    },
    contactUs: {
      title: 'Contact Us',
      subject: 'Subject',
      severity: 'Severity',
      body: 'Body',
      description: 'Description',
      file: 'Optional',
      error_responses: 'Error Responses: \n {{error_responses}}',
      audit_subject: 'Error Completing Action - {{action}}',
      audit_action: 'Action: {{action}}',
      audit_description: 'Description: {{description}}',
      error_code_subject: 'Error Completing Action - {{errorCode}}',
      contact_support: 'Contact Support',
      information_regarding: 'Information regarding {{id}}',
      drag_and_drop: 'Drop your files here',
      link_text: 'Back to home page',
      successMessage: "The ticket was successfully sent. \n We'll get in touch with you.",
      errorMessage: 'The ticket could not be sent.\n Please submit it again.',
      wrongFileType:
        'Invalid file type. please upload a file of type .tif, .jpg, .jpeg, .png, .pdf.',
      typeOfIssue: 'What type of issue do you have?',
      issueFirstIdentified: 'When was the issue first identified?',
      transactionsUserAffected: 'How many transactions or users were affected?',
      totalTransactionValue: 'Total transaction value',
      customerRequestTypes: {
        GeneralIssueOrSandboxQuery: 'General / Sandbox query',
        TechnicalIssue: 'Technical Issue',
      },
      issueFirstIdentifiedTypes: {
        Past24Hours: 'Past 24 Hours',
        PastWeek: 'Past Week',
        MoreThanAWeek: 'More Than A Week',
        NotRelevant: 'Not Relevant',
      },
      transactionsUsersAffectedTypes: {
        SingleTransactionUser: 'Single transaction / user',
        PartialTransactionsUsersAreAffected: 'Partial transactions / users are affected',
        AllTransactionsUsersAreAffected: 'All transactions / users are affected',
        NotRelevant: 'Not Relevant',
      },
      totalTransactionValueTypes: {
        LessThan1kUSD: '<1k USD',
        '1kTill100kUSD': '1k-100k USD',
        GreaterThan100kUSD: '>100k USD',
        NotRelevant: 'Not Relevant',
      },
    },

    featureRequest: {
      FEATURE_REQUEST: 'Feature Request',
      DESCRIPTION: 'How Will It Help You?',
      CONSENT: 'I’m ok with the product team contacting me regarding this or other features',
      SUCCESS_MESSAGE:
        'Your submission was received and is under review by our product team. We value our customers’ ideas and input and will take your submission under careful consideration. Please note: If you are looking to get help or want to report a bug, visit our <0>support center</0>.',
      SUCCESS_MESSAGE_HEADER: 'Thank you for submitting a new feature!',
      SUPPORT_CENTER: 'Support Center',
    },

    subscriptionRequestAccess: {
      ABOUT_BUISSNESS_FIELD_TITLE:
        'Tell us about your business and how to do you plan to use subscriptions',
      START_BUILDING_FIELD_TITLE: 'When do you plan to start building ?',
      SUBSCRIPTION_NUMBER_FIELD_TITLE: 'How many subscriptions do you plan to create ?',
      SUCCESS_MODAL_HEADER: 'Request Sent',
      SUCCESS_MODAL_MESSAGE: `Your request was received and is under review. \n we'll reach out to you if there's a good fit. `,
      CONSENT: 'I’m ok with the product team contacting me regarding this or other features',
    },

    createMassPayout: {
      CREATE_MASS_PAYOUT_SUBTITLE:
        'In order to create multiple payouts you need to upload a CSV file with the required fields for the selected payout method type',
      UPLOAD_CSV_FILE:
        'upload CSV file with the required fields for the selected payout method type',
      DOWNLOAD_CSV_FILE:
        'download a sample CSV based on the relevant country, currency, payout type and entity type combination',
      GET_STARTED: 'Get Started',
      EMPTY_STATE: 'Add the fields you want to your sample file template.',
      DOWNLOAD_DESCRIPTION: 'Create and download a sample file template for your own mass payout.',
    },

    userRoles: {
      owner: 'Owner',
      admin: 'Admin',
      editor: 'Editor',
      basic: 'Basic',
      rapyd_support: 'Rapyd Support',
    },

    CREATE_NEW_USER_ROLE: 'Create New Role',
    EDIT_ROLE: 'Edit Role',
    SAVE_ROLE: 'Save Role',
    SAVE_CHANGES: 'Save Changes',
    ROLE_NAME: 'Role Name',
    CREATE_ROLE_HEADER_MESSAGE: 'New Role Created',
    CREATE_ROLE_BODY_MESSAGE: 'A new user role was successfully created',
    DELETE_ROLE_HEADER_MESSAGE: 'Delete Customized Role',
    DELETE_ROLE_BODY_MESSAGE:
      'Are you sure you want to delete this role? \n All user associated to this role will be blocked',
    DELETED_ROLE_HEADER: 'User Role Deleted',
    DELETED_ROLE_BODY: 'The User Role {{role_alias}} was successfully deleted',
    CREATE_USER_ROLE: 'Create User Role',
    CREATE_USER_ROLE_FAILURE_HEADER: 'Role could not be created',
    CREATE_USER_ROLE_FAILURE_BODY: 'Role name already exists. Try a new one.',
    USER_ROLE_DEPENDENCIES_NOTE: 'Note: Dependencies exist between some permissions',

    setOrganizationOnLogin: {
      organization_sign_in: 'Organization Sign In',
      select_organization: 'Select Organization',
    },

    mobileNotSupportedMessages: {
      requires_kyb: {
        title: 'Continue on desktop to activate your account',
        message:
          'Mobile support is coming soon, in the meantime please continue on desktop to continue your account activation.',
      },
      kyb_completed: {
        title: 'Mobile support is coming soon!',
        message: 'For now, please use the our desktop version for the best experience!',
      },
    },

    pageTitles: {
      default: 'Rapyd Client Portal',
      sign_in: 'Sign In',
      sign_up: 'Sign Up',
      forgot_password: 'Forgot Password',
      home: 'Home',
      activate_account: 'Activate Account',
      my_account: 'My Account',
      developers: 'Developers',
      collect: 'Collect',
      protect: 'Protect',
      disburse: 'Disburse',
      plugins: 'Plugins',
      reports: 'Reports',
      card_issuing: 'Card Issuing',
      wallets: 'Wallets',
      settings: 'Settings',
      qr_code: 'QR Code',
    },

    virtualTerminalMobile: {
      STEP_COUNT: 'Step {{step}} of {{totalSteps}}',
      STEPS_DESC: 'Accept payment with a payment card – without the physical card',
      ADDITIONAL_DETAILS: 'Additional Details',
      CUSTOMER_DETAILS: 'Select a Customer',
      CUSTOMER_DETAILS_DESC: 'Please select customer from the existing list or create a new one',
      HCP_ERROR_TITLE: 'Check Card Details',
      CREATE_CUSTOMER_ERROR_TITLE: 'Failed',
      CREATE_CUSTOMER_ERROR_DESC: 'Failed to create a new customer, check details',
      PAYMENT_SUCCESS_MESSAGE: 'Your payment of {{amountWithCurrency}} was created successfully',
    },

    brandedSignUp: {
      emailVerified: 'Your email has been verified.',
      returnToDesktop: `Return to the desktop to complete Rapyd's registration`,
    },
  },

  errors: {
    [ApiErrorCodes.ERROR_AMOUNT_EXCEEDS_DESTINATION_EWALLET_LIMIT]:
      'Amount exceeds the limit of the destination wallet',
    [ApiErrorCodes.ERROR_EWALLET_TRANSFER_SOURCE_EWALLET_DISABLED]:
      'The originating wallet is disabled',
    [ApiErrorCodes.NOT_ENOUGH_FUNDS]:
      'There are not enough funds in the requested currency in the originating wallet',
    TRANSFER_FUNDS_DEFAULT_ERROR: 'Error Completing Transfer, please try again later',
    [ApiErrorCodes.MERCHANT_PORTAL_USER_EXISTS]: 'A user with this email already exists',
    [ApiErrorCodes.MERCHANTS_PORTAL_ERROR_SIGN_UP]: 'Error Signing up',
    [ApiErrorCodes.ERROR_UPDATE_USER_EWALLET_REFERENCE_ID_ALREADY_EXISTS]:
      'Wallet Reference ID must be unique',
    [ApiErrorCodes.REQUEST_DECLINED]:
      'Your transaction has been blocked by Rapyd Protect. It can be viewed under the “Blocked” tab.',
    [ApiErrorCodes.REQUEST_DECLINED_RP]:
      'Your transaction has been blocked by Rapyd Protect. It can be viewed under the “Blocked” tab.',
    [ApiErrorCodes.REQUEST_UNDER_REVIEW]:
      'The transaction you attempted to create has been put under review by Rapyd protect.  It can be viewed and approved in the "Under Review" tab',
    [ApiErrorCodes.REQUEST_UNDER_REVIEW_RP]:
      'The transaction you attempted to create has been put under review by Rapyd protect.  It can be viewed and approved in the "Under Review" tab',
    // Escrow Release
    ERROR_RELEASE_ESCROW_EWALLET_ALREADY_FULLY_RELEASED:
      'Entire payment for 1 or more wallets was already released',
    ERROR_RELEASE_ESCROW_EWALLET_AMOUNT_EXCEEDS_ORIGINAL_SPLIT:
      'You tried releasing more than the held amount for 1 or more wallets',
    ERROR_RELEASE_ESCROW_NOT_ENOUGH_FUNDS_ON_HOLD:
      'You tried releasing more than the held amount for 1 or more wallets',
    ERROR_MERCHANTS_PORTAL_RELEASE_ESCROW:
      'There was an error completing your request. Please try again or <0>contact support</0>',
    MERCHANTS_PORTAL_INVALID_FILE_TYPE: 'Invalid parameters or file structure',
    MERCHANTS_PORTAL_ERROR_GET_CHECKOUT: 'Something went wrong, please try again later',
    // Create payout
    ERROR_GET_BENEFICIARY:
      'Error Beneficiary Not Found - The beneficiary in this payout no longer exists.  Please create a new payout with a new beneficiary',
    ERROR_GET_PAYER:
      'Error Sender Not Found - The sender of this payout no longer exists.  Please create a new payout with a new sender',
    ERROR_PAYOUT_CURRENCY_NOT_SUPPORTED:
      'Error Currency Not Supported - The currency selected in this Payout is no longer supported by the payout method.  Please create a new payout using either a currency support by the payout method or a different payout method that does support the currency',
    INVALID_PAYOUT_CURRENCIES:
      'Error Currency Not Supported - The currency selected in this Payout is no longer supported by the payout method.  Please create a new payout using either a currency support by the payout method or a different payout method that does support the currency',
    ERROR_PAYOUT_AMOUNT_NOT_WITHIN_RANGE_OF_PAYOUT_METHOD_TYPE:
      'Error Payout Amount - The amount of the payout was not within the range of the payout method type selected',
    INVALID_PAYER_FIELDS:
      "Error Invalid Sender Fields - One of the fields in the 'sender' object contained a value that is not valid.Please create a new payout with a new sender",
    INVALID_PAYOUT_METHOD_TYPE:
      'Error Payout method not supported - The payout method is no longer supported.  Please create a new Payout with a different payout method',
    PAYOUT_METHOD_TYPE_BENEFICIARY_COUNTRY_MISMATCH:
      'Error Payout Method not available - The payout method is no longer supported by the beneficiary country.  Please create a new payout with a different payout method',
    MERCHANTS_PORTAL_ERROR_CREATE_PAYOUT: 'There was an error completing your payout.',
    ERROR_MERCHANTS_PORTAL_CREATE_REFUND: 'There was an error completing your refund.',
    MERCHANTS_PORTAL_ERROR_GENERATE_HOSTED_PAGE:
      'An error occurred while trying to create your checkout Page.  Please try again at a later time.  If the issue persists, please <0>contact support at support@rapyd.net</0>',
    MERCHANTS_PORTAL_ERROR_GENERATE_HOSTED_CATEGORY_NOT_SUPPORTED:
      'The category or categories selected in this checkout page are not supported by your customized checkout page.  Go to the <0>Customize Checkout Page</0> to enable these categories.',
    ERROR_CHECKOUT_COUNTRY_CURRENCY_MISMATCH:
      'No payment method supports the country and currency selected. Please select a different currency or country and try again.',
    ERROR_HOSTED_PAGE_INVALID_PAYMENT_METHOD_TYPE_AND_PAYMENT_METHOD_TYPE_CATEGORIES:
      'No payment method supports the country and currency selected. Please select a different currency or country and try again.',
    ERROR_CREATE_SETTLEMENT_BANK_ACCOUNT_DUPLICATE_EWALLET_CURRENCY: `A {{currency_code}} bank account has already been added to wallet ({{client_ewallet}})\n\n To add an additional {{currency_code}} bank account you must either delete the existing {{currency_code}} bank account, or <0>contact support</0> to add an additional Client Wallet to your account.`,
    MERCHANTS_PORTAL_ERROR_CHECKOUT_LOGO_INVALID_FILE_NAME: 'Invalid file name',
    MERCHANTS_PORTAL_ERROR_CAPTURE_PAYMENT:
      'Unable to capture funds for <1>{{id}}</1> \nTry again at a later time. If the problem persists <0>contact support</0>',
    [ApiErrorCodes.ERROR_CAPTURE_PAYMENT_IS_EXIPRED]:
      'Unable to capture funds for <1>{{id}}</1> \nbecause the payment has already expired',
    [ApiErrorCodes.ERROR_AUTH_ONLY_IS_NOT_SUPPORTED]:
      'You tried to make a card payment with authorization only, but the selected payment method does not support it. To resolve this issue, either uncheck “Capture later” or select a different payment method.',
    MERCHANTS_PORTAL_ERROR_CREATE_EWALLET: 'There was an error creating a new ewallet.',
  },
  //List
  NO_LIST_DATA: 'No Avalible Data',
  LAST: 'LAST {{listName}}',
};
